(function () {
  'use strict';
  angular.module('com.module.projects',[]);
})();

'use strict';

angular.module('com.module.projects')
  .service('ProjectUsers', ["Project", "CoreService", "CONFIG", "$http", "TeamService", "$q", function(Project,CoreService,CONFIG,$http,TeamService,$q) {
    var vm = this;
    vm.projectId = null;
    vm.ProjectRoles = CONFIG.ProjectRoles;
    vm.load = function(userId,projectId) {
      projectId = projectId || vm.projectId;
      var filters = {"include": {systemUser:"teams"}};
      if(userId) filters.where = {systemuserId:userId};
      return $http.get(CoreService.env.apiUrl+'/Projects/'+projectId+'/access',{
        params:{
          filter: filters
        }
      }).then(function(res){
        return res.data
        // filter teams from other projects
        .map(function(a){
          if(a.systemUser && a.systemUser.teams) {
            a.systemUser.teams = a.systemUser.teams.filter(function(team){
              return team.projectId===projectId;
            })
          }
          return a;
        });
      })
      .catch(CoreService.error);
    };
    
    vm.searchUsers = function(orgId,filters){
      return $http.get(CoreService.env.apiUrl+'/Organizations/'+orgId+'/systemUsers',{
        cache:true,
        params: {
            filter: filters
        }
      });
    }
    
    
    vm.insert = function(obj,user) {
      
      var rolesArray = obj.map(function(o){
        return {email:user.email, role:o.role}
      })
      console.log("Insert roles",rolesArray);
      if(rolesArray.length>0) return vm.inviteBulk(rolesArray);
      else return rolesArray;
      // return $http.post(CoreService.env.apiUrl+'/Projects/'+vm.projectId+'/access',insertObj)
      // .then(CoreService.success)
      // .catch(CoreService.error);
    };
    
    vm.update = function(obj) {
      console.log("Update roles",obj)
      var updateObj = {
        role: obj.role,
        systemuserId: obj.systemuserId
      };
      return $http.put(CoreService.env.apiUrl+'/Projects/'+vm.projectId+'/access/'+obj.id,updateObj)
      .then(CoreService.success)
      .catch(CoreService.error);
    };
    
    vm.delete = function(obj) {
        console.log(obj);
        if(!obj.id || !obj.projectId) return Promise.reject('No access id or no project id');
        return $http.delete(CoreService.env.apiUrl+'/Projects/'+obj.projectId+'/access/'+obj.id)
        
        // remove him from teams
        // .then(function(){
        //   return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+obj.systemuserId+'/teams',{where:{projectId:obj.projectId}});
        // })
        // .then(function(res){
        //   var teams = res.data;
        //   var p=[];
        //   if(teams.length>0) {
        //     teams.forEach(function(t){
        //       p.push(TeamService.unlinkUser(obj.systemuserId,t.id));
        //     });
        //   }
        //   return $q.all(p);
          
        // })
        
        .then(CoreService.success)
        .catch(CoreService.error);
    };
    
    vm.inviteBulk = function(rolesArray,projectId) {
      projectId = projectId || vm.projectId;
      return $http.post(CoreService.env.apiUrl+'/Projects/'+projectId+'/inviteUsers',{users:rolesArray})
      .then(CoreService.success)
      .catch(CoreService.error);
    };
    
    vm.invite = function(users) {
      var rolesArray = [];
      users.forEach(function(user){
        user.roles.forEach(function(role){
          rolesArray.push({email:user.email,role:role})
        })
        
      });
      return vm.inviteBulk(rolesArray);
    };
    
    /* helpers */
    vm.groupRoles = function(res) {
      var resultArray = [];
      if(!res || res.length===0) return resultArray;
      var hash = res.reduce(function(a, b) {
        var roleObj = {
          projectId:b.projectId,
          systemuserId:b.systemuserId,
          id:b.id,
          role:b.role
        };
        
        if(!b.systemUser) {
          console.warn("Bug in projectAccess data: User doesnt exist", b);
          return a;
        }
        
        if (a[b.systemUser.email]) {
          // obj exists
          a[b.systemUser.email].roles.push(roleObj);
        }
        else {
          // new obj
          a[b.systemUser.email] = {
            systemuserId: b.systemuserId,
            email: b.systemUser.email,
            firstName: b.systemUser.firstName,
            lastName: b.systemUser.lastName,
            teams: b.systemUser.teams?b.systemUser.teams.map(function(t){return t.name}).join(","):"",
          };
          a[b.systemUser.email].roles = [roleObj]; //make it an array
        }
        return a;
      }, {});
      for (var item in hash) {
        hash[item].roles_label = hash[item].roles.map(function(roleObj){
          return vm.getRoleLabel(roleObj.role);}).join(',');
        resultArray.push(hash[item]);
      }
      return resultArray;
    }
    
    vm.getRoleLabel = function(search) {
      var label = vm.ProjectRoles.filter(function(role){ return search===role.map}).map(function(role){return role.label});
      if(label.length>0) return label;
      return search;
    }

  }]);

'use strict';

angular.module('com.module.projects')
  .component('projectUsers', {
      templateUrl: 'app/modules/projects/components/project-users/template.html',
      restrict: 'E',
      bindings:{
        'project': '='
      },
      controllerAs: 'vm',
      controller: ["$q", "$rootScope", "$state", "$timeout", "ProjectUsers", "uiGridConstants", "CoreService", "CONFIG", "TeamService", function($q, $rootScope, $state, $timeout, ProjectUsers,uiGridConstants, CoreService,CONFIG,TeamService ) {
        var vm = this;
        ProjectUsers.projectId = vm.project.id;
        
        vm.selected={};
        vm.selectedRoles=[];
        vm.roles = CONFIG.ProjectRoles;
        vm.viewElement = CoreService.viewElement;
        vm.gridOptions = {
          enablePaginationControls: true,
          paginationPageSizes: [15],
          paginationPageSize: 15,
          enableFiltering: true,
          onRegisterApi: function(gridApi) {
            vm.gridApi = gridApi;
            
             vm.gridApi.core.on.filterChanged( null, function() {
              var grid = this.grid;
              var filters = grid.columns.reduce(function(acc,cur) {
                if (cur.filters[0].term && cur.field.indexOf('_label')===-1) acc[cur.field] = cur.filters[0].term;
                return acc;
              }, {});
              console.log("Filters:",filters);
            });
            
            vm.gridApi.core.on.sortChanged( null, function() {
              var grid = this.grid;
              var sort;
              for (var i=0,len=grid.columns.length;i<len;i++){
                sort=grid.columns[i].sort;
                if (sort.direction && sort.priority===0) {
                  sort.field=grid.columns[i].field;
                  break;
                }
              }
              console.log("Sort:",sort);
            });
            
          },
          columnDefs: [
            { name: 'email', cellTooltip:true, displayName: 'Email',width:250},    
            { name: 'firstName', cellTooltip:true, displayName: 'Name',width:100},    
            { name: 'lastName', cellTooltip:true, displayName: 'Surname',width:150},    
            { name: 'teams', cellTooltip:true, displayName: 'Teams',width:150},    
            { 
              name: 'roles_label', 
              displayName: 'Roles', 
              filter: {
                type: uiGridConstants.filter.SELECT,
                selectOptions: CONFIG.ProjectRoles
              }
            },
            {
              field: 'View',
              enableFiltering: false,
              enableColumnMenu: false,
              enableCellEdit: false ,
              cellTemplate: 
                '<div class="ui-grid-cell-contents">'+
                '<a href="" style="margin:2px" title="View" class="btn btn-xs btn-default" ng-click="grid.appScope.vm.viewElement(row.entity)"><i class="fa fa-eye"></i></a>'+
                '</div>',
              width: 70
            },
            {
              field: 'Edit',
              enableFiltering: false,
              enableColumnMenu: false,
              enableCellEdit: false ,
              cellTemplate: 
                '<div class="ui-grid-cell-contents">'+
                '<a href="" title="Edit" class="btn btn-xs btn-warning" style="margin:2px" ng-click="grid.appScope.vm.editElement(row.entity)"><i class="fa fa-pencil"></i></a>'+
                '</div>',
              width: 70
            },
            {
              field: 'Delete',
              enableFiltering: false,
              enableColumnMenu: false,
              enableCellEdit: false ,
              cellTemplate: 
                '<div class="ui-grid-cell-contents">'+
                '<a href="" title="Delete" class="btn btn-xs btn-danger" style="margin:2px" ng-click="grid.appScope.vm.deleteAllRoles(row.entity)"><i class="fa fa-trash"></i></a>'+
                '</div>',
              width: 70
            }
          ]
        };
        
          // BULK importer
          vm.gridOptionsImport = {
            enableGridMenu: true,
            enableFiltering: true,
            importerDataAddCallback: function ( grid, newObjects ) {
              vm.gridOptionsImport.data = newObjects;
              // fix height
              $timeout(function(){
                angular.element(document.getElementById('user-bulk-import-grid'))
                .css('height','100%');
              },500)
            },
            onRegisterApi: function(gridApi) { vm.gridApiImport = gridApi; },
          };
          var handleFileSelect = function( event ){
            event=event.originalEvent;
            var target = event.srcElement || event.target;
            // console.log(target);
            if (target && target.files && target.files.length === 1) {
              var fileObject = target.files[0];
              vm.gridApiImport.importer.importFile( fileObject );
              // target.form.reset();
            }
          };
          $('.file-chooser').change(handleFileSelect);
          vm.bulkProcess = function(){
            var users = vm.bulkDemoAccounts===true 
            ? vm.gridOptionsImport.data.map(function(u){u.demo=true; return u;}) 
            : vm.gridOptionsImport.data.map(function(u){ delete u.demo; return u;});
            vm.promise = ProjectUsers.inviteBulk(users)
              .then(function(res){
                // console.log(res);
                vm.selectedChanges=1;
                vm.editElement({});
              }).catch(console.log);
            return vm.promise;
          }
          
          vm.closeForm = function(){
            // hide form
            vm.formOpen=false;
            if(vm.selectedChanges>0) vm.initLoad();
          };
          /* Edit/Create single */
          vm.editElement = function(obj){
            if(obj.roles) {
              vm.selectedRoles=obj.roles.map(function(role){return role.role});
              vm.selected=obj;
            } else {
              vm.selected={};
              vm.selectedRoles=[];
            }
            
            // show form
            vm.formOpen=true; 
            vm.selectedChanges=0;
          }
          
          vm.selectUser = function(user){
            vm.selectedRoles=[];
            // check if user has already roles
            vm.searchLoaderRoles=ProjectUsers.load(user.id).then(function(res){
              vm.searchLoaderRoles=false;
              if(res.length>0) {
                var users = ProjectUsers.groupRoles(res);
                vm.selectedRoles=users[0].roles.map(function(role){return role.role});
              }
            })
          }
          
          vm.deleteAllRoles = function(user){
            vm.submitRoles(user,[]).then(function(){vm.initLoad()});
          }
          
          vm.submitRoles = function(user,roles){
            
            user.systemuserId = user.systemuserId || user.id;
            user.roles = user.roles || roles || [];
            
            var oldRoles = [];
            var deleteRoles=user.roles.filter(function(oldrole){ oldRoles.push(oldrole.role); return roles.indexOf(oldrole.role)===-1;});
            var insertRoles=roles
              .filter(function(newrole){ return oldRoles.indexOf(newrole)===-1;})
              .map(function(role){ return {
                systemuserId:user.systemuserId,
                projectId:vm.project.id,
                role:role
              }});
            // console.log("oldRoles:",oldRoles);
            // console.log("newRoles:",roles);
            // console.log("deleteRoles:",deleteRoles);
            // console.log("insertRoles:",insertRoles);
            var promises=[];
            var insertRolesArr = [];
            deleteRoles.forEach(function(o){promises.push(ProjectUsers.delete(o));})
            insertRoles.forEach(function(o){insertRolesArr.push(o);})
            vm.selectedChanges=(insertRoles.length||0)+(deleteRoles.length||0);
            if(insertRolesArr.length>0) promises.push(
              ProjectUsers.insert(insertRolesArr,user)
            )
            vm.promise=$q.all(promises).then(function(){
              vm.closeForm();
            })
            return vm.promise;
            
          }
          
          
          /* DATA HANDLING */
          vm.availableUsers=[];
          vm.searchUsers = function(search){
            if(search.length<1) return;
            var searchRegexp = new RegExp(search,'i').toString()
            var filters = {
              // limit:20,
              where: 
              // {email:{regexp:searchRegexp}}
              {
                or: [{
                  email:{regexp:searchRegexp}
                },{
                  firstName:{regexp:searchRegexp}
                },{
                  lastName:{regexp:searchRegexp}
                }]
              }
            };
            vm.searchLoaderUser = ProjectUsers.searchUsers(vm.project.organizationId,filters).then(function(res) {
                vm.searchLoaderUser = false;
                vm.availableUsers = res.data;
            });
          }

          // get all 
          vm.initLoad = function(){
            vm.promise=ProjectUsers.load().then(function(res) {
              res = res || [];
              vm.accessRoles=res;
              vm.loadGrid();
              vm.users =  res.filter(function(i){return !!i.systemUser;}).map(function(item) {
                item.email = item.systemUser.email;
                return item;
              });
            });
          };
          
          vm.loadGrid = function(data){
            data = data || vm.accessRoles;
            vm.gridOptions.data = ProjectUsers.groupRoles(data);
            CoreService.log(vm.gridOptions.data);
          };
        
          // Insert
          vm.insertElement = function(obj){
            ProjectUsers.insert(obj);
          };
          // Update
          vm.updateElement = function(obj){
            ProjectUsers.update(obj);
          }
          // Delete
          vm.deleteElement = function(obj){
            ProjectUsers.delete(obj).then(function(){
              vm.gridOptions.data = vm.gridOptions.data.filter(function(item){
                return obj.id!==item.id;
              })
            });
          }
          
          // 
          
          // init config
          TeamService.setProject(vm.project);
          vm.fillTeams = function(){
            var distributableStudents = vm.gridOptions.data.filter(function(s){
                return s.teams==="" && s.roles_label.indexOf("Student")>=0;
            });
            CoreService.confirm('Are you sure?','This will distribute '+distributableStudents.length +' students',
              function () {
                //   confirm
                vm.promise = TeamService.fillTeams().then(function(res){
                  CoreService.success('Success','Students have been distributed into teams.');
                  vm.initLoad();
                  return true;
                })
              },
              function () {
                //   cancel
              })
          }
            
        
          // Boot
          vm.initLoad();
          
      
        
      }]    
          
  });

'use strict';

angular.module('com.module.projects')
  .service('TeamService', ["$http", "CONFIG", "CoreService", "SchemaMaker", function($http,CONFIG,CoreService,SchemaMaker) {
    var vm = this;
    vm.project = {};
    vm.setProject=function(project){vm.project=project;};    
    vm.filters = {limit:25,skip:0}
    
    
    /* Teams Configuration */;
    
    // basic endpoint
    vm.endpoint = function(){ 
        return CoreService.env.apiUrl 
                +'/Projects/'+vm.project.id+'/teams';
    };
    // basic schema
    vm.schema = {
        "name": {
            "type": "string"
        }
    };
    
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name',
              required: true
            }
          }
        ];    
    };    
    
    vm.fillTeams = function(){
      return $http.post(CoreService.env.apiUrl+'/Projects/'+vm.project.id+'/partitionStudentsIntoTeams');
    }
    vm.searchUsers = function(filters){
      return $http.get(CoreService.env.apiUrl+'/Projects/'+vm.project.id+'/users',{
        cache:true,
        params: {
            filter: filters
        }
      });
    }
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    vm.getMembers = function(teamId) {
      return $http.get(CoreService.env.apiUrl  + '/ProjectTeams/' + teamId+'/members');
    };
    vm.linkUser = function(systemUserId,projectTeamId) {
      return $http.put(CoreService.env.apiUrl  + '/ProjectTeams/'+projectTeamId+'/members/rel/'+systemUserId,{ 
        "role":"member",
        "projectId":vm.project.id
      });
    };
    vm.unlinkUser = function(systemUserId,projectTeamId) {
      return $http.delete(CoreService.env.apiUrl  + '/ProjectTeams/'+projectTeamId+'/members/rel/'+systemUserId);
    };
    
    /* CRUD methods */
    vm.get = function(filters){
      filters = filters || {};
      filters = Object.assign({},filters,vm.filters);
      return $http.get(vm.endpoint(),{
          params: {
              filter: filters
          }
      });
    };
    vm.save = function(item){
      if(item.id) return $http.put(vm.endpoint()+'/'+item.id,item);
      else return $http.post(vm.endpoint(),item);
    };   
    vm.delete = function(item){
      return $http.delete(vm.endpoint()+'/'+item.id);
    };
      
    return vm;
  }]);

angular
    .module('com.module.projects')
    .component('projectTeams', {
        templateUrl: 'app/modules/projects/components/project-teams/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: ["$scope", "$uibModal", "TeamService", "GridHelper", "CoreService", "$state", function($scope,$uibModal, TeamService, GridHelper,CoreService,$state) {
            var vm = this;

            // init config
            TeamService.setProject(vm.project);
            vm.config={
                controllerAs:'vm'
            };
            
            /* List */
            var schema = TeamService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 25,
                sort: null
            };
            vm.filters = {};
            vm.loadListData = function(filters) {
                
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
              
                vm.promise = TeamService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data.sort(function(a,b){return a.order-b.order;}); //postProcess(res.data);
                });
            };
            
            vm.loadMembers = function(team){
                var teamId = team&&team.id?team.id:vm.item.id
                vm.promise = TeamService.getMembers(teamId).then(function(res){
                    vm.teamMembers = res.data;
                    vm.teamMembersIds = res.data.map(function(u){return u.id});
                })
            }
            
            vm.fillTeams = function(){
                CoreService.confirm('Are you sure?','This will distribute students',
                  function () {
                    //   confirm
                    vm.promise = TeamService.fillTeams().then(function(res){
                        CoreService.success('Success','Available students distributed into '+vm.teams.length+' teams')
                        vm.loadListData();
                        return true;
                    })
                  },
                  function () {
                    //   cancel
                  })
            }
            
            
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.gridOptions.rowTemplate= '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'custom\': true }" ui-grid-cell></div></div>'

            vm.loadListData();
            
            /* Single */
            
            vm.item = {};
            vm.formSchema = TeamService.getFormSchema();    
            
            vm.searchUsers = function(search){
              if(search.length<1) return;
              var searchRegexp = new RegExp(search,'i').toString()
              var filters = {
                limit:20,
                where: 
                // {email:{regexp:searchRegexp}}
                {
                  or: [{
                    email:{regexp:searchRegexp}
                  },{
                    firstName:{regexp:searchRegexp}
                  },{
                    lastName:{regexp:searchRegexp}
                  }]
                }
              };
              
              vm.searchLoader = TeamService.searchUsers(filters).then(function(res) {
                  vm.availableUsers = res.data.filter(function(u){
                      return vm.teamMembersIds.indexOf(u.id)<0;
                  }); //postProcess(res.data);
                  vm.searchLoader = false;
              });
            }
            vm.linkUser = function(user){
                TeamService.linkUser(user.id,vm.item.id).then(function(){
                CoreService.success('Success'); 
                vm.loadMembers();
                    
                }).catch(CoreService.error);
                vm.selected=null;  
                vm.loadMembers();
            };
            vm.unlinkUser = function(user){
                TeamService.unlinkUser(user.id,vm.item.id).then(function () {
                vm.loadMembers();
                }).catch(CoreService.error);
            };
            
            
            
            vm.closeForm = function(){
                vm.formOpen = false;            
                vm.loadListData();
            };
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item){
                vm.formOpen = !vm.formOpen;
                vm.item={};
            };
            vm.editElement = function(item){
                vm.formOpen = !vm.formOpen;
                vm.item=item;
                vm.loadMembers(item);
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    TeamService.delete(item).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.submit = function(){
                var item = vm.item;
                vm.promise = TeamService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            
        }]

    })
'use strict';

angular.module('com.module.projects')
  .service('SyllabusService', ["$http", "CONFIG", "CoreService", "SchemaMaker", "LectureService", function($http, CONFIG, CoreService, SchemaMaker,LectureService) {
    var vm = this;
    vm.project = {};
    vm.setProject = function(project) { vm.project = project; };
    vm.filters = { limit: 25, skip: 0 }

    /* Syllabus Configuration */

    // basic endpoint
    vm.endpoint = function() {
      return CoreService.env.apiUrl +
        '/Projects/' + vm.project.id + '/syllabus';
    };

    // create schema for angular-formly
    vm.getFormSchema = function() {
      return [{
          "className": "row",
          "fieldGroup": [{
              className: "col-sm-5",
              key: 'name',
              type: 'input',
              templateOptions: {
                label: 'Name',
                required: true
              }
            },
            {
              className: "col-sm-3",
              key: 'moduleNumber',
              type: 'input',
              templateOptions: {
                label: 'Module number',
              }
            },
            {
              className: "col-sm-4",
              key: 'website',
              type: 'input',
              templateOptions: {
                label: 'Website link',
              }
            }
          ]
        },
        {
          "className": "row",
          "fieldGroup": [{
            className: "col-sm-12",
            key: 'description',
            type: 'textarea',
            templateOptions: {
              label: 'Description',
            }
          }]
        },
        {
          "className": "row",
          "fieldGroup": [{
              className: "col-sm-4",
              key: 'teachingStaff',
              type: 'multiInput',
              templateOptions: {
                label: 'Teaching Staff',
                inputOptions: {
                  type: 'input'
                }
              }
            },
            {
              className: "col-sm-4",
              key: 'feedbackEmail',
              type: 'multiInput',
              templateOptions: {
                label: 'Email destination for feedback forms',
                inputOptions: {
                  type: 'input'
                }
              }
            },
            {
              className: "col-sm-4",
              key: 'officeHours',
              type: 'multiInput',
              templateOptions: {
                label: 'Office hours',
                inputOptions: {
                  type: 'input'
                }
              }
            }
          ]
        },


        {
          "className": "row",
          "fieldGroup": [{
              className: "col-sm-4",
              key: 'learningObjectives',
              type: 'multiInput',
              templateOptions: {
                label: 'Learning Objectives',
                inputOptions: {
                  type: 'input'
                }
              }
            },
            {
              className: "col-sm-4",
              key: 'assessment',
              type: 'multiInput',
              templateOptions: {
                label: 'Assessment',
                inputOptions: {
                  type: 'input'
                }
              }
            },
            {
              className: "col-sm-4",
              key: 'requirements',
              type: 'multiInput',
              templateOptions: {
                label: 'Requirements',
                inputOptions: {
                  type: 'input'
                }
              }
            }
          ]
        },
        {
          "className": "row",
          "fieldGroup": [{
            className: "col-xs-12",
            key: 'schedule',
            type: 'repeatSection',
            "templateOptions": {
              "label": "Schedule",
              "btnText": "Add schedule",
              "fields": [
                {
                  "className": "row",
                  "fieldGroup": [
                  {
                    className: "col-xs-4",
                    key: 'title',
                    type: 'select',
                    templateOptions: {
                      label: 'Lecture',
                      options: [],
                      valueProp: 'id',
                      labelProp: 'name',
                      required: false,
                      placeholder: 'Select Lecture'
                    },
                    controller: /* @ngInject */ ["$scope", "LectureService", function($scope, LectureService) {
                      $scope.to.options = [];
                      // init config
                      LectureService.setProject(vm.project);
                      LectureService.get().then(function(res) {
                        $scope.to.options = res.data.map(function(s) {
                          return { id: s.id, name: s.name };
                        });
                      });
                    }]
                  },                  
                  {
                    className: "col-xs-3",
                    key: 'lecturer',
                    type: 'select',
                    templateOptions: {
                      label: 'Lecturer',
                      options: [],
                      valueProp: 'id',
                      labelProp: 'name',
                      required: false,
                      placeholder: 'Select Lecturer'
                    },
                    controller: /* @ngInject */ ["$scope", "LectureService", function($scope, LectureService) {
                      $scope.to.options = [];
                      // init config
                      $http.get(CoreService.env.apiUrl+'/Projects/'+vm.project.id+'/access',{
                        params:{
                          filter: {
                            where: {
                              role:'lecturer'
                            },
                            include:'systemUser'
                          }
                        }
                      }).then(function(res) {
                        $scope.to.options = res.data.map(function(s) {
                          return { id: s.systemUser.id, name: s.systemUser.firstName +' '+ s.systemUser.lastName };
                        });
                        if(res.data.length===1) {
                          $scope.model.lecturer = res.data[0].systemUser.id
                        }
                      });
                    }]
                  },
                  {
                    "key": "sessionType",
                    "className": "col-xs-2",
                    type: 'select',
                    templateOptions: {
                      label: 'Session Type',
                      options: [
                        {
                          id:'kickoff',
                          label:'Kick-off'
                        },
                        {
                          id:'lecture',
                          label:'Lecture'
                        },
                        {
                          id:'practice_session',
                          label:'Practice Session'
                        },
                        {
                          id:'qa',
                          label:'Q&A'
                        },
                        {
                          id:'midterm',
                          label:'Midterm'
                        },
                        {
                          id:'finalexam',
                          label:'Final exam'
                        }
                      ],
                      valueProp: 'id',
                      labelProp: 'label',
                      required: true,
                      placeholder: 'Select session type'
                    }
                  },                 
                    {
                      "key": "room",
                      "type": "input",
                      "className": "col-xs-3",
                      "templateOptions": {
                        "label": "Room",
                      }
                    }, 
                    {
                      "key": "roomLink",
                      "type": "input",
                      "className": "col-xs-6",
                      "templateOptions": {
                        "label": "Room link (www)",
                      }
                    },
                   {
                      "key": "startDate",
                      "type": "datetimepicker",
                      "className": "col-xs-3",
                      "templateOptions": {
                        "label": "Start Date",
                        "placeholder": "Date..."
                      }
                    },                
                    {
                      "key": "endDate",
                      "type": "datetimepicker",
                      "className": "col-xs-3",
                      "templateOptions": {
                        "label": "End Date",
                        "placeholder": "Date..."
                      }
                    }
                  ]
                }
              ]
            }
            
          }]
        },
        {
          className: "col-sm-4",
          key: 'gradingScheme',
          type: 'select',
          templateOptions: {
            label: 'Grading Scheme',
            options: [],
            valueProp: 'id',
            labelProp: 'label',
            required: true,
            placeholder: 'Select grading scheme'
          },
          controller: /* @ngInject */ ["$scope", "GradingSchemeService", function($scope, GradingSchemeService) {
            $scope.to.options = [];
            GradingSchemeService.find().then(function(res) {
              console.log("GradingScheme", res.data);
              $scope.to.options = res.data.map(function(s) {
                return { id: s.key, label: s.data.label };
              });
            });
          }]
        },
        {
          className: "col-sm-8",
          key: 'gradingPolicy',
          type: 'textarea',
          templateOptions: {
            label: 'Grading Policy',
          }
        }
      ]
    }

    // {
    //   key: 'order',
    //   type: 'input',
    //   templateOptions: {
    //     label: 'Order',
    //   }
    // }


    /* CRUD methods */
    vm.get = function(filters) {
      filters = filters || {};
      filters = Object.assign({}, filters, vm.filters);
      return $http.get(vm.endpoint(), {
        params: {
          filter: filters
        }
      });
    };
    vm.save = function(item) {
      if (item.id) return $http.put(vm.endpoint(), item);
      else return $http.post(vm.endpoint(), item);
    };

    return vm;
  }]);

angular
    .module('com.module.projects')
    .component('projectSyllabus', {
        templateUrl: 'app/modules/projects/components/project-syllabus/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: ["$scope", "$uibModal", "SyllabusService", "GridHelper", "CoreService", "$state", function($scope,$uibModal, SyllabusService, GridHelper,CoreService,$state) {
            var vm = this;
            vm.config={
                controllerAs:'vm'
            };

            // init config
            SyllabusService.setProject(vm.project);
            
            // fetch syllabus or create on the fly
            SyllabusService.get().then(function(res){
                vm.item = res.data;
            }).catch(function(res){
                if(res.status===404) {
                    // auto create one
                    console.log(vm.project);
                    var item ={
                        name:vm.project.name,
                        moduleNumber:vm.project.moduleNumber,
                        website:vm.project.website,
                        description:vm.project.description
                    };
                    SyllabusService.save(item).then(function(res){
                        vm.item = res.data;
                        console.log(vm.item);
                    });
                }
            })
            
            
            /* Single */
            
            vm.item = {};
            vm.formSchema = SyllabusService.getFormSchema();
            vm.submit = function(){
                var item = vm.item;
                vm.promise = SyllabusService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.item = res.data;
                    }).catch(CoreService.error);
            };
            
            
        }]

    })
'use strict';

angular.module('com.module.projects')
  .service('LectureService', ["$http", "CONFIG", "CoreService", "SchemaMaker", function($http,CONFIG,CoreService,SchemaMaker) {
    var vm = this;
    vm.project = {};
    vm.setProject=function(project){vm.project=project;};    
    vm.filters = {limit:25,skip:0}
    
    
    /* Lectures Configuration */;
    
    // basic endpoint
    vm.endpoint = function(){ 
        return CoreService.env.apiUrl 
                +'/Projects/'+vm.project.id+'/lectures';
    };
    // basic schema
    vm.schema = {
        "name": {
            "type": "string"
        },
        // "status": {
        //     "type": "string"
        // },
        "publication": {
            "type": "string"
        }
        // "order": {
        //     "type": "number"
        // }
    };
    
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name',
              required: true
            }
          },
          {
            key: 'description',
            type: 'textarea',
            templateOptions: {
              label: 'Description',
            }
          },
          {
            key: 'startDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'Start accessible date',
            }
          },
          {
            key: 'endDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'End accessible date',
            }
          },
          {
            key: 'publicationDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'Date Published',
            }
          },
          {
            key: 'publicationStatus',
            type: 'input',
            templateOptions: {
              label: 'Status',
            }
          },
          {
            key: 'publication',
            type: 'input',
            templateOptions: {
              label: 'Published Proposal id',
            }
          }
          // {
          //   key: 'order',
          //   type: 'input',
          //   templateOptions: {
          //     label: 'Order',
          //   }
          // }
        ];    
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    vm.saveOrder = function(lectureIds){
      return $http.post(CoreService.env.apiUrl  + '/Projects/'+vm.project.id+'/lectureOrder/'+lectureIds.join(','));
    };
    vm.getProposals = function(lectureId) {
      return $http.get(CoreService.env.apiUrl  + '/Lectures/' + lectureId+'/proposals',{params:{filter:{include:['file','systemUser']}}});
    };
    vm.acceptProposal = function(id) {
      return $http.put(CoreService.env.apiUrl  + '/LectureProposals/'+id,{publicationStatus:'accepted'});
    };
    vm.rejectProposal = function(id) {
      return $http.put(CoreService.env.apiUrl  + '/LectureProposals/'+id,{publicationStatus:'rejected'});
    };
    vm.deleteProposal = function(id) {
      return $http.delete(CoreService.env.apiUrl  + '/LectureProposals/'+id);
    };
    
    /* CRUD methods */
    vm.get = function(filters){
      filters = filters || {};
      filters = Object.assign({},filters,vm.filters);
      return $http.get(vm.endpoint(),{
          params: {
              filter: filters
          }
      });
    };
    vm.save = function(item){
      if(item.id) return $http.put(vm.endpoint()+'/'+item.id,item);
      else return $http.post(vm.endpoint(),item);
    };   
    vm.delete = function(item){
      return $http.delete(vm.endpoint()+'/'+item.id);
    };
      
    return vm;
  }]);

'use strict';

angular.module('com.module.projects')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.projects.view.lectures.edit', {
          url: '/:lectureId',
          template: '<ui-view></ui-view>',
          abstract:true
        })
        .state('app.projects.view.lectures.edit.proposals', {
          url: '/proposals',
          templateUrl: 'app/modules/projects/components/project-lectures/proposals-list.html',
          controllerAs: 'ctrl',
          controller: ["$scope", "$stateParams", "FileService", "LectureService", "CoreService", "$q", function ($scope, $stateParams,FileService, LectureService,CoreService,$q) {
            var vm = this;
            
            vm.lectureId = $stateParams.lectureId;
            vm.cdn = CoreService.env.cdnUrl;
            load();
            function load(){
              vm.promise = LectureService.getProposals(vm.lectureId).then(function(res){
                vm.proposals = res.data
                .map(function(item){
                  item.file.container = FileService.getPublicContainer(item.file.container);
                  return item;
                });
              });
            }
            vm.lectureScope = $scope.$parent.$parent.vm;
            
            vm.acceptProposal = function(id){
              vm.lectureScope.item.publication = id;
              LectureService.save(vm.lectureScope.item);
              
              var p=[];
              // reject first all the accepted proposals
              vm.proposals
                .filter(function(item){return item.publicationStatus==='accepted'})
                .forEach(function(item){
                  p.push(LectureService.rejectProposal(item.id));
                })
              // now accept the one
              p.push(LectureService.acceptProposal(id))
             
              $q.all(p).then(function(result){
                load();
              });
            }
            vm.rejectProposal = function(id){
              LectureService.rejectProposal(id).then(load);
              vm.lectureScope.item.publication = vm.lectureScope.item.publication===id?null:vm.lectureScope.item.publication;
              LectureService.save(vm.lectureScope.item);
            }
            vm.view = CoreService.viewElement;
            vm.deleteProposal = function(id){
              if(vm.lectureScope.item.publication === id) {
                window.alert('You cant delete this because its currently the published one, please accept another one first and then delete it');
              } else {
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    LectureService.deleteProposal(id).then(function (res) {
                        CoreService.success('Deleted successfully',res.data);
                        load();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
              }
            }
          }]
        })
        .state('app.projects.view.lectures.edit.upload', {
          url: '/upload-proposal',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", "$stateParams", function (FileUploader, FileService,$stateParams) {
            FileService.setApi('lectures',$stateParams.lectureId);
            this.uploader = FileService.uploader({url:'/Lectures/'+$stateParams.lectureId+'/uploadProposal'});
            // auto-attach the handlers
            this.uploader.onBeforeUploadItem = function(item) {
              item.file.componentModel = '';
              item.url = item.url + '/uploadProposal';
            };
          }]
        })
        
    }]
  );

angular
    .module('com.module.projects')
    .component('projectLectures', {
        templateUrl: 'app/modules/projects/components/project-lectures/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: ["$scope", "$uibModal", "LectureService", "GridHelper", "CoreService", "$state", function($scope,$uibModal, LectureService, GridHelper,CoreService,$state) {
            var vm = this;

            // init config
            LectureService.setProject(vm.project);
            vm.config={
                controllerAs:'vm'
            };
            
            /* List */
            var schema = LectureService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 25,
                sort: null
            };
            vm.filters = {};
            vm.loadListData = function(filters) {
                
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
              
                vm.promise = LectureService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data.sort(function(a,b){return a.order-b.order;}); //postProcess(res.data);
                });
            };
            
            
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.gridOptions.rowTemplate= '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'custom\': true }" ui-grid-cell></div></div>'

            vm.loadListData();
            // ui-grid-draggable-rows
            vm.dragEnable = true;
            vm.gridOptions.onRegisterApi = function (gridApi) {
                
                gridApi.draggableRows.on.rowFinishDrag(null, function () {
                    vm.changeOrder(vm.gridOptions.data)
                });
                
            };
            
            /* reorder function */
            vm.changeOrder = function(lectures){
                var changed=false;
                var ids=[];
                for (var i = 0; i < lectures.length; i++) {
                    ids.push(lectures[i].id);
                    if(lectures[i].order!==i) {
                        lectures[i].order = i;
                        changed=true;
                    }
                }
                if(changed) LectureService.saveOrder(ids).then(CoreService.success).catch(CoreService.error);
                else CoreService.warning({},'Order not changed')
            }
            
            /* Single */
            
            vm.item = {};
            vm.formSchema = LectureService.getFormSchema();
            vm.closeForm = function(){
                vm.formOpen = false;            
                vm.loadListData();
            };
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item){
                console.log("Create",item);
                vm.formOpen = !vm.formOpen;
                vm.item={};
            };
            vm.editElement = function(item){
                console.log("Edit",item);
                vm.formOpen = !vm.formOpen;
                vm.item=item;
                $state.go('app.projects.view.lectures.edit.proposals',{lectureId:item.id});
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    LectureService.delete(item).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.submit = function(){
                var item = vm.item;
                vm.promise = LectureService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            
        }]

    })
'use strict';

angular.module('com.module.projects')
  .service('CaseStudyService', ["$http", "CONFIG", "CoreService", "SchemaMaker", function($http,CONFIG,CoreService,SchemaMaker) {
    var vm = this;
    vm.project = {};
    vm.setProject=function(project){vm.project=project;};    
    vm.filters = {limit:25,skip:0}
    
    
    /* CaseStudies Configuration */;
    
    // basic endpoint
    vm.endpoint = function(){ 
        return CoreService.env.apiUrl 
                +'/Projects/'+vm.project.id+'/casestudies';
    };
    // basic schema
    vm.schema = {
        "name": {
            "type": "string"
        },
        // "status": {
        //     "type": "string"
        // },
        "teamAccess.name": {
          "displayName": "Connected Team", 
          "type": "relation"
        },
        "createdAt": {
          "type": "date"
        }
        // "order": {
        //     "type": "number"
        // }
    };
    
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name',
              required: true
            }
          },
          {
            key: 'description',
            type: 'textarea',
            templateOptions: {
              label: 'Teaser Description',
            }
          },
          {
            key: 'description_long',
            type: 'textarea',
            templateOptions: {
              label: 'Full Description',
            }
          },
          {
            key: 'startDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'Start accessible date',
            }
          },
          {
            key: 'endDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'End accessible date',
            }
          },
          {
            key: 'publicationStatus',
            type: 'input',
            templateOptions: {
              label: 'Status',
            }
          },
          {
            key: 'organizationId',
            type: 'select',
            templateOptions: {
              label: 'Organization',
              options: [],
              valueProp: 'id',
              labelProp: 'name',
              required: true,
              placeholder:'Select Organization'
            },
            controller: /* @ngInject */ ["$scope", "OrganizationService", function($scope, OrganizationService) {
              OrganizationService.get().then(function(data){
                $scope.to.options = data;
                // note, the line above is shorthand for:
                // $scope.options.templateOptions.options = data;
                return data;
              });
            }]
          }
        ];    
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    vm.saveOrder = function(casestudyIds){
      return $http.post(CoreService.env.apiUrl  + '/Projects/'+vm.project.id+'/casestudyOrder/'+casestudyIds.join(','));
    };    
    
    /* Teams */
    vm.searchTeams = function(filters){
      return $http.get(CoreService.env.apiUrl  + '/Projects/'+vm.project.id+'/teams/',{
        cache:true,
        params: {
            filter: filters
        }
      });
    }
    vm.getTeam = function(casestudyId){
      return $http.get(CoreService.env.apiUrl  + '/CaseStudies/'+casestudyId+'/teamAccess');
    };    
    vm.linkTeam = function(casestudyId,teamId){
      return $http.put(CoreService.env.apiUrl  + '/CaseStudies/'+casestudyId+'/teamAccess/rel/'+teamId,{
        componentId:casestudyId,
        projectteamId:teamId
      });
    };    
    vm.unlinkTeam = function(casestudyId,teamId){
      return $http.delete(CoreService.env.apiUrl  + '/ProjectTeams/'+teamId+'/components/rel/'+casestudyId);
    };
    
    
    /* CaseStudies Tokens for abma */
    
    vm.getTokens = function(caseId){
      return $http.get(CoreService.env.apiUrl  + '/CaseStudies/'+caseId+'/tokens');
    };
    vm.createToken = function(caseId,data){
      data.projectId = vm.project.id;
      return $http.post(CoreService.env.apiUrl  + '/CaseStudies/'+caseId+'/tokens',data);
    };
    vm.deleteToken = function(caseId,tokenId){
      return $http.delete(CoreService.env.apiUrl  + '/CaseStudies/'+caseId+'/tokens/'+tokenId);
    };
    
    
    
    /* CRUD methods */
    vm.get = function(filters){
      filters = filters || {};
      filters = Object.assign({},filters,vm.filters);
      return $http.get(vm.endpoint(),{
          params: {
              filter: filters
          }
      });
    };
    vm.save = function(item){
      if(item.id) {
        
        for (var prop in item.images){
          if (item.images[prop] && item.images[prop].id) item.images[prop] = item.images[prop].id;
        }
        
        return $http.put(vm.endpoint()+'/'+item.id,item);
      }
      else return $http.post(vm.endpoint(),item);
    };   
    vm.delete = function(item){
      return $http.delete(vm.endpoint()+'/'+item.id);
    };
    
      
    return vm;
  }]);

'use strict';

angular
    .module('com.module.projects')
    .component('projectCaseStudies', {
        templateUrl: 'app/modules/projects/components/project-casestudies/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: ["$scope", "$uibModal", "CaseStudyService", "GridHelper", "CoreService", "$state", "$timeout", "FileService", "CONFIG", "$http", function($scope, $uibModal, CaseStudyService, GridHelper, CoreService, $state, $timeout, FileService, CONFIG,$http) {
            var vm = this;

            // init config
            CaseStudyService.setProject(vm.project);
            vm.config = {
                controllerAs: 'vm'
            };

            /* List */
            var schema = CaseStudyService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 25,
                sort: null
            };
            vm.filters = {};
            vm.loadListData = function(filters) {

                filters = filters || vm.filters;
                console.log("Req Filter", filters);

                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
                vm.promise = CaseStudyService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.data = [];
                    $timeout(function() {
                        vm.gridOptions.totalItems = Number(headers['x-total-count']);
                        vm.gridOptions.data = res.data.sort(function(a, b) {
                            return a.order - b.order;
                        }); //postProcess(res.data);
                    });
                });
            };


            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters, vm.config);
            vm.gridOptions.rowTemplate = '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'custom\': true }" ui-grid-cell></div></div>'

            vm.loadListData();
            // ui-grid-draggable-rows
            vm.dragEnable = true;
            vm.gridOptions.onRegisterApi = function(gridApi) {

                gridApi.draggableRows.on.rowFinishDrag(null, function() {
                    vm.changeOrder(vm.gridOptions.data)
                });
                vm.gridApi = gridApi;

            };

            /* reorder function */
            vm.changeOrder = function(casestudies) {
                var changed = false;
                var ids = [];
                for (var i = 0; i < casestudies.length; i++) {
                    ids.push(casestudies[i].id);
                    if (casestudies[i].order !== i) {
                        casestudies[i].order = i;
                        changed = true;
                    }
                }
                if (changed) CaseStudyService.saveOrder(ids).then(CoreService.success).catch(CoreService.error);
            }

            /* Single */

            vm.item = {};
            vm.formSchema = CaseStudyService.getFormSchema();
            vm.closeForm = function() {
                vm.formOpen = false;
                vm.loadListData();
            };
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item) {
                console.log("Create", item);
                vm.formOpen = !vm.formOpen;
                vm.item = {};
            };
            vm.editElement = function(item) {
                console.log("Edit", item);
                vm.formOpen = !vm.formOpen;
                vm.item = item;
                
                vm.item.color_main = vm.item.color_main ||"#fff";
                vm.loadImages(vm.item);
                vm.loadVisitors(vm.item.id);

                vm.searchLoader = CaseStudyService.getTeam(item.id).then(function(res) {
                    vm.item.team = res.data[0];
                    vm.selected = vm.item.team;
                    vm.searchLoader = false;
                })
            };
            vm.deleteElement = function(item) {
                console.log("Delete", item);
                CoreService.confirm('Are you sure?', 'Deleting this cannot be undone',
                    function() {
                        //   confirm
                        CaseStudyService.delete(item).then(function() {
                            CoreService.success('Deleted successfully', (item.name || item.id) + ' deleted!');
                            vm.loadListData();
                        }).catch(CoreService.error);
                    },
                    function() {
                        //   cancel
                    }
                );
            };
            vm.submit = function() {
                var item = vm.item;
                vm.promise = CaseStudyService.save(item)
                    .then(function(res) {
                        CoreService.success('Saved successfully', res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item = null;
                        vm.loadListData();
                    }).catch(CoreService.error);
            };

            /* Visitors */
            
            console.log(CoreService.env);
            vm.abmaUrl = CoreService.env.abmaUrl;
            vm.loadVisitors = function(){
                vm.caseStudyVisitorsLoading = true;
                return CaseStudyService.getTokens(vm.item.id).then(function(res){
                    // console.log("Visitors",res.data);
                    vm.caseStudyVisitors = res.data;
                    vm.caseStudyVisitorsLoading = false;
                })
            }
            vm.addVisitor = function(v){
                vm.caseStudyVisitorsLoading = true;
                var data = {email:v,token:uuid(v.email)};
                CaseStudyService.createToken(vm.item.id,data).then(function(res){
                  vm.loadVisitors();  
                }).catch(CoreService.error);
            }
            vm.removeVisitor = function(v){
                vm.caseStudyVisitorsLoading = true;
                CaseStudyService.deleteToken(vm.item.id,v.id).then(function(res){
                  vm.loadVisitors();  
                }).catch(CoreService.error);
            }
            vm.notifyVisitor = function(v){
                var url = "https://abma.ac/cases/"+vm.item.id+'/presentation/'+v.token;
                var email = v.email;
                window.alert("Not Implemented yet");
            }

            /* Single */

            vm.searchLoader = CaseStudyService.searchTeams({})
                .then(function(res) {
                    vm.searchLoader = false;
                    vm.availableTeams = res.data; //postProcess(res.data);
                })

            vm.selectTeam = function(casestudyId, teamId) {
                console.log(casestudyId, teamId, vm.item);
                var prevTeamId = vm.item.team ? vm.item.team.id : false;

                if (prevTeamId === teamId) return;
                vm.searchLoader = CaseStudyService.linkTeam(casestudyId, teamId).then(function(result) {
                    if (prevTeamId) return CaseStudyService.unlinkTeam(casestudyId, prevTeamId);
                    return Promise.resolve(true);
                }).then(function() {
                    vm.searchLoader = false;
                    vm.closeForm();
                });
            }

            /* Background image upload */

            vm.item.images = vm.item.images || {};

            vm.deleteBackground = function(item){
                if(item.images && item.images.background)
                FileService.delete(item.images.background.id || item.images.background,function(){
                    $timeout(function(){
                        vm.loadImages(item);
                    },50);
                },function(){})
            }
            vm.imageLoading = vm.loadImages = function(item) {
                vm.item.images = vm.item.images || {};
                if (!item.images.background) {
                    vm.imageLoading = null;
                    vm.backgroundImage = null;
                    return;
                }
                var ids = {};
                Object.keys(item.images).forEach(function(prop) {
                    ids[item.images[prop]] = null;
                })
                return FileService.get({
                    where: {
                        id: {
                            inq: Object.keys(ids)
                        }
                    }
                }).then(function(res) {
                    res.data.forEach(function(file) {
                        ids[file.id] = file;
                    })
                    Object.keys(vm.item.images).forEach(function(prop) {
                        var id = vm.item.images[prop];
                        vm.item.images[prop] = ids[id];
                    })
                    vm.backgroundImage = (vm.item.images && vm.item.images.background && vm.item.images.background.id) ? CoreService.env.cdnUrl + vm.item.images.background.container + '/' + vm.item.images.background.data.size["1024x768"] : null;
                    vm.imageLoading = null;
                    
                })
            }

            FileService.setApi('projects', vm.project.id);
            vm.uploader = FileService.uploader({
                url: '/Projects/' + vm.project.id
            });
            vm.uploader.filters.push({
                name: 'imageFilter',
                fn: function(item /*{File|FileLikeObject}*/ , options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
                }
            });
            // auto-attach the handlers
            vm.uploader.onBeforeUploadItem = function(item) {
                item.headers['x-upload-filename'] = item.file.name;
                item.headers['x-meta-data'] = JSON.stringify({
                    data: {
                        size: CONFIG.ProjectBackgroundSizes
                    }
                });
                var url = '/image/uploadFile';
                vm.item.images = vm.item.images || {};
                if (vm.item.images && vm.item.images.background && vm.item.images.background.id) url = '/image/updateFile/' + vm.item.images.background.id;
                item.url = item.url + url;
            };


            vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
                console.info('onCompleteItem', fileItem, response, status, headers);
                vm.item.images = vm.item.images || {};
                vm.item.images.background = response.id;
                vm.imageLoading = CaseStudyService.save(vm.item).then(function() {
                    //   $state.reload(true);
                    vm.uploader.queue = [];
                    vm.imageLoading=null;
                    CoreService.imageInfo();
                    // return $timeout(function(){
                    //     return vm.loadImages(vm.item);
                    // },500);
                });
            };


        }]

    })
'use strict';

angular.module('com.module.projects')
  .service('AssessmentService', ["$http", "CONFIG", "CoreService", "SchemaMaker", function($http,CONFIG,CoreService,SchemaMaker) {
    var vm = this;
    vm.project = {};
    vm.setProject=function(project){vm.project=project;};    
    vm.filters = {limit:25,skip:0}
    
    
    /* Assessments Configuration */;
    
    // basic endpoint
    vm.endpoint = function(){ 
        return CoreService.env.apiUrl 
                +'/Projects/'+vm.project.id+'/assessments';
    };
    // basic schema
    vm.schema = {
        "name": {
            "type": "string"
        },
        // "status": {
        //     "type": "string"
        // },
        "publication": {
            "type": "string"
        },
        "type": {
            "type": "string"
        }
        // "order": {
        //     "type": "number"
        // }
    };
    
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name',
              required: true
            }
          },
          {
            key: 'type',
            type: 'select',
            templateOptions: {
              label: 'Type of assessment',
              options: [
                {id:'assessment'},
                {id:'exam'},
                // {id:'selftest'},
                // {id:'poll'}
              ],
              valueProp: 'id',
              labelProp: 'id',
              required: true,
              placeholder:'Select type of assessment'
            }
          },          
          {
            key: 'description',
            type: 'textarea',
            templateOptions: {
              label: 'Description',
            }
          },
          {
            key: 'startDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'Start accessible date',
            }
          },
          {
            key: 'endDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'End accessible date',
            }
          },
          {
            key: 'publicationDate',
            type: 'datetimepicker',
            templateOptions: {
              label: 'Date Published',
            }
          },          
          {
            "type": "checkbox",
            "key": "graded",
            "templateOptions": {
              "label": "Graded"
            }
          },
          {
            key: 'maximumAttempts',
            type: 'input',
            templateOptions: {
              label: 'Maximum attempts',
              type:"number",
              min:1,
              max:20
            }
          },          
          {
            key: 'passingThreshold',
            type: 'input',
            templateOptions: {
              label: 'Passing threshold (1-100)',
              type:"number",
              min:1,
              max:100
            }
          },
          {
            key: 'publicationStatus',
            type: 'input',
            templateOptions: {
              label: 'Status',
            }
          },
          {
            key: 'publication',
            type: 'input',
            templateOptions: {
              label: 'Published Proposal id',
            }
          },          
          {
            key: 'lectureId',
            type: 'select',
            templateOptions: {
              label: 'Lecture',
              options: [],
              valueProp: 'id',
              labelProp: 'name',
              // required: true,
              placeholder:'Select Lecture'
            },
            controller: /* @ngInject */ ["$scope", "LectureService", function($scope, LectureService) {
              LectureService.setProject(vm.project);
              LectureService.get().then(function(res){
                $scope.to.options = res.data;
                // note, the line above is shorthand for:
                // $scope.options.templateOptions.options = data;
                return res.data;
              });
            }]
          },
          // {
          //   key: 'order',
          //   type: 'input',
          //   templateOptions: {
          //     label: 'Order',
          //   }
          // }
        ];    
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    vm.saveOrder = function(assessmentIds){
      return $http.post(CoreService.env.apiUrl  + '/Projects/'+vm.project.id+'/assessmentOrder/'+assessmentIds.join(','));
    };
    vm.getProposals = function(assessmentId) {
      return $http.get(CoreService.env.apiUrl  + '/Assessments/' + assessmentId+'/proposals',{params:{filter:{include:['file','systemUser']}}});
    };
    vm.acceptProposal = function(id) {
      return $http.put(CoreService.env.apiUrl  + '/AssessmentProposals/'+id,{publicationStatus:'accepted'});
    };
    vm.rejectProposal = function(id) {
      return $http.put(CoreService.env.apiUrl  + '/AssessmentProposals/'+id,{publicationStatus:'rejected'});
    };
    vm.deleteProposal = function(id) {
      return $http.delete(CoreService.env.apiUrl  + '/AssessmentProposals/'+id);
    };
    
    /* CRUD methods */
    vm.get = function(filters){
      filters = filters || {};
      filters = Object.assign({},filters,vm.filters);
      return $http.get(vm.endpoint(),{
          params: {
              filter: filters
          }
      });
    };
    vm.save = function(item){
      if(item.id) return $http.put(vm.endpoint()+'/'+item.id,item);
      else return $http.post(vm.endpoint(),item);
    };   
    vm.delete = function(item){
      return $http.delete(vm.endpoint()+'/'+item.id);
    };
      
    return vm;
  }]);

'use strict';

angular.module('com.module.projects')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.projects.view.assessments.edit', {
          url: '/:assessmentId',
          template: '<ui-view></ui-view>',
          abstract:true
        })
        .state('app.projects.view.assessments.edit.proposals', {
          url: '/proposals',
          templateUrl: 'app/modules/projects/components/project-assessments/proposals-list.html',
          controllerAs: 'ctrl',
          controller: ["$scope", "$stateParams", "AssessmentService", "CoreService", "$q", function ($scope, $stateParams, AssessmentService,CoreService,$q) {
            var vm = this;
            
            vm.assessmentId = $stateParams.assessmentId;
            vm.cdn = CoreService.env.cdnUrl;
            load();
            function load(){
              vm.promise = AssessmentService.getProposals(vm.assessmentId).then(function(res){
                vm.proposals = res.data;
              });
            }
            vm.assessmentScope = $scope.$parent.$parent.vm;
            
            vm.acceptProposal = function(id){
              vm.assessmentScope.item.publication = id;
              AssessmentService.save(vm.assessmentScope.item);
              
              var p=[];
              // reject first all the accepted proposals
              vm.proposals
                .filter(function(item){return item.publicationStatus==='accepted'})
                .forEach(function(item){
                  p.push(AssessmentService.rejectProposal(item.id));
                })
              // now accept the one
              p.push(AssessmentService.acceptProposal(id))
             
              $q.all(p).then(function(result){
                load();
              });
            }
            vm.rejectProposal = function(id){
              AssessmentService.rejectProposal(id).then(load);
              vm.assessmentScope.item.publication = vm.assessmentScope.item.publication===id?null:vm.assessmentScope.item.publication;
              AssessmentService.save(vm.assessmentScope.item);
            }
            vm.view = CoreService.viewElement;
            vm.deleteProposal = function(id){
              if(vm.assessmentScope.item.publication === id) {
                window.alert('You cant delete this because its currently the published one, please accept another one first and then delete it');
              } else {
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    AssessmentService.deleteProposal(id).then(function (res) {
                        CoreService.success('Deleted successfully',res.data);
                        load();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
              }
            }
          }]
        })
        .state('app.projects.view.assessments.edit.upload', {
          url: '/upload-proposal',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", "$stateParams", function (FileUploader, FileService,$stateParams) {
            FileService.setApi('assessments',$stateParams.assessmentId);
            this.uploader = FileService.uploader({url:'/Assessments/'+$stateParams.assessmentId+'/uploadProposal'});
            // auto-attach the handlers
            this.uploader.onBeforeUploadItem = function(item) {
              item.file.componentModel = '';
              item.url = item.url + '/uploadProposal';
            };
          }]
        })
        
    }]
  );

(function () {
    
'use strict';


        projectAssessments.$inject = ["$scope", "$uibModal", "AssessmentService", "GridHelper", "CoreService", "$state"];
angular
    .module('com.module.projects')
    .component('projectAssessments', {
        templateUrl: 'app/modules/projects/components/project-assessments/template.html',
        bindings: {
            'project': '='
        },
        controllerAs: 'vm',
        controller: projectAssessments
    });
        
        
        /* ngInject */
        function projectAssessments($scope,$uibModal, AssessmentService, GridHelper,CoreService,$state) {
            var vm = this;

            // init config
            AssessmentService.setProject(vm.project);
            vm.config={
                controllerAs:'vm'
            };
            
            /* List */
            var schema = AssessmentService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 25,
                sort: null
            };
            vm.filters = {};
            vm.loadListData = function(filters) {
                
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
              
                vm.promise = AssessmentService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data.sort(function(a,b){return a.order-b.order;}); //postProcess(res.data);
                });
            };
            
            
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.gridOptions.rowTemplate= '<div grid="grid" class="ui-grid-draggable-row" draggable="true"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader, \'custom\': true }" ui-grid-cell></div></div>'

            vm.loadListData();
            // ui-grid-draggable-rows
            vm.dragEnable = true;
            vm.gridOptions.onRegisterApi = function (gridApi) {
                
                gridApi.draggableRows.on.rowFinishDrag(null, function () {
                    vm.changeOrder(vm.gridOptions.data)
                });
                
            };
            
            /* reorder function */
            vm.changeOrder = function(assessments){
                var changed=false;
                var ids=[];
                for (var i = 0; i < assessments.length; i++) {
                    ids.push(assessments[i].id);
                    if(assessments[i].order!==i) {
                        assessments[i].order = i;
                        changed=true;
                    }
                }
                if(changed) AssessmentService.saveOrder(ids).then(CoreService.success).catch(CoreService.error);
                else CoreService.warning({},'Order not changed')
            }
            
            /* Single */
            
            vm.item = {};
            vm.formSchema = AssessmentService.getFormSchema();
            vm.closeForm = function(){
                vm.formOpen = false;            
                vm.loadListData();
            };
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item){
                console.log("Create",item);
                vm.formOpen = !vm.formOpen;
                vm.item={};
            };
            vm.editElement = function(item){
                console.log("Edit",item);
                vm.formOpen = !vm.formOpen;
                vm.item=item;
                $state.go('app.projects.view.assessments.edit.proposals',{assessmentId:item.id});
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    AssessmentService.delete(item).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.submit = function(){
                var item = vm.item;
                vm.promise = AssessmentService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        return vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            
        }
        
        
        
})();
(function () {
  'use strict';

  /*jshint sub:true*/
  /*jshint camelcase: false */

angular
    .module('com.module.organizations',[])
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.organizations', {
          abstract: true,
          url: '/organizations',
          templateUrl: 'app/modules/organizations/views/main.html',
          resolve:{
            admin:["AppAuth", "currentUser", function(AppAuth,currentUser){
                return AppAuth.isAdmin(currentUser);
            }]
          }
        })
        .state('app.organizations.list', {
          url: '',
          templateUrl: 'app/modules/organizations/views/list.html',
          controllerAs: 'ctrl',
          controller: ["OrganizationService", function (OrganizationService) {
            var vm = this;
            vm.loading = OrganizationService.get().then(function(data){
                // console.log("Organizations list: ",data);
                vm.organizations = data.sort(function(a,b){
                  return a.name>b.name?1:-1;
                });
            });
            vm.organizationFilter = '';
          }]
        })
        .state('app.organizations.add', {
          url: '/add',
          templateUrl: 'app/modules/organizations/views/form.html',
          controllerAs: 'ctrl',
          controller: ["$state", "OrganizationService", "organization", function ($state, OrganizationService, organization) {
            var vm = this;

            vm.organization = organization;
            vm.formFields = OrganizationService.getFormSchema();
            vm.formOptions = {};
            vm.submit = function () {
              OrganizationService.save(vm.organization).then(function () {
                $state.go('^.list');
              });
            };
          }],
          resolve: {
            organization: function () {
              return {};
            }
          }
        })
        .state('app.organizations.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/organizations/views/form.html',
          controllerAs: 'ctrl',
          controller: ["$state", "OrganizationService", "organization", "BillingService", "LTIservice", "CloudConfigService", "CoreService", function ($state, OrganizationService, organization, BillingService, LTIservice, CloudConfigService, CoreService) {
            var vm = this;
            vm.organization = organization;
            vm.organization.allowedEmails = vm.organization.allowedEmails||[];
            vm.lti_enabled = vm.organization.lti;
            vm.isProd = window.ENV==='production';
            vm.ltiDomain = vm.isProd?'lti':'lti-test';
            vm.formFields = OrganizationService.getFormSchema();
            vm.formOptions = {};
            vm.submit = function () {
              OrganizationService.save(vm.organization)
              .then(function () {
                var p = [];
                if(vm.organizationBilling) {
                  p.push(vm.updateBilling())
                }
                if(vm.organization.lti) {
                  vm.LTI_config.name = vm.organization.name;
                  p.push(OrganizationService.updateLTIconfig(organization.id,vm.LTI_config));
                }
                if(vm.CloudConfig_config.domain) {
                  vm.CloudConfig_config.name = vm.organization.name;
                  p.push(OrganizationService.updateCloudConfig(organization.id,vm.CloudConfig_config));
                }
                return Promise.all(p)
              })
              .then(function(res){
                $state.go('^.list');
              })
              .catch(function(err){
                CoreService.error(err)
              })
            };
            
            /* Billing details => Create/update Stripe customer */
            if(organization.billing) {
              vm.organizationBilling = Object.assign({},organization.billing);
              vm.enableBilling = true;
              delete organization.billing;
            }              
            
            vm.billingformFields = BillingService.getFormSchema();
            vm.billingformOptions = {};
            vm.updateBilling = function() {
              // update vat type
              vm.organizationBilling.vatType = BillingService.getVATtype(vm.organizationBilling.country);
              return OrganizationService.updateBilling(vm.organization.id,vm.organizationBilling)
            }
            
            
            // Handle LTI Configuration
            vm.LTI_formFields = LTIservice.getFormSchema();
            vm.LTI_formOptions = {};
            // auto load lti config
            OrganizationService.getLTIconfig(organization.id).then(function(config){
              vm.LTI_config = config;
            });
            
            // Handle CloudConfig Configuration
            vm.CloudConfig_formFields = CloudConfigService.getFormSchema(vm.organization.id);
            vm.CloudConfig_formOptions = {};
            // auto load lti config
            OrganizationService.getCloudConfig(organization.id).then(function(config){
              config.webhook_config = config.webhook_config || '{"enrollment":null, "module_group": null, "module": null}';
              config.email_config = config.email_config || '{"template":null, "invitation":{"text":null, "btn_text":null, "btn_link": null}, "forgot_password": null, "login_link": null}';
              vm.CloudConfig_config = config;
            });
            
            
          
          }],
          resolve: {
            organization: ["$stateParams", "OrganizationService", function ($stateParams, OrganizationService) {
              return OrganizationService.getById($stateParams.id);
            }]
          }
        })
        .state('app.organizations.view', {
          url: '/:id',
          abstract:true,
          templateUrl: 'app/modules/organizations/views/view.html',
          controllerAs: 'ctrl',
          controller: ["$timeout", "$state", "organization", function ($timeout,$state,organization) {
            var vm = this;
            vm.organization = organization;            
            vm.activeTab = null;
            vm.tabs=[{
              state:'.users',
              label:'Users'
            },{
              state:'.reports.list',
              label:'Report Templates'
            },{
              state:'.files.list',
              label:'Files'
            }];
          }],
          resolve: {
            organization: ["$stateParams", "OrganizationService", function ($stateParams, OrganizationService) {
              return OrganizationService.getById($stateParams.id);
            }]
          }
        })      
        
        .state('app.organizations.view.users', {
          url: '/users',
          template: '<organization-users organization="ctrl.organization"></organization-users>'
        })
        
        .state('app.organizations.view.files', {
          abstract: true,
          url: '/files',
          templateUrl: 'app/modules/files/views/main.html',
          controller:["$scope", function($scope){
            $scope.projectFiles = true;
          }]
        })
        .state('app.organizations.view.files.list', {
          url: '',
          templateUrl: 'app/modules/files/views/list.html',
          controllerAs: 'ctrl',
          controller: 'FilesListController'
        })
        .state('app.organizations.view.files.upload', {
          url: '/upload',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", "$stateParams", function (FileUploader, FileService,$stateParams) {
            this.defaultComponentModel = 'other';
            FileService.setApi('organizations',$stateParams.id);
            this.uploader = FileService.uploader({url:'/Organizations/'+$stateParams.id});
            // auto-attach the handlers
            this.uploader.onBeforeUploadItem = function(item) {
              item.headers['x-upload-filename'] = item.file.name;
              item.url = item.url + '/' + item.file.componentModel + '/uploadFile';
            };
          }]
        })
        .state('app.organizations.view.reports', {
          abstract: true,
          url: '/reports',
          templateUrl: 'app/modules/files/views/main.html',
          controller:["$scope", function($scope){
            $scope.projectFiles = true;
          }]
        })
        .state('app.organizations.view.reports.list', {
          url: '',
          templateUrl: 'app/modules/files/views/list.html',
          controllerAs: 'ctrl',
          controller: ["$uibModal", "FileService", "GridHelper", "CoreService", "$state", function($uibModal, FileService, GridHelper, CoreService, $state) {
            var vm = this;

            vm.cdnUrl = CoreService.env.cdnUrl;
            vm.id = $state.params.id;
            var FilesApiType = $state.current.name.split('.')[1];

            FileService.setApi(FilesApiType, vm.id);

            vm.config = {
              controllerAs: 'ctrl',
              // disable edit
              actionColumns: {
                editElement: {
                  disabled: true
                }
              }
            };

            /* List */
            var schema = FileService.gridSchema;
            vm.filters = { limit: 15, skip: 0, where: {componentModel: 'ReportTemplate'} };
            vm.pagination = {
              pageNumber: 1,
              pageSize: 15,
              sort: null
            };
            vm.loadListData = function(filters) {
              filters = filters || vm.filters;
              console.log("Req Filter", filters);
              vm.loading = FileService.get(filters).then(function(res) {
                var headers = res.headers();
                vm.gridOptions.totalItems = Number(headers['x-total-count']);
                vm.gridOptions.data = res.data; //postProcess(res.data);
              });
            };
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters, vm.config);
            vm.loadListData();

            vm.deleteElement = function(elem) {
              FileService.delete(elem.id,
                function() {
                  vm.loadListData();
                },
                function() {

                });
            };
            vm.viewElement = CoreService.viewElement;

          }]

        })
        .state('app.organizations.view.reports.upload', {
          url: '/upload',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", "$stateParams", function (FileUploader, FileService,$stateParams) {
            FileService.setApi('organizations',$stateParams.id);
            var vm = this;
            vm.defaultComponentModel = 'ReportTemplate';
            vm.uploader = FileService.uploader({url:'/Organizations/'+$stateParams.id});
            // auto-attach the handlers
            vm.uploader.onBeforeUploadItem = function(item) {
              item.headers['x-upload-filename'] = item.file.name;
              item.url = item.url + '/' + item.file.componentModel + '/uploadFile';
            };
          }]
        })
        .state('app.organizations.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$state", "CoreService", "OrganizationService", "organization", function ($state, CoreService,OrganizationService, organization) {
            CoreService.confirm('Are you sure?','Deleting this cannot be undone',
              function () {
                //   confirm
                OrganizationService.delete(organization).then(function () {
                    CoreService.success('Deleted successfully',(organization.name||organization.id)+' deleted!');
                    $state.go('^.list');
                }).catch(CoreService.error);
              },
              function () {
                //   cancel
              }
            );
          }],
          resolve: {
            organization: ["$stateParams", "OrganizationService", function ($stateParams, OrganizationService) {
              return OrganizationService.getById($stateParams.id);
            }]
          }
        });
    }]
  )

   
    
})();
'use strict';

angular.module('com.module.organizations')
  .service('OrganizationUsers', ["CoreService", "CONFIG", "$http", "SchemaMaker", "ProjectUsers", "$q", function(CoreService,CONFIG,$http,SchemaMaker,ProjectUsers,$q) {
    var vm = this;
    vm.organization = {};
    vm.setOrganization = function(organization){vm.organization = organization;};
    vm.filters = {};
    
    // basic endpoint
    vm.endpoint = function(){ 
        return CoreService.env.apiUrl 
                +'/Organizations/'+vm.organization.id+'/systemUsers';
    };
    // basic schema
    vm.schema = {
      "firstName": {
          "type": "string"
      },
      "lastName": {
          "type": "string"
      },
      "email": {
          "type": "string"
      }
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    
    vm.searchUsers = function(filters){
      return $http.get(CoreService.env.apiUrl+'/SystemUsers',{
        cache:true,
        params: {
            filter: filters
        }
      });
    }
    
    /* CRUD methods */
    vm.get = function(filters){
        filters = filters || {};
        filters = Object.assign({},filters,vm.filters)
        return $http.get(vm.endpoint(),{
            params: {
                filter: filters
            }
        });
    }
    
    vm.editElement = function(elem){ vm.formOpen =!vm.formOpen; }
    vm.link = function(userId){ return $http.put(vm.endpoint()+'/rel/'+userId); }   
    
    vm.unlink = function(userId,organizationId){ 
      organizationId = organizationId || vm.organization.id;
      return $http.delete(CoreService.env.apiUrl+'/Organizations/'+organizationId+'/systemUsers/rel/'+userId)
      
        // remove him from projects too
        // .then(function(){
        //   return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+userId+'/projects',{where:{organizationId:organizationId}});
        // })
        // .then(function(res){
        //   var projects = res.data;
        //   var p=[];
        //   if(projects.length>0) {
        //     projects.forEach(function(project){
        //         p.push(ProjectUsers.load(userId,project.id).then(function(data){
        //           var p=[];
        //           data.forEach(function(a){
        //             p.push(ProjectUsers.delete(a));  
        //           });
        //           return $q.all(p);
        //         }));
        //     });
        //   }
        //   return $q.all(p);
          
        // })
      
      // .then(CoreService.success)
      // .catch(CoreService.error);
    }
    
        
    return vm;

  }]);

'use strict';

angular.module('com.module.organizations')
  .component('organizationUsers', {
      templateUrl: 'app/modules/organizations/components/organization-users/template.html',
      restrict: 'E',
      bindings:{
        'organization': '<'
      },
        controllerAs: 'vm',
        controller: ["$uibModal", "OrganizationUsers", "GridHelper", "CoreService", function($uibModal, OrganizationUsers, GridHelper,CoreService) {
            var vm = this;

            // init config
            OrganizationUsers.setOrganization(vm.organization);
            vm.config={
                controllerAs:'vm'        ,        
                // disable edit
                actionColumns :{ 
                    editElement:{
                        disabled:true
                    }
                }
            };
            vm.closeForm = function(){
                // vm.formOpen = false;            
                vm.loadListData();
            };
            
            /* List */
            var schema = OrganizationUsers.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 15,
                sort: null
            };
            vm.filters = {skip:0,limit:vm.pagination.pageSize};
            vm.loadListData = function(filters) {
                
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // when you search make sure you dont skip records
                if (filters.where && Object.keys(filters.where).length > 0) {
                    vm.pagination.pageNumber = 1;
                    filters.skip = 0;
                }
              
                vm.promise = OrganizationUsers.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data; //postProcess(res.data);
                });
                return vm.promise;
            };            
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.loadListData();

            /* Single */
            
            vm.searchUsers = function(search){
              if(search.length<1) return;
              var searchRegexp = new RegExp(search,'i').toString()
              var filters = {
                limit:20,
                where: 
                // {email:{regexp:searchRegexp}}
                {
                  or: [{
                    email:{regexp:searchRegexp}
                  },{
                    firstName:{regexp:searchRegexp}
                  },{
                    lastName:{regexp:searchRegexp}
                  }]
                }
              };
              
              vm.searchLoader = OrganizationUsers.searchUsers(filters).then(function(res) {
                  vm.searchLoader = false;
                  // console.log(res);
                  vm.availableUsers = res.data; //postProcess(res.data);
              });
            }

            vm.item = {};
            vm.viewElement = CoreService.viewElement;
            vm.createElement = function(item){
                console.log("Create",item);
                OrganizationUsers.link(item.id).then(function(){CoreService.success('Success'); vm.loadListData();}).catch(CoreService.error);
                vm.selected=null;  
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    OrganizationUsers.unlink(item.id).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.submit = function(){
                var item = vm.item;
                vm.promise = OrganizationUsers.link(item.id)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        // vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            /* Bulk import */
            vm.gridOptionsImport = {};
            
            
        }]

  });

(function () {
  'use strict';
  /**
   * @ngdoc overview
   * @name com.module.core
   * @module
   * @description
   * @requires loopbackApp
   *
   * The `com.module.core` module provides services for interacting with
   * the models exposed by the LoopBack server via the REST API.
   *
   */
  angular.module('com.module.core', ['gettext']);

})();

(function () {
  'use strict';
  
  angular
    .module('com.module.core')
    .directive('relationViewer',["$uibModal", function($uibModal) {
      return {
        templateUrl: 'app/modules/core/directives/relation-viewer/ui-grid.cell.template.html',
        scope: {
          entity: '<',
          model: '@',
          field: '@'
        },
        link:function(scope,elem,attrs){
          var vm = scope;
          init();
          function process(name){return name.substring(name.lastIndexOf('/')+1); }
          function init(){
            var rel = vm.entity[vm.model];
            vm.items = rel?(rel instanceof Array?rel:[rel]):[];
            vm.simpleList = vm.items.map(function(i) { return i.hasOwnProperty(vm.field)?process(i[vm.field]):'Entity not exists'; }).join(',');
          }
          vm.showDetails = function(){
            vm.modal = $uibModal.open({
              templateUrl: 'app/modules/core/directives/relation-viewer/modal.template.html',
              size: 'md',
              scope:vm
            });
          }
          
          // setup watcher
          scope.$watch('entity.id', function(value) {init()});
          
        }
      }
    }]);  
    
    // angular
    // .module('com.module.core')
    // .component('relationViewer', {
    //     templateUrl: 'app/modules/core/directives/relation-viewer/ui-grid.cell.template.html',
    //     controllerAs:'vm',
    //     bindings: {
    //       entity: '<',
    //       model: '@',
    //       field: '@'
    //     },
    //     controller:function($uibModal){
    //       var vm = this;
    //       vm.$onChanges = init;
    //       function process(name){return name.substring(name.lastIndexOf('/')+1); }
    //       function init(){
    //         var rel = vm.entity[vm.model];
    //         vm.items = rel instanceof Array?rel:[rel];
    //         vm.simpleList = vm.items.map(function(i) { return process(i[vm.field]); }).join(',');
    //         console.log(vm.simpleList);
    //       }
    //       vm.showDetails = function(){
    //         vm.modal = $uibModal.open({
    //           templateUrl: 'app/modules/core/directives/relation-viewer/modal.template.html',
    //           size: 'md',
    //           scope:vm
    //         });
    //       }
          
    //     }
    // });

})();

(function () {
  'use strict';
  
  angular
    .module('com.module.core')
    .directive('objectViewer', ["CoreService", "LoopBackAuth", function (CoreService,LoopBackAuth) {
      return {
        restrict: 'E',
        templateUrl:'app/modules/core/directives/object-viewer/template.html',
        scope: {
          item: '<'
        },
        controller:["$scope", function($scope){
          var vm = $scope;
          vm.props = Object.keys(vm.item);
          vm.isJSON = function(val){ return !!(val instanceof Object);}
        }]
      };
    }]);

})();

(function () {
  'use strict';
  
  angular
    .module('com.module.core')
    .directive('fileDownloader', ["CoreService", "LoopBackAuth", function (CoreService,LoopBackAuth) {
      return {
        restrict: 'E',
        templateUrl:'app/modules/core/directives/file-downloader/template.html',
        scope: {
          file: '<'
        },
        controller:["$scope", function($scope){
          $scope.$watch('file.id',function(n){          
            $scope.url=CoreService.env.apiUrl+'/Files/'+n+'/download?access_token='+LoopBackAuth.accessTokenId
          })
        }]
      };
    }]);

})();

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:adminBox
   * @description
   * # adminBox
   */
  angular
    .module('com.module.core')
    .component('controlButtons', {
        templateUrl: 'app/modules/core/directives/control-buttons/template.html',
        bindings:{
          elementId:'@'
        }
    });

})();

(function() {
    'use strict';
    angular
        .module('com.module.core')
        .run(["formlyConfig", function(formlyConfig) {
            var ngModelAttrs = {};

            var attributes = [
                'ng-model',
                'min-date',
                'max-date',
                'date-disabled',
                'day-format',
                'month-format',
                'year-format',
                'year-range',
                'day-header-format',
                'day-title-format',
                'month-title-format',
                'date-format',
                'date-options',
                'hour-step',
                'minute-step',
                'show-meridian',
                'meridians',
                'readonly-time',
                'readonly-date',
                'hidden-time',
                'hidden-date',
                'mousewheel',
                'show-spinners',
                'current-text',
                'clear-text',
                'close-text'
            ];

            var bindings = [
                'ng-model',
                'min-date',
                'max-date',
                'date-disabled',
                'day-format',
                'month-format',
                'year-format',
                'year-range',
                'day-header-format',
                'day-title-format',
                'month-title-format',
                'date-format',
                'date-options',
                'hour-step',
                'minute-step',
                'show-meridian',
                'readonly-time',
                'readonly-date',
                'hidden-time',
                'hidden-date'
            ];

            angular.forEach(attributes, function(attr) {
                ngModelAttrs[camelize(attr)] = {
                    attribute: attr
                };
            });

            angular.forEach(bindings, function(binding) {
                ngModelAttrs[camelize(binding)] = {
                    bound: binding
                };
            });

            function camelize(string) {
                string = string.replace(/[\-_\s]+(.)?/g,

                    function(match, chr) {
                        return chr ? chr.toUpperCase() : '';
                    });
                // Ensure 1st char is always lowercase
                return string.replace(/^([A-Z])/, function(match, chr) {
                    return chr ? chr.toLowerCase() : '';
                });
            }

            formlyConfig.setType({
                name: 'custom',
                template: '<div id="jsoneditor" style="width: 100%; height: 400px;"></div>'
            });

            formlyConfig.setType({
                name: 'datetimepicker',
                template: '<br><datetimepicker ng-model="model[options.key]" show-spinners="true" date-format="M/d/yyyy" date-options="dateOptions"></datetimepicker>',
                wrapper: ['bootstrapLabel'],
                defaultOptions: {
                    ngModelAttrs: ngModelAttrs,
                    templateOptions: {
                        label: 'Time',
                        minDate: '04/01/2016'
                    }
                }
            });

            formlyConfig.setType({
                name: 'timepicker',
                template: '<uib-timepicker show-meridian="false" ng-model="model[options.key]"></uib-timepicker>',
                wrapper: [
                    'bootstrapLabel',
                    'bootstrapHasError'
                ],
                defaultOptions: {
                    ngModelAttrs: ngModelAttrs,
                    templateOptions: {
                        timepickerOptions: {}
                    }
                }
            });

            formlyConfig.setType({
                name: 'datepicker',
                templateUrl: 'app/modules/core/config/formly/datepicker.html',
                wrapper: [
                    'bootstrapLabel',
                    'bootstrapHasError'
                ],
                defaultOptions: {
                    ngModelAttrs: ngModelAttrs,
                    templateOptions: {
                        datepickerOptions: {}
                    }
                }
            });


            formlyConfig.setType({
                name: 'multiInput',
                templateUrl: 'app/modules/core/config/formly/multiInputTemplate.html',
                defaultOptions: {
                    noFormControl: true,
                    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
                    templateOptions: {
                        inputOptions: {
                            wrapper: null
                        }
                    }
                },
                controller: /* @ngInject */ ["$scope", function($scope) {
                    $scope.copyItemOptions = copyItemOptions;

                    function copyItemOptions() {
                        return angular.copy($scope.to.inputOptions);
                    }
                }]
            });


            var unique = 1;
            formlyConfig.setType({
                name: 'repeatSection',
                templateUrl: 'app/modules/core/config/formly/repeatSectionTemplate.html',
                controller: function($scope) {
                    $scope.formOptions = { formState: $scope.formState };
                    $scope.addNew = addNew;

                    $scope.copyFields = copyFields;


                    function copyFields(fields) {
                        fields = angular.copy(fields);
                        addRandomIds(fields);
                        return fields;
                    }

                    function addNew() {
                        $scope.model[$scope.options.key] = $scope.model[$scope.options.key] || [];
                        var repeatsection = $scope.model[$scope.options.key];
                        var lastSection = repeatsection[repeatsection.length - 1];
                        var newsection = {};
                        if (lastSection) {
                            newsection = angular.copy(lastSection);
                        }
                        repeatsection.push(newsection);
                    }

                    function addRandomIds(fields) {
                        unique++;
                        angular.forEach(fields, function(field, index) {
                            if (field.fieldGroup) {
                                addRandomIds(field.fieldGroup);
                                return; // fieldGroups don't need an ID
                            }

                            if (field.templateOptions && field.templateOptions.fields) {
                                addRandomIds(field.templateOptions.fields);
                            }

                            field.id = field.id || (field.key + '_' + index + '_' + unique + getRandomInt(0, 9999));
                        });
                    }

                    function getRandomInt(min, max) {
                        return Math.floor(Math.random() * (max - min)) + min;
                    }
                }
            });



        }])

})();
(function () {
  'use strict';
  angular.module('com.module.users', ['com.module.authproviders']);

})();

'use strict';

angular.module('com.module.users')
  .service('UService', ["$q", "$http", "CONFIG", "CoreService", "SchemaMaker", "Validators", "OrganizationUsers", function($q,$http,CONFIG,CoreService,SchemaMaker,Validators,OrganizationUsers) {
    var vm = this;
    vm.filters = {};
    // basic endpoint
    vm.endpoint = function(){  return CoreService.env.apiUrl+'/SystemUsers';};
    
    // basic schema
    vm.schema = {
        "firstName": {
            "type": "string"
        },
        "lastName": {
            "type": "string"
        },
        "email": {
            "type": "string"
        },
        "emailVerified": {
            "type": "boolean"
        },
        "systemRoles.name": {
            "type": "relation"
        }
    };
    
    // create schema for angular-formly
    var originalEmailValue;
    vm.getFormSchema = function () {
        return [
          {
            key: 'firstName',
            type: 'input',
            templateOptions: {
              label: 'First Name'
            }
          },
          {
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: 'Last Name'
            }
          },
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: 'Email',
              required:true
            },
            expressionProperties: {
              // 'templateOptions.disabled':'model.id'
            },
            asyncValidators: {
              emailValid: {
                expression: function($viewValue, $modelValue, scope) {
                  var p = $q.defer();
                  console.log($viewValue,$modelValue,scope.fc);
                  if(!originalEmailValue && scope.fc.$viewValue===scope.fc.$modelValue) {
                    originalEmailValue = scope.fc.$modelValue;
                  } else if(scope.fc.$viewValue===originalEmailValue) {
                    p.resolve(true);
                  } else if (Validators.email($viewValue)) {
                    scope.formOptions.loading = true;
                    vm.emailValid($viewValue).then(function(res) {
                      scope.formOptions.loading = false;
                      if (res.data.exists) {
                        p.reject('exist');
                        CoreService.toastWarning('Validation error', 'Email already exists!');
                      }
                      else {
                        p.resolve(true);
                        CoreService.toastSuccess('Valid Email');
                      }
                    });
                  }
                  else {
                    p.reject('Not Valid');
                  }

                  return p.promise;
                }
              }
            },
            modelOptions: {
              allowInvalid: false, updateOn: 'default', debounce: 500
            }
          },
          {
            key: 'emailVerified',
            type: 'checkbox',
            templateOptions: {
              label: 'Verified',
            }
          }
        ];    
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    
    /* CRUD methods */
    vm.get = function(filters){
        filters = filters || {};
        filters = Object.assign({},filters,vm.filters)
        return $http.get(vm.endpoint(),{
            params: {
                filter: filters
            }
        });
    }
    vm.save = function(item){
      if(item.id) return $http.post(vm.endpoint()+'/'+item.id + '/updateProfile',{
        id: item.id,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        emailVerified: item.emailVerified
      });
      else return $http.post(vm.endpoint()+'/invite',item);
    } 
    vm.deleteBulk = function(ids){
      return $http.post(CoreService.env.apiUrl+'/SystemUsers/deleteBulk',ids);
    }
    vm.delete = function(item){
      return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+item.id+'/organizations')
        // remove him from organizations too
        // .then(function(res){
        //   var orgs = res.data;
        //   var p=[];
        //   if(orgs.length>0) {
        //     orgs.forEach(function(org){
        //       p.push(OrganizationUsers.unlink(item.id,org.id));  
        //     });
        //   }
        //   return $q.all(p);
          
        // })
        .then(function(){
          return $http.delete(vm.endpoint()+'/'+item.id);
        })
    }
    
    /* User seats management */
    vm.getUserSeats = function(userId){
      return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+userId+'/account').then(function(res){
        return res.data;
      }).catch(function(err){
        if(err.status===404){
          return {
            systemuserId:userId,
            seats:0
          }
        }
      });
    }
    vm.updateUserSeats = function(userId,seats){
      return $http.post(CoreService.env.apiUrl+'/SystemUsers/updateSeatsForUser/'+userId,{seats:seats});
    }
    
    
    /* Extra Methods */
    vm.emailValid = function(email){
      return $http.get(vm.endpoint()+'/emailExists/'+email,{cache:true});
    }
      
    vm.userSessions = function(userId){
      return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+userId+'/userSessions');
    }
    
    vm.createTempSession = function(userId){
      return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+userId+'/createTempSession');
    }
    
      
    return vm;
  }]);

(function () {
  'use strict';

  /*jshint sub:true*/
  /*jshint camelcase: false */

angular
    .module('com.module.users')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.users', {
          url: '/users',
          resolve:{
            admin:["AppAuth", "currentUser", function(AppAuth,currentUser){
                return AppAuth.isAdmin(currentUser);
            }]
          },
          template: '<section admin-header class="content-header" title="Users" sub-title="Manage your users here!"></section><section class="content"><users></users></section>'
        })
    }])
    .component('users', {
        templateUrl: 'app/modules/users/users-component/template.html',
        bindings: {
        },
        controllerAs: 'vm',
        controller: ["$uibModal", "UService", "SchemaMaker", "GridHelper", "CoreService", "AuthProvidersService", "AuthProviderConnectionsService", "CONFIG", "UserService", "$state", "$timeout", "SystemUser", "LoopBackAuth", function($uibModal, UService, SchemaMaker, GridHelper,CoreService,AuthProvidersService,AuthProviderConnectionsService,CONFIG,UserService,$state,$timeout,SystemUser, LoopBackAuth) {
            var vm = this;
            
            vm.availableAuthProviders = [];
            AuthProvidersService.find().then(function(res) { 
                vm.availableAuthProviders = res.data;
            });
            

            // init config
            vm.config={
                controllerAs:'vm'
            };
            vm.closeForm = function(){
                vm.formOpen=!vm.formOpen;
                $state.reload();
            };
            
            /* List */
            var schema = UService.gridSchema;
            vm.pagination = {
                pageNumber: 1,
                pageSize: 15,
                sort: null
            };
            vm.filters = {skip:0,limit:vm.pagination.pageSize};
            vm.loadListData = function(filters) {
                filters = filters || vm.filters;
                // console.log("Req Filter", filters);
                // when you search make sure you dont skip records
                // if (filters.where && Object.keys(filters.where).length > 0) {
                //     vm.pagination.pageNumber = 1;
                //     filters.skip = 0;
                // }
              
                vm.promise = UService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data; //postProcess(res.data);
                });
                return vm.promise;
            };
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.loadListData();
            
            vm.deleteAll = function() {
                if (vm.filters.where) {
                    CoreService.confirm('Are you sure?', 'Deleting ' + vm.gridOptions.totalItems + ' users!',
                        function(success) {
                            UService.get({ where: vm.filters.where })
                                .then(function(res) {
                                    return res.data.map(function(u) { return u.id });
                                })
                                .then(function(ids) {
                                    // console.log(ids);
                                    // return { data: { count: ids.length } };
                                    return UService.deleteBulk(ids);
                                })
                                .then(function(res) {
                                    CoreService.toastSuccess(res.data.count + ' users deleted!');
                                    vm.loadListData();
                                })
                                .catch(function(err) {
                                    console.error(err);
                                    CoreService.toastError(err.error.message);
                                });
                        },
                        function(cancel) {}
                    );
                }
            };

            /* Single */
            
            vm.item = {};
            vm.formSchema = UService.getFormSchema();
            vm.viewElement = CoreService.viewElement;
            vm.env = CoreService.env;
            
            window.tempSessions = window.tempSessions || {};
            vm.createSessionUrl = function(token){
                return vm.env.apiUrl + '/SystemUsers/'+ vm.item.id +'/setTempSession?access_token=' + token;
            };
            vm.createTempSession = function(){
                UService.createTempSession(vm.item.id)
                    .then(function(res){
                        vm.session = {
                            url : vm.createSessionUrl(res.data.id),
                            token:res.data.id,
                            ttl: res.data.ttl/3600
                        };
                        window.tempSessions[vm.item.id] = Object.assign({},vm.session);
                        getSessions();
                    });
            }
            vm.createElement = function(item){
                // CoreService.alertInfo("Cannot create User from here", "Users should only be invited to projects.");
                // console.log("Create",item);
                // vm.formOpen = !vm.formOpen;
                // vm.item={};
            };
            vm.resetPassword = function(email){
                SystemUser.resetPassword({email:email}).$promise.then(function(result){
                    CoreService.toastSuccess('Password reset requested!','Please check your email: '+email);
                }).catch(CoreService.error);
            };
            vm.getUpdatePasswordUrl = function(userId){
                var root = CoreService.env.apiUrl;
                var token = LoopBackAuth.accessTokenId;
                var url = root+'/SystemUsers/'+vm.item.id+'/getUpdatePasswordUrl?access_token='+token;
                return url;                
            };
            function getSessions(){
               vm.currentSessions = [];
               UService.userSessions(vm.item.id).then(function(res) {
                   console.log("Current session tokens:", res.data);
                   vm.currentSessions = res.data;
                   vm.session = window.tempSessions[vm.item.id];
               });
            }
            function getSSOData(){
                vm.currentSSOConnections = [];
                AuthProviderConnectionsService.getUserConnections(vm.item.id).then(function(res) {
                    vm.currentSSOConnections = res;
                });
            }
            vm.editElement = function(item){
                vm.currentUserSeats = 0;
                console.log("Edit",item);
                vm.formOpen = !vm.formOpen;
                vm.item=item;
                vm.item.roles = item.systemRoles.map(function(r){return Object.assign({},r,vm.getRole(r.name));});
                getSessions();
                getSSOData();
                if(vm.hasRole('creouser')) {
                    UService.getUserSeats(vm.item.id).then(function(account){
                        vm.currentUserSeats = account.seats;
                    });
                }
            };
            vm.deleteElement = function(item){
                console.log("Delete",item);     
                CoreService.confirm('Are you sure?','Deleting this cannot be undone',
                  function () {
                    //   confirm
                    vm.promise = UService.delete(item).then(function () {
                        CoreService.success('Deleted successfully',(item.name||item.id)+' deleted!');
                        vm.loadListData();
                    }).catch(CoreService.error);
                  },
                  function () {
                    //   cancel
                  }
                );
            };
            vm.updateUserSeats = function(seats) {
                var userId = vm.item.id;
                if(!vm.hasRole('creouser')) return;
                if (!seats || seats < 0) return CoreService.error({data:{error:{
                    status:400,
                    name:"Invalid Seats",
                    message:"Seats must be greater than 0"
                }}});
                console.log("vm.currentUserSeats",seats);
                return UService.updateUserSeats(userId, seats)
                    .then(function(res) {
                        CoreService.success('Seats saved successfully');
                    }).catch(CoreService.error);

            }
            vm.submit = function(){
                var item = vm.item;
                vm.updateUserSeats(vm.currentUserSeats);
                vm.promise = UService.save(item)
                    .then(function(res){
                        CoreService.success('Saved successfully',res.data.id);
                        vm.formOpen = !vm.formOpen;
                        vm.item=null;
                        vm.loadListData();
                    }).catch(CoreService.error);
            };
            
            /* Special Roles Methods */
            vm.hasRole = function(role){
                if(!vm.item.id) return;
                return vm.item.roles.filter(function(r){
                    return role===r.value;
                }).length>0
            }
            vm.systemRoles = CONFIG.SystemRoles;
            vm.getRole = function(role){
                return vm.systemRoles.filter(function(r){
                    return (r.value===role||r.id===role);
                })[0];
            };
            vm.deleteRole = function(user,role){
              vm.promise = UserService.deleteSystemRole(user,role).then(function(){
                user.roles = user.roles.filter(function(r){ return r.id!==role.id; });
              });
            };
            vm.insertRole = function(user,role){
              var exist=user.roles.map(function(role){return role.name}).indexOf(role.value)>=0;
              if(!exist) vm.promise = UserService.insertSystemRole(user,role).then(function(){
                vm.item.roles.push(role);
              });
            };
            
            /* Special SSO Auth Provider methods */
            vm.addAuthProviderConnection = function(c) {
                var found;
                vm.currentSSOConnections.forEach(function(p){
                    if(c.label===p.label) {
                        found = true;
                    }
                })
                if(found) {
                    CoreService.toastWarning(c.label+' already enabled!','This SSO provider is already enabled for this user!');
                    return;
                }
                AuthProviderConnectionsService.addUserConnection(vm.item.id,vm.item.email,c.id).then(function(){
                    getSSOData();
                })
            }
            vm.deleteAuthProviderConnection = function(c) {
                AuthProviderConnectionsService.deleteUserConnection(vm.item.id,c.id,function(){
                    getSSOData();
                })
            }
            
            
        }]

    });
    
    
})();
(function () {
  'use strict';

  /*jshint sub:true*/
  /*jshint camelcase: false */

angular
    .module('com.module.users')
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state('app.userProfile', {
                url: '/profile',
                templateUrl: 'app/modules/users/user-profile/template.html',
                controllerAs: 'ctrl',
                controller: ["data", "UserService", "SystemUser", "CoreService", function(data,UserService,SystemUser,CoreService) {
                    this.user = data.user;
                    this.formFields = UserService.getFormFields('edit');
                    this.formOptions = {};
                    this.submit = function() {
                        UserService.upsert(this.user).then(function() {window.location.reload()});
                    };
                    this.resetPassword = function(email){
                        SystemUser.resetPassword({email:email}).$promise.then(function(result){
                            CoreService.toastSuccess('Password reset requested!','Please check your email: '+email);
                        }).catch(CoreService.error)
                    }
                    
                }],
                resolve: {
                    'data': ["SystemUser", function(SystemUser) {
                        return SystemUser.currentUser().$promise;
                    }]
                }
            });
    }]);
    
})();
(function () {
  'use strict';
  angular
    .module('com.module.users')
    .service('UserService', ["$state", "CoreService", "SystemUser", "gettextCatalog", "SystemAccess", function ($state, CoreService, SystemUser, gettextCatalog, SystemAccess) {
      
      var SystemAccessFilter = {"filter": {"include":["role","systemUser"]}}
      this.find = function (all) {
        if(all) return SystemUser.find().$promise;
        else return SystemAccess.find(SystemAccessFilter).$promise.then(function(res){
          var users = res.reduce(function(acc,cur){
            // transform to user
            var id = cur.principalId;
            if(acc[id]) {
              acc[id].roles.push(cur.role)              
            } else {
              acc[id] = Object.assign({},cur.systemUser,{roles:[cur.role]})
            }
            return acc;
          },{});
          var usersArray=[];
          for (var key in users){
            usersArray.push(users[key]);
          }
          return usersArray;
        });
      };

      this.findById = function (id) {
        return SystemUser.findById({
          id: id,
          filter:{include:"systemRoles"}
        }).$promise.then(function(res){
          res.roles = res.systemRoles;
          delete res.systemRoles;
          return res;
        });
      };
      this.deleteSystemRole = function(user,role) {
          return SystemAccess.findOne({filter:{where:{
            roleId:role.id,
            principalType:'USER',
            principalId:user.id
          }}}).$promise
          .then(function(res){
            return SystemAccess.destroyById({id:res.id}).$promise
          })
          .then(CoreService.success)
          .catch(CoreService.error);
      };
      this.insertSystemRole = function(user,role){
        return SystemAccess.create({
          principalId:user.id,
          principalType:'USER',
          roleId:role.id
        }).$promise
          .then(CoreService.success)
          .catch(CoreService.error);
      }

      this.upsert = function (user) {
        return SystemUser.upsert(user).$promise
          .then(function () {
            CoreService.toastSuccess(
              gettextCatalog.getString('SystemUser saved'),
              gettextCatalog.getString('Your user is safe with us!')
            );
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving user '),
              gettextCatalog.getString('This user could no be saved: ' + err)
            );
          }
        );
      };

      this.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            SystemUser.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('SystemUser deleted'),
                gettextCatalog.getString('Your user is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting user'),
                gettextCatalog.getString('Your user is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };


      this.getFormFields = function (formType) {
        var form = [
          {
            key: 'email',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('Email'),
              required: true
            },
            expressionProperties: {
              'templateOptions.disabled':'model.id'
            }
          },
          {
            key: 'firstName',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('First name'),
              required: true
            }
          },
          {
            key: 'lastName',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('Last name'),
              required: true
            }
          }
        ];
        if (formType === 'add') {
          form.push({
            key: 'password',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('Password'),
              required: true
            }
          });
        }
        return form;
      };

    }]);

})();

(function () {
  'use strict';

  /*jshint sub:true*/
  /*jshint camelcase: false */

  angular
    .module('com.module.users')
    .factory('AppAuth', ["$q", "SystemUser", "$http", "LoopBackAuth", "CoreService", function ($q, SystemUser,$http,LoopBackAuth,CoreService) {
      var self = {
        currentUser:null,
        isAdmin:function(currentUser){
          currentUser = currentUser || self.currentUser || {};
          var p=$q.defer();
          if(currentUser.roles.indexOf("superadmin")>=0) p.resolve(true);
          else p.reject(true);
          return p.promise;
        },
        isCreoUser:function(currentUser){
          currentUser = currentUser || self.currentUser || {};
          var p=$q.defer();
          if(currentUser.roles.indexOf("creouser")>=0) p.resolve(true);
          else p.reject(true);
          return p.promise;
        },
        login: function (options,data,cb) {
          cb = cb || function(){};
          var promise = SystemUser.login(options,data).$promise;
          promise.then(function(res){
            console.log("Successfull Login",res);
              self.currentUser = {
                id:res.user.id,
                email:res.user.email,
                username:res.user.username,
                name:res.user.name,
                surname:res.user.surname,
                roles:res.roles,
                token:{
                  id:res.id,
                  ttl:res.ttl,
                  created:res.created
                }
              };
              cb(null,res);
              return res;
          }).catch(cb);
          return promise;
        },

        logout: function (cb) {
          cb = cb || function(){};
          //Destroy the access token.
          SystemUser.logout(function () {
            console.log("Successfull logout");
            self.currentUser = null;
            cb();
          });
        },
        getAuthenticatedUser: function(cb){
          cb = cb || function(){};
          var deferred = $q.defer();
          if(self.currentUser && !self.currentUser.then) {
            console.log("Found cached:",self.currentUser);
            
            // check if there is a cached user
            deferred.resolve(self.currentUser);
            cb(self.currentUser);
            
          }  else if(self.currentUser && self.currentUser.then){
            console.log("Found Promise:",self.currentUser);
            
            // check if this request is already running
            self.currentUser.then(function(){
              deferred.resolve(self.currentUser);
              cb(self.currentUser);
            });
          } 
          else {
            
            console.log("Nothing Found so starting request:",self.currentUser);
            self.currentUser = SystemUser.currentUser().$promise;
            self.currentUser.then(function(res){
              self.currentUser = res.user;
                                
              if(!window.AESG.canLogin({data:self.currentUser})) {
                // silent logout
                $http.post(CoreService.env.apiUrl + "/SystemUsers/logout",null,{ ignoreLoadingBar: true }).then(function(res){
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                });
                var error = {
                  code: "LOGIN_FAILED",
                  message: "login failed, not enough permissions",
                  name: "Error",
                  status: 401,
                  statusCode: 401
                }
                cb({data:{error:error}});
                return $q.reject({data:{error:error}});
              }
              
              deferred.resolve(self.currentUser);
              cb(self.currentUser);  
            }).catch(function(err){
              // hack logout user
              deferred.resolve({error:err});
            });
          }
          return deferred.promise;
        }
      };
      return self;
    }]);

})();

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:register
   * @description
   * # register
   */
  angular
    .module('com.module.users')
    .directive('register', function () {
      return {
        templateUrl: 'app/modules/users/views/register.html',
        restrict: 'E'
      };
    });

})();

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:login
   * @description
   * # login
   */
  angular
    .module('com.module.users')
    .directive('login', function () {
      return {
        templateUrl: 'app/modules/users/views/login.html',
        restrict: 'E'
      };
    });

})();

// (function () {
//   'use strict';
//   /**
//   * @ngdoc function
//   * @name com.module.users.controller:RegisterCtrl
//   * @description Login Controller
//   * @requires $scope
//   * @requires $routeParams
//   * @requires $location
//   * Controller for Register Page
//   **/
//   angular
//     .module('com.module.users')
//     .controller('RegisterCtrl', function ($scope, $routeParams, $location, $filter, CoreService, SystemUser, AppAuth, gettextCatalog) {

//       $scope.registration = {
//         firstName: '',
//         lastName: '',
//         email: '',
//         password: ''
//       };

//       $scope.schema = [{
//         label: '',
//         property: 'firstName',
//         placeholder: gettextCatalog.getString('First Name'),
//         type: 'text',
//         attr: {
//           ngMinlength: 4,
//           required: true
//         },
//         msgs: {
//           minlength: gettextCatalog.getString(
//             'Needs to have at least 4 characters')
//         }
//       }, {
//         label: '',
//         property: 'lastName',
//         placeholder: gettextCatalog.getString('Last Name'),
//         type: 'text',
//         attr: {
//           ngMinlength: 4,
//           required: true
//         },
//         msgs: {
//           minlength: gettextCatalog.getString(
//             'Needs to have at least 4 characters')
//         }
//       }, {
//         label: '',
//         property: 'email',
//         placeholder: gettextCatalog.getString('Email'),
//         type: 'email',
//         help: gettextCatalog.getString(
//           'Don\'t worry we won\'t spam your inbox'),
//         attr: {
//           required: true,
//           ngMinlength: 4
//         },
//         msgs: {
//           required: gettextCatalog.getString('You need an email address'),
//           email: gettextCatalog.getString('Email address needs to be valid'),
//           valid: gettextCatalog.getString('Nice email address!')
//         }
//       }, {
//         type: 'multiple',
//         fields: [{
//           label: '',
//           property: 'password',
//           placeholder: gettextCatalog.getString('Password'),
//           type: 'password',
//           attr: {
//             required: true,
//             ngMinlength: 6
//           }
//         }, {
//           label: '',
//           property: 'confirmPassword',
//           placeholder: gettextCatalog.getString('Confirm Password'),
//           type: 'password',
//           attr: {
//             confirmPassword: 'user.password',
//             required: true,
//             ngMinlength: 6
//           },
//           msgs: {
//             match: gettextCatalog.getString(
//               'Your passwords need to match')
//           }
//         }],
//         columns: 6
//       }];

//       $scope.options = {
//         validation: {
//           enabled: true,
//           showMessages: false
//         },
//         layout: {
//           type: 'basic',
//           labelSize: 3,
//           inputSize: 9
//         }
//       };

//       $scope.confirmPassword = '';

//       $scope.register = function () {

//         $scope.registration.username = $scope.registration.email;
//         delete $scope.registration.confirmPassword;
//         $scope.user = SystemUser.save($scope.registration,
//           function () {

//             $scope.loginResult = SystemUser.login({
//                 include: 'user',
//                 rememberMe: true
//               }, $scope.registration,
//               function () {
//                 AppAuth.currentUser = $scope.loginResult.user;
//                 CoreService.toastSuccess(gettextCatalog.getString(
//                   'Registered'), gettextCatalog.getString(
//                   'You are registered!'));
//                 $location.path('/');
//               },
//               function (res) {
//                 CoreService.toastWarning(gettextCatalog.getString(
//                   'Error signin in after registration!'), res.data.error
//                   .message);
//                 $scope.loginError = res.data.error;
//               }
//             );

//           },
//           function (res) {
//             CoreService.toastError(gettextCatalog.getString(
//               'Error registering!'), res.data.error.message);
//             $scope.registerError = res.data.error;
//           }
//         );
//       };
//     })
//     .directive('confirmPassword',
//     function () {
//       return {
//         restrict: 'A',
//         require: 'ngModel',
//         link: function (scope, element, attrs, ngModel) {
//           var validate = function (viewValue) {
//             var password = scope.$eval(attrs.confirmPassword);
//             ngModel.$setValidity('match', ngModel.$isEmpty(viewValue) ||
//               viewValue === password);
//             return viewValue;
//           };
//           ngModel.$parsers.push(validate);
//           scope.$watch(attrs.confirmPassword, function () {
//             validate(ngModel.$viewValue);
//           });
//         }
//       };
//     }
//   );

// })();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name com.module.users.controller:LoginCtrl
   * @description Login Controller
   * @requires $scope
   * @requires $routeParams
   * @requires $location
   * Contrller for Login Page
   **/
  angular
    .module('com.module.users')
    .controller('LoginCtrl', ["$rootScope", "$scope", "$routeParams", "$location", "CoreService", "AppAuth", "gettextCatalog", function ($rootScope,$scope, $routeParams, $location, CoreService, AppAuth, gettextCatalog) {

      var TWO_WEEKS = 1000 * 60 * 60 * 24 * 7 * 2;
      
      AppAuth.getAuthenticatedUser(function(cur){ if(cur.id) $location.path('/app'); });
      
      $scope.credentials = {
        ttl: TWO_WEEKS,
        rememberMe: true
      };

      $scope.schema = [
        {
          label: '',
          property: 'email',
          placeholder: gettextCatalog.getString('Email'),
          type: 'email',
          attr: {
            required: true,
            ngMinlength: 4
          },
          msgs: {
            required: gettextCatalog.getString('You need an email address'),
            email: gettextCatalog.getString('Email address needs to be valid'),
            valid: gettextCatalog.getString('Nice email address!')
          }
        },
        {
          label: '',
          property: 'password',
          placeholder: gettextCatalog.getString('Password'),
          type: 'password',
          attr: {
            required: true
          }
        },
        {
          property: 'rememberMe',
          label: gettextCatalog.getString('Stay signed in'),
          type: 'checkbox'
        }
      ];

      $scope.options = {
        validation: {
          enabled: true,
          showMessages: false
        },
        layout: {
          type: 'basic',
          labelSize: 3,
          inputSize: 9
        }
      };


      $scope.login = function () {
        
        var promise = AppAuth.login({ rememberMe: $scope.credentials.rememberMe },$scope.credentials);
        promise
        .then(function(res){
            var next = $location.nextAfterLogin || '/';
            $location.nextAfterLogin = null;
            CoreService.toastSuccess(gettextCatalog.getString('Logged in'),
              gettextCatalog.getString('You are logged in!'));
            if (next === '/login') { next = '/'; }
            $location.path(next);
        })
        .catch(function(res){
          console.error(res);
          $scope.loginError = res.data.error;
        });
      };

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.users')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('login', {
          url: '/login',
          template: '<login></login>',
          controller: 'LoginCtrl'
        })
        // .state('register', {
        //   url: '/register',
        //   template: '<register></register>',
        //   controller: 'RegisterCtrl'
        // })
        
        
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.users')
    .run(["$rootScope", "gettextCatalog", "SystemUser", function ($rootScope, gettextCatalog, SystemUser) {
      // $rootScope.currentUser = SystemUser.currentUser().$promise;
      // $rootScope.currentUser.then(function(res){
      //   $rootScope.currentUser=res.user;
      //   if(res.user.roles.indexOf('superadmin')>=0) {
      //     $rootScope.addMenu(gettextCatalog.getString('Users'), 'app.users.list', 'fa-user');
      //   }
        
      // })
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.users')
    .config(["$routeProvider", "$httpProvider", function ($routeProvider, $httpProvider) {

      // Intercept 401 responses and redirect to login screen
      $httpProvider.interceptors.push(["$q", "$location", "CoreService", "$rootScope", function ($q, $location, CoreService,$rootScope) {
        return {
          responseError: function (rejection) {
            if (rejection.status === 401) {
              var loc = $location.path();
              // save the current location so that login can redirect back
              $location.nextAfterLogin = loc; 
              if (loc === '/router' || loc === '/login') {
                console.log('401 while on router on login path');
              } else {
                if (loc !== '/register') {
                  $location.path('/login');
                }
                CoreService.toastWarning('Unauthorized action',
                  'We received a 401 error from the API!'
                );
              }
            }
            if (rejection.status === 404) {
              console.log(rejection);
              CoreService.toastError('Error 404 received', rejection.data
                .error.message);
            }
            if (rejection.status === 422) {
              console.log(rejection);
              CoreService.toastError('Error 422 received', rejection.data
                .error.message);
            }
            if (rejection.status === 0) {
              $location.path('/');
              CoreService.toastError('Connection Refused',
                'The connection to the API is refused. Please verify that the API is running!'
              );
            }
            return $q.reject(rejection);
          }
        };
      }]);
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.settings', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.settings')
    .service('SettingService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", function ($state, CoreService, Setting, gettextCatalog,$http) {
      var vm = this;
      vm.settings = [];
      vm.find = function (refresh) {
        refresh = refresh || vm.settings.length===0; 
        return refresh?$http.get(CoreService.env.apiUrl+'/Settings').then(function(res){
          vm.settings = res.data;
          return vm.settings;
        }):vm.settings;
      };
      
      vm.getConf = function() {
        return $http.get(CoreService.env.apiUrl + '/Settings/key/admin.configuration', {
            ignoreLoadingBar: true
          })
          .then(function(res) {
            var roles = res.data[0].data.allowedLoginRoles;
            console.log(res);
            window.AESG.allowedLoginRoles = roles;
          })
      }

      vm.key = function (key) {
        for(var i=0,len=vm.settings.length;i<len;i++){
          if(vm.settings[i].key===key) return vm.settings[i];
        }
        return null;
      };

      vm.findById = function (id) {
        return Setting.findById({
          id: id
        }).$promise;
      };
      
      vm.findByKey = function (key) {
        return Setting.find({
          filter:{
            where:{
              key: key
            }
          }
        }).$promise.then(function(res){
          return res[0];
        });
        
      }

      vm.upsert = function (setting) {
        return Setting.upsert(setting).$promise
          .then(function () {
            CoreService.toastSuccess(
              gettextCatalog.getString('Setting saved'),
              gettextCatalog.getString('Your setting is safe with us!')
            );
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving setting '),
              gettextCatalog.getString('This setting could no be saved: ' + err)
            );
          }
        );
      };

      vm.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            Setting.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('Setting deleted'),
                gettextCatalog.getString('Your setting is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting setting'),
                gettextCatalog.getString('Your setting is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };


      vm.getFormFields = function () {
        var form = [
          {
            key: 'key',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('key'),
              required: true
            }
          },
          // {
          //   key: 'data',
          //   type: 'custom',
          //   templateOptions: {
          //     label: gettextCatalog.getString('data'),
          //     required: true
          //   },
          //   controller:function($timeout,$scope){
              
          //     $timeout(function(){
          //       // create the editor
          //       var container = document.getElementById("jsoneditor");
          //       var options = {onChange:dataChanged};
          //       var editor = new JSONEditor(container, options);
          //       // set json
          //       editor.set($scope.model.data);
          //       function dataChanged(){
          //         var json = editor.get();
          //         console.log(json,$scope.model);
          //         $scope.model.data = json;
                  
          //       }
                
          //     },100)
          //   }
          // }
        ];
        return form;
      };
      
      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.settings')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.settings', {
          abstract: true,
          url: '/settings',
          templateUrl: 'app/modules/settings/views/main.html'
        })
        .state('app.settings.list', {
          url: '',
          templateUrl: 'app/modules/settings/views/list.html',
          controllerAs: 'ctrl',
          controller: ["settings", function (settings) {
            this.settings = settings;
          }],
          resolve: {
            settings: ["SettingService", function (SettingService) {
              return SettingService.find(true);
            }]
          }
        })
        .state('app.settings.add', {
          url: '/add',
          templateUrl: 'app/modules/settings/views/form.html',
          controllerAs: 'ctrl',
          controller:'SettingSingleController',
          resolve: {
            setting: function () {
              return {};
            }
          }
        })
        .state('app.settings.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/settings/views/form.html',
          controllerAs: 'ctrl',
          controller:'SettingSingleController',
          resolve: {
            setting: ["$stateParams", "SettingService", function ($stateParams, SettingService) {
              return SettingService.findById($stateParams.id);
            }]
          }
        })
        .state('app.settings.view', {
          url: '/:id',
          templateUrl: 'app/modules/settings/views/view.html',
          controllerAs: 'ctrl',
          controller: ["setting", function (setting) {
            this.setting = setting;
          }],
          resolve: {
            setting: ["$stateParams", "SettingService", function ($stateParams, SettingService) {
              return SettingService.findById($stateParams.id);
            }]
          }
        })
        .state('app.settings.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$stateParams", "$state", "SettingService", function ($stateParams, $state, SettingService) {
            SettingService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }]
        });
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.settings')
    .controller('SettingSingleController', ["$timeout", "$state", "SettingService", "setting", function($timeout, $state, SettingService, setting) {
      var vm = this;
      vm.setting = setting;
      vm.setting.data = vm.setting.data || {};
      vm.formFields = SettingService.getFormFields();
      vm.formOptions = {};
      vm.submit = function() {
        SettingService.upsert(vm.setting).then(function() {
          $state.go('^.list');
        });
      };
      // create the editor
      var container = document.getElementById("jsoneditor");
      var options = {
        onChange: dataChanged,
        mode: 'tree',
        modes: [
          // 'code', 
          // 'form', 
          'text',
          'tree',
          // 'view'
        ], // allowed modes
        onError: function(err) {
          alert(err.toString());
        },
        onModeChange: function(newMode, oldMode) {
          console.log('Mode switched from', oldMode, 'to', newMode);
        }

      };
      var editor = new JSONEditor(container, options);
      // set json
      editor.set(vm.setting.data);

      function dataChanged() {
        var json = editor.get();
        vm.setting.data = json;
        $timeout(function() {
          vm.preview = json;
        })
      }
      vm.preview = vm.setting.data;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.settings')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
        
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.reporting', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.reporting')
    .service('ReportingService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", "LoopBackAuth", function ($state, CoreService, Setting, gettextCatalog,$http,LoopBackAuth) {
      var vm = this;
      vm.reporttemplates = [];
      vm.find = function () {
        return $http.get(CoreService.env.apiUrl+'/Settings/key/report.template');
      };
      
      vm.key = function (key) {
        for(var i=0,len=vm.reporttemplates.length;i<len;i++){
          if(vm.reporttemplates[i].key===key) return vm.reporttemplates[i];
        }
        return null;
      };

      vm.findById = function (id) {
        return Setting.findById({
          id: id
        }).$promise;
      };
      
      vm.findByKey = function (key) {
        return Setting.find({
          filter:{
            where:{
              key: key
            }
          }
        }).$promise.then(function(res){
          return res[0];
        });
        
      }

      vm.upsert = function (report) {
        return Setting.upsert(report).$promise
          .then(function () {
            CoreService.toastSuccess(
              gettextCatalog.getString('Report saved')
              
            );
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving report template '),
              gettextCatalog.getString('This report template could no be saved: ' + err)
            );
          }
        );
      };

      vm.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            Setting.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('Report deleted'),
                gettextCatalog.getString('Your report template is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting report template'),
                gettextCatalog.getString('Your report template is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };
      

      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.reporting')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.reporting', {
          abstract: true,
          url: '/reporting',
          templateUrl: 'app/modules/reporting/views/main.html'
        })
        .state('app.reporting.list', {
          url: '/list',
          templateUrl: 'app/modules/reporting/views/list.html',
          controllerAs: 'ctrl',
          controller: ["ReportingService", function (ReportingService) {
            var vm = this;
            
            vm.loading = ReportingService.find().then(function(res){
              vm.reporting = res.data;
            })
            
            
          }]
        })
        .state('app.reporting.add', {
          url: '/add',
          templateUrl: 'app/modules/reporting/views/form.html',
          controllerAs: 'ctrl',
          controller:'ReportingSingleController',
          resolve: {
            report: function () {
              return {data:{}};
            },
            previewComponent: ["$stateParams", "Setting", function($stateParams, Setting) {
              return Setting.find({
                filter: {
                  where: {
                    key: 'admin.configuration'
                  }
                }
              }).$promise.then(function(res) {
                return res[0].data.stylePreviewLectureLink;
              });
            }]
          }
        })
        .state('app.reporting.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/reporting/views/form.html',
          controllerAs: 'ctrl',
          controller:'ReportingSingleController',
          resolve: {
            report: ["$stateParams", "ReportingService", function($stateParams, ReportingService) {
              return ReportingService.findById($stateParams.id);
            }],
            previewComponent: ["$stateParams", "Setting", function($stateParams, Setting) {
              return Setting.find({
                filter: {
                  where: {
                    key: 'admin.configuration'
                  }
                }
              }).$promise.then(function(res) {
                return res[0].data.stylePreviewLectureLink;
              });
            }]
          }
        })
        .state('app.reporting.view', {
          url: '/:id',
          templateUrl: 'app/modules/reporting/views/view.html',
          controllerAs: 'ctrl',
          controller: ["report", "CoreService", "OrganizationService", "ProjectsService", "ReportingService", "LoopBackAuth", function (report, CoreService, OrganizationService, ProjectsService, ReportingService, LoopBackAuth ) {
            var vm = this;
            
            var options = {
              // onChange: dataChanged,
              mode: 'tree',
              modes: [
                // 'code', 
                // 'form', 
                'text',
                'tree',
                // 'view'
              ], // allowed modes
              onError: function(err) {
                alert(err.toString());
              },
              onModeChange: function(newMode, oldMode) {
                console.log('Mode switched from', oldMode, 'to', newMode);
              }
            }
            var sourceDataPreview = new JSONEditor(document.getElementById("sourceDataPreview"), options);
            var outputDataPreview = new JSONEditor(document.getElementById("outputDataPreview"), options);
            
            vm.report = report.data;
            vm.selectedOrg = {};
            vm.availableOrgs = [];
            vm.availableProjects = [];
            OrganizationService.get().then(function(data){vm.availableOrgs = data;});
            
            
            vm.searchLoader = null;
            vm.searchProject = function(item) {
              // if (!name || name.length < 2) return;
              vm.searchLoader = ProjectsService.get({
                where: {
                  organizationId: item.id,
                  // name: {
                  //   like: name,
                  //   options: 'i'
                  // }
                }
              }).then(function(data) {
                vm.availableProjects = data;
                vm.searchLoader = null;
                return vm.availableProjects;
              });
            };
            vm.copySourceDataLink = function(){
              var url=CoreService.env.apiUrl+'/'
              // LoopBackAuth.accessTokenId
              switch (vm.report.sourceAPI.func) {
                case 'getAssessmentReportData':
                  if(!vm.selectedOrg.id) return;
                  url +='Organizations/'+vm.selectedOrg.id+'/getAssessmentReportData?access_token='+LoopBackAuth.accessTokenId
                  
                  if(vm.selectedProject) {
                    url+='&projectId='+vm.selectedProject.id
                  }
                  if(vm.selectedAssessment) {
                    url+='&assessmentId='+vm.selectedAssessment.id
                  }
                  break;
                default:
              }
              console.log("copySourceDataLink", url);
              vm.copyToClipboard(url);
            }
            
            vm.loadSourceData = function() {
              var config = {};
              var p = null;
              switch (vm.report.sourceAPI.func) {
                case 'getAssessmentReportData':
                  if(!vm.selectedOrg.id) return;
                  config.organizationId = vm.selectedOrg.id
                  if(vm.selectedProject) {
                    config.projectId = vm.selectedProject.id;
                  }
                  vm.searchLoader = true;
                  p = OrganizationService.getAssessmentReportData(config).then(function(data){
                    vm.sourceData = data;
                    sourceDataPreview.set(data);
                    vm.searchLoader = null;
                  })
                  // code
                  break;
                
                default:
                  console.error("Function not found");
                  // code
              }
              p.then(function(){
                vm.processData();
              })
            }
            
            vm.processData = function(){
              try {
                var fn = new Function("data",vm.report.preprocessFn);
                vm.outputData = fn(vm.sourceData);
                outputDataPreview.set(vm.outputData);
                vm.error = null;
                return true;
              } catch(err){
                console.log(err);
                vm.error = err.toString();
                return false;
              }
            }
            
            //helper functions
            vm.downloadObjectAsJson = CoreService.downloadObjectAsJson;
            vm.copyToClipboard = CoreService.copyToClipboard;
            
            vm.updateProcessFn = function(){
              var success = vm.processData();
              if(success) {
                ReportingService.upsert(report)
              }
            }
            
            
            console.log("Report", report);
          }],
          resolve: {
            report: ["$stateParams", "ReportingService", function ($stateParams, ReportingService) {
              return ReportingService.findById($stateParams.id);
            }]
          }
        })
        .state('app.reporting.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$stateParams", "$state", "ReportingService", function ($stateParams, $state, ReportingService) {
            ReportingService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }]
        });
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.reporting')
    .controller('ReportingSingleController', ["previewComponent", "$timeout", "$state", "ReportingService", "report", "CoreService", function(previewComponent,$timeout, $state, ReportingService, report,CoreService) {
      var vm = this;
      vm.report = report;
      vm.report.data = vm.report.data || {};
      if(vm.report.data.style && !vm.report.data.preview) {
        vm.report.data.preview = vm.report.data.style;
      }
      vm.formOptions = {};
      vm.reportData = vm.report.data;
      vm.getPreviewUrl = function(){
        return CoreService.env.sylvaHost + previewComponent +
        '?customStyle=report.template.'+vm.report.data.label.replace(/ /g,'_').toLowerCase();
      }
      vm.updatePreview = function() {
        vm.report.key = 'report.template.' + vm.report.data.label.replace(/ /g,'_').toLowerCase();
        ReportingService.upsert(vm.report)
        .then(function(){
          window.open(vm.getPreviewUrl(), '_blank');
        })
        .catch(function(err){
          console.error(err);
        })
      };
      vm.submit = function() {
        vm.report.key = 'report.template.' + vm.report.data.label.replace(/ /g,'_').toLowerCase();
        vm.report.data.style = vm.report.data.preview;
        vm.report.data.preview = null;
        ReportingService.upsert(vm.report).then(function() {
          $state.go('^.list');
        });
      };
      vm.formFields = [{
          className: "col-xs-4",
          key: 'data.label',
          type: 'input',
          templateOptions: {
            label: 'Label',
            required: true
          }
        },
        {
          className: "col-xs-4",
          key: 'data.sourceAPI',
          type: 'select',
          defaultValue: 'HMAC-SHA1',
          templateOptions: {
            label: 'Source API Function',
            options: [],
            valueProp: 'value',
            labelProp: 'label',
            required: false,
            placeholder: 'Source API Function'
          },
          controller: /* @ngInject */ ["$scope", function($scope) {
            $scope.to.options = [
              {value: {
                model:'Organization',
                func: 'getAssessmentReportData',
                preprocessFn: '',
                args: [
                  'organizationId',
                  'projectId',
                  'assessmentId'
                ]
              },label: 'SYLVA Assessment Report Data'}
            ]
          }]
        },
      ]



    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.reporting')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
        
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.permissions', []);
    
})();

(function () {
  'use strict';
  angular
    .module('com.module.permissions')
    .service('PermissionService', ["$q", "$http", "CoreService", function ($q, $http, CoreService) {
    
        var vm = this;
        vm.models = {
            __data:[],
            get:function(){
                return this.__data; 
            },
            set:function(models){
                 this.__data = models   
            }
        };
        
        vm.get = function(filter){
            return $http.get(CoreService.env.apiUrl + '/Settings/viewPermissions',{cache:true})
            .then(function(res){return res.data.filter(function(m){
                if (!m.acls) m.acls = [];
                return m.acls.length>0;
            })})
            .catch(function(err){console.log(err)});
        }       
        
        vm.groupByModel = function(data,filter){
            return data.map(function(m) {
                if (!m.acls) m.acls = [];
                m.acls = m.acls.map(function(a) {
                    a.property = a.property || a.properties;
                    if (!(a.property instanceof Array)) {
                        a.property = a.property ? [a.property] : ["*"];
                    }
                    return a;
                })
                return m;
            }).filter(function(m) {
                if(filter) {
                    return filter.indexOf(m.name)>=0;
                }
                if (!m.acls) return false;
                if (m.acls.filter(function(a) { return a.property && a.property.length > 0; }).length > 0) return true;
                return false;
    
            }).sort(function(a, b) {
                return b.acls.length - a.acls.length;
            });
        }
        vm.groupByProperty = function(data) {
            return data.map(function(m){
                m.roles = {};
                m.properties = {};
                if (!m.acls) m.acls = [];
                m.acls.forEach(function(a){
                    if(!a.principalId) return;
                    a.principalId = a.principalId.replace('$','').replace('group:','')
                    .replace("teachingassistant","TA")
                    .replace("contentmanager","CM");
                    m.roles[a.principalId] = {name:a.principalId};
                    a.property.forEach(function(p){
                        if(!m.properties[p]) {
                            m.properties[p] = {
                                name:p,
                                accessType:a.accessType,
                                roles:{}
                            };
                            m.properties[p].roles[a.principalId] = a.permission.toUpperCase()==='ALLOW'?2:1;
                        } else {
                            
                            m.properties[p].roles[a.principalId] = a.permission.toUpperCase()==='ALLOW'?2:1;
                        }
                            
                    })
                })
            })
            
        }
        
        vm.getRequests = function(query){
            query = query || 'is:unresolved level:info';
            return $http.get(CoreService.env.apiUrl + '/Settings/fetchEvents',{params:{query:query},cache:true});
        }
        
        
        
        return vm;
        
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.permissions')
  
    .config(["$stateProvider", function($stateProvider){
        $stateProvider
        .state('app.permissions', {
          abstract: true,
          url: '/permissions',
          templateUrl: 'app/modules/permissions/views/main.html',
          controllerAs: 'vm',
          controller:["$scope", "PermissionService", "data", function($scope,PermissionService,data){
            var vm = this;
            vm.availableModels = data.map(function(m){
              return m.name;
            });
            vm.models = PermissionService.models.__data;
            
            vm.selectModels = function(models){
              PermissionService.models.__data = models;
              $scope.$broadcast('model.selection',models);
            }
            
          }],
          resolve:{
            data:["PermissionService", function(PermissionService){
              PermissionService.models.set(['Project']);
              return PermissionService.get();
            }]
          }
        })
        .state('app.permissions.list', {
          url: '/list',
          templateUrl: 'app/modules/permissions/views/list.roles.html',
          controllerAs: 'ctrl',
          controller: 'PermissionsListController'
        })
    }])
    
})();

(function () {
  'use strict';
  angular.module('com.module.gradingschemes', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.gradingschemes')
    .service('GradingSchemeService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", function ($state, CoreService, Setting, gettextCatalog,$http) {
      var vm = this;
      vm.gradingschemes = [];
      vm.find = function () {
        return $http.get(CoreService.env.apiUrl+'/Settings/key/grading.scheme');
      };
      
      vm.getConf = function() {
        return $http.get(CoreService.env.apiUrl + '/Settings/key/grading.scheme', {
            ignoreLoadingBar: true
          })
          .then(function(res) {
            var roles = res.data[0].data.allowedLoginRoles;
            console.log(res);
            window.AESG.allowedLoginRoles = roles;
          })
      }

      vm.key = function (key) {
        for(var i=0,len=vm.gradingschemes.length;i<len;i++){
          if(vm.gradingschemes[i].key===key) return vm.gradingschemes[i];
        }
        return null;
      };

      vm.findById = function (id) {
        return Setting.findById({
          id: id
        }).$promise;
      };
      
      vm.findByKey = function (key) {
        return Setting.find({
          filter:{
            where:{
              key: key
            }
          }
        }).$promise.then(function(res){
          return res[0];
        });
        
      }

      vm.upsert = function (gradingscheme) {
        return Setting.upsert(gradingscheme).$promise
          .then(function () {
            CoreService.toastSuccess(
              gettextCatalog.getString('Setting saved'),
              gettextCatalog.getString('Your grading scheme is safe with us!')
            );
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving grading scheme '),
              gettextCatalog.getString('This grading scheme could no be saved: ' + err)
            );
          }
        );
      };

      vm.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            Setting.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('Setting deleted'),
                gettextCatalog.getString('Your grading scheme is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting grading scheme'),
                gettextCatalog.getString('Your grading scheme is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };


      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.gradingschemes')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.gradingschemes', {
          abstract: true,
          url: '/gradingschemes',
          templateUrl: 'app/modules/gradingschemes/views/main.html'
        })
        .state('app.gradingschemes.list', {
          url: '/list',
          templateUrl: 'app/modules/gradingschemes/views/list.html',
          controllerAs: 'ctrl',
          controller: ["GradingSchemeService", function (GradingSchemeService) {
            var vm = this;
            
            vm.loading = GradingSchemeService.find().then(function(res){
              vm.gradingschemes = res.data;
            })
            
            
          }]
        })
        .state('app.gradingschemes.add', {
          url: '/add',
          templateUrl: 'app/modules/gradingschemes/views/form.html',
          controllerAs: 'ctrl',
          controller:'GradingSchemeSingleController',
          resolve: {
            gradingscheme: function () {
              return {data:{scheme:[]}};
            }
          }
        })
        .state('app.gradingschemes.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/gradingschemes/views/form.html',
          controllerAs: 'ctrl',
          controller:'GradingSchemeSingleController',
          resolve: {
            gradingscheme: ["$stateParams", "GradingSchemeService", function ($stateParams, GradingSchemeService) {
              return GradingSchemeService.findById($stateParams.id);
            }]
          }
        })
        .state('app.gradingschemes.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$stateParams", "$state", "GradingSchemeService", function ($stateParams, $state, GradingSchemeService) {
            GradingSchemeService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }]
        });
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.gradingschemes')
    .controller('GradingSchemeSingleController', ["$timeout", "$state", "GradingSchemeService", "gradingscheme", function($timeout, $state, GradingSchemeService, gradingscheme) {
      var vm = this;
      vm.gradingscheme = gradingscheme;
      vm.gradingscheme.data = vm.gradingscheme.data || {};
      vm.formOptions = {};
      vm.gradingschemeData = vm.gradingscheme.data; 
      vm.submit = function() {
        if(!vm.gradingscheme.key) {
          vm.gradingscheme.type = 'grading.scheme';
          console.log("Creating new GradingScheme", gradingscheme);
        }        
        GradingSchemeService.upsert(vm.gradingscheme).then(function() {
          $state.go('^.list');
        });
      };
      vm.formFields = [{
          className: "col-xs-7",
          key: 'data.label',
          type: 'input',
          templateOptions: {
            label: 'Label',
            required: true
          }
        },
        {
          className: "col-xs-2",
          key: 'data.strict',
          type: 'select',
          templateOptions: {
            required:true,
            label: 'Grade rounding',      
            "options": [
              {
                "name": "disabled",
                "value": true
              },
              {
                "name": "enabled",
                "value": false
              }
            ]
          }
        },
        {
          className: "col-xs-3",
          key: 'data.passingThreshold',
          type: 'input',
          templateOptions: {
            type: 'number',
            min: 0,
            max: 100,
            label: 'Passing Threshold (%)',
            required: true
          }
        }
      ]



    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.gradingschemes')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
        
    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.files', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.files')
    .service('FileService', ["$http", "CONFIG", "CoreService", "SchemaMaker", "FileUploader", "uiGridConstants", "gettextCatalog", "LoopBackAuth", function ($http, CONFIG, CoreService, SchemaMaker,FileUploader, uiGridConstants, gettextCatalog,LoopBackAuth) {
      var vm = this;
      vm.api = CoreService.env.apiUrl+'/Files';
      
      vm.getPublicContainer = function(container){
        return CoreService.env.StorageContainers.filter(function(c){return c.value===container})[0].id;
      };
      
      vm.setApi=function(type,id){
        
        var schema = Object.assign({},vm.schema);
        
        switch (type) {
          case 'lectures':
          vm.api = CoreService.env.apiUrl+'/Lectures/'+id;
          vm.uploadApi = CoreService.env.apiUrl+'/Lectures/'+id;
          break;
          
          case 'projects':
          vm.api = CoreService.env.apiUrl+'/Projects/'+id+'/files';
          vm.uploadApi = CoreService.env.apiUrl+'/Projects/'+id;
          
          // custom projects schema
          delete schema["organization.name"];
          delete schema["project.name"];
          delete schema["container"];
          vm.gridSchema = SchemaMaker.uiGrid(schema,vm.filters);
          
          break;
          case 'organizations':
          vm.api = CoreService.env.apiUrl+'/Organizations/'+id+'/files';
          vm.uploadApi = CoreService.env.apiUrl+'/Organizations/'+id;
          
          // custom organizations schema
          delete schema["organization.name"];
          delete schema["project.name"];
          delete schema["container"];
          vm.gridSchema = SchemaMaker.uiGrid(schema,vm.filters);
          
          break;
          default:
          vm.api = CoreService.env.apiUrl+'/Files';
          vm.uploadApi = CoreService.env.apiUrl+'/Files';
          
          // auto create schema for ui-grid;
          vm.gridSchema = SchemaMaker.uiGrid(schema,vm.filters);
        }
      }
      
      vm.filters = {};
    
      // basic schema
      vm.schema = {
        "FileName": {
          field:"name",
          type: "string",
          // cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.source.substring(row.entity.source.lastIndexOf(\'/\')+1)}}</div>',
        },
        "download":{
          field: 'Download',
          enableSorting: false,
          enableFiltering: false,
          enableColumnMenu: false,
          enableCellEdit: false,
          cellClass:'showDownloadInGrid',
          cellTemplate: '<div class="ui-grid-cell-contents text-center"><file-downloader file="row.entity"></file-downloader></div>',
          width:90
        },
        "size": {
          type: "number",
          "cellFilter":'formatByte:this'
        },
        "componentModel": {
          type: "string",
          width:150
        },
        "container": {
          type: "string",
          width:120,              
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: CoreService.env.StorageContainers
          }
        },
        "project.name": {
          enableSorting: false,
          enableFiltering: false,
          enableColumnMenu: false,
          enableCellEdit: false,
          type: "relation"
        },
        "organization.name": {
          enableSorting: false,
          enableFiltering: false,
          enableColumnMenu: false,
          enableCellEdit: false,
          type: "relation"
        }
      };
    
      
      vm.get = function (filters) {
        filters = filters || {};
        filters = Object.assign({},filters,vm.filters);
        return $http.get(vm.api,{ params: { filter: filters } });
      };
      
      vm.uploader = function(config){
        config = config || {};
        
        return new FileUploader({    
          url: vm.uploadApi,
          withCredentials: false,
          autoUpload: false,
          method: 'POST',
          removeAfterUpload: false,
          headers: {
              authorization: LoopBackAuth.accessTokenId
          }
        });
      }
      vm.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            $http.delete(vm.api+'/'+ encodeURIComponent(id)).success(
              function () {
                CoreService.toastSuccess(
                  gettextCatalog.getString('File deleted'),
                  gettextCatalog.getString('Your file is deleted!')
                );
                successCb();
              });
          }, function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error deleting file'),
              gettextCatalog.getString('Your file is not deleted! ') + err);
            cancelCb();
          });
      };

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.files')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.files', {
          abstract: true,
          url: '/files',
          templateUrl: 'app/modules/files/views/main.html',
          resolve:{
            admin:["AppAuth", "currentUser", function(AppAuth,currentUser){
                return AppAuth.isAdmin(currentUser);
            }]
          }
        })
        .state('app.files.list', {
          url: '',
          templateUrl: 'app/modules/files/views/list.html',
          controllerAs: 'ctrl',
          controller: 'FilesListController'
        })
        .state('app.files.upload', {
          url: '/upload',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", function (FileUploader, FileService) {
            FileService.setApi();
            this.uploader = FileService.uploader();
            this.uploader.onBeforeUploadItem = function(item) {
              item.url = item.url + '/' + item.file.componentModel + '/uploadFile';
              // item.headers['x-upload-filename'] = item.file.name;
            };
          }]
        });
    }]);

})();

angular
    .module('com.module.files')
    .controller('FilesListController', ["$uibModal", "FileService", "GridHelper", "CoreService", "$state", function($uibModal, FileService, GridHelper,CoreService,$state) {
            var vm = this;

            vm.cdnUrl = CoreService.env.cdnUrl;
            vm.id = $state.params.id;
            var FilesApiType = $state.current.name.split('.')[1];
            
            FileService.setApi(FilesApiType,vm.id);
            
            vm.config={
                controllerAs:'ctrl',
                // disable edit
                actionColumns :{ 
                    editElement:{
                        disabled:true
                    }
                }
            };
            
            /* List */
            var schema = FileService.gridSchema;
            vm.filters = {limit:15,skip:0};
            vm.pagination = {
                pageNumber: 1,
                pageSize: 15,
                sort: null
            };
            vm.loadListData = function(filters) {
                filters = filters || vm.filters;
                console.log("Req Filter", filters);
                
                // TODO : Fix
                // if(JSON.stringify(filters.where)!=JSON.stringify(vm.filters.where)) {
                //     vm.filters.skip=0;
                //     filters.skip=0;
                // }
                // vm.filters.where = Object.assign({},vm.filters.where,filters.where);
                
                vm.loading = FileService.get(filters).then(function(res) {
                    var headers = res.headers();
                    vm.gridOptions.totalItems = Number(headers['x-total-count']);
                    vm.gridOptions.data = res.data; //postProcess(res.data);
                });
            };
            vm.gridOptions = GridHelper.gridOptions(schema, vm.loadListData, vm.pagination, vm.filters,vm.config);
            vm.loadListData();
            
            vm.deleteElement = function(elem){
                FileService.delete(elem.id,
                function(){
                    vm.loadListData();
                },function(){
                    
                });
            };
            vm.viewElement = CoreService.viewElement;

        }]

    );
(function () {
  'use strict';
  angular
    .module('com.module.files')
    .run(["$rootScope", "$http", "CoreService", "gettextCatalog", "FileService", function ($rootScope, $http, CoreService, gettextCatalog, FileService) {

      // FileService.find()
      //   .then(function (data) {
      //     $rootScope.addDashboardBox(gettextCatalog.getString('Files'), 'bg-blue', 'ion-paperclip', data.length, 'app.files.list');
      //   });

    }]);

})();

(function () {
  'use strict';
  angular.module('com.module.customstyles', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.customstyles')
    .service('CustomStylesService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", "LoopBackAuth", function ($state, CoreService, Setting, gettextCatalog,$http,LoopBackAuth) {
      var vm = this;
      vm.customstyles = [];
      vm.find = function () {
        return $http.get(CoreService.env.apiUrl+'/Settings/key/custom.style');
      };
      
      vm.key = function (key) {
        for(var i=0,len=vm.customstyles.length;i<len;i++){
          if(vm.customstyles[i].key===key) return vm.customstyles[i];
        }
        return null;
      };

      vm.findById = function (id) {
        return Setting.findById({
          id: id
        }).$promise;
      };
      
      vm.findByKey = function (key) {
        return Setting.find({
          filter:{
            where:{
              key: key
            }
          }
        }).$promise.then(function(res){
          return res[0];
        });
        
      }

      vm.upsert = function (customstyle) {
        return Setting.upsert(customstyle).$promise
          .then(function () {
            CoreService.toastSuccess(
              gettextCatalog.getString('Setting saved'),
              gettextCatalog.getString('Your custom style is safe with us!')
            );
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving custom style '),
              gettextCatalog.getString('This custom style could no be saved: ' + err)
            );
          }
        );
      };

      vm.delete = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            Setting.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('Setting deleted'),
                gettextCatalog.getString('Your custom style is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting custom style'),
                gettextCatalog.getString('Your custom style is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };
      

      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.customstyles')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.customstyles', {
          abstract: true,
          url: '/customstyles',
          templateUrl: 'app/modules/customstyles/views/main.html'
        })
        .state('app.customstyles.list', {
          url: '/list',
          templateUrl: 'app/modules/customstyles/views/list.html',
          controllerAs: 'ctrl',
          controller: ["CustomStylesService", function (CustomStylesService) {
            var vm = this;
            
            vm.loading = CustomStylesService.find().then(function(res){
              vm.customstyles = res.data;
            })
            
            
          }]
        })
        .state('app.customstyles.add', {
          url: '/add',
          templateUrl: 'app/modules/customstyles/views/form.html',
          controllerAs: 'ctrl',
          controller:'CustomStylesSingleController',
          resolve: {
            customstyle: function () {
              return {data:{}};
            },
            previewComponent: ["$stateParams", "Setting", function($stateParams, Setting) {
              return Setting.find({
                filter: {
                  where: {
                    key: 'admin.configuration'
                  }
                }
              }).$promise.then(function(res) {
                return res[0].data.stylePreviewLectureLink;
              });
            }]
          }
        })
        .state('app.customstyles.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/customstyles/views/form.html',
          controllerAs: 'ctrl',
          controller:'CustomStylesSingleController',
          resolve: {
            customstyle: ["$stateParams", "CustomStylesService", function($stateParams, CustomStylesService) {
              return CustomStylesService.findById($stateParams.id);
            }],
            previewComponent: ["$stateParams", "Setting", function($stateParams, Setting) {
              return Setting.find({
                filter: {
                  where: {
                    key: 'admin.configuration'
                  }
                }
              }).$promise.then(function(res) {
                return res[0].data.stylePreviewLectureLink;
              });
            }]
          }
        })
        .state('app.customstyles.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$stateParams", "$state", "CustomStylesService", function ($stateParams, $state, CustomStylesService) {
            CustomStylesService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }]
        });
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.customstyles')
    .controller('CustomStylesSingleController', ["previewComponent", "$timeout", "$state", "CustomStylesService", "customstyle", "CoreService", function(previewComponent,$timeout, $state, CustomStylesService, customstyle,CoreService) {
      var vm = this;
      vm.customstyle = customstyle;
      vm.customstyle.data = vm.customstyle.data || {};
      if(vm.customstyle.data.style && !vm.customstyle.data.preview) {
        vm.customstyle.data.preview = vm.customstyle.data.style;
      }
      vm.formOptions = {};
      vm.customstyleData = vm.customstyle.data;
      vm.getPreviewUrl = function(){
        return CoreService.env.sylvaHost + previewComponent +
        '?customStyle=custom.style.'+vm.customstyle.data.label.replace(/ /g,'_').toLowerCase();
      }
      vm.updatePreview = function() {
        vm.customstyle.key = 'custom.style.' + vm.customstyle.data.label.replace(/ /g,'_').toLowerCase();
        CustomStylesService.upsert(vm.customstyle)
        .then(function(){
          window.open(vm.getPreviewUrl(), '_blank');
        })
        .catch(function(err){
          console.error(err);
        })
      };
      vm.submit = function() {
        vm.customstyle.key = 'custom.style.' + vm.customstyle.data.label.replace(/ /g,'_').toLowerCase();
        vm.customstyle.data.style = vm.customstyle.data.preview;
        vm.customstyle.data.preview = null;
        CustomStylesService.upsert(vm.customstyle).then(function() {
          $state.go('^.list');
        });
      };
      vm.formFields = [{
          className: "col-xs-7",
          key: 'data.label',
          type: 'input',
          templateOptions: {
            label: 'Label',
            required: true
          }
        },
      ]



    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.customstyles')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
        
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.core')
    .service('LTIservice', ["$q", "$http", "CoreService", function($q, $http, CoreService) {
      var vm = this;
      
      

      // create schema for angular-formly
      vm.getFormSchema = function() {
        return [
          {
            key: 'lti1p0',
            type: 'checkbox',
            templateOptions: {
              label: 'LTI Version 1.0'
            }
          },
          {
            key: 'lti1p1',
            type: 'checkbox',
            templateOptions: {
              label: 'LTI Version 1.1'
            }
          },
          {
            key: 'lti1p3',
            type: 'checkbox',
            templateOptions: {
              disabled:true,
              label: 'LTI Version 1.3'
            }
          },
          {
            key: 'consumer_key',
            type: 'input',
            templateOptions: {
              label: 'OAuth consumer key',
              required: false
            }
          },
          {
            key: 'shared_secret',
            type: 'input',
            templateOptions: {
              label: 'OAuth shared secret',
              required: false
            }
          },
          {
            key: 'signature_method',
            type: 'select',
            defaultValue: 'HMAC-SHA1',
            templateOptions: {
              label: 'OAuth signature method',
              options: [],
              valueProp: 'value',
              labelProp: 'label',
              required: false,
              placeholder: 'Select LTI version'
            },
            controller: /* @ngInject */ ["$scope", function($scope) {
              $scope.to.options = [
                {value:'HMAC-SHA256',label: 'HMAC-SHA256'},
                {value:'HMAC-SHA1',label: 'HMAC-SHA1'}
              ]
            }]
          },
          {
            key: 'favicon',
            type: 'input',
            templateOptions: {
              label: 'Favicon URL (Optional)',
              required: false
            }
          },
          {
            key: 'logo',
            type: 'input',
            templateOptions: {
              label: 'Logo - small image',
              required: false
            }
          },
          {
            key: 'url',
            type: 'input',
            templateOptions: {
              label: 'Partner url',
              required: false
            }
          },
          {
            key: 'help_icon',
            type: 'input',
            templateOptions: {
              label: 'Help Icon (Optional)',
              required: false
            }
          },
          {
            key: 'help_title',
            type: 'input',
            templateOptions: {
              label: 'Help Title (Optional)',
              required: false
            }
          },
          {
            key: 'help_url',
            type: 'input',
            templateOptions: {
              label: 'Help Url (Optional)',
              required: false
            }
          },
          {
            key: 'custom_config',
            type: 'textarea',
            templateOptions: {
              label: 'Partner custom JSON configuration (Optional)',
              required: false
            }
          },
          {
            key: 'custom_css',
            type: 'textarea',
            templateOptions: {
              label: 'Partner custom CSS (Optional)',
              required: false
            }
          },
          {
            key: 'custom_params',
            type: 'textarea',
            templateOptions: {
              label: 'Custom Parameters (Optional)',
              placeholder: 'custom_control=async&custom_flow_control=2...',
              required: false
            }
          }

        ]
      }




      return vm;
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
    .service('CoreService', ["ENV", "SweetAlert", "toasty", "$log", "$uibModal", function (ENV, SweetAlert, toasty,$log,$uibModal) {

      this.env = ENV[window.ENV];
      
      this.log = function(info,type){
        type = type || "info"
        $log[type](type+':',info);
      }
      this.success = function(obj) {
        this.log(obj);
        this.toastSuccess('Success');
      }.bind(this)
      this.error = function(obj) {
        this.log(obj,'error');
        obj = obj || {};
        obj.data = obj.data || {};
        var err = obj.data.error || {};
        if(err.status>=500) this.toastError(err.name+': '+err.status, err.message);
        else this.toastWarning(err.name+': '+err.status, err.message);
      }.bind(this)

      this.alert = function (title, text) {
        SweetAlert.swal(title, text);
      };

      this.alertSuccess = function (title, text) {
        SweetAlert.swal(title, text, 'success');
      };

      this.alertError = function (title, text) {
        SweetAlert.swal(title, text, 'error');
      };

      this.alertWarning = function (title, text) {
        SweetAlert.swal(title, text, 'warning');
      };

      this.alertInfo = function (title, text) {
        SweetAlert.swal(title, text, 'info');
      };
      this.imageInfo = function (title, text) {
        SweetAlert.swal("Success: Image Processing started","The Processing should complete in a couple seconds depending on our server loads. You should visit this page after a while", 'info');
      };

      this.confirm = function (title, text, successCb, cancelCb) {
        var config = {
          title: title,
          text: text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#DD6B55'
        };
        this._swal(config, successCb, cancelCb);
      };

      this._swal = function (config, successCb, cancelCb) {
        SweetAlert.swal(config,
          function (confirmed) {
            if (confirmed) {
              successCb();
            } else {
              cancelCb();
            }
          });
      };

      this.toastSuccess = function (title, text) {
        toasty.pop.success({
          title: title,
          msg: text,
          sound: false
        });
      };

      this.toastError = function (title, text) {
        toasty.pop.error({
          title: title,
          msg: text,
          sound: false
        });
      };

      this.toastWarning = function (title, text) {
        toasty.pop.warning({
          title: title,
          msg: text,
          sound: false
        });
      };

      this.toastInfo = function (title, text) {
        toasty.pop.info({
          title: title,
          msg: text,
          sound: false
        });
      };
      
      this.copyToClipboard = function(data) {
        if(!data) return;
        var str = typeof data === 'object'?JSON.stringify(data):data;
                
        // // Create new element
        // var el = document.getElementById('clipboard-textarea');
        // // Set value (string to be copied)
        // el.value = str;
        // // Select text inside element
        // el.select();
        // // Copy text to clipboard
        // document.execCommand('copy');
        
        // el.value = "";
        navigator.clipboard.writeText(str).then(function(){
          console.log("navigator.clipboard.writeText Done");
        });
        var msg = str.length<1000 ? str.substr(0,100)+'...' :'Total bytes: '+Math.round(lengthInUtf8Bytes(str)/1024)+'KB' 
        toasty.pop.info({
          title: 'Copied to Clipboard',
          msg: msg,
          sound: false
        });

      }
      function lengthInUtf8Bytes(str) {
        // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
        var m = encodeURIComponent(str).match(/%[89ABab]/g);
        return str.length + (m ? m.length : 0);
      }
      
      this.downloadObjectAsJson = function(exportObj, exportName){
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
        var downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute("href",     dataStr);
        downloadAnchorNode.setAttribute("download", exportName + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      }
      
      this.viewElement = function(item) {
        // console.log("View", item);
        var modal = $uibModal.open({
          template: '<div class="panel panel-default">'+
          '<div class="panel-heading"><h1>Details<a href="" class="pull-right" ng-click="close()"><i class="fa fa-close"></i></a></h1></div>'+
          '<div class="panel-body"><object-viewer item="item"></object-viewer></div>'+
          '</div>',
          size: 'md',
          controller: ["$scope", function($scope) {
            $scope.item = item;
            $scope.close = modal.close; // link inner scope to outer variable
          }]
        });
      }

    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.core')
    .service('CloudConfigService', ["$q", "$http", "CoreService", "AuthProvidersService", "ProjectsService", function($q, $http, CoreService, AuthProvidersService, ProjectsService) {
      var vm = this;
      
      

      // create schema for angular-formly
      vm.getFormSchema = function(organizationId) {
        return [
          {
            key: 'domain',
            type: 'input',
            templateOptions: {
              label: 'Target Domain',
              required: false
            }
          },
          {
            key: 'auth_provider',
            type: 'select',
            templateOptions: {
              label: 'Login/Auth Provider',
              options: [],
              valueProp: 'value',
              labelProp: 'label',
              required: false,
              placeholder: 'Select Auth Provider'
            },
            controller: /* @ngInject */ ["$scope", function($scope) {
              AuthProvidersService.find().then(function(res){
                console.log("AuthProviders",res.data)
                $scope.to.options = [{
                  label: "SYLVA Password",
                  value: "sylva_password",
                }].concat(res.data.map(function(p){
                  return {
                    label: p.label,
                    value: p.id
                  }
                }))
              })
            }]
          },
          {
            key: 'sso_autoprovision',
            type: 'checkbox',
            templateOptions: {
              label: 'Auto-provision users'
            }
          },
          {
            key: 'sso_default_project',
            type: 'select',
            templateOptions: {
              label: 'Default Project',
              options: [],
              valueProp: 'value',
              labelProp: 'label',
              required: false,
              placeholder: 'Select Default Project'
            },
            controller: /* @ngInject */ ["$scope", function($scope) {
              ProjectsService.get({where:{
                organizationId: organizationId
              }}).then(function(data){
                $scope.to.options = data && data.map(function(p){
                  return {
                    label: p.name,
                    value: p.id
                  }
                }) || [];
              })
            }]
          },
          {
            key: 'page_title',
            type: 'input',
            templateOptions: {
              label: 'Page Title',
              required: false
            }
          },
          {
            key: 'favicon',
            type: 'input',
            templateOptions: {
              label: 'Favicon URL (Optional)',
              required: false
            }
          },
          {
            key: 'logo',
            type: 'input',
            templateOptions: {
              label: 'Logo - small image',
              required: false
            }
          },
          {
            key: 'help_icon',
            type: 'input',
            templateOptions: {
              label: 'Help Icon (Optional)',
              required: false
            }
          },
          {
            key: 'help_title',
            type: 'input',
            templateOptions: {
              label: 'Help Title (Optional)',
              required: false
            }
          },
          {
            key: 'help_url',
            type: 'input',
            templateOptions: {
              label: 'Help Url (Optional)',
              required: false
            }
          },
          {
            key: 'support_email',
            type: 'input',
            templateOptions: {
              label: 'Support Email Sender',
              required: false
            }
          },
          {
            key: 'email_config',
            type: 'textarea',
            templateOptions: {
              label: 'Custom Email Templates (Sendgrid) configuration. Available keys = {template,invitation,forgot_password,login_link}',
              required: false
            }
          },
          {
            key: 'webhook_config',
            type: 'textarea',
            templateOptions: {
              label: 'WebHook Config. Updates per User. Available keys = {enrollment,module_group,module} Available Actions = {started,completed} ',
              required: false
            }
          },
          {
            key: 'custom_config',
            type: 'textarea',
            templateOptions: {
              label: 'Partner custom JSON configuration (Optional)',
              required: false
            }
          },
          {
            key: 'custom_css',
            type: 'textarea',
            templateOptions: {
              label: 'Partner custom CSS (Optional)',
              required: false
            }
          },
          {
            key: 'custom_params',
            type: 'textarea',
            templateOptions: {
              label: 'Custom Parameters (Optional)',
              placeholder: 'custom_control=async&custom_flow_control=2...',
              required: false
            }
          }

        ]
      }




      return vm;
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
    .service('BillingService', ["$q", "$http", "CoreService", function ($q, $http, CoreService) {
      var vm = this;
      
      vm.getCountries = function () {
        var obj = { "BD": "Bangladesh", "BE": "Belgium", "BF": "Burkina Faso", "BG": "Bulgaria", "BA": "Bosnia and Herzegovina", "BB": "Barbados", "WF": "Wallis and Futuna", "BL": "Saint Barthelemy", "BM": "Bermuda", "BN": "Brunei", "BO": "Bolivia", "BH": "Bahrain", "BI": "Burundi", "BJ": "Benin", "BT": "Bhutan", "JM": "Jamaica", "BV": "Bouvet Island", "BW": "Botswana", "WS": "Samoa", "BQ": "Bonaire, Saint Eustatius and Saba ", "BR": "Brazil", "BS": "Bahamas", "JE": "Jersey", "BY": "Belarus", "BZ": "Belize", "RU": "Russia", "RW": "Rwanda", "RS": "Serbia", "TL": "East Timor", "RE": "Reunion", "TM": "Turkmenistan", "TJ": "Tajikistan", "RO": "Romania", "TK": "Tokelau", "GW": "Guinea-Bissau", "GU": "Guam", "GT": "Guatemala", "GS": "South Georgia and the South Sandwich Islands", "GR": "Greece", "GQ": "Equatorial Guinea", "GP": "Guadeloupe", "JP": "Japan", "GY": "Guyana", "GG": "Guernsey", "GF": "French Guiana", "GE": "Georgia", "GD": "Grenada", "GB": "United Kingdom", "GA": "Gabon", "SV": "El Salvador", "GN": "Guinea", "GM": "Gambia", "GL": "Greenland", "GI": "Gibraltar", "GH": "Ghana", "OM": "Oman", "TN": "Tunisia", "JO": "Jordan", "HR": "Croatia", "HT": "Haiti", "HU": "Hungary", "HK": "Hong Kong", "HN": "Honduras", "HM": "Heard Island and McDonald Islands", "VE": "Venezuela", "PR": "Puerto Rico", "PS": "Palestinian Territory", "PW": "Palau", "PT": "Portugal", "SJ": "Svalbard and Jan Mayen", "PY": "Paraguay", "IQ": "Iraq", "PA": "Panama", "PF": "French Polynesia", "PG": "Papua New Guinea", "PE": "Peru", "PK": "Pakistan", "PH": "Philippines", "PN": "Pitcairn", "PL": "Poland", "PM": "Saint Pierre and Miquelon", "ZM": "Zambia", "EH": "Western Sahara", "EE": "Estonia", "EG": "Egypt", "ZA": "South Africa", "EC": "Ecuador", "IT": "Italy", "VN": "Vietnam", "SB": "Solomon Islands", "ET": "Ethiopia", "SO": "Somalia", "ZW": "Zimbabwe", "SA": "Saudi Arabia", "ES": "Spain", "ER": "Eritrea", "ME": "Montenegro", "MD": "Moldova", "MG": "Madagascar", "MF": "Saint Martin", "MA": "Morocco", "MC": "Monaco", "UZ": "Uzbekistan", "MM": "Myanmar", "ML": "Mali", "MO": "Macao", "MN": "Mongolia", "MH": "Marshall Islands", "MK": "Macedonia", "MU": "Mauritius", "MT": "Malta", "MW": "Malawi", "MV": "Maldives", "MQ": "Martinique", "MP": "Northern Mariana Islands", "MS": "Montserrat", "MR": "Mauritania", "IM": "Isle of Man", "UG": "Uganda", "TZ": "Tanzania", "MY": "Malaysia", "MX": "Mexico", "IL": "Israel", "FR": "France", "IO": "British Indian Ocean Territory", "SH": "Saint Helena", "FI": "Finland", "FJ": "Fiji", "FK": "Falkland Islands", "FM": "Micronesia", "FO": "Faroe Islands", "NI": "Nicaragua", "NL": "Netherlands", "NO": "Norway", "NA": "Namibia", "VU": "Vanuatu", "NC": "New Caledonia", "NE": "Niger", "NF": "Norfolk Island", "NG": "Nigeria", "NZ": "New Zealand", "NP": "Nepal", "NR": "Nauru", "NU": "Niue", "CK": "Cook Islands", "XK": "Kosovo", "CI": "Ivory Coast", "CH": "Switzerland", "CO": "Colombia", "CN": "China", "CM": "Cameroon", "CL": "Chile", "CC": "Cocos Islands", "CA": "Canada", "CG": "Republic of the Congo", "CF": "Central African Republic", "CD": "Democratic Republic of the Congo", "CZ": "Czech Republic", "CY": "Cyprus", "CX": "Christmas Island", "CR": "Costa Rica", "CW": "Curacao", "CV": "Cape Verde", "CU": "Cuba", "SZ": "Swaziland", "SY": "Syria", "SX": "Sint Maarten", "KG": "Kyrgyzstan", "KE": "Kenya", "SS": "South Sudan", "SR": "Suriname", "KI": "Kiribati", "KH": "Cambodia", "KN": "Saint Kitts and Nevis", "KM": "Comoros", "ST": "Sao Tome and Principe", "SK": "Slovakia", "KR": "South Korea", "SI": "Slovenia", "KP": "North Korea", "KW": "Kuwait", "SN": "Senegal", "SM": "San Marino", "SL": "Sierra Leone", "SC": "Seychelles", "KZ": "Kazakhstan", "KY": "Cayman Islands", "SG": "Singapore", "SE": "Sweden", "SD": "Sudan", "DO": "Dominican Republic", "DM": "Dominica", "DJ": "Djibouti", "DK": "Denmark", "VG": "British Virgin Islands", "DE": "Germany", "YE": "Yemen", "DZ": "Algeria", "US": "United States", "UY": "Uruguay", "YT": "Mayotte", "UM": "United States Minor Outlying Islands", "LB": "Lebanon", "LC": "Saint Lucia", "LA": "Laos", "TV": "Tuvalu", "TW": "Taiwan", "TT": "Trinidad and Tobago", "TR": "Turkey", "LK": "Sri Lanka", "LI": "Liechtenstein", "LV": "Latvia", "TO": "Tonga", "LT": "Lithuania", "LU": "Luxembourg", "LR": "Liberia", "LS": "Lesotho", "TH": "Thailand", "TF": "French Southern Territories", "TG": "Togo", "TD": "Chad", "TC": "Turks and Caicos Islands", "LY": "Libya", "VA": "Vatican", "VC": "Saint Vincent and the Grenadines", "AE": "United Arab Emirates", "AD": "Andorra", "AG": "Antigua and Barbuda", "AF": "Afghanistan", "AI": "Anguilla", "VI": "U.S. Virgin Islands", "IS": "Iceland", "IR": "Iran", "AM": "Armenia", "AL": "Albania", "AO": "Angola", "AQ": "Antarctica", "AS": "American Samoa", "AR": "Argentina", "AU": "Australia", "AT": "Austria", "AW": "Aruba", "IN": "India", "AX": "Aland Islands", "AZ": "Azerbaijan", "IE": "Ireland", "ID": "Indonesia", "UA": "Ukraine", "QA": "Qatar", "MZ": "Mozambique" };

        return Object.keys(obj)
          .map(function(k) {
            return {
              label: obj[k] + " (" + k + ")",
              value: k
            };
          })
          .sort(function(a, b) { return a.label < b.label ? -1 : 1; });
      }
      
      vm.getVATtype = function(countryCode) {
        var type;
        switch (countryCode) {
          case 'AT':
          case 'BE':
          case 'BG':
          case 'CY':
          case 'CZ':
          case 'DE':
          case 'EE':
          case 'ES':
          case 'FI':
          case 'FR':
          case 'GB':
          case 'HR':
          case 'GR':
          case 'HU':
          case 'IE':
          case 'IT':
          case 'LT':
          case 'LU':
          case 'LV':
          case 'MT':
          case 'NL':
          case 'PL':
          case 'PT':
          case 'RO':
          case 'SE':
          case 'SI':
          case 'SK':
            type ="eu_vat";
            break;
          case 'AU':
            type ="au_abn";
            break;
          case 'IN':
            type ="in_gst";
            break;
          case 'NO':
            type ="no_vat";
            break;
          case 'NG':
            type ="ng_gst";
            break;
          
          default:
            type = false
        }
        return type;
      }
      
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
              className: "col-xs-12",
              key: 'email',
              type: 'input',
              templateOptions: {
                label: 'Email',
                required: true
              }
            },
            {
              className: "col-xs-12",
              key: 'name',
              type: 'input',
              templateOptions: {
                label: 'Name',
                required: true
              }
            },
            {
              className: "col-xs-12",
              key: 'line1',
              type: 'input',
              templateOptions: {
                label: 'Address',
                required: true
              }
            },
            {
              className: "col-xs-6",
              key: 'city',
              type: 'input',
              templateOptions: {
                label: 'City',
                required: true
              }
            },
            {
              className: "col-xs-6",
              key: 'postal_code',
              type: 'input',
              templateOptions: {
                label: 'Post code',
                required: true
              }
            },
            {
              className: "col-xs-6",
              key: 'vatId',
              type: 'input',
              templateOptions: {
                label: 'VAT ID',
                required: false
              }
            },
            {
              className: "col-xs-6",
              key: 'country',
              type: 'select',
              templateOptions: {
                label: 'Country',
                options: [],
                valueProp: 'value',
                labelProp: 'label',
                required: true,
                placeholder:'Select country'
              },
              controller: /* @ngInject */ ["$scope", function($scope) {
                $scope.to.options = vm.getCountries();
                // $scope.to.options = SettingService.key('Orga').data;
                // SettingService.findByKey('styleDefinitions').then(function(res){
                //   $scope.to.options = res.data;
                // });
              }]
            },
          
          ]
    }
      
      
      
    
      return vm;
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
    .service('ApiService', ["$q", "$http", "CoreService", function ($q, $http, CoreService) {

      this.checkConnection = function () {
        return $q(function (resolve, reject) {
          $http.get(CoreService.env.apiUrl)
            .success(resolve)
            .error(reject);
        });
      };

    }]);

})();

(function() {
  'use strict';

  angular
    .module('com.module.core')
    .factory('SchemaMaker', function() {

      var vm = this;

      vm.uiGrid = function(schema, filters) {
        var gridSchema = [];
        var relations = [];
        Object.keys(schema).forEach(function(key) {
          var obj = Object.assign(
            {},
            schema[key],
            {
            'name': key,
            'type': schema[key].type || "string"
          });
          gridSchema.push(obj);
        });
        
        var ref,model,field;
        
        gridSchema = gridSchema.map(function(item) {
          switch (item.type) {
            case 'date':
              item.cellFilter = item.cellFilter || 'date:\'yyyy-MM-dd h:mm\'';
              item.width = 110;
              break;

            case 'number':
              item.width = 100;
              break;

            case 'string':
              break;

            case 'relation':
              ref = item.name.split('.');
              model = ref[0];
              field = ref[1];
              relations.push({
                model: model,
                field: field
              });
              item.field = item.name; //file.name
              item.name = model; //file

              item.cellTemplate = 
              '<div class="ui-grid-cell-contents" title="TOOLTIP">'+
              '<relation-viewer entity="row.entity" model="'+model+'" field="'+field+'"></relation-viewer>'+
              '</div>';

              item.enableFiltering = false;
              break;
              
            case 'image':
              ref = item.name.split('.');
              model = ref[0];
              field = ref[1];
              item.name = model;
              item.field = model;
              item.cellTemplate = 
              '<img style="max-height:50px" ng-src="data:image/*;base64,{{ row.entity.logo.'+field+' }}" alt="Organization logo" title="Organization logo">'

              item.enableFiltering = false;
              break;

            default:
              // other
          }
          // default props
          item.cellTooltip = true;
          return item;
        });


        // add relations (includes)
        if (relations.length > 0) {
          filters.include = [];
          relations.forEach(function(rel) {
            filters.include.push(rel.model);
          });
        }

        console.log('GridSchema calculated')

        return gridSchema;

      };

      


      return vm;

    });


})();

(function() {
  'use strict';

  angular
    .module('com.module.core')
    .service('GridHelper', ["$timeout", function($timeout) {

      var vm = this;

      vm.gridOptions = function(schema, getPageData, paginationOptions, filterOptions, config, gridApiBinding) {
        // Configuration
        var controllerAs = config?'.'+config.controllerAs||'':'';
        
        // actionColumns
        config = config || {};
        var actionColumns = [];
        config.actionColumns = config.actionColumns || {};
        // defaults
        config.actionColumns.viewElement = config.actionColumns.viewElement || {
          template:'<a href="" style="margin:2px" title="View" class="btn btn-xs btn-default" ng-click="grid.appScope'+controllerAs+'.viewElement(row.entity)"><i class="fa fa-eye"></i></a>'
        }
        config.actionColumns.editElement = config.actionColumns.editElement || {
          template:'<a href="" style="margin:2px" title="Edit" class="btn btn-xs btn-warning" ng-click="grid.appScope'+controllerAs+'.editElement(row.entity)"><i class="fa fa-pencil"></i></a>'
        }
        config.actionColumns.deleteElement = config.actionColumns.deleteElement || {
          template:'<a href="" style="margin:2px" title="Delete" class="btn btn-xs btn-danger" ng-click="grid.appScope'+controllerAs+'.deleteElement(row.entity)"><i class="fa fa-trash"></i></a>'
        }
        if(!config.actionColumns.viewElement.disabled) actionColumns.push(createActionColumn('view',config.actionColumns.viewElement.template)); 
        if(!config.actionColumns.editElement.disabled) actionColumns.push(createActionColumn('edit',config.actionColumns.editElement.template)); 
        if(!config.actionColumns.deleteElement.disabled) actionColumns.push(createActionColumn('delete',config.actionColumns.deleteElement.template)); 
        
        return {
          enableFiltering: true,
          enableColumnResizing: true,
          paginationPageSizes: [15],
          paginationPageSize: paginationOptions.pageSize || 15,
          useExternalPagination: true,
          useExternalSorting: true,
          useExternalFiltering: true,
          onRegisterApi: function(gridApi) {
            // vm.gridApi = gridApi;0
            gridApiBinding = gridApi;

            // external pagination
            gridApi.pagination.on.paginationChanged(null, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;

              filterOptions.limit = paginationOptions.pageSize;
              filterOptions.skip = paginationOptions.pageSize * (paginationOptions.pageNumber - 1);
              getPageData();
            });

            // external filters
            gridApi.core.on.filterChanged(null, function() {
              var grid = this.grid;
              var filters = grid.columns.reduce(function(acc, cur) {
                if (cur.field.indexOf('_label') === -1 &&
                  cur.filters[0].term &&
                  cur.filters[0].term.length > 0) {
                  acc[cur.field] = {
                    "regexp": new RegExp(cur.filters[0].term, 'i').toString()
                  };
                  // or like {"like":cur.filters[0].term}
                }
                return acc;
              }, {});
              
              if (Object.keys(filters).length > 0) {

                filterOptions.where = filters;
                // debounce 1sec
                $timeout.cancel(vm.filtersDebounced);
                vm.filtersDebounced = $timeout(function() {
                  getPageData();
                }, 1000);
              }
              else {

                delete filterOptions.where;
                // do not debounce for clearing filters
                getPageData();
              }
            });

            // external sorting
            gridApi.core.on.sortChanged(null, function() {
              var grid = this.grid;
              var sort;
              for (var i = 0, len = grid.columns.length; i < len; i++) {
                sort = grid.columns[i].sort;
                if (sort.direction && sort.priority === 0) {
                  sort.field = grid.columns[i].field;
                  break;
                }
              }
              if (sort.direction) {
                filterOptions.order = sort.field + ' ' + sort.direction.toUpperCase();
              }
              else {
                delete filterOptions.order;
              }
              getPageData();
            });

          },
          columnDefs: schema.concat(actionColumns)
          
        };

      };
      
      
      function createActionColumn(field,template){
        return {
          name: field,
          enableSorting: false,
          enableFiltering: false,
          enableColumnMenu: false,
          enableCellEdit: false,
          cellTemplate: '<div class="ui-grid-cell-contents">' + template + '</div>',
          width: 60
        }
      }

      return vm;

    }]);


})();

(function () {
  'use strict';

  angular
    .module('com.module.core')
    .factory('FormHelper', ["$state", "CoreService", "gettextCatalog", function ($state, CoreService, gettextCatalog) {

      return function (model) {

        console.log('This is the model', model);

        this.model = model;

        /**
         * @param {string} id: id of the item that is to be deleted.
         *
         * @description
         * Initiates a delete action. Prompts the user form confirmation
         * before actioning the delete.
         */
        this.delete = function (id) {

          CoreService.confirm(gettextCatalog.getString('Are you sure?'),
            gettextCatalog.getString('Deleting this cannot be undone'),
            function () {
              this.model.deleteById(id, function () {
                CoreService.toastSuccess(gettextCatalog.getString(
                  'Item deleted'), gettextCatalog.getString(
                  'Your item has been deleted!'));
                $state.reload();
              }, function (err) {
                CoreService.toastError(gettextCatalog.getString(
                  'Oops'), gettextCatalog.getString(
                    'Error deleting item: ') + err);
              });
            },
            function () {
              return false;
            });

        };

        /**
         * @param {string} id: name of state to transition to
         *
         * @description
         * Cancel a form action. Sends the user back to the previous page they
         * were on
         */
        this.cancel = function (defaultState) {
          $state.go(defaultState);
        };

      };

    }]);

})();

(function () {
  'use strict';

  angular
    .module('com.module.core')
    .service('Validators', function () {
    
        var vm =  {
            'email':validateEmail,
            'emailRaw':new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        };
        
        function validateEmail(email) {
            return vm.emailRaw.test(email);
        };
        
        
        return vm
        
    });
})();
window.uuid = function() {
  var uuid = "", i, random;
  for (i = 0; i < 32; i++) {
    random = Math.random() * 16 | 0;

    if (i == 8 || i == 12 || i == 16 || i == 20) {
      uuid += "-"
    }
    uuid += (i == 12 ? 4 : (i == 16 ? (random & 3 | 8) : random)).toString(16);
  }
  return uuid;
}
  angular
    .module('com.module.core')
    .filter('propsFilter', function() {
        return function(items, props) {
          var out = [];
      
          if (angular.isArray(items)) {
            var keys = Object.keys(props);
      
            items.forEach(function(item) {
              var itemMatches = false;
              var text;
              for (var i = 0; i < keys.length; i++) {
                var prop = keys[i];
                var nested = prop.split('.');
                if(nested.length===1) {
                  text = props[prop].toLowerCase();
                  if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                    itemMatches = true;
                    break;
                  }
                } else if(nested.length===2) {
                  text = props[prop].toLowerCase();
                  if (item[nested[0]][nested[1]].toString().toLowerCase().indexOf(text) !== -1) {
                    itemMatches = true;
                    break;
                  }
                } else {
                  console.log("propsFilter: Only 2 levels of nested properties are supported.");
                }
              }
      
              if (itemMatches) {
                out.push(item);
              }
            });
          } else {
            // Let the output be the input untouched
            out = items;
          }
      
          return out;
        };
      })
      .filter('formatByte', function () {
       
        return function (size) {
          var base = 1024;
          return ((size / base ).toFixed(1) + ' KB');
          // auto calculate prefix - nice but ruins sorting
          // var prefixes = ['K','M','G','T','P','E','Z','Y'];
          // var exp = Math.log(size) / Math.log(base) | 0;
          // return (size / Math.pow(base, exp)).toFixed(1) + ' ' +
          //   ((exp > 0) ? prefixes[exp - 1] + 'B' : 'Bytes');
        };
      });


(function () {
    'use strict';
    /**
     * @name CSV
     * @namespace
     */
    // implemented as a singleton because JS is single threaded
    var CSV = {};
    CSV.RELAXED = false;
    CSV.IGNORE_RECORD_LENGTH = false;
    CSV.IGNORE_QUOTES = false;
    CSV.LINE_FEED_OK = true;
    CSV.CARRIAGE_RETURN_OK = true;
    CSV.DETECT_TYPES = true;
    CSV.IGNORE_QUOTE_WHITESPACE = true;
    CSV.DEBUG = false;

    CSV.COLUMN_SEPARATOR = ",";

    CSV.ERROR_EOF = "UNEXPECTED_END_OF_FILE";
    CSV.ERROR_CHAR = "UNEXPECTED_CHARACTER";
    CSV.ERROR_EOL = "UNEXPECTED_END_OF_RECORD";
    CSV.WARN_SPACE = "UNEXPECTED_WHITESPACE"; // not per spec, but helps debugging

    var QUOTE = "\"",
        CR = "\r",
        LF = "\n",
        SPACE = " ",
        TAB = "\t";

    // states
    var PRE_TOKEN = 0,
        MID_TOKEN = 1,
        POST_TOKEN = 2,
        POST_RECORD = 4;
    /**
     * @name CSV.parse
     * @function
     * @description rfc4180 standard csv parse
     * with options for strictness and data type conversion
     * By default, will automatically type-cast numeric an boolean values.
     * @param {String} str A CSV string
     * @return {Array} An array records, each of which is an array of scalar values.
     * @example
     * // simple
     * var rows = CSV.parse("one,two,three\nfour,five,six")
     * // rows equals [["one","two","three"],["four","five","six"]]
     * @example
     * // Though not a jQuery plugin, it is recommended to use with the $.ajax pipe() method:
     * $.get("csv.txt")
     *    .pipe( CSV.parse )
     *    .done( function(rows) {
     *        for( var i =0; i < rows.length; i++){
     *            console.log(rows[i])
     *        }
     *  });
     * @see http://www.ietf.org/rfc/rfc4180.txt
     */
    CSV.parse = function (str) {
        var result = CSV.result = [];
        CSV.offset = 0;
        CSV.str = str;
        CSV.record_begin();

        CSV.debug("parse()", str);

        var c;
        while( 1 ){
            // pull char
            c = str[CSV.offset++];
            CSV.debug("c", c);

            // detect eof
            if (c == null) {
                if( CSV.escaped )
                    CSV.error(CSV.ERROR_EOF);

                if( CSV.record ){
                    CSV.token_end();
                    CSV.record_end();
                }

                CSV.debug("...bail", c, CSV.state, CSV.record);
                CSV.reset();
                break;
            }

            if( CSV.record == null ){
                // if relaxed mode, ignore blank lines
                if( CSV.RELAXED && (c == LF || c == CR && str[CSV.offset + 1] == LF) ){
                    continue;
                }
                CSV.record_begin();
            }

            // pre-token: look for start of escape sequence
            if (CSV.state == PRE_TOKEN) {

                if ( (c === SPACE || c === TAB) && CSV.next_nonspace() == QUOTE ){
                    if( CSV.RELAXED || CSV.IGNORE_QUOTE_WHITESPACE ) {
                        continue;
                    }
                    else {
                        // not technically an error, but ambiguous and hard to debug otherwise
                        CSV.warn(CSV.WARN_SPACE);
                    }
                }

                if (c == QUOTE && ! CSV.IGNORE_QUOTES) {
                    CSV.debug("...escaped start", c);
                    CSV.escaped = true;
                    CSV.state = MID_TOKEN;
                    continue;
                }
                CSV.state = MID_TOKEN;
            }

            // mid-token and escaped, look for sequences and end quote
            if (CSV.state == MID_TOKEN && CSV.escaped) {
                if (c == QUOTE) {
                    if (str[CSV.offset] == QUOTE) {
                        CSV.debug("...escaped quote", c);
                        CSV.token += QUOTE;
                        CSV.offset++;
                    }
                    else {
                        CSV.debug("...escaped end", c);
                        CSV.escaped = false;
                        CSV.state = POST_TOKEN;
                    }
                }
                else {
                    CSV.token += c;
                    CSV.debug("...escaped add", c, CSV.token);
                }
                continue;
            }

            // fall-through: mid-token or post-token, not escaped
            if (c == CR ) {
                if( str[CSV.offset] == LF  )
                    CSV.offset++;
                else if( ! CSV.CARRIAGE_RETURN_OK )
                    CSV.error(CSV.ERROR_CHAR);
                CSV.token_end();
                CSV.record_end();
            }
            else if (c == LF) {
                if( ! (CSV.LINE_FEED_OK || CSV.RELAXED) )
                    CSV.error(CSV.ERROR_CHAR);
                CSV.token_end();
                CSV.record_end();
            }
            else if (c == CSV.COLUMN_SEPARATOR) {
                CSV.token_end();
            }
            else if( CSV.state == MID_TOKEN ){
                CSV.token += c;
                CSV.debug("...add", c, CSV.token);
            }
            else if ( c === SPACE || c === TAB) {
                if (! CSV.IGNORE_QUOTE_WHITESPACE )
                    CSV.error(CSV.WARN_SPACE );
            }
            else if( ! CSV.RELAXED ){
                CSV.error(CSV.ERROR_CHAR);
            }
        }
        return result;
    };

    CSV.json = function () {
	var s = new require('stream').Transform({objectMode: true})
	s._transform = function(chunk, encoding, done) {
	    s.push(JSON.stringify(chunk.toString())+require('os').EOL)
	    done()
	}
	return s
    }

    /**
     * @name CSV.stream
     * @function
     * @description stream a CSV file
     * @example
     * node -e "c=require('CSV-JS');require('fs').createReadStream('csv.txt').pipe(c.stream()).pipe(c.json()).pipe(process.stdout)"
     */
    CSV.stream = function () {
	var s = new require('stream').Transform({objectMode: true})
	s.EOL = '\n'
	s.prior = ""
	s.emitter = function(s) {
	    return function(e) {
		s.push(CSV.parse(e+s.EOL))
	    }
	}(s);

	s._transform = function(chunk, encoding, done) {
	    var lines = (this.prior == "") ?
		chunk.toString().split(this.EOL) :
		(this.prior + chunk.toString()).split(this.EOL)
	    this.prior = lines.pop();
	    lines.forEach(this.emitter)
	    done()
	}

	s._flush = function(done) {
	    if (this.prior != "") {
		this.emitter(this.prior)
		this.prior = ""
	    }
	    done()
	}
	return s
    }
    
    CSV.reset = function () {
        CSV.state = null;
        CSV.token = null;
        CSV.escaped = null;
        CSV.record = null;
        CSV.offset = null;
        CSV.result = null;
        CSV.str = null;
    };

    CSV.next_nonspace = function () {
        var i = CSV.offset;
        var c;
        while( i < CSV.str.length ) {
            c = CSV.str[i++];
            if( !( c == SPACE || c === TAB ) ){
                return c;
            }
        }
        return null;
    };

    CSV.record_begin = function () {
        CSV.escaped = false;
        CSV.record = [];
        CSV.token_begin();
        CSV.debug("record_begin");
    };

    CSV.record_end = function () {
        CSV.state = POST_RECORD;
        if( ! (CSV.IGNORE_RECORD_LENGTH || CSV.RELAXED) && CSV.result.length > 0 && CSV.record.length !=  CSV.result[0].length ){
            CSV.error(CSV.ERROR_EOL);
        }
        CSV.result.push(CSV.record);
        CSV.debug("record end", CSV.record);
        CSV.record = null;
    };

    CSV.resolve_type = function (token) {
        if( token.match(/^\d+(\.\d+)?$/) ){
            token = parseFloat(token);
        }
        else if( token.match(/^(true|false)$/i) ){
            token = Boolean( token.match(/true/i) );
        }
        else if(token === "undefined" ){
            token = undefined;
        }
        else if(token === "null" ){
            token = null;
        }
        return token;
    };

    CSV.token_begin = function () {
        CSV.state = PRE_TOKEN;
        // considered using array, but http://www.sitepen.com/blog/2008/05/09/string-performance-an-analysis/
        CSV.token = "";
    };

    CSV.token_end = function () {
        if( CSV.DETECT_TYPES ) {
            CSV.token = CSV.resolve_type(CSV.token);
        }
        CSV.record.push(CSV.token);
        CSV.debug("token end", CSV.token);
        CSV.token_begin();
    };

    CSV.debug = function (){
        if( CSV.DEBUG )
            console.log(arguments);
    };

    CSV.dump = function (msg) {
        return [
            msg , "at char", CSV.offset, ":",
            CSV.str.substr(CSV.offset- 50, 50)
                .replace(/\r/mg,"\\r")
                .replace(/\n/mg,"\\n")
                .replace(/\t/mg,"\\t")
        ].join(" ");
    };

    CSV.error = function (err){
        var msg = CSV.dump(err);
        CSV.reset();
        throw msg;
    };

    CSV.warn = function (err){
        var msg = CSV.dump(err);
        try {
            console.warn( msg );
            return;
        } catch (e) {}

        try {
            console.log( msg );
        } catch (e) {}

    };

    (function(name, context, definition) {
        var define;
            if (typeof module != 'undefined' && module.exports) module.exports = definition();
            else if (typeof define == 'function' && typeof define.amd == 'object') define(definition);
            else context[name] = definition();
        }('CSV', Function('return this')(), function()
            { return CSV; }
        )
    );

})();
(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:smallbBox
   * @restrict E
   * @description Dashboard Box
   * @param {string} name Box Title
   * @param {string} color Admin-Lte bg-color
   * @param {string} icon Ionic-icon class
   * @param {string} quantity Title
   * @param {string} href ui-shref link
   */
  angular
    .module('com.module.core')
    .directive('smallBox', function () {
      return {
        restrict: 'E',
        templateUrl: 'app/modules/core/views/elements/small-box.html',
        scope: {
          name: '@',
          color: '@',
          icon: '@',
          quantity: '@',
          href: '@'
        }
      };
    });

})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name com.module.core.directive:home
   * @description
   * # home
   */
  angular
    .module('com.module.core')
 .directive('ngThumb', ['$window', function($window) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function(scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                if (!helper.isImage(params.file)) return;

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }]);

})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name com.module.core.directive:navbar
   * @description
   * # navbar
   */
  angular
    .module('com.module.core')
    .directive('navbar', function () {
      return {
        templateUrl: 'app/modules/core/views/elements/navbar.html',
        restrict: 'E'
      };
    });

})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name com.module.core.directive:home
   * @description
   * # home
   */
  angular
    .module('com.module.core')
    .directive('home', function () {
      return {
        template: '<div></div>',
        restrict: 'E',
        link: function postLink (scope, element, attrs) {
          element.text('this is the home directive ' + attrs);
        }
      };
    });

})();

(function () {
  'use strict';

  angular
    .module('com.module.core')
    .directive('dateButton', function () {
      var linkFn = function link (scope) {
        scope.options.open = false;
        scope.switchOpen = function (event) {
          event.preventDefault();
          event.stopPropagation();
          scope.options.open = true;
          return true;
        };
      };

      return {
        restrict: 'A',
        scope: false,
        compile: function (element) {
          var span = angular.element('<span></span>');
          var button = angular.element('<button></button>');
          var i = angular.element('<i></i>');

          span.addClass('input-group-btn');

          button.attr('type', 'button');
          button.addClass('btn btn-default');
          button.attr('ng-click', 'switchOpen($event)');

          i.addClass('glyphicon glyphicon-calendar');

          button.append(i);
          span.append(button);
          element.after(span);

          return linkFn;
        }
      };
    });

})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name com.module.core.directive:adminHeader
   * @description
   * @param {string} title Title
   * @param {string} subTitle Subtitle
   * # adminHeader
   */
  angular
    .module('com.module.core')
    .directive('adminHeader', function () {
      return {
        templateUrl: 'app/modules/core/views/elements/admin-header.html',
        transclude: true,
        scope: {
          title: '@',
          subTitle: '@'
        },
        restrict: 'A'
      };
    });

})();

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name com.module.core.directive:adminForm
   * @description
   * # adminForm
   */
  angular
    .module('com.module.core')
    .directive('adminForm', function () {
      return {
        template: '<div></div>',
        restrict: 'E',
        link: function postLink (scope, element) {
          element.text('this is the adminForm directive');
        }
      };
    });

})();

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:adminBox
   * @description
   * # adminBox
   */
  angular
    .module('com.module.core')
    .directive('adminBox', function () {
      return {
        template: '<div></div>',
        restrict: 'E',
        link: function postLink (scope, element) {
          element.text('this is the adminBox directive');
        }
      };
    });

})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name com.module.core.controller:RouteCtrl
   * @description Redirect for acess
   * @requires $q
   * @requires $scope
   * @requires $state
   * @requires $location
   * @requires AppAuth
   **/
  angular
    .module('com.module.core')
    .controller('RouteCtrl', ["ApiService", "AppAuth", "$location", "currentUser", "$rootScope", function (ApiService, AppAuth, $location,currentUser,$rootScope) {
      ApiService.checkConnection()
        .then(function () {
          console.log('ApiService.checkConnection success');
          if (!currentUser.id) {
            console.log('Redirecting to /login')
            $location.path('/login');
          } else {
            console.log('Redirecting to /app')
            $location.path('/app/projects');
          }
        })
        .catch(function (err) {
          console.log('ApiService.checkConnection err: ' + err);
          $location.path('/error');
        });

    }]);

})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name com.module.core.controller:MainCtrl
   * @description Login Controller
   * @requires $scope
   * @requires $state

   * @requires CoreService
   * @requires SystemUser
   * @requires gettextCatalog
   **/
  angular
    .module('com.module.core')
    .controller('MainCtrl', ["$timeout", "$scope", "$rootScope", "currentUser", "$state", "AppAuth", "CoreService", "SystemUser", "gettextCatalog", "ProjectsService", function ($timeout,$scope, $rootScope,currentUser, $state, AppAuth, CoreService, SystemUser, gettextCatalog, ProjectsService) {
      
      var vm = $scope;
  
      vm.currentUser = currentUser;
      vm.siteUrl = CoreService.env.siteUrl;
      
      /*Menu Configuration*/
      $rootScope.clearMenu();
      $rootScope.addMenu(gettextCatalog.getString('Projects'), 'app.projects.list', 'fa-calendar-o');
      
      if(vm.currentUser.roles.indexOf('superadmin')>=0) {
        $rootScope.addMenu(gettextCatalog.getString('Users'), 'app.users', 'fa-user');
        $rootScope.addMenu(gettextCatalog.getString('Organizations'), 'app.organizations.list', 'fa-sitemap');
        $rootScope.addMenu(gettextCatalog.getString('Files'), 'app.files.list', 'fa-file');
        $rootScope.addMenu(gettextCatalog.getString('Grading Schemes'),'app.gradingschemes.list', 'fa-file-text');
        $rootScope.addMenu(gettextCatalog.getString('SSO Providers'),'app.authproviders.list', 'fa-id-card');
        $rootScope.addMenu(gettextCatalog.getString('Reporting'),'app.reporting.list', 'fa-table');
        $rootScope.addMenu(gettextCatalog.getString('Custom Styles'),'app.customstyles.list', 'fa-paint-brush');
        $rootScope.addMenu(gettextCatalog.getString('Settings'),'app.settings.list', 'fa-cog');
        $rootScope.addMenu(gettextCatalog.getString('Permissions'),'app.permissions.list', 'fa-key');
      }
      
      vm.menuoptions = $rootScope.menu;   
      
      vm.isMenuActive = function(state){
        if(state==='app.users') return $state.is(state);
        var s = state.substring(0,state.lastIndexOf('.'));
        if(s.indexOf('.')===-1) return false;
        return $state.includes(s)
      }
        
      vm.logout = function () {
        AppAuth.logout(function () {
          CoreService.toastSuccess(gettextCatalog.getString('Logged out'),
            gettextCatalog.getString('You are logged out!'));
          $state.go('login');
        });
      };

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
  /**
   * @ngdoc function
   * @name com.module.core.controller:LayoutCtrl
   * @description Layout controller
   * @requires $scope
   * @requires $rootScope
   * @requires CoreService
   * @requires gettextCatalog
   **/
    .controller('LayoutCtrl', ["$scope", "$rootScope", "$cookies", "CoreService", "gettextCatalog", function ($scope, $rootScope, $cookies, CoreService, gettextCatalog) {

      // angular translate
      $scope.locale = {
        isopen: false
      };

      $scope.locales = $rootScope.locales;
      $scope.selectLocale = $rootScope.locale;

      $scope.setLocale = function (locale) {
        // set the current lang
        $scope.locale = $scope.locales[locale];
        $scope.selectLocale = $scope.locale;
        $rootScope.locale = $scope.locale;
        $cookies.lang = $scope.locale.lang;

        // You can change the language during runtime
        $scope.locale.isopen = !$scope.locale.isopen;

        gettextCatalog.setCurrentLanguage($scope.locale.lang);
      };

      $scope.appName = 'SYLVA Admin';
      $scope.apiUrl = CoreService.env.apiUrl;
      $scope.appTheme = 'skin-aesg';
      $scope.appThemes = [
        {
          'name': 'AESG',
          'class': 'skin-aesg'
        },
        {
          'name': 'Black',
          'class': 'skin-black'
        },
        {
          'name': 'Blue',
          'class': 'skin-blue'
        }
      ];
      $scope.appLayout = '';
      $scope.appLayouts = [
        {
          'name': 'Fixed',
          'class': 'fixed'
        },
        {
          'name': 'Scrolling',
          'class': 'not-fixed'
        }
      ];

      $scope.toggleSidebar = function () {
        // var $ = $ || angular.element;
        if ($(window).width() <= 992) {
          $('.row-offcanvas').toggleClass('active');
          $('.left-side').removeClass('collapse-left');
          $('.right-side').removeClass('strech');
          $('.row-offcanvas').toggleClass('relative');
        } else {
          // Else, enable content streching
          $('.left-side').toggleClass('collapse-left');
          $('.right-side').toggleClass('strech');
        }
      };

      // $scope.settings = $rootScope.settings;
      
      // $rootScope.loadSettings();

    }]);

})();

(function () {
  'use strict';
  /**
   * @ngdoc function
   * @name com.module.core.controller:HomeCtrl
   * @description Dashboard
   * @requires $scope
   * @requires $rootScope
   **/
  angular
    .module('com.module.core')
    .controller('HomeCtrl', ["$scope", "$rootScope", "currentUser", "$state", function ($scope, $rootScope,currentUser,$state) {
      $scope.count = {};
      $scope.boxes = $rootScope.dashboardBox;
      $scope.currentUser = currentUser;
      $state.go('app.projects.list');
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
    .config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
      $stateProvider
        .state('router', {
          url: '/router',
          template: '<div class="lockscreen" style="height: 100%"></div>',
          controller: 'RouteCtrl',
          resolve: {
            currentUser: ["AppAuth", function(AppAuth){
              return AppAuth.getAuthenticatedUser();
            }]
          }
        })
        .state('error', {
          url: '/error',
          template: '<div class="text-center alert alert-danger" style="margin: 100px">An error occurred.</div>',
          controller:["$scope", "ApiService", "$state", function($scope,ApiService,$state){
            ApiService.checkConnection().then(function(){
              $state.go('router');
            }).catch(function(err){
              console.log(err)
            })
          }]
        })
        .state('app', {
          abstract: true,
          url: '/app',
          templateUrl: 'app/modules/core/views/app.html',
          controller: 'MainCtrl',
          resolve: {
            currentUser: ["AppAuth", function(AppAuth){
              return AppAuth.getAuthenticatedUser();
            }],
            settings: ["AppAuth", "SettingService", function(AppAuth,SettingService){
              return SettingService.find();
            }]
          }
        })
        // .state('app.home', {
        //   url: '',
        //   templateUrl: 'app/modules/core/views/home.html',
        //   controller: 'HomeCtrl'
        // });
          
        $urlRouterProvider.otherwise( function($injector) {
          var $state = $injector.get("$state");
          $state.go('router');
        });
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.core')
    .config(["cfpLoadingBarProvider", function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = false;
    }])
    .config(["gravatarServiceProvider", function (gravatarServiceProvider) {
        if(window.ENV!=='development') {
          gravatarServiceProvider.defaults = {
            "default": window.location.origin+window.location.pathname+"images/sylva_icon.png"
          }
        }
    }])
    .config(["LoopBackResourceProvider", "CoreServiceProvider", function (LoopBackResourceProvider,CoreServiceProvider) {
        
        var conf=CoreServiceProvider.$get().env;
        // Use a custom auth header instead of the default 'Authorization'
        // LoopBackResourceProvider.setAuthHeader('X-Access-Token');
        
        // Change the URL where to access the LoopBack REST API server
        LoopBackResourceProvider.setUrlBase(conf.apiUrl);
    }])
    .config(["angularBusyDefaults", function(angularBusyDefaults) {    

      // angularBusyDefaults.message = 'Loading Stuff';
      // angularBusyDefaults.backdrop = false;
      // angularBusyDefaults.templateUrl = 'my_custom_template.html';
      // angularBusyDefaults.delay = 300;
      // angularBusyDefaults.minDuration = 700;
      // angularBusyDefaults.wrapperClass = 'my-class my-class2';
    
    }])
    .run(["$rootScope", "gettextCatalog", "SettingService", function ($rootScope, gettextCatalog, SettingService) {

      // Left Sidemenu
      $rootScope.menu = [];

      // Add Sidebar Menu
      $rootScope.clearMenu = function(uisref){
        if(!uisref) $rootScope.menu = [];
        else {        
          $rootScope.menu = $rootScope.menu.filter(function(elem){
            return elem.sref!==uisref;
          })
        }
      }
      $rootScope.addMenu = function (name, uisref, icon) {
        var exists=false;        
        $rootScope.menu.forEach(function(elem){
          if(elem.sref===uisref) exists=true;
        })
        if(!exists) $rootScope.menu.push({
          name: name,
          sref: uisref,
          icon: icon
        });
      };
      
      // Get settings config from DB
      SettingService.getConf();

      // // Add Menu Dashboard
      // $rootScope.addMenu(gettextCatalog.getString('Dashboard'), 'app.home',
      //   'fa-dashboard');

      // // Dashboard
      // $rootScope.dashboardBox = [];

      // // Add Dashboard Box
      // $rootScope.addDashboardBox = function (name, color, icon, quantity, href) {
      //   $rootScope.dashboardBox.push({
      //     name: name,
      //     color: color,
      //     icon: icon,
      //     quantity: quantity,
      //     href: href
      //   });
      // };

      // // Get Settings for Database
      // $rootScope.setSetting = function (key, value) {

      //   Setting.find({
      //     filter: {
      //       where: {
      //         key: key
      //       }
      //     }
      //   }, function (data) {

      //     if (data.length) {
      //       data[0].value = value;
      //       data[0].$save();
      //     } else {
      //       Setting.create({
      //         key: key,
      //         value: value
      //       }, function (data) {
      //         console.log(data);
      //       });
      //     }
      //     $rootScope.loadSettings();
      //   });
      // };

      // // Load Settings blank
      // $rootScope.settings = {};

      // // Get Settings for Loopback Service
      // $rootScope.loadSettings = function () {
      //   Setting.find(function (settings) {
      //     $rootScope.settings.data = settings;
      //   });
      // };

    }])

})();

(function () {
  'use strict';
  angular.module('com.module.authproviders', []);
})();

(function () {
  'use strict';
  angular
    .module('com.module.authproviders')
    .service('AuthProvidersService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", "LoopBackAuth", function ($state, CoreService, Setting, gettextCatalog,$http,LoopBackAuth) {
      var vm = this;
      vm.authproviders = [];
      vm.find = function () {
        return $http.get(CoreService.env.apiUrl+'/AuthProviders');
      };
      
      vm.findById = function (id) {
        return $http.get(CoreService.env.apiUrl+'/AuthProviders/'+id).then(function(res){
          return res.data;
        })
      };

      vm.upsert = function(provider) {
        var p;
        if (provider.id) {
          // put
          p = $http.put(CoreService.env.apiUrl + '/AuthProviders/' + provider.id, provider);
        }
        else {
          // post
          p = $http.post(CoreService.env.apiUrl + '/AuthProviders', provider);

        }
        p
        .then(function(res){
          return res.data;
        })
        .then(function() {
            CoreService.toastSuccess(
              gettextCatalog.getString('Provider saved')
            );
          })
          .catch(function(err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving provider'),
              err.toString()
            );
          });
        return p;
      };

      vm.delete = function(id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function() {
            $http.delete(CoreService.env.apiUrl + '/AuthProviders/' + id)
              .then(function(){
                CoreService.toastSuccess(
                  gettextCatalog.getString('Provider deleted')
                )
                successCb();
              })
              .catch(function(err) {
                CoreService.toastError(
                  gettextCatalog.getString('Error deleting provider'),
                  err.toString()
                )
                cancelCb();
              })
          },
          function() {
            cancelCb();
          }
        );
      };
      

      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.authproviders')
    .service('AuthProviderConnectionsService', ["$state", "CoreService", "Setting", "gettextCatalog", "$http", "LoopBackAuth", function ($state, CoreService, Setting, gettextCatalog,$http,LoopBackAuth) {
      var vm = this;
      vm.authproviders = [];
      vm.find = function () {
        return $http.get(CoreService.env.apiUrl+'/AuthProviderConnections');
      };
      
      vm.getUserConnections = function (userId) {
        return $http.get(CoreService.env.apiUrl+'/SystemUsers/'+userId+'/authproviders').then(function(res){
          return res.data;
        })
      };

      vm.addUserConnection = function(userId,email,providerId) {
        return $http.put(CoreService.env.apiUrl + '/SystemUsers/' + userId + '/authproviders/rel/' + providerId, {
          email: email
        })
        .then(function(res){
          return res.data;
        })
        .then(function() {
            CoreService.toastSuccess(
              gettextCatalog.getString('Connection saved')
            );
          })
          .catch(function(err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving Connection'),
              err.toString()
            );
          });
      };

      vm.deleteUserConnection = function(userId, providerId, successCb, cancelCb) {
        successCb = successCb || function(){};
        cancelCb = cancelCb || function(){};
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function() {
              return $http.delete(CoreService.env.apiUrl + '/SystemUsers/' + userId + '/authproviders/rel/' + providerId)
              .then(function(){
                CoreService.toastSuccess(
                  gettextCatalog.getString('Connection deleted')
                )
                successCb();
              })
              .catch(function(err) {
                CoreService.toastError(
                  gettextCatalog.getString('Error deleting Connection'),
                  err.toString()
                )
                cancelCb();
              })
          },
          function() {
            cancelCb();
          }
        );
      };
      

      return vm;

    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.authproviders')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.authproviders', {
          abstract: true,
          url: '/authproviders',
          templateUrl: 'app/modules/authproviders/views/main.html'
        })
        .state('app.authproviders.list', {
          url: '/list',
          templateUrl: 'app/modules/authproviders/views/list.html',
          controllerAs: 'ctrl',
          controller: ["AuthProvidersService", function (AuthProvidersService) {
            var vm = this;
            
            vm.loading = AuthProvidersService.find().then(function(res){
              vm.authproviders = res.data;
            })
            
            
          }]
        })
        .state('app.authproviders.add', {
          url: '/add',
          templateUrl: 'app/modules/authproviders/views/form.html',
          controllerAs: 'ctrl',
          controller:'AuthProvidersSingleController',
          resolve: {
            authprovider: function () {
              return {data:{}};
            }
          }
        })
        .state('app.authproviders.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/authproviders/views/form.html',
          controllerAs: 'ctrl',
          controller:'AuthProvidersSingleController',
          resolve: {
            authprovider: ["$stateParams", "AuthProvidersService", function($stateParams, AuthProvidersService) {
              return AuthProvidersService.findById($stateParams.id);
            }],
            previewComponent: ["$stateParams", "Setting", function($stateParams, Setting) {
              return Setting.find({
                filter: {
                  where: {
                    key: 'admin.configuration'
                  }
                }
              }).$promise.then(function(res) {
                return res[0].data.stylePreviewLectureLink;
              });
            }]
          }
        })
        .state('app.authproviders.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$stateParams", "$state", "AuthProvidersService", function ($stateParams, $state, AuthProvidersService) {
            AuthProvidersService.delete($stateParams.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }]
        });
    }]);

})();

(function() {
  'use strict';
  angular
    .module('com.module.authproviders')
    .controller('AuthProvidersSingleController', ["$timeout", "$state", "AuthProvidersService", "authprovider", "CoreService", function($timeout, $state, AuthProvidersService, authprovider,CoreService) {
      var vm = this;
      vm.authprovider = authprovider;
      vm.authprovider.data = vm.authprovider.data || {};
      vm.formOptions = {};
      var api = CoreService.env.apiUrl;
      vm.previewUrl = api.substring(0,api.lastIndexOf('/api')) + '/sso/auth-callback/' + vm.authprovider.id;
      vm.samlMetadataUrl = api.substring(0,api.lastIndexOf('/api')) + '/sso/saml-metadata/' + vm.authprovider.id;
      vm.submit = function() {
        AuthProvidersService.upsert(vm.authprovider).then(function() {
          $state.go('^.list');
        });
      };
      
      // create the editor
      var container = document.getElementById("jsoneditor");
      var options = {
        onChange: dataChanged,
        mode: 'tree',
        modes: [
          // 'code', 
          // 'form', 
          'text',
          'tree',
          // 'view'
        ], // allowed modes
        onError: function(err) {
          alert(err.toString());
        },
        onModeChange: function(newMode, oldMode) {
          console.log('Mode switched from', oldMode, 'to', newMode);
        }

      };
      var editor = new JSONEditor(container, options);
      // set json
      editor.set(vm.authprovider.data);
      function dataChanged() {
        var json = editor.get();
        vm.authprovider.data = json;
      }
      
      vm.formFields = [
        {
          className: "col-xs-8",
          key: 'label',
          type: 'input',
          templateOptions: {
            label: 'Label',
            required: true
          }
        },
        {
          className: "col-xs-4",
          key: 'strategy',
          type: 'select',
          templateOptions: {
            required:true,
            label: 'Provider Type',      
            "options": [
              {
                "name": "SAML",
                "value": "saml"
              },
              {
                "name": "OpenID Connect",
                "value": "oidc"
              },
              {
                "name": "Email",
                "value": "email"
              },
              {
                "name": "Phone",
                "value": "phone"
              }
            ]
          }
        },
      ]



    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.authproviders')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
        
    }]);

})();

(function () {
  'use strict';
  /**
   * @ngdoc overview
   * @name com.module.about
   * @module
   * @description
   * @requires loopbackApp
   *
   * The `com.module.core` module provides services for interacting with
   * the models exposed by the LoopBack server via the REST API.
   *
   */
  angular.module('com.module.about', []);

})();

(function () {
  'use strict';
  angular
    .module('com.module.about')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.about', {
          abstract: true,
          url: '/about',
          templateUrl: 'app/modules/about/views/main.html'
        })
        .state('app.about.index', {
          url: '',
          templateUrl: 'app/modules/about/views/about.html',
          controller: 'AboutCtrl'
        });
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.about')
  /**
   * @ngdoc function
   * @name com.module.about.controller:AboutCtrl
   * @description
   * # AboutCtrl
   * Controller of the clientApp
   */
    .controller('AboutCtrl', ["$scope", function ($scope) {
      $scope.angular = angular;
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.about')
    .run(["$rootScope", "gettextCatalog", function ($rootScope, gettextCatalog) {
    //   $rootScope.addDashboardBox(gettextCatalog.getString('About'), 'bg-maroon',
    //     'ion-information', 0, 'app.about.index');
    }])
})();

(function () {
  'use strict';
  angular
    .module('com.module.projects')
    .service('ProjectsService', ["$state", "CoreService", "$http", "Project", "gettextCatalog", "AppAuth", "SystemUser", "$rootScope", "$q", function ($state, CoreService, $http, Project, gettextCatalog, AppAuth,SystemUser,$rootScope,$q) {
      var vm = this;
      
      vm.getProjects = function(user) {
        var d=$q.defer();
        if(user&&user.roles){
          if(user.roles.indexOf('superadmin')>=0) {
            console.log("SuperAdmin");
            return Project.find({filter:{include:'organization'}}).$promise;
          }
          else if(user.id) {
            console.log("Other user",user.id);
            return $http.get(CoreService.env.apiUrl +'/SystemUsers/'+user.id+'/linkedProjects',{params:{
              filter:{include:'organization'}
            }}).then(function(res){return res.data});
          }
          else {
            console.log("No userID",user.id);
            d.reject("No userId",user);
          }
        } else {
          console.log("No current user");
          d.reject('No current user yet');
        }
        return d.promise;
      };
      

      vm.getProject = function (id) {
        return Project.findById({
          id: id,
          filter:{include:'organization'}
        }).$promise;
      };

      vm.isPublic = function (id) {
        return $http.get(CoreService.env.apiUrl +'/Projects/'+id+'/access',
          {params:{filter:{where:{role:'student',systemuserId:'public'}}}})
          .then(function(res){
            console.log(res);
            return res.data[0];
          });
      };

      vm.togglePublic = function (project) {
        var id = project.id;
        return vm.isPublic(id).then(function(data){
            if(!project.isPublic && data && data.id){
              return $http.delete(CoreService.env.apiUrl +'/Projects/'+id+'/access/'+data.id);
            } else if(project.isPublic && !data) {
              return $http.post(CoreService.env.apiUrl +'/Projects/'+id+'/access',{role:'student',systemuserId:'public'});
            }
         });
      };
      
      vm.getMaximumSeats = function(projectId){
        return $http.get(CoreService.env.apiUrl +'/Projects/'+projectId+'/account')
        .then(function(res){if (res.data) return res.data.seats; else return null;});
      }
      
      vm.saveMaximumSeats = function(projectId,seats,isNew){
        return $http[isNew?'post':'put'](CoreService.env.apiUrl +'/Projects/'+projectId+'/account',{seats:seats})
          .then(function (res) {
            CoreService.toastSuccess('Seats saved: '+res.data.seats); 
            console.log(res);
          })
          .catch(function (err) {
            CoreService.toastError('Error saving seats',err.data.error.message);
            console.log(err);
          }
        );
      }

      vm.upsertProject = function (project) {
        delete project.organization;
        for (var prop in project.images){
          if (project.images[prop] && project.images[prop].id) project.images[prop] = project.images[prop].id;
        }
        var action = project.id ? Project.upsert(project).$promise : Project.create(project).$promise;
          return action.then(function (res) {
            CoreService.toastSuccess(
              gettextCatalog.getString('Project saved'),
              gettextCatalog.getString('Your project is safe with us!')
            );
            console.log("Project saved",res);
            return res;
          })
          .catch(function (err) {
            CoreService.toastError(
              gettextCatalog.getString('Error saving project '),
              gettextCatalog.getString('This project could no be saved: ') + err
            );
          }
        );
      };

      vm.deleteProject = function (id, successCb, cancelCb) {
        CoreService.confirm(
          gettextCatalog.getString('Are you sure?'),
          gettextCatalog.getString('Deleting this cannot be undone'),
          function () {
            Project.deleteById({id: id}, function () {
              CoreService.toastSuccess(
                gettextCatalog.getString('Project deleted'),
                gettextCatalog.getString('Your project is deleted!'));
              successCb();
            }, function (err) {
              CoreService.toastError(
                gettextCatalog.getString('Error deleting project'),
                gettextCatalog.getString('Your project is not deleted! ') + err);
              cancelCb();
            });
          },
          function () {
            cancelCb();
          }
        );
      };
      vm.get = function(filter) {
        return $http.get(CoreService.env.apiUrl + '/projects', {
          params: {
            filter: filter
          }
        }).then(function(res) { return res.data });
      }
      vm.getFormFields = function (projectId) {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('Name'),
              required: true
            }
          },
          {
            key: 'shortName',
            type: 'input',
            templateOptions: {
              label: gettextCatalog.getString('Short Name'),
              required: true
            }
          },
          // {
          //   key: 'moduleNumber',
          //   type: 'input',
          //   templateOptions: {
          //     label: gettextCatalog.getString('Module Number'),
          //     required: false
          //   }
          // },
          // {
          //   key: 'website',
          //   type: 'input',
          //   templateOptions: {
          //     label: gettextCatalog.getString('Website/Link')
          //   }
          // },
          // {
          //   key: 'description',
          //   type: 'textarea',
          //   templateOptions: {
          //     label: gettextCatalog.getString('Description'),
          //   }
          // },
          // {
          //   key: 'projectType',
          //   type: 'select',
          //   templateOptions: {
          //     label: gettextCatalog.getString('Project Type'),
          //     options: [],
          //     valueProp: 'id',
          //     labelProp: 'label',
          //     required: true,
          //     placeholder:'Select Type'
          //   },
          //   controller: /* @ngInject */ function($scope, SettingService) {
          //     $scope.to.options = [
          //       {id:"lecture","label":"Lecture"},
          //       {id:"seminar","label":"Seminar"}
          //     ];
          //   }
          // },
          {
            key: 'semester',
            type: 'select',
            templateOptions: {
              label: gettextCatalog.getString('Semester'),
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: true,
              placeholder:'Select semester'
            },
            controller: /* @ngInject */ ["$scope", "SettingService", function($scope, SettingService) {
              $scope.to.options = [];
              var year = new Date().getFullYear();
              for (var i=(year-3);i<=(year+3);i++) {
                var s = "Spring "+i;
                var f = "Fall "+i;
                $scope.to.options.push({id:f,label:f})
                $scope.to.options.push({id:s,label:s})
              }
            }]
          },
          {
            key: 'isPublic',
            type: 'checkbox',
            templateOptions: {
              label: 'Is Public',
            },
            controller: /* @ngInject */ ["$scope", "$http", "CoreService", function($scope,$http,CoreService) {
              
              if(projectId) {
              vm.isPublic(projectId)
              .then(function(res){
                $scope.options.value(res && !!res.id);
                // note, the line above is shorthand for:
                // $scope.options.templateOptions.options = data;
              });
              }
            }]
          },
          {
            key: 'organizationId',
            type: 'select',
            templateOptions: {
              label: 'Organization',
              options: [],
              valueProp: 'id',
              labelProp: 'name',
              required: true,
              placeholder:'Select Organization'
            },
            controller: /* @ngInject */ ["$scope", "OrganizationService", function($scope, OrganizationService) {
              OrganizationService.get().then(function(data){
                $scope.to.options = data;
                // note, the line above is shorthand for:
                // $scope.options.templateOptions.options = data;
                return data;
              });
            }]
          },
          {
            key: 'sylvaStyleDefinitions',
            type: 'select',
            templateOptions: {
              label: 'SYLVA Style Definitions',
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: false,
              placeholder:'Select style'
            },
            controller: /* @ngInject */ ["$scope", "CustomStylesService", function($scope, CustomStylesService) {
              $scope.to.options = [];
              CustomStylesService.find().then(function(res){
                $scope.to.options = res.data.map(function(style){
                  return {
                    id:style.key,
                    label:style.data.label
                  };
                });
              });
            }]
          },
          {
            key: 'styleDefinitions',
            type: 'select',
            templateOptions: {
              label: 'CREO Style Definitions',
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: false,
              placeholder:'Select style'
            },
            controller: /* @ngInject */ ["$scope", "SettingService", function($scope, SettingService) {
              $scope.to.options = [];
              SettingService.findByKey('creoStyleDefinitions').then(function(res){
                $scope.to.options = res.data.map(function(style){
                  return {
                    id:style.id,
                    label:style.label
                  };
                });
              });
            }]
          }
        ];
      };


    return vm;
    
    }]);

})();

(function () {
  'use strict';
  angular
    .module('com.module.projects')
    .config(["$stateProvider", function ($stateProvider) {
      $stateProvider
        .state('app.projects', {
          abstract: true,
          url: '/projects',
          templateUrl: 'app/modules/projects/views/main.html'
        })
        .state('app.projects.list', {
          url: '',
          templateUrl: 'app/modules/projects/views/list.html',
          controllerAs: 'ctrl',
          controller: ["ProjectsService", "currentUser", "SettingService", function (ProjectsService,currentUser,SettingService) {
            var vm = this;
            // return unique
            vm.loading = ProjectsService.getProjects(currentUser)
            .then(function(data){
              vm.projects = data.sort(function(a,b){
                return a.name>b.name?1:-1;
              });
            })
            vm.projectFilter = '';
            // $rootScope.addDashboardBox('Projects', 'bg-purple', 'ion-calendar', this.projects.length, 'app.projects.list');
            

          }],
          resolve: {
          }
        })
        .state('app.projects.add', {
          url: '/add',
          templateUrl: 'app/modules/projects/views/form.html',
          controllerAs: 'ctrl',
          controller: ["$state", "ProjectsService", "project", function ($state, ProjectsService, project) {
            var vm = this;
            vm.project = project;
            vm.formFields = ProjectsService.getFormFields();
            vm.formOptions = {};
            vm.submit = function () {
              ProjectsService.upsertProject(vm.project)
              .then(function (project) {
                return ProjectsService.saveMaximumSeats(project.id,vm.maxSeats,vm.noSeats)
              })
              .then(function(){
                vm.noSeats = false;
                $state.go('^.list');
              });
            };
          }],
          resolve: {
            hasAccess: ["$state", "currentUser", function($state,currentUser){
              if(currentUser.roles.length===0) $state.go('^'); 
              return;
            }],
            project: function () {
              return {};
            }
          }
        })
        .state('app.projects.edit', {
          url: '/:id/edit',
          templateUrl: 'app/modules/projects/views/form.html',
          controllerAs: 'ctrl',
          controller: ["$q", "$state", "ProjectsService", "project", "FileService", "CoreService", "CONFIG", "$timeout", function ($q,$state, ProjectsService, project,FileService,CoreService,CONFIG,$timeout) {
            var vm = this;
            vm.project = project;
            vm.project.images = vm.project.images || {};
            vm.formFields = ProjectsService.getFormFields(project.id);
            vm.formOptions = {};
            vm.submit = function () {
                ProjectsService.togglePublic(vm.project)
                .then(function(res){
                  delete vm.project.isPublic;
                  return $q.all([
                    ProjectsService.upsertProject(vm.project),
                    ProjectsService.saveMaximumSeats(project.id,vm.maxSeats,vm.noSeats)
                  ])
                  .then(function () {
                    $state.go('^.list');
                  });
                });
            };
            
            vm.noSeats=true;
            ProjectsService.getMaximumSeats(project.id).then(function(seats){
              if(seats) {
                vm.maxSeats = seats;
                vm.noSeats = false;
              }
            })
            vm.updateSeats = function(seats){
              ProjectsService.saveMaximumSeats(project.id,seats,vm.noSeats)
              .then(function(){
                vm.noSeats = false;
              });
            }
            
            
            vm.deleteBackground = function(item){
                if(item.images && item.images.background)
                FileService.delete(item.images.background.id || item.images.background,function(){
                    $timeout(function(){
                        vm.loadImages(item);
                    },50);
                },function(){})
            }
            vm.imageLoading = vm.loadImages = function (project){
              vm.project.images = vm.project.images || {};
              if (!project.images.background) {
                  vm.backgroundImage = null;
                  vm.imageLoading = null;
                  return;
              }
              var ids = {};
              Object.keys(project.images).forEach(function(prop){
                ids[project.images[prop]]=null;
              })
              return FileService.get({where:{id:{inq:Object.keys(ids)}}}).then(function(res){
                res.data.forEach(function(file){
                  ids[file.id] = file;
                })
                Object.keys(vm.project.images).forEach(function(prop){
                  var id = vm.project.images[prop];
                  vm.project.images[prop] = ids[id];
                })
                vm.backgroundImage = (vm.project.images && vm.project.images.background && vm.project.images.background.id) ? 
                  CoreService.env.cdnUrl+FileService.getPublicContainer(vm.project.images.background.container) +'/'+ vm.project.images.background.data.size["1024x768"] : null;
                vm.imageLoading = null;
                
              })
            }
            vm.loadImages(vm.project);
            
            FileService.setApi('projects',vm.project.id);
            vm.uploader = FileService.uploader({url:'/Projects/'+vm.project.id});
            vm.uploader.filters.push({
              name: 'imageFilter',
              fn: function(item /*{File|FileLikeObject}*/ , options) {
                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
              }
            });
            // auto-attach the handlers
            vm.uploader.onBeforeUploadItem = function(item) {
              item.headers['x-upload-filename'] = item.file.name;
              item.headers['x-meta-data'] = JSON.stringify({data:
                {size:CONFIG.ProjectBackgroundSizes}
              });
              var url = '/image/uploadFile';
              if(vm.project.images && vm.project.images.background && vm.project.images.background.id) url = '/image/updateFile/'+vm.project.images.background.id;
              item.url = item.url + url;
            };
            
            
            vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
                console.info('onCompleteItem', fileItem, response, status, headers);
                vm.project.images = vm.project.images || {};
                vm.project.images.background = response.id;
                vm.imageLoading = ProjectsService.upsertProject(vm.project).then(function () { 
                  // $state.reload(true);
                    vm.uploader.queue = [];
                    CoreService.imageInfo();
                    // return $timeout(function(){
                    //     return vm.loadImages(vm.project);
                    // },500);
                });
            };
            
          }],
          resolve: {
            project: ["$stateParams", "ProjectsService", function ($stateParams, ProjectsService) {
              return ProjectsService.getProject($stateParams.id);
            }]
          }
        })
        .state('app.projects.view', {
          url: '/:id',
          abstract:true,
          templateUrl: 'app/modules/projects/views/view.html',
          controllerAs: 'ctrl',
          controller: ["$timeout", "$state", "project", "currentUser", function ($timeout,$state,project,currentUser) {
            var vm = this;
            vm.project = project;
            vm.activeTab = null;
            vm.tabs=[{
              state:'.syllabus',
              label:'Syllabus'
            },{
              state:'.users',
              label:'Users'
            },{
              state:'.teams',
              label:'Teams'
            },{
              state:'.lectures',
              label:'Lectures'
            },{
              state:'.assessments',
              label:'Assessments'
            },
            // {
            //   state:'.casestudies',
            //   label:'Case Studies'
            // },
            {
              state:'.files.list',
              label:'Files'
            }];
          }],
          resolve: {
            project: ["$stateParams", "ProjectsService", function ($stateParams, ProjectsService) {
              return ProjectsService.getProject($stateParams.id);
            }]
          }
        })
        .state('app.projects.view.syllabus', {
          url: '/syllabus',
          template: '<project-syllabus project="ctrl.project"></project-syllabus>'
        })
        .state('app.projects.view.users', {
          url: '/users',
          template: '<project-users project="ctrl.project"></project-users>'
        })
        .state('app.projects.view.teams', {
          url: '/teams',
          template: '<project-teams project="ctrl.project"></project-teams>'
        })
        .state('app.projects.view.lectures', {
          url: '/lectures',
          template: '<project-lectures project="ctrl.project"></project-lectures>'
        })
        .state('app.projects.view.assessments', {
          url: '/assessments',
          template: '<project-assessments project="ctrl.project"></project-assessments>'
        })
        .state('app.projects.view.casestudies', {
          url: '/casestudies',
          template: '<project-case-studies project="ctrl.project"></project-case-studies>'
        })
        .state('app.projects.view.files', {
          abstract: true,
          url: '/files',
          templateUrl: 'app/modules/files/views/main.html',
          controller:["$scope", function($scope){
            $scope.projectFiles = true;
          }]
        })
        .state('app.projects.view.files.list', {
          url: '',
          templateUrl: 'app/modules/files/views/list.html',
          controllerAs: 'ctrl',
          controller: 'FilesListController'
        })
        .state('app.projects.view.files.upload', {
          url: '/upload',
          templateUrl: 'app/modules/files/views/upload.html',
          controllerAs: 'ctrl',
          controller: ["FileUploader", "FileService", "$stateParams", function (FileUploader, FileService,$stateParams) {
            FileService.setApi('projects',$stateParams.id);
            this.uploader = FileService.uploader({url:'/Projects/'+$stateParams.id});
            // auto-attach the handlers
            this.uploader.onBeforeUploadItem = function(item) {
              item.headers['x-upload-filename'] = item.file.name;
              item.headers['x-meta-data'] = JSON.stringify({data:JSON.parse(item.file.data)});
              item.url = item.url + '/' + item.file.componentModel + '/uploadFile';
            };
          }]
        })
        
        
        .state('app.projects.delete', {
          url: '/:id/delete',
          template: '',
          controllerAs: 'ctrl',
          controller: ["$state", "ProjectsService", "project", function ($state, ProjectsService, project) {
            ProjectsService.deleteProject(project.id, function () {
              $state.go('^.list');
            }, function () {
              $state.go('^.list');
            });
          }],
          resolve: {
            project: ["$stateParams", "ProjectsService", function ($stateParams, ProjectsService) {
              return ProjectsService.getProject($stateParams.id);
            }]
          }
        });
    }]
  );

})();

(function () {
  'use strict';
  angular.module('com.module.permissions')
  .controller('PermissionsListController',["$scope", "PermissionService", "data", function ($scope,PermissionService,data) {
    
    
    var vm = this;
    vm.loadData = function(models){
      models = models || PermissionService.models.get()
      vm.permissions = PermissionService.groupByModel(data,models);
      console.log(vm.permissions);
      PermissionService.groupByProperty(vm.permissions);
      
      PermissionService.getRequests().then(function(res){
        var filtered = res.data.filter(function(o){
          return models.indexOf(o.model)>=0;
        });
        console.log(filtered);
      })
    }
    $scope.$on('model.selection',function(event,models){
      console.log(models);
      vm.loadData(models);
    })
    vm.getMethodClass = function(r) {
      var c = 'info';
      switch (r.accessType) {
        case 'READ':
          c = 'success'
          break;
        case 'EXECUTE':
          c = 'warning'
          break;
        case 'WRITE':
          c = 'danger'
          break;
    
        default:
          c = 'info'
      }
      return 'label-' + c;
    
    }
    
    vm.goToAPI = function(method, model) {
      if (method.indexOf('__') === 0) {
        // this is a related method
        method = method.replace(/__/g, '_');
        method = 'prototype' + method;
      }
      var url = 'https://dev.sylva.ac/api-explorer/#!/' + model + '/' + model + '_' + method;
      window.open(url, '_blank');
    }
    
    
    vm.loadData();
    
    
    
    
  }])
    
})();

'use strict';

angular.module('com.module.organizations')
  .service('OrganizationService', ["$q", "$http", "CONFIG", "CoreService", "SchemaMaker", function($q,$http,CONFIG,CoreService,SchemaMaker) {
    var vm = this;
    vm.filters = {};
    // basic endpoint
    vm.endpoint = function(){  return CoreService.env.apiUrl+'/Organizations';};
    
    // basic schema
    vm.schema = {   
        "name": {
          "type": "string",
          "required": true
        },
        "shortName": {
          "type": "string"
        },
        "logo.base64": {
          "type": "image"
        },
        "description": {
          "type": "string"
        }
    };
    
    // create schema for angular-formly
    vm.getFormSchema = function () {
        return [
          {
            key: 'name',
            type: 'input',
            templateOptions: {
              label: 'Name',
              required: true
            }
          },
          {
            key: 'shortName',
            type: 'input',
            templateOptions: {
              label: 'Short Name'
            }
          },      
          {
            key: 'logo',
            templateUrl: 'app/modules/core/views/elements/fields/formly-field-file-upload.html',
            templateOptions: {
              label: 'Logo',
              buttonLabel: 'Select logo'
            }
          },
          {
            key: 'description',
            type: 'textarea',
            templateOptions: {
              label: 'Description'
            }
          },
          {
            key: 'allowedEmails',
            type: 'multiInput',
            templateOptions: {
              label: 'Supported emails for registration (e.g. xxx@stanford.edu)',
              inputOptions: {
                type: 'input'
              }
            }
          },
          {
            key: 'orgType',
            type: 'select',
            templateOptions: {
              label: 'Organization type',
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: true,
              placeholder:'Select type'
            },
            controller: /* @ngInject */ ["$scope", function($scope) {
              $scope.to.options = CONFIG.OrganizationTypes;
              // $scope.to.options = SettingService.key('Orga').data;
              // SettingService.findByKey('styleDefinitions').then(function(res){
              //   $scope.to.options = res.data;
              // });
            }]
          },
          {
            key: 'autoLoginLinks',
            type: 'checkbox',
            templateOptions: {
              label: 'Use Easy auto Login Links (Email link expires in 6 months)'
            }
          },
          {
            key: 'styleDefinitions',
            type: 'select',
            templateOptions: {
              label: 'Style Definitions',
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: true,
              placeholder:'Select style'
            },
            controller: /* @ngInject */ ["$scope", "CustomStylesService", function($scope, CustomStylesService) {
              $scope.to.options = [];
              CustomStylesService.find().then(function(res){
                $scope.to.options = res.data.map(function(style){
                  return {
                    id:style.key,
                    label:style.data.label
                  };
                });
              });
            }]
          },
          {
            key: 'gradingScheme',
            type: 'select',
            templateOptions: {
              label: 'Grading Scheme',
              options: [],
              valueProp: 'id',
              labelProp: 'label',
              required: true,
              placeholder:'Select default grading scheme'
            },
            controller: /* @ngInject */ ["$scope", "GradingSchemeService", function($scope, GradingSchemeService) {
              $scope.to.options = [];
              GradingSchemeService.find().then(function(res){
                $scope.to.options = res.data.map(function(style){
                  return {
                    id:style.key,
                    label:style.data.label
                  };
                });
              });
            }]
          },
          {
            key: 'website',
            type: 'input',
            templateOptions: {
              label: 'Website Url'
            }
          },
          {
            key: 'lti',
            type: 'checkbox',
            templateOptions: {
              label: 'Enable LTI support as a Tool Provider'
            }
          }
        ];    
    };
    
    // auto create schema for ui-grid;
    vm.gridSchema = SchemaMaker.uiGrid(vm.schema,vm.filters);
    
    /* CRUD methods */
    vm.get = function(filters){
        filters = filters || {};
        filters = Object.assign({},filters,vm.filters)
        return $http.get(vm.endpoint(),{
            params: {
                filter: filters
            }
        }).then(function(res){ return res.data; });
    }
    vm.getById = function(id){
      return $http.get(vm.endpoint()+'/'+id).then(function(res){ return res.data; });
    }
    vm.save = function(item){
        if(item.id) return $http.put(vm.endpoint()+'/'+item.id,item);
        else return $http.post(vm.endpoint(),item);
    }   
    vm.delete = function(item){
        return $http.delete(vm.endpoint()+'/'+item.id);
    }
    
    /* Extra Methods */
    
    vm.getAssessmentReportData = function(config) {
      var params = {};
      if(config.projectId) params.projectId = config.projectId;
      if(config.assessmentId) params.assessmentId = config.assessmentId;
      return $http.get(vm.endpoint()+'/'+config.organizationId+'/getAssessmentReportData',params)
        .then(function(res){ return res.data; });
    }
    
    vm.updateBilling = function(id,billing){
      var data = {
        billing: billing
      };
      return $http.post(vm.endpoint()+'/'+id+'/updateBilling',data).then(function(res){ return res.data; });
    }
    
    
    // LTI 
    vm.getLTIconfig = function(id){
      return $http.get(vm.endpoint()+'/'+id+'/LTI_config').then(function(res){ return res.data; });
    }
    vm.updateLTIconfig = function(id,data){
      return $http.post(vm.endpoint()+'/'+id+'/LTI_config',{config:data}).then(function(res){ return res.data; });
    }
    vm.deleteLTIconfig = function(id){
      return $http.delete(vm.endpoint()+'/'+id+'/LTI_config').then(function(res){ return res.data; });
    }
    
    // Premium Cloud Config for SYLVA Next
    vm.getCloudConfig = function(id){
      return $http.get(vm.endpoint()+'/'+id+'/cloudConfig').then(function(res){ return res.data; });
    }
    vm.updateCloudConfig = function(id,data){
      if(data.id) {
        return $http.put(vm.endpoint()+'/'+id+'/cloudConfig',data).then(function(res){ return res.data; });
      } else {
        return $http.post(vm.endpoint()+'/'+id+'/cloudConfig',data).then(function(res){ return res.data; });
      }
    }
    vm.deleteCloudConfig = function(id,data){
      return $http.delete(vm.endpoint()+'/'+id+'/cloudConfig');
    }
    
    return vm;
  }]);

(function () {
  'use strict';
  /**
   * @ngdoc overview
   * @name loopbackApp
   * @description
   * # loopbackApp
   *
   * Main module of the application.
   */
  angular
    .module('loopbackApp', [
      'angular-loading-bar',
      'angular.filter',
      'angularFileUpload',
      'oitozero.ngSweetAlert',
      'config',
      'formly',
      'formlyBootstrap',
      'naif.base64',
      'lbServices',
      'monospaced.elastic',
      // 'pmImageEditor',
      'angular-busy',
      'ngAnimate',
      'ngCookies',
      'ngResource',
      'ngRoute',
      'ngSanitize',
      'ngTouch',
      'ui.codemirror',
      'ui.bootstrap',
      'ui.bootstrap.datetimepicker',
      'ui.gravatar',
      'ui.grid',
      'ui.grid.importer',
      'ui.grid.autoResize',
      'ui.grid.pagination', 
      'ui.grid.resizeColumns', 
      'ui.grid.grouping',
      'ui.grid.draggable-rows',
      'ui.router',
      'toasty',
      'colorpicker.module',
      'autofields',
      'autofields.bootstrap.validation',
      'gettext',
      'ui.select',
      'com.module.core',
      'com.module.files',
      'com.module.about',
      'com.module.projects',
      'com.module.organizations',
      'com.module.users',
      'com.module.settings',
      'com.module.gradingschemes',
      'com.module.reporting',
      'com.module.authproviders',
      'com.module.customstyles',
      'com.module.permissions',
      // 'com.module.browser',
      // 'com.module.events',
      // 'com.module.notes',
      // 'com.module.pages',
      // 'com.module.posts',
      // 'com.module.products',
      // 'com.module.sandbox',
    ])    
    .config(['$httpProvider',
      function($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
      },
    ])
    .run(["$rootScope", "$location", function($rootScope,$location){
      
        // handle ui-router error redirect
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){
            if(toState.name==='500_API_ERROR') { 
                event.preventDefault(); 
            }
        });

        //handle ui-router errors
        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
            // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
            event.preventDefault();
            console.error('Ui Router error:', event, toState, toParams, fromState, fromParams, error);
            if(error.status===401) $location.path('/login');
            else $location.path('/error');
        });
    }])
    
    // .run(function ($rootScope, $cookies, gettextCatalog) {

    //   $rootScope.locales = {
    //     'de': {
    //       lang: 'de',
    //       country: 'DE',
    //       name: gettextCatalog.getString('German')
    //     },
    //     'en': {
    //       lang: 'en',
    //       country: 'US',
    //       name: gettextCatalog.getString('English')
    //     },
    //     'es_MX': {
    //       lang: 'es_MX',
    //       country: 'MX',
    //       name: gettextCatalog.getString('Spanish')
    //     },
    //     'fr': {
    //       lang: 'fr',
    //       country: 'FR',
    //       name: gettextCatalog.getString('Français')
    //     },
    //     'nl': {
    //       lang: 'nl',
    //       country: 'NL',
    //       name: gettextCatalog.getString('Dutch')
    //     },
    //     'pt-BR': {
    //       lang: 'pt_BR',
    //       country: 'BR',
    //       name: gettextCatalog.getString('Portuguese Brazil')
    //     },
    //     'ru_RU': {
    //       lang: 'ru_RU',
    //       country: 'RU',
    //       name: gettextCatalog.getString('Russian')
    //     },
    //     'zh_CN': {
    //       lang: 'zh_CN',
    //       country: 'CN',
    //       name: gettextCatalog.getString('Chinese')
    //     }
    //   };

    //   var lang = $cookies.lang || navigator.language || navigator.userLanguage;

    //   $rootScope.locale = $rootScope.locales[lang];

    //   if (angular.isUndefined($rootScope.locale)) {
    //     $rootScope.locale = $rootScope.locales[lang];
    //     if (angular.isUndefined($rootScope.locale)) {
    //       $rootScope.locale = $rootScope.locales['en'];
    //     }
    //   }

    //   gettextCatalog.setCurrentLanguage($rootScope.locale.lang);

    // })

})();

angular.module('loopbackApp').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('de', {"About":"Über","Actions":"Aktion","Add":"Hinzufügen","Add a new event":"Ereignis hinzufügen","Add a new setting":"Einstellung hinzufügen","Are you sure?":"Bist du sicher ?","Browse":"Browse","Cancel":"Abbrechen","Cancel all":"Alles Abbrechen","Categories":"Kategorien","Category deleted":"Kategorie gelöscht","Category saved":"Kategorie gespeichert","Change it here!":"Ändere es hier !","Confirm Password":"Bestätige Passwort","Could not add event!":"Konnte Ereignis nicht hinzufügen","Could not add setting!":"Konnte Einstellung nicht hinzufügen","Current user":"Derzeitiger Nutzer","Dashboard":"Instrumententafel","Deleting this cannot be undone":"Löschen kann nicht wiederufen werden","Don't worry we won't spam your inbox":"Keine Sorge wir versenden keinen Spam","Edit event":"Ereignis editieren","Edit setting":"Einstellung editieren","Email address needs to be valid":"Die E-Mail -Adresse muss gültig sein","Enjoy the new you!":"Genieße deine neue Persönlichkeit ","Error deleting category":"Fehler beim löschen der Kategorie","Error deleting event":"Fehler beim löschen des Ereignises","Error deleting page":"Fehler beim löschen der Seite","Error deleting post":"Fehler beim löschen des Beitrags","Error deleting product":"Fehler beim löschen des Produkts","Error deleting setting":"Fehler beim löschen der Einstellung","Error deleting user":"Fehler beim löschen des Nutzers","Error registering!":"Fehler bei der Registrierung","Error saving profile":"Fehler beim speichern des Profils","Error saving user:":"Fehler beim speichern des Nutzers","Error signin in after registration!":"Fehler beim Einloggen nach der Registrierung","Event deleted":"Ereignis gelöscht","Event not added":"Ereignis nicht hinzugefügt","Event saved":"Ereignis gespeichert","Events":"Ereignis","File deleted":"Datei gelöscht","Files":"Dateien","First Name":"Vorname","Home":"Ausgangsposition","Key":"Schlüssel","Last Name":"Nachname","Logged in":"Eingeloggt","Logged out":"Ausgeloggt","Manage your events here!":"Verwalte deine Ereignisse hier","Manage your files here!":"Verwalte deine Dateien hier","Manage your settings here!":"Verwalte deine Einstellungen hier","Manage your users here!":"Verwalte deine Nutzer hier","More info":"Mehr Information","Name":"Name","Needs to have at least 4 characters":"Muss aus mindestens 4 Zeichen bestehen","Nice email address!":"Korrekte E-Mail Adresse !","Notes":"Anmerkungen","Or register":"Oder registriere","Or sign in":"oder Einloggen","Page deleted":"Seite gelöscht","Page saved":"Seite gespeichert","Pages":"Seiten","Password":"Passwort","Post deleted":"Beitrag gelöscht","Post saved":"Beitrag gespeichert","Posts":"Beitrag","Product deleted":"Produkt gelöscht","Product saved":"Produkt gespeichert","Products":"Produkt","Profile":"Profil","Profile saved":"Profil gespeichert","Progress":"Fortschritt","Register":"Registrieren","Registered":"Registriert","Remove all":"Alles Entfernen","Setting deleted":"Einstellung gelöscht","Setting saved":"Einstellung gespeichert","Settings":"Einstellung","Sign In":"Einloggen","Sign in":"Einloggen","Sign out":"Ausloggen","Size":"Grösse","Status":"Zustand","Stay signed in":"Eingeloggt bleiben","Submit":"Übermitteln","Theme":"Motiv","There are no events":"Keine Ereignisse vorhanden","There are no files":"Keine Daten vorhanden","There are no settings":"Keine Einstellungen vorhanden","This user is save!":"Dieser Nutzer ist geschützt ","Toggle navigation":"Orientierung wechseln","Update profile":"Profil aktualisieren","Upload":"Hochladen","Upload all":"Alles hochladen","Upload files":"Daten hochladen","Upload queue":"Warteschlange hochladen","User deleted":"Nutzer gelöscht","User saved":"Nutzer gespeichert","Users":"Nutzer","Value":"Wert","Variables":"Variable ","Welcome!":"Willkommen","You are logged in!":"Du bist Eingeloggt !","You are logged out!":"Du bist Ausgeloggt !","You are registered!":"Du bist Registeriert !","You can just drag them in this window!":"Du kannst Sie in dieses Fester ziehen","You need an email address":"Du brauchst eine E-Mail Adresse","Your Gravatar":"Dein Gravatar ","Your category is deleted!":"Deine Kategorie ist gelöscht !","Your category is not deleted:":"Deine Kategorie ist nicht gelöscht","Your category is safe with us!":"Deine Kategorie ist sicher bei uns !","Your event is deleted!":"Dein Ereignis ist gelöscht","Your event is not deleted:":"Dein Ereignis ist nicht gelöscht","Your event is safe with us!":"Dein Ereignis ist sicher bei uns","Your file is deleted!":"Deine Datei ist gelöscht","Your page is deleted!":"Deine Seite ist gelöscht","Your page is not deleted:":"Deine Seite ist nicht gelöscht:","Your page is safe with us!":"Deine Seite ist sicher bei uns !","Your post is deleted!":"Dein Beitrag ist gelöscht!","Your post is not deleted:":"Dein Beitrag ist nicht gelöscht:","Your post is safe with us!":"Dein Beitrag ist sicher bei uns !","Your product is deleted!":"Dein Produkt ist gelöscht!","Your product is not deleted:":"Dein Produkt ist nicht gelöscht:","Your product is safe with us!":"Dein Produkt ist sicher bei uns!","Your profile":"Dein Profil","Your profile is not saved:":"Dein Profil ist nicht gespeichert","Your setting is deleted!":"Deine Einstellungen sind gespeichert!","Your setting is not deleted:":"Deine Einstellungen sind nicht gelöscht:","Your setting is safe with us!":"Deine Einstellungen sind sicher bei uns!","Your user is deleted!":"Dein Nutzer ist gelöscht!","Your user is not deleted:":"Dein Nutzer ist nicht gelöscht:","here":"Hier","in queue":"In der Ereigniskette"});
    gettextCatalog.setStrings('es_MX', {"<i class=\"fa fa-arrow-left\"></i> Pages":"<i class=\"fa fa-arrow-left\"></i> Páginas","<i class=\"fa fa-arrow-left\"></i> Users":"<i class=\"fa fa-arrow-left\"></i> Usuarios","<i class=\"fa fa-save\"></i>  Save":"<i class=\"fa fa-save\"></i>  Guardar","<i class=\"fa fa-save\"></i> Save":"<i class=\"fa fa-save\"></i> Guardar","About":"Acerca de","Actions":"Acciones","Add":"Añadir","Add Category":"Añadir Categoría","Add Product":"Añadir Producto","Add a new category":"Añadir una nueva categoría","Add a new event":"Añadir un nuevo evento","Add a new note":"Añadir nueva nota","Add a new post":"Añadir una nueva publicación","Add a new product":"Añadir un nuevo producto","Add a new setting":"Añadir una nueva configuración","Add product to category":"Añadir producto a una categoría","All about this application!":"¡Todo acerca de esta aplicación!","Are you sure?":"¿Esta seguro?","Body":"Cuerpo","Browse":"Buscar","Cancel":"Cancelar","Cancel all":"Cancelar todo","Categories":"Categorias","Category":"Categoría","Category deleted":"Categoría eliminada","Category saved":"Categoria guardada","Change it here!":"¡Cambielo aquí!","Click <a href=\"\" ui-sref=\"^.add\">here</a>\n      to add a post!":"¡Haga click <a href=\"\" ui-sref=\"^.add\">aquí</a>\n      para añadir una nueva publicación!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a event!":"¡Haga click <a href=\"\" ui-sref=\"^.add\">aquí</a> para añadir un evento!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a note!":"¡Haga click <a href=\"\" ui-sref=\"^.add\">aquí</a> para añadir una nota!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a page!":"¡Haga click <a href=\"\" ui-sref=\"^.add\">aquí</a> para añadir una pagina!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a setting!":"¡Haga click <a href=\"\" ui-sref=\"^.add\">aquí</a> para añadir una configuración!","Click <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">here</a> to add a product!":"¡Haga click <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">aquí</a> para añadir un producto!","Click <a href=\"\" ui-sref=\"^.upload\" translate=\"\">here</a> to upload some!":"¡Haga click <a href=\"\" ui-sref=\"^.upload\" translate=\"\">aquí</a> para subir algo!","Confirm Password":"Confirme Contraseña","Content":"Contenido","Could not add category!":"¡No se pudo añadir la categoría!","Could not add event!":"¡No se pudo añadir el evento!","Could not add note!":"¡No se pudo añadir la nota!","Could not add page!":"¡No se pudo añadir la pagina!","Could not add post!":"¡No se pudo añadir la publicación!","Could not add setting!":"¡No se pudo añadir la configuración!","Could not add user!":"¡No se pudo añadir el usuario!","Create pages with rich content!":"¡Cree paginas con rico contenido!","Current user":"Usuario Actual","Dashboard":"Panel de control","Delete category":"Eliminar categoría","Deleting this cannot be undone":"Al eliminar esto no se podrá deshacer","Description":"Descripción","Don't worry we won't spam your inbox":"No se preocupe, no le enviaremos spam","Edit category":"Editar Categoría","Edit event":"Editar evento","Edit note":"Editar nota","Edit post":"Editar publicación","Edit product":"Editar producto","Edit setting":"Editar configuración","Email address needs to be valid":"Se necesita un correo electronico valido","End":"Fin","End Time":"Fin del tiempo","Enjoy the new you!":"¡Disfruta el nuevo tu!","Error deleting category":"Error al eliminar la categoria","Error deleting event":"Error al eliminar el evento","Error deleting item:":"Error al eliminar el elemento:","Error deleting note":"Error al eliminar la nota","Error deleting page":"Error al eliminar la pagina","Error deleting product":"Error al eliminar el producto","Error deleting setting":"Error al eliminar la configuración","Error deleting user":"Error al eliminar el usuario","Error registering!":"¡Error al registrar!","Error saving note":"Error al guardar la nota","Error saving profile":"Error al guardar el perfil","Error saving user:":"Error al guardar el usuario:","Error signin in after registration!":"¡Error al iniciar sesión después de registrarse!","Event deleted":"Evento eliminado","Event not added":"Evento no añadido","Event saved":"Evento guardado","Events":"Eventos","File deleted":"Archivo eliminado","Files":"Archivos","First Name":"Nombre","First name":"Nombre","Hello,":"Hola,","Home":"Principal","Item deleted":"Elemento eliminado","Last Name":"Apellido","Last name":"Apellido","Logged in":"Logueado","Logged out":"Deslogueado","Manage your events here!":"¡Administre sus eventos aquí!","Manage your files here!":"¡Administre sus archivos aquí!","Manage your notes here!":"¡Administre sus notas aquí!","Manage your posts here!":"¡Administre sus publicaciones aquí!","Manage your products here!":"¡Administre sus productos aquí!","Manage your settings here!":"¡Administre sus configuraciones aquí!","Manage your users here!":"¡Administre los usuarios aquí!","More info":"Mas Información","Name":"Nombre","Needs to have at least 4 characters":"Debe contener por lo menos 4 caracteres","New page":"Nueva pagina","Nice email address!":"¡Buen correo electrónico!","Note deleted":"Nota eliminada","Note saved":"Nota guardada","Notes":"Notas","Or register":"Ó regístrese","Or sign in":"Ó inicie sesión","Page deleted":"Pagina eliminada","Page saved":"Pagina guardada","Pages":"Paginas","Password":"Contraseña","Post saved":"Publicación guardada","Posts":"Publicaciones","Price":"Precio","Product":"Producto","Product deleted":"Producto eliminado","Product saved":"Producto guardado","Products":"Productos","Profile":"Perfil","Profile saved":"Perfil guardado","Progress":"Progreso","Register":"Registro","Registered":"Registrado","Remove all":"Remover todos","Save":"Guardar","Setting deleted":"Configuración eliminada","Setting saved":"Configuración guardada","Settings":"Configuración","Sign In":"Iniciar Sesión","Sign in":"Iniciar sesión","Sign out":"Cerrar sesión","Size":"Tamaño","Start Date":"Fecha de inicio","Start Time":"Hora de inicio","Status":"Estado","Stay signed in":"Mantener sesión","Submit":"Enviar","Theme":"Tema","There are no events":"No hay eventos","There are no files":"No hay archivos","There are no notes":"No hay notas","There are no pages":"No hay paginas","There are no products in this category!":"¡No hay productos en esta categoría!","There are no settings":"No hay configuraciones","This note could no be saved:":"Esta nota no pudo ser guardada:","This user is save!":"¡El usuario esta guardado!","Title":"Titulo","Toggle navigation":"Mostrar navegación","Update profile":"Actualizar perfil","Upload":"Subir","Upload all":"Subir todos","Upload files":"Subir archivos","Upload queue":"Cola de subida","User deleted":"Usuario eliminado","User saved":"Usuario guardado","Username":"Nombre de usuario","Users":"Usuarios","Value":"Valor","Variables":"Variables","Welcome!":"¡Bienvenido!","You are logged in!":"¡Has iniciado sesión!","You are logged out!":"¡Has cerrado sesión!","You are registered!":"¡Estas registrado!","You can just drag them in this window!":"¡Puedes arrastrarlas a esta ventana!","You need an email address":"Necesitas un correo electrónico","Your Gravatar":"Tu Gravatar","Your category is deleted!":"¡Tu categoría esta eliminada!","Your category is not deleted:":"Tu categoría no esta eliminada:","Your category is safe with us!":"¡Tu categoría esta segura con nosotros!","Your event is deleted!":"¡Tu evento esta eliminado!","Your event is not deleted:":"Tu evento no esta eliminado:","Your event is safe with us!":"¡Tu evento esta seguro con nosotros!","Your file is deleted!":"¡Tu archivo esta eliminado!","Your item has been deleted!":"¡Tu elemento ha sido eliminado!","Your note is deleted!":"¡Tu nota esta eliminada!","Your note is not deleted!":"¡Tu nota no esta borrada!","Your note is safe with us!":"¡Tu nota esta segura con nosotros!","Your page is deleted!":"¡Tu pagina esta borrada!","Your page is not deleted:":"Tu pagina no esta borrada","Your page is safe with us!":"¡Tu pagina esta segura con nosotros!","Your passwords need to match":"Tus contraseñas deben coincidir","Your post is safe with us!":"¡Tu publicación esta segura con nosotros!","Your product is deleted!":"¡Tu producto esta eliminado!","Your product is not deleted:":"Tu producto no esta borrado:","Your product is safe with us!":"¡Tu producto esta seguro con nosotros!","Your profile":"Tu perfil","Your profile is not saved:":"Tu perfil no esta guardado:","Your setting is deleted!":"¡Tu configuración esta borrada!","Your setting is not deleted:":"Tu configuración no esta borrada:","Your setting is safe with us!":"¡Tu configuración esta segura con nosotros!","Your user is deleted!":"¡Tu usuario esta borrado!","Your user is not deleted:":"Tu usuario no esta borrado:","dd/MM/yyyy":"dd/MM/aaaa","here":"aquí","image":"imagen","in queue":"en cola"});
    gettextCatalog.setStrings('fr', {"<i class=\"fa fa-arrow-left\"></i> Pages":"<i class=\"fa fa-arrow-left\"></i> Pages","<i class=\"fa fa-arrow-left\"></i> Users":"<i class=\"fa fa-arrow-left\"></i> Utilisateurs","<i class=\"fa fa-save\"></i>  Save":"<i class=\"fa fa-save\"></i>  Enregistrer","<i class=\"fa fa-save\"></i> Save":"<i class=\"fa fa-save\"></i>  Enregistrer","About":"A propos","Actions":"Actions","Add":"Ajouter","Add Category":"Ajoutez une catégorie","Add a new category":"Ajoutez une catégorie","Add a new event":"Ajoutez un évènement","Add a new note":"Ajoutez une note","Add a new post":"Ajoutez un post","Add a new product":"Ajoutez un produit","Add a new setting":"Ajoutez un paramètre","Add product to category":"Ajoutez une produit à la catégorie","Are you sure?":"Êtes vous sûr ?","Body":"Corp","Browse":"Ouvrir","Cancel":"Annuler","Cancel all":"Tout annuler","Categories":"Catégories","Category":"Catégorie","Category deleted":"Catégorie effacée","Category saved":"Catégorie enregistrée","Change it here!":"Modifiez ici!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a event!":"Cliquer <a href=\"\" ui-sref=\"^.add\">ici</a> pour ajouter un évènement!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a note!":"Cliquer <a href=\"\" ui-sref=\"^.add\">ici</a> pour ajouter une note!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a page!":"Cliquer <a href=\"\" ui-sref=\"^.add\">ici</a> pour ajouter une page!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a post!":"Cliquer <a href=\"\" ui-sref=\"^.add\">ici</a> pour ajouter un post!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a setting!":"Cliquer <a href=\"\" ui-sref=\"^.add\">ici</a> pour ajouter un paramètre!","Click <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">here</a> to add a product!":"Cliquer <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">ici</a> pour ajouter un produit!","Click <a href=\"\" ui-sref=\"^.upload\" translate=\"\">here</a> to upload some!":"Cliquer <a href=\"\" ui-sref=\"^.upload\" translate=\"\">ici</a> pour en télécharger!","Confirm Password":"Confirmez le mot de passe","Content":"Contenu","Could not add category!":"La catégorie n'a pu être ajoutée","Could not add event!":"L'évènement n'a pu être ajouté","Could not add note!":"La note n'a pu être ajoutée","Could not add page!":"La page n'a pu être ajoutée","Could not add post!":"Le post n'a pu être ajouté","Could not add product!":"Le produit n'a pu être ajouté","Could not add setting!":"Le paramètre n'a pu être ajouté","Could not add user!":"L'utilisateur n'a pu être ajouté","Create pages with rich content!":"Créez une page avec du contenu riche!","Current user":"Utilisateur courant","Dashboard":"Tableau de bord","Delete category":"Détruire la catégorie","Deleting this cannot be undone":"Cette opération ne peux être annulée","Description":"Description","Don't worry we won't spam your inbox":"Pas de soucis, vous ne recevrez pas de pourriels de notre part.","E-mail":"Adresse courriel","Edit category":"Modifier la catégorie","Edit event":"Modifier l'évènement","Edit note":"Modifier la note","Edit post":"Modifier le post","Edit product":"Modifier le produit","Edit setting":"Modifier le paramètre","Email address needs to be valid":"Votre adresse courriel doit être validé","End":"Fin","End Time":"Heure de fin","Enjoy the new you!":"Votre nouveau compte!","Error deleting category":"La catégorie ne peux être effacée","Error deleting event":"L'évènement ne peux être effacé","Error deleting note":"La note n'a pu être effacée","Error deleting page":"La page ne peux être effacée","Error deleting post":"Le post ne peux être effacé","Error deleting product":"Le produit ne peux être éffacé","Error deleting setting":"Le paramètre ne peut être effacé","Error deleting user":"L'utilisateur ne peux être effacé","Error registering!":"Erreur lors de l'enregistrement du compte","Error saving note":"Erreur lors de l'enregistrement de la note","Error saving profile":"Erreur lors de l'enregistrement du profil","Error saving user:":"Erreur lors de l'enregistrement de l'utilisateur:","Error signin in after registration!":"Erreur de connexion après l'enregistrement!","Event deleted":"Évènement effacé","Event not added":"L'évènement n'a pu être ajouté","Event saved":"Évènement ajouté","Events":"Évènements","File deleted":"Ficher effacé","Files":"Fichiers","First Name":"Prénom","First name":"Prénom","Hello,":"Bonjour,","Home":"Accueil","Key":"Clé","Last Name":"Nom","Last name":"Nom","Logged in":"Connecté","Logged out":"Déconnecté","Manage your events here!":"Gérez vos évènements ici!","Manage your files here!":"Gérez vos fichiers ici!","Manage your notes here!":"Gérez vos notes ici!","Manage your posts here!":"Gérez vos posts ici!","Manage your products here!":"Gérez vos produits ici!","Manage your settings here!":"Gérez vos paramètres ici!","Manage your users here!":"Gérez vos utilisateurs ici!","More info":"Plus d'infos","Name":"Nom","Needs to have at least 4 characters":"Doit avoir au moins 4 caractères","New page":"Nouvelle page","Nice email address!":"Bonne adresse courriel!","Note deleted":"Note effacée","Note saved":"Note enregistrée","Notes":"Notes","Or register":"Ou créez un compte","Or sign in":"Ou connectez-vous","Page deleted":"Page effacée","Page saved":"Page enregistrée","Pages":"Pages","Password":"Mot de passe","Percentage":"Pourcentage","Post deleted":"Post effacé","Post saved":"Post enregistré","Posts":"Post","Price":"Prix","Product":"Produit","Product deleted":"Produit effacé","Product saved":"Produit enregistré","Products":"Produits","Profile":"Profil","Profile saved":"Profil enregistré","Progress":"Progrès","Raw":"Source","Register":"Créez un compte","Registered":"Compte créé","Remove all":"Tout retirer","Roles":"Rôles","Save":"Enregistrer","Setting deleted":"Paramètre effacé","Setting saved":"Paramètre enregistré","Settings":"Paramètres","Sign In":"Connexion","Sign in":"Connexion","Sign out":"Déconnexion","Size":"Grandeur","Start Date":"Date de début","Start Time":"Heure de début","Status":"Status","Stay signed in":"Rester connecté","Submit":"Soumettre","Theme":"Thème","There are no events":"Il n'y a pas d'évènements","There are no files":"Il n'y a pas de fichiers","There are no notes":"Il n'y a pas de notes","There are no pages":"Il n'y a pas de pages","There are no posts":"Il n'y a pas de posts","There are no products in this category!":"Il n'y a pas de produits dans cette catégorie!","There are no settings":"Il n'y a aucun paramètres","This note could no be saved:":"La note n'a pu être enregistrée","This user is save!":"L'utilisateur est enregistré","Title":"Titre","Toggle navigation":"Basculer la navigation","Update profile":"Mise à jour du profil","Upload":"Télécharger","Upload all":"Tout télécharger","Upload files":"Télécharger les fichiers","Upload queue":"File d'attente de téléchargement","User deleted":"L'utilisateur est effacé","User saved":"Utilisateur enregistré","Username":"Code utilisateur","Users":"Utilisateurs","Value":"Valeur","Variables":"Variables","Welcome!":"Bienvenu!","You are logged in!":"Vous êtes connecté","You are logged out!":"Vous êtes déconnecté","You are registered!":"Vous êtes enregistré","You can just drag them in this window!":"Vous pouvez les glisser sur cette fenêtre","You need an email address":"Une adresse courriel est requise","Your Gravatar":"Votre Gravatar","Your category is deleted!":"La catégorie est effacée!","Your category is not deleted:":"La catégorie n'a pu être effacée:","Your category is safe with us!":"La catégorie est enregistrée!","Your event is deleted!":"L'évènement est effacé!","Your event is not deleted:":"L'évènement n'a pu être effacé:","Your event is safe with us!":"L'évènement est enregistré!","Your file is deleted!":"Le fichier est effacé!","Your note is deleted!":"La note est effacée!","Your note is not deleted!":"La note n'a pu être effacée!","Your note is safe with us!":"La note est enregistrée!","Your page is deleted!":"La page est effacée!","Your page is not deleted:":"La page n'a pu être effacée:","Your page is safe with us!":"La page est enregistrée!","Your passwords need to match":"Les mots de passe ne sont pas identiques","Your post is deleted!":"Le post est effacé!","Your post is not deleted:":"Le post n'a pu être effacé:","Your post is safe with us!":"Le post est enregistré!","Your product is deleted!":"Le produit est effacé!","Your product is not deleted:":"Le produit n'a pu être effacé:","Your product is safe with us!":"Le produit est enregistré!","Your profile":"Votre profil","Your profile is not saved:":"Votre profil n'est pas enregistré:","Your setting is deleted!":"Le paramètre est effacé!","Your setting is not deleted:":"Le paramètre n'a pu être effacé:","Your setting is safe with us!":"Le paramètre est effacé!","Your user is deleted!":"L'utilisateur est effacé!","Your user is not deleted:":"L'utilisateur n'a pu être effacé:","dd/MM/yyyy":"dd/MM/yyyy","email":"adresse courriel","here":"ici","image":"image","in queue":"en file"});
    gettextCatalog.setStrings('nl', {"About":"Over","Actions":"Acties","Add":"Toevoegen","Add a new event":"Voeg een evenement toe","Add a new setting":"Voeg een instelling toe","Are you sure?":"Weet u het zeker?","Browse":"Bladeren","Cancel":"Annuleren","Cancel all":"Alles annuleren","Categories":"Categorieën","Category deleted":"Category verwijderd","Category saved":"Category opgeslagen","Change it here!":"Verander het hier!","Confirm Password":"Wachtwoord bevestigen","Could not add event!":"Het evenement kan niet toegevoegd worden","Could not add setting!":"De instelling kan niet toegevoegd worden","Current user":"Huidige gebruiker","Dashboard":"Dashboard","Deleting this cannot be undone":"Het verwijderen kan niet ongedaan gemaakt worden.","Don't worry we won't spam your inbox":"Wees niet bang, we zullen niet je inbox spammen","Edit event":"Evenement wijzigen","Edit setting":"Instelling wijzigen","Email address needs to be valid":"E-mailadres moet geldig zijn","Enjoy the new you!":"Geniet van je nieuwe profiel!","Error deleting category":"Fout bij het verwijderen van de category","Error deleting event":"Fout bij het verwijderen van het evenement","Error deleting page":"Fout bij het verwijderen van de pagina","Error deleting post":"Fout bij het verwijderen van de post","Error deleting product":"Fout bij het verwijderen van het product","Error deleting setting":"Fout bij het verwijderen van de instelling","Error deleting user":"Fout bij het verwijderen van de gebruiker","Error registering!":"Fout bij het registreren","Error saving profile":"Fout bij het opslaan van het profiel","Error saving user:":"Fout bij het opslaan van de gebruiker","Error signin in after registration!":"Fout bij het inloggen na registratie","Event deleted":"Evenement verwijderd","Event not added":"Evenement niet toegevoegd","Event saved":"Evenement opgeslagen","Events":"Evenementen","File deleted":"Bestand verwijderd","Files":"Bestanden","First Name":"Voornaam","Home":"Home","Key":"Sleutel","Last Name":"Achternaam","Logged in":"Ingelogd","Logged out":"Uitgelogd","Manage your events here!":"Hier beheer je je evenementen","Manage your files here!":"Hier beheer je je bestanden","Manage your settings here!":"Hier beheer je je instellingen","Manage your users here!":"Hier beheer je je gebruikers","More info":"Meer informatie","Name":"Naam","Needs to have at least 4 characters":"Moet op z'n minst uit 4 tekens bestaan","Nice email address!":"Mooi e-mailadres!","Notes":"Notities","Or register":"Of registreer","Or sign in":"Of meld je aan","Page deleted":"Pagina verwijderd","Page saved":"Pagina opgeslagen","Pages":"Pagina's","Password":"Wachtwoord","Post deleted":"Post verwijderd","Post saved":"Post opgeslagen","Posts":"Posts","Product deleted":"Product verwijderd","Product saved":"Product opgeslagen","Products":"Producten","Profile":"Profiel","Profile saved":"Profiel opgeslagen","Progress":"Voortgang","Register":"Aanmelden","Registered":"Aangemeld","Remove all":"Alle verwijderen","Setting deleted":"Instelling verwijderd","Setting saved":"Instelling opgeslagen","Settings":"Instellingen","Sign In":"Aanmelden","Sign in":"Aanmelden","Sign out":"Afmelden","Size":"Grootte","Status":"Status","Stay signed in":"Aangemeld blijven","Submit":"Submit","Theme":"Thema","There are no events":"Er zijn geen evenementen","There are no files":"Er zijn geen bestanden","There are no settings":"Er zijn geen instellingen","This user is save!":"Deze gebruiker is opgeslagen","Toggle navigation":"Navigatie wisselen","Update profile":"Profile bijwerken","Upload":"Upload","Upload all":"Alle uploaden","Upload files":"Bestanden uploaden","Upload queue":"Upload wachtrij","User deleted":"Gebruiker verwijderd","User saved":"Gebruiker opgeslagen","Users":"Gebruikers","Value":"Waarde","Variables":"Variabelen","Welcome!":"Welkom!","You are logged in!":"U bent ingelogd!","You are logged out!":"U bent uitgelogd!","You are registered!":"U bent geregistreerd!","You can just drag them in this window!":"U kunt ze gewoon in dit venster slepen!","You need an email address":"U heeft een e-mailadres nodig","Your Gravatar":"Uw Gravatar","Your category is deleted!":"De category is verwijderd","Your category is not deleted:":"De category is niet verwijderd","Your category is safe with us!":"De category is veilig opgeslagen","Your event is deleted!":"Uw evenement is verwijderd ","Your event is not deleted:":"Uw evenement is niet verwijderd:","Your event is safe with us!":"Het evenement is veilig opgeslagen","Your file is deleted!":"Uw bestand is verwijderd","Your page is deleted!":"De pagina is verwijderd","Your page is not deleted:":"De pagina is niet verwijderd","Your page is safe with us!":"De pagina is veilig opgeslagen","Your post is deleted!":"De post is verwijderd","Your post is not deleted:":"De post is niet verwijderd","Your post is safe with us!":"De post is veilig opgeslagen","Your product is deleted!":"Het product is verwijderd","Your product is not deleted:":"Het product is niet verwijderd","Your product is safe with us!":"Het product is veilig opgeslagen","Your profile":"Uw profiel","Your profile is not saved:":"Het profiel is niet opgeslagen","Your setting is deleted!":"Uw instelling is verwijderd","Your setting is not deleted:":"Uw instelling is niet verwijderd","Your setting is safe with us!":"Uw instelling is veilig bij ons!","Your user is deleted!":"De gebruiker is verwijderd","Your user is not deleted:":"De gebruiker is niet verwijderd","here":"hier","in queue":"in de wachtrij"});
    gettextCatalog.setStrings('pt_BR', {"About":"Sobre","Actions":"Ações","Add":"Novo","Add a new event":"Novo Evento","Add a new setting":"Adicionar nova configuração","Are you sure?":"Tem certeza?","Browse":"Navegar","Cancel":"Cancelar","Cancel all":"Cancelar todos","Categories":"Categorias","Category deleted":"Categoria deletada","Category saved":"Categoria atualizada","Change it here!":"Mude Aqui!","Confirm Password":"Confirmar Senha","Could not add event!":"Nenhum evento","Could not add setting!":"Não foi possível criar a configuração","Current user":"Usuário atual","Dashboard":"Painel de Controle","Edit event":"Editar Evento","Edit setting":"Editar configurações","Email address needs to be valid":"﻿Você precisa de um endereço de e-mail válido","Event deleted":"Evento deletado","Events":"Eventos","File deleted":"Arquivo deletado","Files":"Arquivos","First Name":"Nome","Home":"Inicial","Key":"Chave","Last Name":"Sobrenome","Logged in":"Você está logado!","Logged out":"Você não está mais logado!","Manage your events here!":"Administrar seus eventos","Manage your files here!":"Administrar seus arquivos","Manage your settings here!":"Administrar configurações do sistema!","Manage your users here!":"Administrar sua conta","More info":"Mais informações","Name":"Nome","Nice email address!":"﻿Endereço de e-mail legal!","Notes":"Notas","Or register":"Ou Cadastre-se","Or sign in":"Fazer Login","Page deleted":"Página deletada","Page saved":"Página salva","Pages":"Páginas","Password":"Senha","Posts":"Posts","Products":"Produtos","Profile":"Perfil","Progress":"Progresso","Register":"Cadastro","Registered":"Cadastrado","Remove all":"Remover Todos","Settings":"Configurações","Sign In":"Logar","Sign in":"Logar","Sign out":"Sair","Size":"Tamanho","Status":"Status","Stay signed in":"Continuar logado","Submit":"Enviar","Theme":"Tema","There are no events":"Nenhum evento","There are no files":"Nenhum arquivo","There are no settings":"Nenhuma configurações","This user is save!":"Usuário atualizado!","Toggle navigation":"Mudar Navegação","Update profile":"Atualizar Perfil","Upload":"Enviar","Upload all":"Enviar todos","Upload files":"Enviar arquivos","Upload queue":"Fila de envio","User deleted":"Usuário deletado","User saved":"Usuário atualizado","Users":"Usuários","Value":"Valor","Variables":"Variáveis","Welcome!":"Bem vindo!","You are logged in!":"Você está logado!","You are logged out!":"Você não está mais logado!","You are registered!":"Você está cadastrado!","You can just drag them in this window!":"Você pode mover essa janela!","You need an email address":"﻿Você precisa de um endereço de e-mail","Your Gravatar":"Seu gravatar","Your category is deleted!":"Categoria deletada","Your profile":"Seu perfil","here":"arqui","in queue":"na fila"});
    gettextCatalog.setStrings('ru_RU', {"<i class=\"fa fa-arrow-left\"></i> Pages":"<i class=\"fa fa-arrow-left\"></i> Страницы","<i class=\"fa fa-arrow-left\"></i> Users":"<i class=\"fa fa-arrow-left\"></i> Пользователи","<i class=\"fa fa-save\"></i>  Save":"<i class=\"fa fa-save\"></i> Сохранить","<i class=\"fa fa-save\"></i> Save":"<i class=\"fa fa-save\"></i> Сохранить","About":"О нас","Actions":"Действия","Add":"Добавить","Add Category":"Добавить категорию","Add a new category":"Добавить новую категорию","Add a new event":"Добавить новое событие","Add a new note":"Добавить новое примечание","Add a new post":"Добавить новый пост","Add a new product":"Добавить новый продукт","Add a new setting":"Добавьте новый параметр","Add product to category":"Добавить продукт в категории","Are you sure?":"Вы уверены?","Body":"Body","Browse":"Обзор","Cancel":"Отмена","Cancel all":"Отменить все","Categories":"Категории","Category":"Категория","Category deleted":"Категория удалена","Category saved":"Категория сохранена","Change it here!":"Изменить здесь!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a event!":"Нажмите <a href=\"\" ui-sref=\"^.add\">здесь</a> чтобы добавить событие!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a note!":"Нажмите <a href=\"\" ui-sref=\"^.add\">здесь</a> чтобы добавить примечание!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a page!":"Нажмите <a href=\"\" ui-sref=\"^.add\">здесь</a> чтобы добавить страницу!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a post!":"Нажмите <a href=\"\" ui-sref=\"^.add\">здесь</a> чтобы добавить пост!","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a setting!":"Нажмите <a href=\"\" ui-sref=\"^.add\">здесь</a> чтобы добавить параметр!","Click <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">here</a> to add a product!":"Нажмите <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">здесь</a> чтобы добавить продукт!","Click <a href=\"\" ui-sref=\"^.upload\" translate=\"\">here</a> to upload some!":"Нажмите <a href=\"\" ui-sref=\"^.upload\" translate=\"\">здесь</a> чтобы загрузить что-то!","Confirm Password":"Подтвердите Пароль","Content":"Content","Could not add category!":"Не удалось добавить категорию!","Could not add event!":"Не удалось добавить событие!","Could not add note!":"Не удалось добавить примечание!","Could not add page!":"Не удается добавить страницу!","Could not add post!":"Не удалось добавить пост!","Could not add product!":"Не удалось добавить продукт!","Could not add setting!":"Не удалось добавить параметр!","Could not add user!":"Не удалось добавить пользователя!","Create pages with rich content!":"Создание страниц с контентом!","Current user":"Текущий пользователь","Dashboard":"Панель управления","Delete category":"Удалить категорию","Deleting this cannot be undone":"Удаление этого не может быть отменено","Description":"Описание","Don't worry we won't spam your inbox":"Не волнуйтесь, мы не спамим \"Входящие\"","E-mail":"E-mail","Edit category":"Редактирование категории","Edit event":"Редактировать мероприятие","Edit note":"Редактировать примечание","Edit post":"Редактировать пост","Edit product":"Редактировать продукт","Edit setting":"Редактировать параметр","Email address needs to be valid":"Email адрес должен быть действительным","End":"Конец","End Time":"Время окончания","Enjoy the new you!":"Наслаждайтесь новым собой!","Error deleting category":"Ошибка удаления категории","Error deleting event":"Ошибка удаления события","Error deleting note":"Ошибка удаления примечания","Error deleting page":"Ошибка удаления страницы","Error deleting post":"Ошибка удаления поста","Error deleting product":"Ошибка удаления продукта","Error deleting setting":"Ошибка удаления параметра","Error deleting user":"Ошибка удаления пользователя","Error registering!":"Ошибка регистрации!","Error saving note":"Ошибка при сохранении примечания","Error saving profile":"Ошибка при сохранении профиля","Error saving user:":"Ошибка при сохранении пользователя:","Error signin in after registration!":"Ошибка авторизации после регистрации!","Event deleted":"Событие удалено","Event not added":"Событие не добавлено","Event saved":"Событие сохранено","Events":"События","File deleted":"Файл удален","Files":"Файлы","First Name":"Имя","First name":"Имя","Hello,":"Привет,","Home":"Главная","Key":"Key","Last Name":"Фамилия","Last name":"Фамилия","Logged in":"Вошли","Logged out":"Вышел из","Manage your events here!":"Диспетчер ваших событий здесь!","Manage your files here!":"Диспетчер ваших файлов здесь!","Manage your notes here!":"Диспетчер ваших примечаний здесь!","Manage your posts here!":"Диспетчер ваших постов здесь!","Manage your products here!":"Диспетчер ваших продуктов здесь!","Manage your settings here!":"Диспетчер ваших настройек здесь!","Manage your users here!":"Диспетчер ваших пользователей здесь!","More info":"Подробнее","Name":"Name","Needs to have at least 4 characters":"Необходимо иметь по крайней мере 4 символа","New page":"Новая страница","Nice email address!":"Nice email address!","Note deleted":"Примечание удалено","Note saved":"Примечание сохранено","Notes":"Примечания","Or register":"Или зарегистрируйтесь","Or sign in":"Или войдите","Page deleted":"Страница удалена","Page saved":"Страница сохранена","Pages":"Страницы","Password":"Пароль","Percentage":"Процент","Post deleted":"Пост удален","Post saved":"Пост сохранен","Posts":"Посты","Price":"Цена","Product":"Продукт","Product deleted":"Продукт удален","Product saved":"Продукт сохранен","Products":"Продукты","Profile":"Профиль","Profile saved":"Профиль сохранен","Progress":"Ход выполнения","Raw":"Raw","Register":"Регистрация","Registered":"Зарегистрирован(а)","Remove all":"Удалить все","Roles":"Роли","Save":"Сохранить","Setting deleted":"Параметр удален","Setting saved":"Параметр сохранен","Settings":"Настройки","Sign In":"Войти","Sign in":"Войти","Sign out":"Выйти","Size":"Размер","Start Date":"Дата начала","Start Time":"Время начала","Status":"Статус","Stay signed in":"Оставаться авторизованным","Submit":"Отправить","Theme":"Тема","There are no events":"Нет событий","There are no files":"Нет файлов","There are no notes":"Нет примечания","There are no pages":"Нет страниц","There are no posts":"Нет постов","There are no products in this category!":"Нет продуктов в этой категории!","There are no settings":"Не параметров","This note could no be saved:":"Эта примечение не может быть сохранена:","This user is save!":"Этот пользователь сохранен!","Title":"Название","Toggle navigation":"Переключить навигацию","Update profile":"Обновить профиль","Upload":"Загрузить","Upload all":"Загрузить все","Upload files":"Загрузить файлы","Upload queue":"Загрузить очередь","User deleted":"Пользователь удален","User saved":"Пользователь сохранен","Username":"Ваш логин","Users":"Пользователи","Value":"Значение","Variables":"Переменная","Welcome!":"Добро пожаловать!","You are logged in!":"Вы вошли!","You are logged out!":"Вы вышли!","You are registered!":"Вы зарегистрированы!","You can just drag them in this window!":"Вы просто можете перетащить их в это окно!","You need an email address":"Вам нужен email почты","Your Gravatar":"Ваш Gravatar","Your category is deleted!":"Ваша категория удалена!","Your category is not deleted:":"Ваша категория не удалена:","Your category is safe with us!":"Your category is safe with us!","Your event is deleted!":"Ваше событие удалено!","Your event is not deleted:":"Ваше событие не удалено:","Your event is safe with us!":"Your event is safe with us!","Your file is deleted!":"Ваш файл удален!","Your note is deleted!":"Ваше примечание удалено!","Your note is not deleted!":"Ваше примечание не удалено!","Your note is safe with us!":"Your note is safe with us!","Your page is deleted!":"Ваша страница удалена!","Your page is not deleted:":"Ваша страница не удалена:","Your page is safe with us!":"Your page is safe with us!","Your passwords need to match":"Ваши пароли должны совпадать","Your post is deleted!":"Ваш пост удален!","Your post is not deleted:":"Ваш пост не удален:","Your post is safe with us!":"Your post is safe with us!","Your product is deleted!":"Ваш продукт удален!","Your product is not deleted:":"Ваш продукт не удален:","Your product is safe with us!":"Your product is safe with us!","Your profile":"Ваш профиль","Your profile is not saved:":"Ваш профиль не сохранен:","Your setting is deleted!":"Ваш параметр удален!","Your setting is not deleted:":"Ваш параметр не удален:","Your setting is safe with us!":"Your setting is safe with us!","Your user is deleted!":"Ваш пользователь удален!","Your user is not deleted:":"Ваш пользователь не удален:","dd/MM/yyyy":"дд/ММ/гггг","email":"email","here":"здесь","image":"картинка","in queue":"в очереди"});
    gettextCatalog.setStrings('zh_CN', {"<i class=\"fa fa-arrow-left\"></i> Pages":"<i class=\"fa fa-arrow-left\"></i> 网页","<i class=\"fa fa-arrow-left\"></i> Users":"<i class=\"fa fa-arrow-left\"></i> 用户","<i class=\"fa fa-save\"></i>  Save":"<i class=\"fa fa-save\"></i>  保存","<i class=\"fa fa-save\"></i> Save":"<i class=\"fa fa-save\"></i> 保存","About":"关于","Actions":"行为","Add":"添加","Add Category":"添加分类","Add Product":"添加产品","Add a new category":"添加一个新分类","Add a new event":"添加一个新事件","Add a new note":"添加一个新笔记","Add a new post":"添加一个新邮件","Add a new product":"添加一个新产品","Add a new setting":"添加一个新设置","Add product to category":"向分类里添加产品","All about this application!":"关于本程序","Are you sure?":"你确定吗？","Body":"主体","Browse":"浏览","Cancel":"取消","Cancel all":"取消所有","Categories":"分类","Category":"分类","Category deleted":"分类已删除","Category saved":"分类已保存","Change it here!":"在这儿修改！","Click <a href=\"\" ui-sref=\"^.add\">here</a>\n      to add a post!":"点击<a href=\"\" ui-sref=\"^.add\">这里</a>来添加一个邮件！","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a event!":"点击<a href=\"\" ui-sref=\"^.add\">这里</a>来添加一个事件！","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a note!":"点击<a href=\"\" ui-sref=\"^.add\">这里</a>来添加一个笔记！","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a page!":"点击<a href=\"\" ui-sref=\"^.add\">这里</a>来添加一个页面！","Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a setting!":"点击<a href=\"\" ui-sref=\"^.add\">这里</a>来添加一个设置！","Click <a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">here</a> to add a product!":"点击<a href=\"\" ui-sref=\"^.add({ categoryId: category.id })\">这里</a>来添加一个产品！","Click <a href=\"\" ui-sref=\"^.upload\" translate=\"\">here</a> to upload some!":"点击<a href=\"\" ui-sref=\"^.upload\" translate=\"\">这里</a>来上传！","Confirm Password":"确认密码","Content":"内容","Could not add category!":"添加分类失败！","Could not add event!":"添加事件失败！","Could not add note!":"添加笔记失败！","Could not add page!":"添加页面失败！","Could not add post!":"添加邮件失败！","Could not add setting!":"添加设置失败！","Could not add user!":"添加用户失败！","Create pages with rich content!":"通过富文本内容来创建页面！","Current user":"当前用户","Dashboard":"仪表盘","Delete category":"删除仪表盘","Deleting this cannot be undone":"删除后不能撤销哦","Description":"描述","Don't worry we won't spam your inbox":"放心，我们不会给您发送垃圾邮件的","E-mail":"邮件","Edit category":"编辑分类","Edit event":"编辑事件","Edit note":"编辑笔记","Edit post":"编辑邮件","Edit product":"编辑产品","Edit setting":"编辑设置","Email":"邮件","Email address needs to be valid":"您必须验证您的邮箱","End":"结束","End Time":"结束时间","Enjoy the new you!":"看好你哦！","Error deleting category":"删除分类失败","Error deleting event":"删除事件失败","Error deleting item:":"删除项目失败：","Error deleting note":"删除笔记失败","Error deleting page":"删除页面失败","Error deleting product":"删除产品失败","Error deleting setting":"删除设置失败","Error deleting user":"删除用户失败","Error registering!":"注册失败！","Error saving note":"保存笔记失败","Error saving profile":"保存属性失败","Error saving user:":"保存用户失败：","Error signin in after registration!":"注册后登录失败！","Event deleted":"事件已删除","Event not added":"事件添加失败","Event saved":"事件已保存","Events":"事件","File deleted":"文件已删除","Files":"文件","First Name":"名字","First name":"名字","Hello,":"你好，","Home":"首页","Item deleted":"项目已删除","Key":"密钥","Last Name":"姓氏","Last name":"姓氏","Logged in":"登录","Logged out":"退出","Manage your events here!":"在这里管理您的事件！","Manage your files here!":"在这里管理您的文件!","Manage your notes here!":"在这里管理您的笔记！","Manage your posts here!":"在这里管理您的邮件！","Manage your products here!":"在这里管理您的产品！","Manage your settings here!":"在这里管理您的设置！","Manage your users here!":"在这里管理您的用户！","More info":"更多信息","Name":"名字","Needs to have at least 4 characters":"至少需呀4个字符","New page":"新页面","Nice email address!":"邮箱地址合法！","Note deleted":"笔记已删除","Note saved":"笔记已保存","Notes":"笔记","Oops":"我去","Or register":"或者去注册","Or sign in":"或者去登录","Page deleted":"页面已删除","Page saved":"页面已保存","Pages":"页面","Password":"密码","Post saved":"邮件已保存","Posts":"邮件","Price":"价格","Product":"产品","Product deleted":"产品已删除","Product saved":"产品已保存","Products":"产品","Profile":"属性","Profile saved":"属性已保存","Progress":"进程","Raw":"原始","Register":"注册","Registered":"已注册","Remove all":"删除所有","Roles":"角色","Save":"保存","Setting deleted":"设置已删除","Setting saved":"设置已保存","Settings":"设置","Sign In":"登录","Sign in":"登录","Sign out":"登出","Size":"大小","Start Date":"开始日期","Start Time":"开始时间","Status":"状态","Stay signed in":"保持登录状态","Submit":"提交","Theme":"主题","There are no events":"事件不存在","There are no files":"文件不存在","There are no notes":"笔记不存在","There are no pages":"页面不存在","There are no products in this category!":"在这个分类下没有产品！","There are no settings":"设置不存在","This note could no be saved:":"这个笔记不能被保存：","This user is save!":"用户已保存！","Title":"标题","Toggle navigation":"触发导航","Update profile":"更新属性","Upload":"上传","Upload all":"上传全部","Upload files":"上传文件","Upload queue":"上传队列","User deleted":"用户已删除","User saved":"用户已保存","Username":"用户名","Users":"用户","Value":"值","Variables":"变量","Welcome!":"欢迎！","You are logged in!":"登录成功！","You are logged out!":"登出成功！","You are registered!":"注册成功！","You can just drag them in this window!":"你可以把它们拖动到这个窗口里！","You need an email address":"你需要一个邮箱地址","Your Gravatar":"你的头像","Your category is deleted!":"分类已删除！","Your category is not deleted:":"分类删除失败：","Your category is safe with us!":"你的分类很安全！","Your event is deleted!":"事件已删除！","Your event is not deleted:":"事件删除失败：","Your event is safe with us!":"你的事件很安全！","Your file is deleted!":"文件已删除！","Your item has been deleted!":"项目已删除！","Your note is deleted!":"笔记已删除！","Your note is not deleted!":"笔记删除失败！","Your note is safe with us!":"你的笔记很安全！","Your page is deleted!":"页面已删除！","Your page is not deleted:":"页面删除失败：","Your page is safe with us!":"你的页面很安全！","Your passwords need to match":"密码不匹配","Your post is safe with us!":"你的邮件很安全！","Your product is deleted!":"产品已删除！","Your product is not deleted:":"产品删除失败：","Your product is safe with us!":"你的产品很安全！","Your profile":"你的信息","Your profile is not saved:":"信息保存失败：","Your setting is deleted!":"设置已删除！","Your setting is not deleted:":"设置删除失败：","Your setting is safe with us!":"你的设置很安全：","Your user is deleted!":"用户已删除！","Your user is not deleted:":"用户删除失败：","dd/MM/yyyy":"dd/MM/yyyy","here":"这里","image":"图片","in queue":"在排队"});
/* jshint +W100 */
}]);
angular.module("loopbackApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/modules/organizations/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement()\">\n                <i class=\"fa fa-plus\"></i> Add Organization\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div angular-busy=\"vm.promise\" class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-6\">\n                <div style=\"padding:15px\">\n                    <h2>Form</h2>\n                    <hr>\n                    <form>\n                        <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                    </form>\n                </div>\n            </div>\n            <div class=\"col-sm-6\">              \n                <div style=\"padding:15px\">\n                    <h2>Logo Preview</h2>\n                    <hr>\n                    <img class=\"img-thumbnail\" ng-src=\"data:{{ vm.item.logo.filetype }};base64,{{ vm.item.logo.base64 }}\" alt=\"Organization logo\" title=\"Organization logo\" ng-show=\"vm.item.logo\">\n                    <img class=\"img-thumbnail\" src=\"http://placehold.it/350x150/7ba9d0/fff?text=Select+an+image+%3A%29\" ng-show=\"!vm.item.logo\">\n                </div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" style=\"height:600px\" ui-grid=\"vm.gridOptions\" ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid organization-component\"></div>\n            </div>\n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>");
$templateCache.put("app/modules/about/views/about.html","<h4>AngularJS\n  <small>{{angular.version.full}} - {{angular.version.codeName}}</small>\n</h4>\n");
$templateCache.put("app/modules/about/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'About\' | translate }}\" sub-title=\"{{ \'All about this application!\' | translate }}\"></section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/authproviders/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.authprovider.id\" translate>Add a new SSO Provider</span>\n      <span ng-show=\"ctrl.authprovider.id\" translate>Edit SSO Provider</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <formly-form model=\"ctrl.authprovider\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n          <div class=\"col-xs-12\" ng-show=\"ctrl.authprovider.id\">\n            <label>Login link - Use Private mode because it overrides the current session</label>\n            <pre ng-bind=\"ctrl.previewUrl\"></pre>\n            <label ng-if=\"ctrl.authprovider.strategy===\'saml\'\">SAML Metdata</label>\n            <pre ng-if=\"ctrl.authprovider.strategy===\'saml\'\" ng-bind=\"ctrl.samlMetadataUrl\"></pre>\n          </div>\n          <div class=\"col-xs-12\">\n            <label>JSON configuration</label>\n            <div id=\"jsoneditor\" style=\"width: 100%; height: 400px\"></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Save and deploy\n      </button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/authproviders/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.authproviders.length}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n       Add SSO Provider <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.authproviders\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.edit({id: item.id})\">{{item.label}}</a>\n      </h4>\n      <p class=\"list-group-item-text\">\n        <span ng-bind=\"item.strategy\" class=\"label label-primary\"></span>\n      </p>\n    </div>\n    <div ng-show=\"!ctrl.authproviders.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no SSO Providers\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add an SSO Provider!</p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/authproviders/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Single Sign On Providers\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/core/views/app.html","<header class=\"header\">\n  <a class=\"logo\" title=\"SYLVA Administration\" alt=\"SYLVA Administration\" ng-href=\"{{siteUrl}}\">\n    <img style=\"width:35px;text-align:left\" src=\"https://assets.website-files.com/5b17c2dc0de8fe50832b9817/5d757e2c42881ea4faf92241_PNG%201.2.png\">\n    <span>Administration</span>\n  </a>\n  <navbar></navbar>\n</header>\n<div>\n  <div class=\"wrapper row-offcanvas row-offcanvas-left\">\n    <aside class=\"left-side sidebar-offcanvas\">\n      <section class=\"sidebar\">\n        <!--<div class=\"sidebar-quickselect\">-->\n        <!--  <ui-select class=\"quickselect\" ng-model=\"project.selected\" on-select=\"onSelectCallback($item,$model)\" theme=\"bootstrap\" ng-disabled=\"disabled\" title=\"Select a project\">-->\n        <!--    <ui-select-match placeholder=\"Select a project\">{{$select.selected.name}}</ui-select-match>-->\n        <!--    <ui-select-choices repeat=\"project in projects | propsFilter: {name: $select.search}\">-->\n        <!--      <div ng-bind-html=\"project.name | highlight: $select.search\"></div>-->\n              <!--<small>-->\n              <!--  email: {{project.email}}-->\n              <!--  age: <span ng-bind-html=\"\'\'+project.age | highlight: $select.search\"></span>-->\n              <!--</small>-->\n        <!--    </ui-select-choices>-->\n        <!--  </ui-select>-->\n        <!--</div>-->\n        <ul class=\"sidebar-menu\">\n          <li ng-repeat=\"item in menuoptions\" ng-class=\"{active:isMenuActive(item.sref)}\">\n            <a class=\"\" href=\"\" ui-sref=\"{{item.sref}}\"><i class=\"fa fa-fw {{item.icon}}\"></i> {{item.name | translate}}</a>\n          </li>\n        </ul>\n      </section>\n    </aside>\n    <aside ui-view class=\"right-side at-view-fade-in at-view-fade-out\">\n\n    </aside>\n  </div>\n</div>\n");
$templateCache.put("app/modules/core/views/home.html","<section class=\"content-header\">\n  <div class=\"pull-right\">\n  </div>\n  <h1>\n    {{ \'Home\' | translate }}\n    <small translate>Welcome!</small>\n  </h1>\n</section>\n<section class=\"content\">\n  <div class=\"row\">\n    <div class=\"col-xs-12\">\n      <uib-tabset class=\"nav-tabs-custom\">\n        <uib-tab heading=\"{{ \'Dashboard\' | translate }}\">\n          <div class=\"row\">\n            <div class=\"col-xs-12\">\n              \n              <div class=\"panel panel-default\">\n                \n                \n              </div>\n              \n            </div>\n              \n\n          </div>\n        </uib-tab>\n        <!--<uib-tab heading=\"{{ \'Variables\' | translate }}\">-->\n        <!--  <div class=\"row\">-->\n            \n        <!--  </div>-->\n        <!--</uib-tab>-->\n        <!--<uib-tab heading=\"{{ \'Theme\' | translate }}\">-->\n        <!--  <div class=\"row\">-->\n        <!--    <div class=\"col-md-6\">-->\n        <!--      <h4> {{ \'Theme\' | translate }}-->\n        <!--        <small>{{appTheme}}</small>-->\n        <!--      </h4>-->\n        <!--      <div class=\"btn-group\" data-toggle=\"btn-toggle\">-->\n        <!--        <button type=\"button\" class=\"btn btn-default btn-xs\" data-toggle=\"on\"-->\n        <!--                ng-repeat=\"theme in appThemes\" ng-click=\"setSetting(\'appTheme\', theme.class)\">-->\n        <!--          {{theme.name}}-->\n        <!--        </button>-->\n        <!--      </div>-->\n        <!--      <h4>Layout-->\n        <!--        <small>{{appLayout}}</small>-->\n        <!--      </h4>-->\n        <!--      <div class=\"btn-group\" data-toggle=\"btn-toggle\">-->\n        <!--        <button type=\"button\" class=\"btn btn-default btn-xs\" data-toggle=\"on\"-->\n        <!--                ng-repeat=\"layout in appLayouts\" ng-click=\"setSetting(\'appLayout\', layout.class)\">-->\n        <!--          {{layout.name}}-->\n        <!--        </button>-->\n        <!--      </div>-->\n        <!--    </div>-->\n        <!--  </div>-->\n        <!--</uib-tab>-->\n      </uib-tabset>\n    </div>\n  </div>\n</section>\n");
$templateCache.put("app/modules/customstyles/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.customstyle.id\" translate>Add a new custom style</span>\n      <span ng-show=\"ctrl.customstyle.id\" translate>Edit custom style</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <formly-form model=\"ctrl.customstyle\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n          <div class=\"col-xs-12\">\n            <label>CSS \n            <!--<a class=\"btn btn-xs btn-info\" ng-if=\"ctrl.customstyle.id && ctrl.customstyle.data.preview\" ng-href=\"{{ctrl.previewLink}}\" target=\"_blank\">Preview Link</a>-->\n            </label>\n            <textarea ui-codemirror=\"{\n                lineNumbers: true,\n                theme:\'twilight\',\n                lineWrapping : true,\n                mode: \'text/css\'\n              }\" ng-model=\"ctrl.customstyle.data.preview\"></textarea>\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button class=\"btn btn-primary\" ng-if=\"ctrl.customstyle.id && ctrl.customstyle.data.preview\" ng-click=\"ctrl.updatePreview()\" ng-disabled=\"form.$invalid\">\n        Preview\n      </button>\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Save and deploy\n      </button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/customstyles/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.customstyles.length}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n       Add custom style <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.customstyles\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.edit({id: item.id})\">{{item.data.label}}</a>\n      </h4>\n\n      <p class=\"list-group-item-text\">{{item.value}}</p>\n    </div>\n    <div ng-show=\"!ctrl.customstyles.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no custom styles\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a custom style!</p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/customstyles/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Custom Styles\' | translate }}\" sub-title=\"{{ \'Manage your custom styles here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/files/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.gridOptions.totalItems}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.upload\">\n        Add file <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n\n  <div class=\"panel-body\" style=\"padding:0\">\n      <div class=\"row\">\n          <div class=\"col-xs-12\">\n              <div angular-busy=\"ctrl.loading\" style=\"height:600px\" ui-grid=\"ctrl.gridOptions\" ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n          </div>\n      </div>\n  </div>  \n  \n</div>\n");
$templateCache.put("app/modules/files/views/main.html","<section ng-if=\"!projectFiles\" admin-header class=\"content-header\" title=\"Files\" sub-title=\"Manage your files here!\"></section>\n<section ui-view ng-class=\"{\'content\':!projectFiles}\"></section>\n");
$templateCache.put("app/modules/files/views/upload.html","<div nv-file-drop uploader=\"ctrl.uploader\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      {{ \'Upload files\' | translate }}\n      <span class=\"text-muted\" translate>You can just drag them in this window!</span>\n      <span class=\"pull-right\">\n        <div class=\"file-input btn btn-xs btn-success btn-file\">\n          {{ \'Browse\' | translate }}&hellip;\n          <input nv-file-select type=\"file\" uploader=\"ctrl.uploader\" multiple=\"multiple\">\n        </div>\n      </span>\n    </div>\n\n    <table class=\"table table-bordered table-stiped\">\n      <tr>\n        <th width=\"30%\" translate>Name</th>\n        <th width=\"20%\" translate>Metadata (JSON)</th>\n        <th width=\"10%\" translate>Component model</th>\n        <th ng-show=\"ctrl.uploader.isHTML5\" translate>Size</th>\n        <th ng-show=\"ctrl.uploader.isHTML5\" translate>Progress</th>\n        <th width=\"3%\" translate>Status</th>\n        <th translate>Actions</th>\n      </tr>\n      <tr ng-repeat=\"item in ctrl.uploader.queue\">\n        <td><strong>{{ item.file.name }}</strong>\n        </td>\n        <td>    \n          <div class=\"form-group\">\n            <textarea placeholder=\"Component Metadata\" ng-model=\"item.file.data\" ng-init=\"item.file.data=\'{}\'\" class=\"form-control\"></textarea>\n          </div>\n        </td>\n        <td>    \n          <div class=\"form-group\">\n            <input type=\"text\" placeholder=\"Component model\" ng-model=\"item.file.componentModel\" ng-init=\"item.file.componentModel=ctrl.defaultComponentModel||\'lecture\'\" class=\"form-control\">\n          </div>\n        </td>\n        <td ng-show=\"ctrl.uploader.isHTML5\" nowrap=\"nowrap\">{{ item.file.size/1024/1024|number:2 }} MB\n        </td>\n        <td ng-show=\"ctrl.uploader.isHTML5\">\n          <div class=\"progress\" style=\"margin-bottom: 0\">\n            <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div>\n          </div>\n        </td>\n        <td class=\"text-center\">\n          <span ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>\n          <span ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>\n          <span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>\n        </td>\n        <td nowrap=\"nowrap\">\n          <div class=\"input-group pull-right btn-group btn-group-xs\">\n            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\">\n              <span class=\"glyphicon glyphicon-upload\"></span>\n            </button>\n            <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\">\n              <span class=\"glyphicon glyphicon-ban-circle\"></span>\n            </button>\n            <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\">\n              <span class=\"glyphicon glyphicon-trash\"></span>\n            </button>\n          </div>\n        </td>\n      </tr>\n    </table>\n\n    <div class=\"panel-footer\">\n      <div class=\"row\">\n        <div class=\"col-md-3\">\n          {{ \'Upload queue\' | translate }}\n          <small> {{ ctrl.uploader.queue.length }} {{ \'in queue\' | translate }}</small>\n        </div>\n        <div class=\"col-md-6\">\n          <div class=\"progress\" style=\"margin-bottom: 0px\" ng-if=\"ctrl.uploader.progress\">\n            <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': ctrl.uploader.progress + \'%\' }\">\n              {{ctrl.uploader.progress}}%\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-3\" class=\"text-nowrap\">\n          <div class=\"pull-right btn-group\" class=\"text-nowrap\">\n            <a class=\"btn btn-success btn-xs\" ng-click=\"ctrl.uploader.uploadAll()\" ng-disabled=\"!ctrl.uploader.getNotUploadedItems().length\">\n              {{ \'Upload\' | translate }}\n            </a>\n            <a class=\"btn btn-warning btn-xs\" ng-click=\"ctrl.uploader.cancelAll()\" ng-disabled=\"!ctrl.uploader.isUploading\">\n              {{ \'Cancel\' | translate }}\n            </a>\n            <a class=\"btn btn-danger btn-xs\" ng-click=\"ctrl.uploader.clearQueue()\" ng-disabled=\"!ctrl.uploader.queue.length\">\n              {{ \'Remove\' | translate }}\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/gradingschemes/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.gradingscheme.id\" translate>Add a new grading scheme</span>\n      <span ng-show=\"ctrl.gradingscheme.id\" translate>Edit grading scheme</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <formly-form model=\"ctrl.gradingscheme\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n          <div class=\"col-xs-12\">\n            <label>Scheme *</label>\n            <div style=\"font-weight:bold\">\n              <div class=\"col-xs-11\">\n                <div class=\"col-xs-3\">Percent(%)</div>\n                <div class=\"col-xs-3\">Grade</div>\n                <div class=\"col-xs-6\">Short signification</div>\n              </div>\n              <div class=\"col-xs-1\"></div>\n            </div>\n\n            <div ng-repeat=\"row in ctrl.gradingscheme.data.scheme track by $index\">\n              <div class=\"col-xs-11\">\n                <div class=\"col-xs-3\">\n                  <input ng-model=\"row.percent\" class=\"form-control\" style=\"display:inline; margin:5px\" placeholder=\"Percent(%)\" required=\"true\" min=\"0\" type=\"number\">\n                </div>\n                <div class=\"col-xs-3\">\n                  <input type=\"text\" ng-model=\"row.grade\" class=\"form-control\" style=\"display:inline; margin:5px\" placeholder=\"Grade\">\n                </div>\n                <div class=\"col-xs-6\">\n                  <input ng-model=\"row.signification\" class=\"form-control\" style=\"display:inline; margin:5px\" placeholder=\"Short signification\" required=\"true\">\n                </div>\n                <div class=\"col-xs-12\">\n                  <textarea rows=\"1\" ng-model=\"row.description\" class=\"form-control\" style=\"display:inline; margin:5px\" placeholder=\"Long description\"></textarea>\n                </div>\n              </div>\n              <div class=\"col-xs-1\">\n                <a href=\"\" ng-click=\"ctrl.gradingscheme.data.scheme.splice($index,1)\" style=\"line-height:30px;margin-top:20px\" class=\"btn btn-sm btn-danger\"><i class=\"fa fa-remove\"></i></a>\n              </div>\n              <div class=\"col-xs-12\">\n                <hr>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"col-xs-12\">\n            <!--Add button-->\n            <a style=\"margin:10px\" href=\"\" ng-click=\"ctrl.gradingscheme.data.scheme.push({})\" class=\"btn btn-sm btn-success\">Add new</a>\n          </div>\n        </div>\n        <div class=\"col-md-4\">\n          <!--<pre>{{ctrl.gradingscheme | json}}</pre>-->\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Submit\n      </button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/gradingschemes/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.gradingschemes.length}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n       Add Grading scheme <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.gradingschemes\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.edit({id: item.id})\">{{item.data.label}}</a>\n      </h4>\n\n      <p class=\"list-group-item-text\">{{item.value}}</p>\n    </div>\n    <div ng-show=\"!ctrl.gradingschemes.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no gradingschemes\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a Grading scheme!</p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/gradingschemes/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Grading Schemes\' | translate }}\" sub-title=\"{{ \'Manage your grading schemes here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/organizations/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.organization.id\" translate>Add a new organization</span>\n      <span ng-show=\"ctrl.organization.id\" translate>Edit organization</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-sm-6\">\n            <div style=\"padding:15px\">\n                <h2>Form</h2>\n                <hr>\n                <form>\n                    <formly-form model=\"ctrl.organization\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n                </form>\n                <form name=\"LTIForm\" ng-show=\"ctrl.organization.lti\">\n                  \n                  <h2>LTI Options </h2>\n                  <hr>\n                  <div ng-show=\"ctrl.LTI_config.lti1p0\">\n                    <label>\n                        LTI 1.0 Launch URL\n                    </label>\n                    <pre>https://{{ctrl.ltiDomain}}.sylva.ac/v1p0/{{ctrl.organization.id}}</pre>\n                  </div>\n                  <div ng-show=\"ctrl.LTI_config.lti1p1\">\n                    <label>\n                        LTI 1.1 Launch URL\n                    </label>\n                    <pre>https://{{ctrl.ltiDomain}}.sylva.ac/v1p1/{{ctrl.organization.id}}</pre>\n                  </div>\n                  <formly-form model=\"ctrl.LTI_config\" fields=\"ctrl.LTI_formFields\" options=\"ctrl.LTI_formOptions\"></formly-form>\n                  <div class=\"form-group\">\n                      <label class=\"control-label\" for=\"color_picker\">Theme Color (Optional)</label>\n                      <input colorpicker class=\"form-control\" name=\"color_picker\" style=\"width:100px\" ng-model=\"ctrl.LTI_config.color\">\n                      <span style=\"width:100%;height:100%;display:block\" ng-style=\"{\'background\':ctrl.LTI_config.color}\">&nbsp;</span>\n                  </div>\n                </form>\n                \n            </div>\n        </div>\n        <div class=\"col-sm-6\">              \n            <div style=\"padding:15px\">\n                <h2>Logo Preview</h2>\n                <hr>\n                <img style=\"max-height: 200px; width:auto\" class=\"img-thumbnail\" ng-src=\"data:{{ ctrl.organization.logo.filetype }};base64,{{ ctrl.organization.logo.base64 }}\" alt=\"Organization logo\" title=\"Organization logo\" ng-show=\"ctrl.organization.logo\">\n                <img class=\"img-thumbnail\" src=\"images/logo-placeholder-generic.200x200.png\" ng-show=\"!ctrl.organization.logo\">\n            </div> \n            <div style=\"padding:15px\" ng-if=\"ctrl.organization.id && !ctrl.isProd\">\n                <h2>Billing details \n                <button class=\"btn btn-sm btn-primary\" ng-hide=\"ctrl.enableBilling\" ng-click=\"ctrl.enableBilling = true;\">Enable</button></h2>\n                <hr>\n                <form name=\"billing\" ng-if=\"ctrl.enableBilling\">\n                    <formly-form model=\"ctrl.organizationBilling\" fields=\"ctrl.billingformFields\" options=\"ctrl.billingformOptions\"></formly-form>\n                </form>\n                <hr>\n            </div>\n            \n        </div>\n        <div class=\"col-sm-6\">       \n            <div style=\"padding:15px\">\n              <form name=\"CloudConfigForm\">\n                <h2>Premium Cloud Service </h2>\n                <hr>\n                <formly-form model=\"ctrl.CloudConfig_config\" fields=\"ctrl.CloudConfig_formFields\" options=\"ctrl.CloudConfig_formOptions\"></formly-form>\n              </form>\n            </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Submit\n      </button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/organizations/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div style=\"display:flex\">\n      <span class=\"text-left\" style=\"width:10%\">\n        <span class=\"label label-default\" style=\"display:inline-flex\"><font style=\"font-size:20px\">{{ctrl.organizations.length}}</font> </span>\n      </span>\n      <span class=\"text-center\" style=\"width:70%\">\n        <input class=\"form-control\" type=\"text\" placeholder=\"Search organizations...\" ng-model=\"ctrl.organizationFilter\" ng-model-options=\"{ debounce: 500 }\">\n      </span>\n      <span class=\"text-right\" style=\"width:20%\">\n        <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n         Add organization <i class=\"fa fa-plus\"></i>\n        </a>\n      </span>\n    </div>\n  </div>\n\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.organizations | propsFilter: {name: ctrl.organizationFilter, shortName: ctrl.organizationFilter}\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.view.users({id: item.id})\">{{item.name}} <span ng-if=\"item.shortName\">{{\' (\'+item.shortName+\')\'}}</span></a>\n      </h4>\n      <!--<p class=\"list-group-item-text\" ng-bind=\"item.description\"></p>-->\n      <p class=\"list-group-item-text\">\n        <span ng-bind=\"item.updatedAt | date:\'short\'\" class=\"label label-default\"></span>\n        <span ng-bind=\"item.styleDefinitions\" class=\"label label-primary\"></span>\n      </p>\n    </div>\n    <div ng-show=\"!ctrl.organizations.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no organizations\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a organization!</p>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/modules/organizations/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'organizations\' | translate }}\" sub-title=\"{{ \'Manage your organizations here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/organizations/views/view.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n    {{ctrl.organization.name}}\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: ctrl.organization.id})\">\n        <i class=\"fa fa-pencil\"></i>\n      </a>\n      <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: ctrl.organization.id})\">\n        <i class=\"fa fa-trash-o\"></i>\n      </a>\n    </span>\n  </div>  \n  <div>\n    <uib-tabset class=\"nav-tabs-custom\" active=\"ctrl.activeTab\">\n      <uib-tab ng-repeat=\"tab in ctrl.tabs\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" heading=\"{{ tab.label | translate }}\"></uib-tab>\n    </uib-tabset>\n    <ui-view></ui-view>\n  </div>\n  <!--<div class=\"panel-body\">-->\n  <!--  <div class=\"row\">-->\n  <!--    <div class=\"col-sm-6\">-->\n  <!--      <div style=\"padding:15px;\">-->\n  <!--        <h2>Organization details</h2>-->\n  <!--        <hr>-->\n  <!--        <object-viewer item=\"ctrl.organization\"></object-viewer>-->\n  <!--      </div>-->\n  <!--    </div>-->\n  <!--    <div class=\"col-sm-6\">-->\n  <!--      <div style=\"padding:15px;\">-->\n  <!--        <h2>Logo</h2>-->\n  <!--        <hr>-->\n  <!--        <img class=\"img-thumbnail\" ng-src=\"data:{{ ctrl.organization.logo.filetype }};base64,{{ ctrl.organization.logo.base64 }}\" alt=\"Organization logo\" title=\"Organization logo\" ng-show=\"ctrl.organization.logo\">-->\n  <!--        <img class=\"img-thumbnail\" src=\"images/logo-placeholder-generic.200x200.png\" ng-show=\"!ctrl.organization.logo\">-->\n  <!--      </div>-->\n  <!--    </div>-->\n  <!--  </div>-->\n  <!--</div>-->\n  \n</div>\n");
$templateCache.put("app/modules/permissions/views/list.html","<div ng-repeat=\"model in ctrl.permissions\" class=\"panel panel-default\">\n  <div class=\"panel-heading\" style=\"min-height: 50px\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{model.name}}</font> </span>\n    </div>\n  </div>\n  <div class=\"panel-body\">\n\n    <table class=\"table\" style=\"width: 100%;table-layout: fixed;font-size:1.2em\">\n      <thead>\n        <tr>\n          <th width=\"20%\">Access type</th>\n          <th width=\"20%\">Role</th>\n          <th width=\"20%\">Permission</th>\n          <th width=\"60%\">Properties</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"row in model.acls\">\n          <td><span class=\"label\" ng-class=\"ctrl.getMethodClass(row)\">{{:: row.accessType || \"*\"}}</span></td>\n          <td style=\"font-weight:400\">{{:: row.principalId || \"*\"}}</td>\n          <td>{{:: row.permission}}</td>\n          <td style=\"display:flex; flex-wrap:wrap\">\n            <span ng-repeat=\"p in row.property track by $index\" style=\"margin:4px\" class=\"label\" ng-class=\"ctrl.getMethodClass(row)\">\n  <a href style=\"color:white\" ng-click=\"ctrl.goToAPI(p,model.name)\">{{p}}</a>\n</span>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n  </div>\n</div>");
$templateCache.put("app/modules/permissions/views/list.roles.html","<div ng-repeat=\"model in ctrl.permissions\" class=\"panel panel-default\">\n  <div class=\"panel-heading\" style=\"min-height: 50px\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:23px\">{{model.name}}</font> </span>\n    </div>\n  </div>\n  <div class=\"panel-body\">\n\n    <table class=\"table\" style=\"width: 100%;table-layout: fixed;font-size:1.2em\">\n      <thead>\n        <tr>\n          <th width=\"20%\">Properties</th>\n          <th ng-repeat=\"role in model.roles\" width=\"7%\">{{role.name}}</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"p in model.properties track by $index\">\n          <td style=\"display:flex; flex-wrap:wrap\">\n            <span style=\"margin:4px\" class=\"label\" ng-class=\"ctrl.getMethodClass(p)\">\n              <a title=\"Access Type: {{p.accessType}}\" href style=\"color:white\" ng-click=\"ctrl.goToAPI(p.name,model.name)\">{{p.name}}</a>\n            </span>\n          </td>\n          <td ng-repeat=\"role in model.roles\" style=\"font-weight:400\">\n            <i title=\"{{role.name}}: DENY\" ng-if=\"p.roles[role.name]===2\" style=\"color:#5cb85c\" class=\"fa fa-check\"></i> \n            <i title=\"{{role.name}}: ALLOW\" ng-if=\"p.roles[role.name]===1\" style=\"color:#d9534f\" class=\"fa fa-close\"></i> \n          </td>\n        </tr>\n      </tbody>\n    </table>\n\n  </div>\n</div>");
$templateCache.put("app/modules/permissions/views/main.html","<section admin-header class=\"content-header\" title=\"Permissions\"></section>\n<div class=\"content\">\n    \n    <ui-select on-select=\"vm.selectModels(vm.models)\" on-remove=\"vm.selectModels(vm.models)\" class=\"quickselect\" multiple=\"multiple\" ng-model=\"vm.models\" theme=\"bootstrap\" close-on-select=\"true\">\n      <ui-select-match placeholder=\"Select models\">{{$item}}</ui-select-match>\n      <ui-select-choices repeat=\"m in vm.availableModels | filter: $select.search track by $index\">\n        <div ng-bind-html=\"m | highlight: $select.search\"></div>\n      </ui-select-choices>\n    </ui-select>\n    \n</div>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/projects/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.project.id\" translate>Add a new project</span>\n      <span ng-show=\"ctrl.project.id\" translate>Edit project</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-sm-5\">\n          <formly-form model=\"ctrl.project\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n        </div>\n        <div class=\"col-sm-7\">\n          <div>\n            <label class=\"control-label\">Maxmimum student seats</label>\n            <input class=\"form-control\" type=\"number\" style=\"width:100px\" ng-model=\"ctrl.maxSeats\">\n          </div>\n          <div ng-if=\"ctrl.project.id\">\n\n            <h3>Select Background\n              <a href=\"\" ng-show=\"ctrl.backgroundImage\" ng-click=\"ctrl.deleteBackground(ctrl.project)\" class=\"btn btn-xs btn-danger\">clear <i class=\"fa fa-close\"></i></a>\n              <span style=\"padding:5px\" ng-show=\"ctrl.imageLoading\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span>\n\n            </h3>\n            <input type=\"file\" nv-file-select=\"\" uploader=\"ctrl.uploader\"><br>\n\n            <div ng-if=\"ctrl.uploader.queue.length>0\">\n              <table class=\"table\">\n                <thead>\n                  <tr>\n                    <th width=\"50%\">Name</th>\n                    <th ng-show=\"ctrl.uploader.isHTML5\">Size</th>\n                    <th ng-show=\"ctrl.uploader.isHTML5\">Progress</th>\n                    <th>Status</th>\n                    <th>Actions</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in ctrl.uploader.queue\">\n                    <td>\n                      <strong>{{ item.file.name }}</strong>\n                       Image preview \n                      auto height\n                      <div ng-thumb=\"{ file: item.file, width: 100 }\"></div>\n                      auto width\n                      <div ng-show=\"ctrl.uploader.isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\"></div>\n                      fixed width and height \n                      <div ng-thumb=\"{ file: item.file, width: 100, height: 100 }\"></div>\n                    </td>\n                    <td ng-show=\"ctrl.uploader.isHTML5\" nowrap=\"nowrap\">{{ item.file.size/1024/1024|number:2 }} MB</td>\n                    <td ng-show=\"ctrl.uploader.isHTML5\">\n                      <div class=\"progress\" style=\"margin-bottom: 0\">\n                        <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div>\n                      </div>\n                    </td>\n                    <td class=\"text-center\">\n                      <span ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>\n                      <span ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>\n                      <span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>\n                    </td>\n                    <td nowrap=\"nowrap\">\n                      <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\">\n                                            <span class=\"glyphicon glyphicon-upload\"></span> Upload\n                                        </button>\n                      <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\">\n                                            <span class=\"glyphicon glyphicon-trash\"></span>\n                                        </button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n\n            </div>\n            <img class=\"img-thumbnail\" style=\"max-height:400px\" ng-src=\"{{ctrl.backgroundImage}}\" ng-show=\"ctrl.backgroundImage\">\n\n          </div>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Submit\n      </button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/projects/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div style=\"display:flex\">\n      <span class=\"text-left\" style=\"width:10%\">\n        <span class=\"label label-default\" style=\"display:inline-flex\"><font style=\"font-size:20px\">{{ctrl.projects.length}}</font> </span>\n      </span>\n      <span class=\"text-center\" style=\"width:70%\">\n        <input class=\"form-control\" type=\"text\" placeholder=\"Search projects...\" ng-model=\"ctrl.projectFilter\" ng-model-options=\"{ debounce: 500 }\">\n      </span>\n      <span class=\"text-right\" style=\"width:20%\">\n        <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n         Add Project <i class=\"fa fa-plus\"></i>\n        </a>\n      </span>\n    </div>\n  </div>\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.projects | propsFilter: {name: ctrl.projectFilter, shortName: ctrl.projectFilter, \'organization.name\': ctrl.projectFilter}\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.view.syllabus({id: item.id})\">{{item.name}} <span ng-if=\"item.shortName\">{{\' (\'+item.shortName+\')\'}}</span></a>\n      </h4>\n      <!--<p class=\"list-group-item-text\" ng-bind=\"item.description\"></p>-->\n      <p class=\"list-group-item-text\" style=\"padding-top:6px\">\n        <span ng-bind=\"item.updatedAt | date:\'short\'\" class=\"label label-default\"></span>\n        <span class=\"label label-primary\">{{::item.organization.styleDefinitions}}</span>\n        <span class=\"label label-default\">{{::item.organization.name}}</span>\n      </p>\n    </div>\n    <div ng-show=\"!ctrl.projects.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no projects\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a project!</p>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("app/modules/projects/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Projects\' | translate }}\" sub-title=\"{{ \'Manage your projects here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/projects/views/view.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n    {{ctrl.project.name}}\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: ctrl.project.id})\">\n        <i class=\"fa fa-pencil\"></i>\n      </a>\n      <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: ctrl.project.id})\">\n        <i class=\"fa fa-trash-o\"></i>\n      </a>\n    </span>\n  </div>\n  <div>\n    <uib-tabset class=\"nav-tabs-custom\" active=\"ctrl.activeTab\">\n      <uib-tab ng-repeat=\"tab in ctrl.tabs\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" heading=\"{{ tab.label | translate }}\"></uib-tab>\n    </uib-tabset>\n    <ui-view></ui-view>\n  </div>\n</div>\n");
$templateCache.put("app/modules/reporting/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.report.id\" translate>Add a new report template</span>\n      <span ng-show=\"ctrl.report.id\" translate>Edit report template</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-xs-12\">\n          <formly-form model=\"ctrl.report\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Save\n      </button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/reporting/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.reporting.length}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n       Add report template <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n  <div angular-busy=\"ctrl.loading\" class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.reporting\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.view({id: item.id})\">{{item.data.label}}</a>\n      </h4>\n\n      <p class=\"list-group-item-text\">{{item.value}}</p>\n    </div>\n    <div ng-show=\"!ctrl.reporting.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no report templates\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a report template!</p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/reporting/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Custom Report templates\' | translate }}\" sub-title=\"{{ \'Manage your reporting templates here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/reporting/views/view.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n    {{ctrl.report.label}}\n    <small>{{ctrl.setting.value}}</small>\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: ctrl.setting.id})\">\n        <i class=\"fa fa-pencil\"></i>\n      </a>\n      <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: ctrl.setting.id})\">\n        <i class=\"fa fa-trash-o\"></i>\n      </a>\n    </span>\n  </div>\n  <div class=\"panel-body\">\n    <div class=\"row\">\n      \n      <div class=\"col-xs-6\">\n        <label>\n          Source API: {{ctrl.report.sourceAPI.model}}.{{ctrl.report.sourceAPI.func}}\n        </label>\n        <span style=\"padding:5px\" ng-show=\"ctrl.searchLoader\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span>\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <label for=\"orgSelector\">Selected Organization</label>\n          </div>\n          <div class=\"col-xs-8\">\n            <ui-select on-select=\"ctrl.searchProject($item)\" class=\"quickselect\" disabled=\"\" ng-model=\"ctrl.selectedOrg\" theme=\"bootstrap\" title=\"Select organization\">\n                <ui-select-match placeholder=\"Search for an organization\">\n                    {{$select.selected.name}}\n                </ui-select-match>\n                <ui-select-choices repeat=\"org in ctrl.availableOrgs\">\n                    <div>\n                        <span ng-bind-html=\"org.name | highlight: $select.search\"></span> \n                    </div>\n                </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-4\">\n            <label for=\"projectSelector\">Selected Project (Optional)</label>\n          </div>\n          <div class=\"col-xs-8\">\n            <ui-select id=\"projectSelector\" class=\"quickselect\" ng-disabled=\"!ctrl.selectedOrg.id\" ng-model=\"ctrl.selectedProject\" theme=\"bootstrap\" title=\"Select project\">\n                <ui-select-match allow-clear=\"true\" placeholder=\"Search for a project\">\n                    {{$select.selected.name}}\n                </ui-select-match>\n                <ui-select-choices repeat=\"project in ctrl.availableProjects | propsFilter: {name: $select.search}\">\n                    <div>\n                        <span ng-bind-html=\"project.name | highlight: $select.search\"></span> \n                    </div>\n                </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-xs-12\">\n            <label class=\"pull-left\">\n              <a class=\"btn btn-default\" ng-click=\"ctrl.copySourceDataLink();\">Copy Request URL</a>\n            </label>\n            <label class=\"pull-right\">\n              <a class=\"btn btn-default\" ng-click=\"ctrl.loadSourceData();\">Load Data</a>\n            </label>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-xs-6\">\n        <label style=\"width:100%\">Source Data Preview\n          <a class=\"btn btn-default pull-right\" ng-click=\"ctrl.copyToClipboard(ctrl.sourceData);\">Copy to clipboard</a>\n          <a class=\"btn btn-default pull-right\" ng-click=\"ctrl.downloadObjectAsJson(ctrl.sourceData,\'sourceData\');\">Download as JSON</a>\n        </label>\n        <div id=\"sourceDataPreview\" style=\"width: 100%; height: 300px\"></div>\n      </div>\n    </div>\n    <hr>\n    <div class=\"row\" ng-show=\"ctrl.sourceData\">\n      <div class=\"col-xs-6\">\n        <label>Data pre-processing logic (Javascript Function)\n        <!--<a class=\"btn btn-xs btn-info\" ng-if=\"ctrl.report.id && ctrl.report.data.preview\" ng-href=\"{{ctrl.previewLink}}\" target=\"_blank\">Preview Link</a>-->\n        </label>\n        <textarea ui-codemirror=\"{\n            lineNumbers: true,\n            lineWrapping : true,\n            foldGutter: true,\n            matchBrackets: true,\n            autoCloseBrackets: true,\n            mode: \'text/javascript\'\n          }\" ng-model=\"ctrl.report.preprocessFn\" ng-change=\"ctrl.updateProcessFn()\" ng-model-options=\"{ debounce: 1500 }\"></textarea>\n\n      </div>\n      <div class=\"col-xs-6\">\n        <label style=\"width:100%\">Output Preview \n          <a class=\"btn btn-xs btn-info\" ng-click=\"ctrl.processData();\">Update Output</a>\n          <a class=\"btn btn-default pull-right\" ng-click=\"ctrl.copyToClipboard(ctrl.outputData);\">Copy to clipboard</a>\n          <a ng-show=\"!ctrl.error && ctrl.outputData\" class=\"btn btn-default pull-right\" ng-click=\"ctrl.downloadObjectAsJson(ctrl.outputData,\'outputData\');\">Download as JSON</a>\n        </label>\n        <div ng-show=\"ctrl.error\" class=\"alert alert-danger\" role=\"alert\">\n          {{ctrl.error}}\n        </div>\n        \n        <div ng-show=\"!ctrl.error && ctrl.outputData\" id=\"outputDataPreview\" style=\"width: 100%; height: 400px\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/settings/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.setting.id\" translate>Add a new setting</span>\n      <span ng-show=\"ctrl.setting.id\" translate>Edit setting</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <formly-form model=\"ctrl.setting\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n          <div id=\"jsoneditor\" style=\"width: 100%; height: 400px\"></div>\n        </div>\n        <div class=\"col-md-6\">\n        <pre>{{ctrl.preview | json}}</pre>\n        </div>\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Submit\n      </button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/settings/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <div class=\"text-right\">\n      <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.settings.length}}</font> </span>\n      <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.add()\">\n       Add Setting <i class=\"fa fa-plus\"></i>\n      </a>\n    </div>\n  </div>\n  <div class=\"list-group\">\n    <div ng-repeat=\"item in ctrl.settings\" class=\"list-group-item\">\n      <control-buttons element-id=\"{{item.id}}\"></control-buttons>\n      <h4 class=\"list-group-item-heading\">\n        <a href=\"\" ui-sref=\"^.view({id: item.id})\">{{item.key}}</a>\n      </h4>\n\n      <p class=\"list-group-item-text\">{{item.value}}</p>\n    </div>\n    <div ng-show=\"!ctrl.settings.length\" class=\"list-group-item\">\n      <h4 class=\"list-group-item-heading\" translate>\n        There are no settings\n      </h4>\n\n      <p class=\"list-group-item-text\" translate>Click <a href=\"\" ui-sref=\"^.add\">here</a> to add a setting!</p>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/settings/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Settings\' | translate }}\" sub-title=\"{{ \'Manage your settings here!\' | translate }}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/settings/views/view.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n    {{ctrl.setting.key}}\n    <small>{{ctrl.setting.value}}</small>\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: ctrl.setting.id})\">\n        <i class=\"fa fa-pencil\"></i>\n      </a>\n      <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: ctrl.setting.id})\">\n        <i class=\"fa fa-trash-o\"></i>\n      </a>\n    </span>\n  </div>\n  <div class=\"panel-body\">\n    <pre>{{ctrl.setting | json}}</pre>\n  </div>\n</div>\n");
$templateCache.put("app/modules/users/user-profile/template.html","<section admin-header class=\"content-header\" title=\"{{ \'My Profile\' | translate}}\" sub-title=\"{{ \'Manage your profile here!\' | translate}}\">\n</section>\n<section class=\"content\">\n    <div class=\"row\">\n        <div class=\"col-md-4\">\n            <form name=\"form\">\n                <div class=\"panel panel-default\">\n                    <div class=\"panel-heading\">\n                        Your profile\n                    </div>\n                    <div class=\"panel-body\">\n                        <formly-form model=\"ctrl.user\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n                    </div>\n                    <div class=\"panel-footer\">\n                        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\"> Submit </button>\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n                    </div>\n                </div>\n            </form>\n        </div>\n        <div class=\"col-md-2\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">Request Password RESET\n                </div>\n                <div class=\"panel-body\">\n                    <a href=\"\" class=\"btn btn-lg btn-warning\" title=\"Password Reset\" ng-click=\"ctrl.resetPassword(ctrl.user.email)\">Password Reset</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-2\">\n            <div class=\"panel panel-default\">\n                <div class=\"panel-heading\">\n                    {{ \'Your Gravatar\' | translate }}\n                </div>\n                <div class=\"panel-body\">\n                    <img gravatar-src=\"ctrl.user.email\" class=\"img-circle\" alt=\"User Image\" gravatar-size=\"150\">\n                    <h4><a href=\"http://gravatar.com\" target=\"_blank\" translate>Change it here!</a></h4>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n");
$templateCache.put("app/modules/users/users-component/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <!--<a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.deleteAll(vm.gridOptions.data)\">-->\n            <!--    <i class=\"fa fa-trash-o\"></i> Delete selected-->\n            <!--</a>-->\n            <span ng-show=\"!vm.formOpen\">\n                To create a user, you need to invite a user through Projects or SYLVA Administration\n            </span>\n            <!--<a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement(vm.gridOptions.data)\">-->\n            <!--    <i class=\"fa fa-plus\"></i> Add User-->\n            <!--</a>-->\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div angular-busy=\"vm.promise\" class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-6\">\n                <div style=\"padding:15px\">\n                    <h2>Form </h2>\n                    <hr>\n                    <form name=\"usersForm\">  \n                        <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                    </form>\n                </div>\n            </div>\n            <div ng-if=\"vm.item.id\">\n                <div style=\"padding:15px\" class=\"col-sm-3\">\n                    <h2>Roles</h2>\n                    <hr>\n                    <div ng-if=\"vm.item.roles.length\">\n                        <ul>\n                            <li ng-repeat=\"role in vm.item.roles\">\n                                {{role.label}}\n                                <a ng-click=\"vm.deleteRole(vm.item,role)\" href=\"\" style=\"margin-left:10px\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-close\"></i></a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div ng-show=\"!vm.item.roles.length\">\n                        <h4>This user has no roles</h4>\n                    </div>\n\n                    <!--Add Role-->\n                    <div style=\"top:20px;left:10px\" uib-dropdown on-toggle=\"toggled(open)\">\n                        <a class=\"btn btn-xs btn-success\" href uib-dropdown-toggle>\n                                      Add Role <i class=\"fa fa-plus\"></i>\n                                    </a>\n                        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                            <li ng-repeat=\"role in vm.systemRoles\">\n                                <a ng-click=\"vm.insertRole(vm.item,role)\" href>{{role.label}}</a>\n                            </li>\n                        </ul>\n                    </div>\n\n                </div>\n                \n                <div style=\"padding:15px\" class=\"col-sm-3\">\n                    <h2>Control</h2>\n                    <hr>\n                    <a href=\"\" class=\"btn btn-md btn-warning\" title=\"Send email for Password reset\" ng-click=\"vm.resetPassword(vm.item.email)\">Send email for Password reset</a>\n                    <br>\n                </div>\n                \n                <div ng-if=\"vm.hasRole(\'creouser\')\" class=\"col-sm-6\">\n                    <div style=\"padding:15px\">\n                        <h2>User Seats</h2>\n                        <hr>\n                        <input min=\"0\" class=\"form-control\" type=\"number\" style=\"width:100px;display:inline\" ng-model=\"vm.currentUserSeats\">\n                        <a style=\"vertical-align: top\" href=\"\" ng-click=\"vm.updateUserSeats(vm.currentUserSeats)\" class=\"btn btn-primary\">Update</a>\n                    </div>\n                </div>\n                \n                <div class=\"col-sm-6\">\n                    <div style=\"padding:15px; margin-bottom:20px\">\n                        <h2>Enabled SSO Providers\n                        \n                            <!--Add Provider-->\n                            <div style=\"display:inline;left:10px\" uib-dropdown on-toggle=\"toggled(open)\">\n                                <a class=\"btn btn-xs btn-success\" href uib-dropdown-toggle>\n                                                                  Enable SSO Provider <i class=\"fa fa-plus\"></i>\n                                                                </a>\n                                <ul class=\"dropdown-menu\" uib-dropdown-menu>\n                                    <li ng-repeat=\"p in vm.availableAuthProviders\">\n                                        <a ng-click=\"vm.addAuthProviderConnection(p)\" href>{{p.label}}</a>\n                                    </li>\n                                </ul>\n                            </div>\n                        \n                        </h2>\n                        <hr>\n                        <div ng-if=\"vm.currentSSOConnections.length\">\n                            <ul>\n                                <li ng-repeat=\"p in vm.currentSSOConnections\">\n                                    {{p.label}}\n                                    <a ng-click=\"vm.deleteAuthProviderConnection(p)\" href=\"\" style=\"margin-left:10px\" class=\"btn btn-xs btn-danger\">\n                                        <i class=\"fa fa-close\"></i>\n                                    </a>\n                                </li>\n                            </ul>\n                        </div>\n                        <div ng-show=\"!vm.currentSSOConnections.length\">\n                            <h4>This user has no enabled SSO providers</h4>\n                        </div>\n                    \n                    </div>\n                </div>\n                \n                <div style=\"padding:15px\" class=\"col-sm-6\">\n                    <h2>Active Sessions\n                        <a href=\"\" class=\"btn btn-default\" ng-click=\"vm.createTempSession()\" ng-if=\"!vm.session\">Create temp session <i class=\"fa fa-plus\"></i></a>\n                    </h2>\n                    <div ng-if=\"vm.session\">\n                        <h4>This session is visible until you close this browser window.</h4>\n                        <h4>Valid for <b>{{vm.session.ttl/24 | number:0}}</b> days</h4>\n                        <h4>Paste the url in Private Mode</h4>\n                        <pre ng-bind=\"vm.session.url\"></pre>\n                    </div>\n                    <hr>\n                    <ul>\n                        <li ng-repeat=\"s in vm.currentSessions\">\n                            Logged in at {{s.created|date:\'hh:mm dd/MM/yy\'}} \n                            <a href=\"\" class=\"btn btn-xs btn-primary\" ng-click=\"vm.currentToken=vm.currentToken===s.id?null:s.id\">display token</a>\n                            <span ng-if=\"s.id===vm.currentToken\">\n                                <pre ng-bind=\"s.id\"></pre>\n                                <pre ng-bind=\"vm.createSessionUrl(s.id)\"></pre>\n                            </span>\n                        </li>\n                    </ul>\n                </div>\n                \n            </div>\n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"usersForm.$invalid||vm.formOptions.loading\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>");
$templateCache.put("app/modules/users/views/form.html","<form name=\"form\">\n  <div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n      <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n      <span ng-show=\"!ctrl.user.id\" translate>Add a new user</span>\n      <span ng-show=\"ctrl.user.id\" translate>Edit user</span>\n    </div>\n    <div class=\"panel-body\">\n      <div class=\"row\">\n        <div class=\"col-md-4\">\n          <div class=\"alert alert-danger\" ng-if=\"addError\" translate>Could not add user!</div>\n\n          <div ng-if=\"ctrl.user.roles.length\">\n            <ul>\n              <li ng-repeat=\"role in ctrl.user.roles\">\n                {{role.name}}\n                <button ng-click=\"ctrl.deleteRole(ctrl.user,role)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash\"></i></button>\n              </li>\n            </ul>\n          </div>\n          <div ng-if=\"!ctrl.user.roles.length\">\n            <h4>This user has no roles</h4>\n          </div>\n\n          <!--Add Role-->\n          <div style=\"top:20px\" uib-dropdown on-toggle=\"toggled(open)\">\n            <a class=\"btn btn-sm btn-primary\" href uib-dropdown-toggle>\n                  Add Role <i class=\"fa fa-plus\"></i>\n                </a>\n            <ul class=\"dropdown-menu\" uib-dropdown-menu>\n              <li ng-repeat=\"role in ctrl.systemRoles\">\n                <a ng-click=\"ctrl.insertRole(ctrl.user,role)\" href>{{role.label}}</a>\n              </li>\n            </ul>\n          </div>\n\n          <div style=\"margin:40px\"></div>\n          <formly-form model=\"ctrl.user\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"panel-footer\">\n      <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n        Submit\n      </button>\n      <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/modules/users/views/list.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    Users\n    \n    <a style=\"margin-left:30px\" href ng-click=\"ctrl.toggleUsers()\">Toggle All/System</a>\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-success\" ui-sref=\"^.add()\">\n        <i class=\"fa fa-plus\"></i>\n      </a>\n    </span>\n  </div>\n\n  <div class=\"list-group\">\n    <div ng-repeat=\"user in ctrl.users\" class=\"list-group-item\">\n      <span class=\"pull-right btn-group\">\n        <a class=\"btn btn-xs btn-default\" ui-sref=\"app.users.password({ id: user.id })\">\n          <i class=\"fa fa-key\"></i>\n        </a>\n        <a class=\"btn btn-xs btn-default\" ui-sref=\"app.users.edit({ id: user.id })\">\n          <i class=\"fa fa-pencil\"></i>\n        </a>\n        <a class=\"btn btn-xs btn-danger\" ui-sref=\"app.users.delete({ id: user.id })\">\n          <i class=\"fa fa-trash-o\"></i>\n        </a>\n      </span>\n      <span>\n        <a href=\"\" ui-sref=\"app.users.view({id: user.id})\">{{user.firstName}} {{user.lastName}}\n      <span class=\"text-muted\">{{user.email}}</span>\n      </a>\n        <span ng-repeat=\"role in user.roles\" class=\"label label-info\">{{role.name}}</span>\n\n      </span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/users/views/login.html","<div class=\"lockscreen\" style=\"height: 100%\">\n  <div class=\"form-box\" id=\"login-box\">\n    <span class=\"pull-right image\" style=\"margin: 15px 20px; float: left\">\n      <img style=\"max-width: 80px !important\" gravatar-src=\"credentials.email\" alt=\"User Image\" gravatar-size=\"80\">\n    </span>\n\n    <div class=\"header\" style=\"text-align: left; padding-left: 25px\" translate>Sylva Administration</div>\n    <form role=\"form\" ng-submit=\"login()\" method=\"post\">\n      <div class=\"body bg-gray\">\n        <div class=\"callout callout-danger\" ng-if=\"loginError\">\n          <p>{{loginError.message | translate}}</p>\n        </div>\n        <auto:fields fields=\"schema\" data=\"credentials\" options=\"options\"></auto:fields>\n      </div>\n      <div class=\"footer\">\n        <button type=\"submit\" class=\"btn btn-block\" translate>Login</button>\n        <!--<a href=\'#/register\' class=\"btn bg-yellow btn-block\" translate>Or register</a>-->\n        <!--<a ng-repeat=\"provider in authProviders\" ng-hide=\"provider.link\" ng-click=\"socialLogin(provider)\"-->\n        <!--   class=\"btn btn-block btn-{{provider.class}}\">-->\n        <!--  {{provider.provider | ucfirst}}-->\n        <!--</a>-->\n      </div>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/modules/users/views/main.html","<section admin-header class=\"content-header\" title=\"{{ \'Users\' | translate}}\" sub-title=\"{{ \'Manage your users here!\' | translate}}\">\n</section>\n<section ui-view class=\"content\"></section>\n");
$templateCache.put("app/modules/users/views/profile.html","<div class=\"row\">\n  <div class=\"col-md-4\">\n    <form name=\"form\">\n      <div class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n          Your profile\n        </div>\n        <div class=\"panel-body\">\n          <formly-form model=\"ctrl.user\" fields=\"ctrl.formFields\" options=\"ctrl.formOptions\"></formly-form>\n        </div>\n        <div class=\"panel-footer\">\n          <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"ctrl.submit()\" ng-disabled=\"form.$invalid\">\n            Submit\n          </button>\n          <button type=\"button\" class=\"btn btn-default\" ng-click=\"ctrl.formOptions.resetModel()\">Reset</button>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class=\"col-md-2\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\">\n        {{ \'Your Gravatar\' | translate }}\n      </div>\n      <div class=\"panel-body\">\n        <img gravatar-src=\"user.email\" class=\"img-circle\" alt=\"User Image\" gravatar-size=\"150\">\n        <h4><a href=\"http://gravatar.com\" target=\"_blank\" translate>Change it here!</a></h4>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/modules/users/views/register.html","<div class=\"lockscreen\" style=\"height: 100%\">\n  <div class=\"form-box\" id=\"login-box\">\n    <span class=\"pull-right image\" style=\"margin: 15px 20px; float: left\">\n      <img gravatar-src=\"registration.email\" class=\"img-circle\" alt=\"User Image\" gravatar-size=\"50\">\n    </span>\n\n    <div class=\"header\" style=\"text-align: left; padding-left: 25px\" translate>Register</div>\n\n    <form name=\"joinForm\" class=\"form-signin\" role=\"form\" ng-submit=\"register()\">\n      <div class=\"body bg-gray\">\n        <div class=\"callout callout-danger\" ng-if=\"registerError\">\n          <p>{{registerError.message | translate }}</p>\n        </div>\n        <auto:fields fields=\"schema\" data=\"registration\" options=\"options\"></auto:fields>\n      </div>\n      <div class=\"footer\">\n        <button type=\"submit\" class=\"btn bg-olive btn-block\" ng-class=\"{\'btn-primary\':joinForm.$valid}\" translate>\n          Register\n        </button>\n        <a href=\"#/login\" class=\"btn bg-yellow btn-block\" translate>Or sign in </a>\n      </div>\n    </form>\n  </div>\n</div>\n");
$templateCache.put("app/modules/users/views/view.html","<div class=\"panel panel-default\">\n  <div class=\"panel-heading\">\n    <a href=\"\" ui-sref=\"^.list\" class=\"btn btn-xs btn-default\"><i class=\"fa fa-arrow-left\"></i></a>\n    {{ctrl.user.username}}\n    <small>{{ctrl.user.email}}</small>\n    <span class=\"pull-right btn-group\">\n      <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: ctrl.user.id})\">\n        <i class=\"fa fa-pencil\"></i>\n      </a>\n      <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: ctrl.user.id})\">\n        <i class=\"fa fa-trash-o\"></i>\n      </a>\n    </span>\n  </div>\n  <div class=\"panel-body\">\n    <h3 translate>Roles</h3>\n\n    <div ng-if=\"ctrl.user.roles.length\">\n      <ul>\n        <li ng-repeat=\"role in ctrl.user.roles\">{{role.name}}</li>\n      </ul>\n    </div>\n    <div ng-if=\"!ctrl.user.roles.length\">\n      <h4>This user has no roles</h4>\n    </div>\n    <hr>\n    <pre>{{ctrl.user | json}}</pre>\n  </div>\n</div>\n");
$templateCache.put("app/modules/core/config/formly/datepicker.html","<p class=\"input-group\">\n    <input type=\"text\" class=\"form-control\" uib-datepicker-popup ng-model=\"model[options.key]\" is-open=\"opened\" datepicker-options=\"model[options.datepickerOptions]\" close-text=\"Close\">\n    <span class=\"input-group-btn\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened=!opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n    </span>\n</p>");
$templateCache.put("app/modules/core/config/formly/multiInputTemplate.html","<div>\n    <div class=\"clearfix\">\n        <div class=\"row\" style=\"margin-bottom:14px\" ng-repeat=\"item in model[options.key] track by $index\" ng-init=\"itemOptions = copyItemOptions()\">\n            <formly-field class=\"col-xs-10\" options=\"itemOptions\" model=\"model[options.key]\" form=\"form\" index=\"$index\">\n            </formly-field>\n            <div class=\"col-xs-2\">\n                <a href=\"\" ng-click=\"model[options.key].splice($index, 1)\">\n                    <i style=\"color:red\" class=\"fa fa-lg fa-times\" aria-hidden=\"true\"></i>\n                </a>\n            </div>\n        </div>\n        <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"model[options.key].push(\'\')\">Add</button>\n    </div>\n</div>");
$templateCache.put("app/modules/core/config/formly/repeatSectionTemplate.html","<div>\n    <div class=\"clearfix\">\n            <label class=\"control-label\" ng-bind=\"options.templateOptions.label\"></label>\n            <div class=\"{{hideRepeat}}\">\n                <div class=\"row repeatsection\" style=\"margin-bottom:14px\" ng-repeat=\"element in model[options.key]\" ng-init=\"fields = copyFields(to.fields)\">\n                    <formly-form fields=\"fields\" class=\"col-xs-11\" model=\"element\" form=\"form\"></formly-form>\n                    <div class=\"col-xs-1\" style=\"padding:0\">\n                        <span>\n                            <a href=\"\" class=\"btn btn-default btn-xs\" style=\"margin-top:55px;line-height:150px\" ng-click=\"model[options.key].splice($index, 1)\">\n                                <i style=\"color:red\" class=\"fa fa-lg fa-times\" aria-hidden=\"true\"></i>\n                            </a>\n                        </span>\n                    </div>\n                    <hr>\n                </div>\n                <p class=\"AddNewButton\">\n                    <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"addNew({})\">{{to.btnText}}</button>\n                </p>\n            </div>\n    </div>\n</div>");
$templateCache.put("app/modules/core/directives/control-buttons/template.html","<span class=\"pull-right btn-group\">\n  <a href=\"\" class=\"btn btn-xs btn-default\" ui-sref=\"^.edit({id: $ctrl.elementId})\">\n    Edit <i class=\"fa fa-pencil\"></i>\n  </a>\n  <a href=\"\" class=\"btn btn-xs btn-danger\" ui-sref=\"^.delete({id: $ctrl.elementId})\">\n    <i class=\"fa fa-trash-o\"></i>\n  </a>\n</span>");
$templateCache.put("app/modules/core/directives/file-downloader/template.html","<div style=\"display:inline\">\n    <a class=\"btn btn-xs btn-default\" ng-href=\"{{url}}&type=stream\">Download <i class=\"fa fa-download\"></i></a>\n</div>");
$templateCache.put("app/modules/core/directives/object-viewer/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        {{(item.name||item.id)}} \n        <!--Download Options-->\n        <file-downloader ng-if=\"item.source\" file=\"item\"></file-downloader>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <ul class=\"list-group\">\n            <li ng-repeat=\"prop in props\" class=\"list-group-item\" ng-hide=\"item[prop].base64\"><b>{{prop}}</b>: \n            \n            <span ng-show=\"isJSON(item[prop])\"><pre>{{item[prop]|json}}</pre></span>\n            <span ng-show=\"!isJSON(item[prop])\">{{item[prop]}}</span>\n            \n            </li>\n        </ul>\n    </div>\n</div>");
$templateCache.put("app/modules/core/directives/relation-viewer/modal.template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <h1>{{model}} Items\n        \n        <a class=\"pull-right\" href=\"\" ng-click=\"modal.close();\"><i class=\"fa fa-close fa-lg\"></i></a>\n        </h1>\n    </div>\n    <div class=\"panel-body\">\n        <div ng-repeat=\"item in items track by $index\">\n            <object-viewer item=\"item\"></object-viewer>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/modules/core/directives/relation-viewer/ui-grid.cell.template.html","<div ng-if=\"simpleList\">\n    <button style=\"margin-right:5px\" class=\"btn btn-xs btn-default\" ng-click=\"showDetails()\">\n        <i class=\"fa fa-info\"></i></button>\n    <span>{{simpleList}}</span>\n</div>");
$templateCache.put("app/modules/core/views/elements/admin-header.html","<div class=\"pull-right\">\n    <div ng-transclude></div>\n</div>\n<h1>\n    {{title}}\n    <small>{{subTitle}}</small>\n</h1>\n");
$templateCache.put("app/modules/core/views/elements/navbar.html","<nav class=\"navbar navbar-static-top\" role=\"navigation\">\n  <a class=\"navbar-btn sidebar-toggle\" data-toggle=\"offcanvas\" ng-click=\"toggleSidebar()\" role=\"button\">\n    <span class=\"sr-only\" translate>Toggle navigation</span>\n    <span class=\"icon-bar\"></span>\n    <span class=\"icon-bar\"></span>\n    <span class=\"icon-bar\"></span>\n  </a>\n\n   \n  <div class=\"navbar-right\">\n    <ul class=\"nav navbar-nav\">\n      <!--<li class=\"dropdown user user-menu\">-->\n      <!--  <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">-->\n      <!--    <i class=\"fa fa-flag flag-icon flag-icon-{{selectLocale.country.toLowerCase() }}\"></i>-->\n      <!--    {{ selectLocale.name | translate }} <i class=\"caret\"></i> </span>-->\n      <!--  </a>-->\n      <!--  <ul class=\"dropdown-menu\">-->\n      <!--    <li ng-repeat=\"(index, locale) in locales\" ng-show=\"locale != selectLocale\">-->\n      <!--      <a ng-click=\"setLocale(index)\">-->\n      <!--        <span class=\"flag-icon flag-icon-{{locale.country.toLowerCase() }}\"></span> {{locale.name | translate }}-->\n      <!--      </a>-->\n      <!--    </li>-->\n      <!--  </ul>-->\n      <!--</li>-->\n      <li class=\"dropdown user user-menu\">\n        <a class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n          <i class=\"glyphicon glyphicon-user\"></i>\n          <span>{{currentUser.email}}<i class=\"caret\"></i></span>\n        </a>\n        <ul class=\"dropdown-menu\">\n          <li class=\"user-header bg-sylva\">\n            <img gravatar-src=\"currentUser.email\" class=\"img-circle\" alt=\"User Image\">\n\n            <p>\n              {{currentUser.firstName || currentUser.profiles[0].profile.displayName}}\n              <small>{{currentUser.email}}</small>\n            </p>\n          </li>\n          <li class=\"user-footer\">\n            <div class=\"pull-left\">\n              <a ui-sref=\"app.userProfile\" class=\"btn btn-default btn-flat\" translate>Profile</a>\n            </div>\n            <div class=\"pull-right\">\n              <a ng-click=\"logout()\" class=\"btn btn-default btn-flat\" translate>Sign out</a>\n            </div>\n          </li>\n        </ul>\n      </li>\n    </ul>\n  </div>\n</nav>\n");
$templateCache.put("app/modules/core/views/elements/small-box.html","<div class=\"col-lg-3 col-xs-6\">\n  <div class=\"small-box {{ color }}\" ui-sref=\"{{ href }}\">\n    <div class=\"inner\">\n      <h3>{{quantity}} &nbsp;</h3>\n      <p>{{ name | translate }}</p>\n    </div>\n    <a class=\"small-box-footer\">{{ \'More info\' | translate }} <i class=\"fa fa-arrow-circle-right\"></i></a>\n  </div>\n</div>\n");
$templateCache.put("app/modules/organizations/components/organization-users/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <!--<a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm()\">-->\n            <!--    <i class=\"fa fa-list\"></i> Back to List-->\n            <!--</a>-->\n            <span style=\"padding:5px\" ng-show=\"vm.searchLoader\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span>\n            \n            <span style=\"display:inline-table; width:250px\">\n                <ui-select id=\"orgUser\" class=\"quickselect\" disabled=\"\" ng-model=\"vm.selected\" theme=\"bootstrap\" title=\"Select a user\">\n                    <ui-select-match placeholder=\"Search for a user\">\n                        {{$select.selected.firstName}} {{$select.selected.lastName}} &lt;{{$select.selected.email}}&gt;\n                    </ui-select-match>\n                    <ui-select-choices repeat=\"user in vm.availableUsers | propsFilter: {email: $select.search,firstName:$select.search,lastName:$select.search}\" refresh=\"vm.searchUsers($select.search)\">\n                        <div>\n                            <span ng-bind-html=\"user.firstName | highlight: $select.search\"></span> \n                            <span ng-bind-html=\"user.lastName | highlight: $select.search\"></span>\n                            <div ng-bind-html=\"user.email | highlight: $select.search\"></div>\n                        </div>\n                    </ui-select-choices>\n                </ui-select>\n            </span>\n            \n            <a href=\"\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement(vm.selected)\">\n                <i class=\"fa fa-plus\"></i> Add\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-7\">\n                <!--<div style=\"padding:20px\">-->\n                <!--    <h4>Bulk Assessment <span class=\"badge\">{{vm.gridOptionsImport.data.length}}</span>-->\n                <!--        <a href=\"\" ng-show=\"vm.gridOptionsImport.data.length>0\" class=\"btn btn-sm btn-primary\" -->\n                <!--        ng-click=\"vm.bulkProcess()\"><i class=\"fa fa-upload\"></i> Process</a>-->\n                <!--    </h4>              -->\n                <!--    <hr>-->\n\n                <!--    <form>-->\n                <!--        <div class=\"row\">-->\n                <!--            <div class=\"col-xs-6\">-->\n                <!--                <input type=\"file\" class=\"file-chooser\" id=\"files\" name=\"files[]\">-->\n                <!--            </div>-->\n                <!--        </div>-->\n                <!--        <div class=\"row\">-->\n                <!--            <div class=\"col-xs-12\">           -->\n                <!--                <div ng-show=\"vm.gridOptionsImport.data.length>0\" ui-grid-importer ui-grid-auto-resize ui-grid=\"vm.gridOptionsImport\" class=\"grid\"></div>-->\n                <!--            </div>-->\n                <!--        </div>-->\n                <!--    </form>-->\n                    \n                <!--</div>-->\n            </div>\n        </div>\n    </div>\n    \n</div>\n");
$templateCache.put("app/modules/projects/components/project-assessments/proposals-list.html","<div angular-busy=\"ctrl.promise\" class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span>Total</span>\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.proposals.length}}</font> </span>\n            <!--<a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.upload\">-->\n            <!--    Add Proposal <i class=\"fa fa-plus\"></i>-->\n            <!--</a>-->\n        </div>\n    </div>\n\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div style=\"padding:20px\">\n                    <h3>Proposals</h3>\n                    <ul class=\"list-group\">\n                        <li class=\"list-group-item\" ng-repeat=\"p in ctrl.proposals\">\n                            <span class=\"text-left\">\n                                <span ng-show=\"!p.publicationStatus\" class=\"label label-primary\">Not Reviewed</span>\n                                <span ng-show=\"p.publicationStatus===\'accepted\'\" class=\"label label-success\">Accepted <i class=\"fa fa-check\"></i></span>\n                                <span ng-show=\"p.publicationStatus===\'rejected\'\" class=\"label label-danger\">Rejected <i class=\"fa fa-close\"></i></span>\n                                | {{p.updatedAt|date:\'medium\'}} by <a href ng-click=\"ctrl.view(p.systemUser)\">{{p.systemUser.email}}</a>\n                            </span> | \n                            <span class=\"btn-group\">\n                              <button type=\"button\" ng-click=\"ctrl.acceptProposal(p.id)\" class=\"btn btn-xs btn-success\">Accept</button>\n                              <button type=\"button\" ng-click=\"ctrl.rejectProposal(p.id)\" class=\"btn btn-xs btn-warning\">Reject</button>\n                             </span>\n                            <span class=\"btn-group\">\n                              <button type=\"button\" ng-click=\"ctrl.view(p)\" class=\"btn btn-xs btn-primary\">View</button>\n                              <button type=\"button\" ng-click=\"ctrl.deleteProposal(p.id)\" class=\"btn btn-xs btn-danger\">Delete</button>\n                            </span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-assessments/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement()\">\n                <i class=\"fa fa-plus\"></i> Add Assessment\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-draggable-rows ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-4\">\n                <form name=\"form\" style=\"padding:15px\">\n                <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                </form>\n            </div>      \n            <div class=\"col-sm-8\">\n                <section ui-view class=\"content\"></section>\n            </div>      \n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-casestudies/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement()\">\n                <i class=\"fa fa-plus\"></i> Add CaseStudy\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-draggable-rows ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-6\">\n                <form name=\"form\" style=\"padding:15px\">\n                <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                </form>\n                \n            </div>      \n            <div class=\"col-sm-6\">\n                <div style=\"padding:15px\">\n                    <div class=\"form-group\" ng-if=\"vm.item.id\" style=\"max-width:400px\">\n                        <label for=\"teamAccess\">Select a team for this case study  <span style=\"padding:5px\" ng-show=\"vm.searchLoader\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span></label>\n                        <ui-select id=\"teamAccess\" ng-show=\"!vm.searchLoader\" on-select=\"vm.selectTeam(vm.item.id,vm.selected.id)\" ng-model=\"vm.selected\" theme=\"bootstrap\" title=\"Select a team\">\n                            <ui-select-match placeholder=\"Search for a team\">\n                                {{$select.selected.name}}\n                            </ui-select-match>\n                            <ui-select-choices repeat=\"team in vm.availableTeams | filter: {name: select.search}\">\n                                <div>\n                                    <span ng-bind-html=\"team.name | highlight: $select.search\"></span>\n                                </div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    \n                    <div class=\"form-group\" ng-if=\"vm.item.id\" style=\"max-width:400px\">\n                        <form name=\"visitorForm\" ng-submit=\"vm.addVisitor(vm.newVisitor)\">\n                        <label for=\"visitorAccess\">Add visitor email for this case study <span style=\"padding:5px\" ng-show=\"vm.caseStudyVisitorsLoading\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span></label>\n                            <div class=\"input-group\">\n                                <input type=\"email\" name=\"visitorEmail\" required class=\"form-control\" ng-model=\"vm.newVisitor\" placeholder=\"e.g. partner@ucla.edu\">\n                                <span class=\"input-group-btn\">\n                                    <button class=\"btn btn-default\" type=\"submit\">Add</button>\n                                </span>\n                            </div>\n                        </form>\n                        <ul class=\"list-group\">\n                          <li class=\"list-group-item\" ng-repeat=\"v in vm.caseStudyVisitors\">\n                            <div style=\"text-align:left\">\n                                <b>{{v.email}}</b>\n                            </div>\n                            <div style=\"text-align:right\">\n                                <a class=\"badge label label-primary\" target=\"_blank\" ng-href=\"{{vm.abmaUrl}}/cases/{{vm.item.id}}/presentation/{{v.token}}\">ABMA Link</a>\n                                <!--<a href=\"\" ng-click=\"vm.notifyVisitor(v)\" class=\"badge label label-primary\">Send Email</a>-->\n                                <a href=\"\" ng-click=\"vm.removeVisitor(v)\" class=\"badge label label-danger\">Remove</a>\n                            </div>\n                          </li>\n                        </ul>\n                            \n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label\" for=\"color_picker\">Case Color  <span ng-style=\"{\'background\':vm.item.color_main}\" class=\"casestudy-color-preview\">{{vm.item.name}}</span> </label>\n                        <input colorpicker class=\"form-control\" name=\"color_picker\" style=\"width:100px\" ng-model=\"vm.item.color_main\">\n                    </div>\n                    <div class=\"form-group\">\n                        <label class=\"control-label\" for=\"select_background\">Select Background\n                        <a href=\"\" ng-show=\"vm.backgroundImage\" ng-click=\"vm.deleteBackground(vm.item)\" class=\"btn btn-xs btn-danger\">clear <i class=\"fa fa-close\"></i></a>\n                        <span style=\"padding:5px\" ng-show=\"vm.imageLoading\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span>\n                        </label>\n                        <input type=\"file\" nv-file-select=\"\" name=\"select_background\" uploader=\"vm.uploader\">\n                        <div ng-if=\"vm.uploader.queue.length>0\">\n                            <table class=\"table\">\n                                <thead>\n                                    <tr>\n                                        <th width=\"50%\">Name</th>\n                                        <th ng-show=\"vm.uploader.isHTML5\">Size</th>\n                                        <th ng-show=\"vm.uploader.isHTML5\">Progress</th>\n                                        <th>Status</th>\n                                        <th>Actions</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr ng-repeat=\"item in vm.uploader.queue\">\n                                        <td>\n                                            <strong>{{ item.file.name }}</strong>\n                                            <!-- Image preview -->\n                                            <!--auto height-->\n                                            <!--<div ng-thumb=\"{ file: item.file, width: 100 }\"></div>-->\n                                            <!--auto width-->\n                                            <div ng-show=\"vm.uploader.isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\"></div>\n                                            <!--fixed width and height -->\n                                            <!--<div ng-thumb=\"{ file: item.file, width: 100, height: 100 }\"></div>-->\n                                        </td>\n                                        <td ng-show=\"vm.uploader.isHTML5\" nowrap=\"nowrap\">{{ item.file.size/1024/1024|number:2 }} MB</td>\n                                        <td ng-show=\"vm.uploader.isHTML5\">\n                                            <div class=\"progress\" style=\"margin-bottom: 0\">\n                                                <div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div>\n                                            </div>\n                                        </td>\n                                        <td class=\"text-center\">\n                                            <span ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span>\n                                            <span ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span>\n                                            <span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span>\n                                        </td>\n                                        <td nowrap=\"nowrap\">\n                                            <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\">\n                                                                <span class=\"glyphicon glyphicon-upload\"></span> Upload\n                                                            </button>\n                                            <!--<button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\">-->\n                                            <!--                    <span class=\"glyphicon glyphicon-ban-circle\"></span> Cancel-->\n                                            <!--                </button>-->\n                                            <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"item.remove()\">\n                                                                <span class=\"glyphicon glyphicon-trash\"></span>\n                                                            </button>\n                                        </td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <img class=\"img-thumbnail\" style=\"max-height:400px\" ng-src=\"{{vm.backgroundImage}}\" ng-show=\"vm.backgroundImage\">\n                    \n                    </div>\n                </div>\n            </div>      \n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-lectures/proposals-list.html","<div angular-busy=\"ctrl.promise\" class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{ctrl.proposals.length}}</font> </span>\n            <a href=\"\" class=\"btn btn-sm btn-success\" ui-sref=\"^.upload\">\n                Add Proposal <i class=\"fa fa-plus\"></i>\n            </a>\n        </div>\n    </div>\n\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div style=\"padding:20px\">\n                    <h3>Proposals</h3>\n                    <ul class=\"list-group\">\n                        <li class=\"list-group-item\" ng-repeat=\"p in ctrl.proposals\">\n                            <span class=\"text-left\">\n                                <span ng-show=\"!p.publicationStatus\" class=\"label label-primary\">Not Reviewed</span>\n                                <span ng-show=\"p.publicationStatus===\'accepted\'\" class=\"label label-success\">Accepted <i class=\"fa fa-check\"></i></span>\n                                <span ng-show=\"p.publicationStatus===\'rejected\'\" class=\"label label-danger\">Rejected <i class=\"fa fa-close\"></i></span>\n                                | <a class=\"btn btn-xs btn-default\" ng-href=\"{{ctrl.cdn}}{{p.file.container}}/{{p.file.source}}\" target=\"_blank\">XML File</a>\n                                | <a class=\"btn btn-xs btn-default\" ng-href=\"{{ctrl.cdn}}{{p.file.container}}/{{p.file.parsed}}\" target=\"_blank\">HTML Parsed</a>\n                                | <file-downloader file=\"p.file\"></file-downloader>\n                                | {{p.updatedAt|date:\'medium\'}} by <a href ng-click=\"ctrl.view(p.systemUser)\">{{p.systemUser.email}}</a>\n                            </span> | \n                            <span class=\"btn-group\">\n                              <button type=\"button\" ng-click=\"ctrl.acceptProposal(p.id)\" class=\"btn btn-xs btn-success\">Accept</button>\n                              <button type=\"button\" ng-click=\"ctrl.rejectProposal(p.id)\" class=\"btn btn-xs btn-warning\">Reject</button>\n                             </span>\n                            <span class=\"btn-group\">\n                              <button type=\"button\" ng-click=\"ctrl.view(p)\" class=\"btn btn-xs btn-primary\">View</button>\n                              <button type=\"button\" ng-click=\"ctrl.deleteProposal(p.id)\" class=\"btn btn-xs btn-danger\">Delete</button>\n                            </span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-lectures/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement()\">\n                <i class=\"fa fa-plus\"></i> Add Lecture\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-draggable-rows ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-4\">\n                <form name=\"form\" style=\"padding:15px\">\n                <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                </form>\n            </div>      \n            <div class=\"col-sm-8\">\n                <section ui-view class=\"content\"></section>\n            </div>      \n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-syllabus/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <form name=\"form\" style=\"padding:15px\">\n                    <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                </form>\n            </div>\n        </div>\n    </div>\n    <div class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-teams/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm();\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-warning\" ng-click=\"vm.fillTeams()\">\n                <i class=\"fa fa-cog\"></i> Auto Distribute students\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.createElement()\">\n                <i class=\"fa fa-plus\"></i> Add Team\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" ui-grid=\"vm.gridOptions\" ui-grid-grouping ui-grid-auto-resize ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-4\">\n                <form name=\"form\" style=\"padding:15px\">\n                    <formly-form model=\"vm.item\" fields=\"vm.formSchema\" options=\"vm.formOptions\"></formly-form>\n                </form>\n            </div>\n            <div class=\"col-sm-8\">\n                <div angular-busy=\"vm.promise\" class=\"panel panel-default\">\n                    <div class=\"panel-heading\">\n                        <div class=\"text-right\">\n                            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.teamMembers.length}}</font> </span>\n                            \n                            <span style=\"padding:5px\" ng-show=\"vm.searchLoader\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span>\n                            <span style=\"display:inline-table; width:250px\">\n                                <ui-select id=\"orgUser\" class=\"quickselect\" disabled=\"\" ng-model=\"vm.selected\" theme=\"bootstrap\" title=\"Select a user\">\n                                    <ui-select-match placeholder=\"Search for a user\">\n                                        {{$select.selected.firstName}} {{$select.selected.lastName}} &lt;{{$select.selected.email}}&gt;\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"user in vm.availableUsers | propsFilter: {email: $select.search,firstName:$select.search,lastName:$select.search}\" refresh=\"vm.searchUsers($select.search)\">\n                                        <div>\n                                            <span ng-bind-html=\"user.firstName | highlight: $select.search\"></span> \n                                            <span ng-bind-html=\"user.lastName | highlight: $select.search\"></span>\n                                            <div ng-bind-html=\"user.email | highlight: $select.search\"></div>\n                                        </div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </span>\n                            <a href=\"\" class=\"btn btn-sm btn-success\" ng-click=\"vm.linkUser(vm.selected)\">\n                                <i class=\"fa fa-plus\"></i> Add\n                            </a>\n                        </div>\n                    </div>\n\n                    <div class=\"panel-body\" style=\"padding:0\">\n                        <div class=\"row\">\n                            <div class=\"col-xs-12\">\n                                <div style=\"padding:20px\">\n                                    <h3>Users</h3>\n                                    <ul class=\"list-group\">\n                                        <li class=\"list-group-item\" ng-repeat=\"p in vm.teamMembers\">\n                                            <span class=\"text-left\">\n                                                {{::p.firstName}} {{::p.lastName}} | \n                                                <a ng-href=\"mailTo:{{::p.email}}\"> {{::p.email}}</a> \n                                            </span> \n                                            \n                                            <span class=\"btn-group text-right\">\n                                              <button type=\"button\" ng-click=\"vm.unlinkUser(p)\" class=\"btn btn-xs btn-warning\">Remove</button>\n                                            </span>\n                             \n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-show=\"vm.formOpen\" class=\"panel-footer\">\n        <button type=\"submit\" class=\"btn btn-primary btn-success\" ng-click=\"vm.submit()\" ng-disabled=\"form.$invalid\">\n                Submit\n              </button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.formOptions.resetModel()\">Reset</button>\n    </div>\n</div>\n");
$templateCache.put("app/modules/projects/components/project-users/template.html","<div class=\"panel panel-default\">\n    <div class=\"panel-heading\">\n        <div class=\"text-right\">\n            <span class=\"pull-left label label-default\"><font style=\"font-size:20px\">{{vm.gridOptions.totalItems}}</font> </span>\n            <a href=\"\" ng-show=\"vm.formOpen\" class=\"btn btn-sm btn-default\" ng-click=\"vm.closeForm()\">\n                <i class=\"fa fa-list\"></i> Back to List\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-warning\" ng-click=\"vm.fillTeams()\">\n                <i class=\"fa fa-cog\"></i> Auto Distribute students\n            </a>\n            <a href=\"\" ng-show=\"!vm.formOpen\" class=\"btn btn-sm btn-success\" ng-click=\"vm.editElement({})\">\n                <i class=\"fa fa-plus\"></i> Assign users\n            </a>\n        </div>\n    </div>\n    <div class=\"panel-body\" style=\"padding:0\">\n        <div class=\"row\" ng-show=\"!vm.formOpen\">\n            <div class=\"col-xs-12\">\n                <div angular-busy=\"vm.promise\" id=\"project-users-grid\" ui-grid=\"vm.gridOptions\" ui-grid-grouping ui-grid-pagination class=\"grid project-components\"></div>\n            </div>\n        </div>\n        <div class=\"row\" ng-show=\"vm.formOpen\">\n            <div class=\"col-sm-5\">\n                <div style=\"padding:20px\">\n                    <h4>Single Assessment</h4>\n                    <hr>\n                    <form>\n                        <div class=\"form-group\">\n                            <label>User <span style=\"padding:5px\" ng-show=\"vm.searchLoaderUser\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span></label>\n                            <ui-select id=\"orgUser\" class=\"quickselect\" on-select=\"vm.selectUser($item)\" ng-model=\"vm.selected\" theme=\"bootstrap\" title=\"Select a user\">\n                                <ui-select-match>\n                                    <span ng-show=\"!$select.selected.email\">Search for a user</span>\n                                    <span ng-if=\"$select.selected.email\">\n                                        {{$select.selected.firstName}} {{$select.selected.lastName}} &lt;{{$select.selected.email}}&gt;\n                                    </span>\n                                </ui-select-match>\n                                <ui-select-choices repeat=\"user in vm.availableUsers | propsFilter: {email: $select.search,firstName:$select.search,lastName:$select.search}\" refresh=\"vm.searchUsers($select.search)\">\n                                    <div>\n                                        <span ng-bind-html=\"user.firstName | highlight: $select.search\"></span> \n                                        <span ng-bind-html=\"user.lastName | highlight: $select.search\"></span>\n                                        <div ng-bind-html=\"user.email | highlight: $select.search\"></div>\n                                    </div>\n                                </ui-select-choices>\n                            </ui-select>\n                                \n                        </div>\n                        <div class=\"form-group\">\n                            <label>Project Roles <span style=\"padding:5px\" ng-show=\"vm.searchLoaderRoles\"><i class=\"fa fa-cog fa-spin fa-lg\"></i></span></label>\n                            <ui-select class=\"quickselect\" multiple=\"multiple\" ng-model=\"vm.selectedRoles\" theme=\"bootstrap\" close-on-select=\"true\">\n                                <ui-select-match placeholder=\"Select roles...\">{{$item.label}}</ui-select-match>\n                                <ui-select-choices repeat=\"role.map as role in vm.roles | propsFilter: {label: $select.search}\">\n                                    <div ng-bind-html=\"role.label | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.submitRoles(vm.selected,vm.selectedRoles)\">Submit</button>\n                    </form>\n                </div>\n                \n            </div>\n            <div class=\"col-sm-7\">\n                <div style=\"padding:20px\">\n                    <h4>Bulk Assessment <span class=\"badge\">{{vm.gridOptionsImport.data.length}}</span></h4>\n                    <div ng-show=\"vm.gridOptionsImport.data.length>0\">\n                        <div class=\"checkbox\">\n                        <label><input type=\"checkbox\" ng-model=\"vm.bulkDemoAccounts\">Import as demo accounts</label>\n                        </div>\n                        <div>\n                            <a href=\"\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.bulkProcess()\"><i class=\"fa fa-upload\"></i> Process</a>\n                        </div>\n                    </div>\n                    <hr>\n\n                    <form>\n                        <div class=\"row\">\n                            <div class=\"col-xs-6\">\n                                <input type=\"file\" class=\"file-chooser\" id=\"files\" name=\"files[]\">\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-xs-12\">           \n                                <div id=\"user-bulk-import-grid\" style=\"overflow:auto\" ng-show=\"vm.gridOptionsImport.data.length>0\" ui-grid-importer ui-grid-auto-resize ui-grid=\"vm.gridOptionsImport\"></div>\n                            </div>\n                        </div>\n                    </form>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n    \n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/date.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n  <label for=\"{{id}}\">\n    {{options.label || \'Text\'}}\n    {{options.required ? \'*\' : \'\'}}\n  </label>\n  <p class=\"input-group\">\n    <input type=\"text\" class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\" datepicker-popup=\"{{options.format}}\" is-open=\"options.open\" close-text=\"Close\" date-button=\"showCalendar\">\n  </p>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-checkbox.html","<div class=\"checkbox\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label>\n		<input type=\"checkbox\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\">\n		{{options.label || \'Checkbox\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-email.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Email\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<input type=\"email\" class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\">\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-file-upload.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n    <label for=\"{{id}}\">\n		{{options.templateOptions.label || \'File\'}}\n		{{options.templateOptions.required ? \'*\' : \'\'}}\n	</label>\n    <div class=\"input-group\">\n        <span class=\"input-group-btn\">\n            <span class=\"btn btn-primary btn-file\">{{options.templateOptions.buttonLabel||\'Browse\'}} &hellip;\n                <input id=\"{{id}}\" type=\"file\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" ng-disabled=\"options.disabled\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-model=\"model[options.key || index]\" name=\"files\" accept=\"image/*\" maxsize=\"5000\" base-sixty-four-input=\"base-sixty-four-input\">\n            </span>\n        </span>\n        <input type=\"text\" value=\"{{model[options.key || index][\'filename\']}}\" readonly=\"readonly\" class=\"form-control\">\n    </div>\n    <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-hidden.html","<input type=\"hidden\" ng-model=\"result[options.key || index]\">");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-number.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Number\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<input type=\"number\" class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" min=\"{{options.min}}\" max=\"{{options.max}}\" ng-minlength=\"{{options.minlength}}\" ng-maxlength=\"{{options.maxlength}}\" ng-model=\"result[options.key || index]\">\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-password.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Password\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<input type=\"password\" class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-trim=\"{{options.trimWhitespace || false}}\" ng-model=\"result[options.key || index]\">\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-radio.html","<div class=\"radio-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label class=\"control-label\">\n		{{options.label}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<div class=\"radio\" ng-repeat=\"(key, option) in options.options\">\n		<label>\n			<input type=\"radio\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" id=\"{{id + \'_\'+ $index}}\" aria-describedby=\"{{id}}_description\" ng-value=\"option.value\" ng-required=\"options.required\" ng-model=\"$parent.result[$parent.options.key || $parent.index]\">\n			{{option.name}}\n		</label>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"option.description\">{{option.description}}</p>\n	</div>\n\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-select.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Select\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<select class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" aria-describedby=\"{{id}}_description\" ng-model=\"result[options.key || index]\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-options=\"option.value as option.name group by option.group for option in options.options\">\n	</select>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-text.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Text\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<input type=\"text\" class=\"form-control\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\">\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>");
$templateCache.put("app/modules/core/views/elements/fields/formly-field-textarea.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n	<label for=\"{{id}}\">\n		{{options.label || \'Text\'}}\n		{{options.required ? \'*\' : \'\'}}\n	</label>\n	<textarea type=\"text\" class=\"form-control msd-elastic\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" rows=\"{{options.lines}}\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\">\n	</textarea>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/phone-number.html","<div class=\"form-group\">\n  <label for=\"{{id}}\">\n    {{options.label || \'Number\'}}\n    {{options.required ? \'*\' : \'\'}}\n  </label>\n  <input type=\"text\" class=\"form-control\" id=\"{{id}}\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" min=\"{{options.min}}\" max=\"{{options.max}}\" ng-minlength=\"{{options.minlength}}\" ng-maxlength=\"{{options.maxlength}}\" ng-model=\"result[options.key || index]\" phone-number>\n   <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");
$templateCache.put("app/modules/core/views/elements/fields/time.html","<div class=\"form-group\" ng-class=\"{\'has-error\': options.formField.$invalid}\">\n  <label for=\"{{id}}\">\n    {{options.label || \'Text\'}}\n    {{options.required ? \'*\' : \'\'}}\n  </label>\n  <timepicker hour-step=\"options.hstep || 1\" minute-step=\"options.mstep || 5\" show-meridian=\"ismeridian\" id=\"{{id}}\" formly-dynamic-name=\"options.key\" formly-custom-validation=\"options.validators\" placeholder=\"{{options.placeholder}}\" aria-describedby=\"{{id}}_description\" ng-required=\"options.required\" ng-disabled=\"options.disabled\" ng-model=\"result[options.key || index]\">\n  </timepicker>\n  <p id=\"{{id}}_description\" class=\"help-block\" ng-if=\"options.description\">{{options.description}}</p>\n</div>\n");}]);
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Setting
 * @header lbServices.Setting
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Setting` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Setting",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/settings/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Setting#create
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/settings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#createMany
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/settings",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#upsert
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/settings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#replaceOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/settings/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#upsertWithWhere
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/settings/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#exists
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/settings/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#findById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/settings/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#replaceById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/settings/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#find
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/settings",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#findOne
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/settings/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#updateAll
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/settings/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#deleteById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/settings/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#count
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/settings/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#prototype$updateAttributes
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/settings/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#createChangeStream
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/settings/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Setting#key
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Get Settings of a specific key pattern
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `key` – `{string}` - Search settings by key with regular expressions
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
            "key": {
              isArray: true,
              url: urlBase + "/settings/key/:key",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Setting#patchOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#updateOrCreate
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#patchOrCreateWithWhere
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#update
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#destroyById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#removeById
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Setting#patchAttributes
             * @methodOf lbServices.Setting
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Setting` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Setting#modelName
        * @propertyOf lbServices.Setting
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Setting`.
        */
        R.modelName = "Setting";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SystemUser
 * @header lbServices.SystemUser
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SystemUser` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SystemUser",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q', '$http',
      function(LoopBackResource, LoopBackAuth, $injector, $q, $http) {
        var R = LoopBackResource(
        urlBase + "/SystemUsers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#prototype$__exists__systemRoles
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Check the existence of systemRoles relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for systemRoles
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "prototype$__exists__systemRoles": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SystemUsers/:id/systemRoles/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use SystemUser.organizations.exists() instead.
            "prototype$__exists__organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SystemUsers/:id/organizations/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use SystemUser.projects.exists() instead.
            "prototype$__exists__projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SystemUsers/:id/projects/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#prototype$__get__systemRoles
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Queries systemRoles of SystemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "prototype$__get__systemRoles": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/systemRoles",
              method: "GET",
            },

            // INTERNAL. Use SystemUser.organizations() instead.
            "prototype$__get__organizations": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/organizations",
              method: "GET",
            },

            // INTERNAL. Use SystemUser.projects() instead.
            "prototype$__get__projects": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#upsert
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/SystemUsers",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#replaceOrCreate
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/SystemUsers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#upsertWithWhere
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/SystemUsers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#exists
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/SystemUsers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#findById
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/SystemUsers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#find
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/SystemUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#deleteById
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/SystemUsers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#count
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/SystemUsers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#prototype$updateAttributes
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/SystemUsers/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#login
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  
                  if(!window.AESG.canLogin(response)) {
                    $http.post(urlBase + "/SystemUsers/logout",null,{ ignoreLoadingBar: true }).then(function(res){
                      LoopBackAuth.clearUser();
                      LoopBackAuth.clearStorage();
                    });
                    var error = {
                      code: "LOGIN_FAILED",
                      message: "login failed, not enough permissions",
                      name: "Error",
                      status: 401,
                      statusCode: 401
                    }
                    return $q.reject({data:{error:error}});
                  }
                  
                  return response.resource;
                },
              },
              url: urlBase + "/SystemUsers/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#logout
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/SystemUsers/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#confirm
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/SystemUsers/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#resetPassword
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/SystemUsers/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#cleanup
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * clean related models from users that dont exist any more
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` - the number of records deleted by the cleanup
             */
            "cleanup": {
              url: urlBase + "/SystemUsers/cleanup",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#currentUser
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Get the current loggedIn user based on Authorization token
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "currentUser": {
              url: urlBase + "/SystemUsers/currentUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#emailExists
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Check if email exists
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `email` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "emailExists": {
              url: urlBase + "/SystemUsers/emailExists/:email",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#inviteUser
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Find or invite a user
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `email` – `{string}` -
             *
             *  - `firstName` – `{string=}` -
             *
             *  - `lastName` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "inviteUser": {
              url: urlBase + "/SystemUsers/invite",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#linkedProjects
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Get a list of projects associated with the current user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "linkedProjects": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/linkedProjects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#projectRoles
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Get an aggregated list of project-associated roles for the current user
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
            "projectRoles": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/projectRoles",
              method: "GET",
            },

            // INTERNAL. Use SystemAccess.systemUser() instead.
            "::get::SystemAccess::systemUser": {
              url: urlBase + "/SystemAccesses/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Group.owner() instead.
            "::get::Group::owner": {
              url: urlBase + "/Groups/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers.findById() instead.
            "::findById::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers.destroyById() instead.
            "::destroyById::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.updateById() instead.
            "::updateById::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.systemUsers.link() instead.
            "::link::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.systemUsers.unlink() instead.
            "::unlink::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.exists() instead.
            "::exists::Organization::systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.systemUsers() instead.
            "::get::Organization::systemUsers": {
              isArray: true,
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers.create() instead.
            "::create::Organization::systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "POST",
            },

            // INTERNAL. Use Organization.systemUsers.createMany() instead.
            "::createMany::Organization::systemUsers": {
              isArray: true,
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "POST",
            },

            // INTERNAL. Use Organization.systemUsers.destroyAll() instead.
            "::delete::Organization::systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.count() instead.
            "::count::Organization::systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers/count",
              method: "GET",
            },

            // INTERNAL. Use Exam.systemUser() instead.
            "::get::Exam::systemUser": {
              url: urlBase + "/Exams/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Lecture.systemUser() instead.
            "::get::Lecture::systemUser": {
              url: urlBase + "/Lectures/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.systemUser() instead.
            "::get::LectureProposal::systemUser": {
              url: urlBase + "/LectureProposals/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.systemUser() instead.
            "::get::Syllabus::systemUser": {
              url: urlBase + "/syllabuses/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Assessment.systemUser() instead.
            "::get::Assessment::systemUser": {
              url: urlBase + "/Assessments/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Project.users.link() instead.
            "::link::Project::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.users.unlink() instead.
            "::unlink::Project::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.users.exists() instead.
            "::exists::Project::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.users() instead.
            "::get::Project::users": {
              isArray: true,
              url: urlBase + "/Projects/:id/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#getCurrent
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/SystemUsers" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SystemUser#patchOrCreate
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#updateOrCreate
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#patchOrCreateWithWhere
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#destroyById
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#removeById
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SystemUser#patchAttributes
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.SystemUser#getCachedCurrent
         * @methodOf lbServices.SystemUser
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.SystemUser#login} or
         * {@link lbServices.SystemUser#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A SystemUser instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.SystemUser#isAuthenticated
         * @methodOf lbServices.SystemUser
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.SystemUser#getCurrentId
         * @methodOf lbServices.SystemUser
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.SystemUser#modelName
        * @propertyOf lbServices.SystemUser
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SystemUser`.
        */
        R.modelName = "SystemUser";

    /**
     * @ngdoc object
     * @name lbServices.SystemUser.organizations
     * @header lbServices.SystemUser.organizations
     * @object
     * @description
     *
     * The object `SystemUser.organizations` groups methods
     * manipulating `Project` instances related to `SystemUser`.
     *
     * Call {@link lbServices.SystemUser#organizations SystemUser.organizations()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.SystemUser#organizations
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Queries organizations of SystemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.organizations = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::SystemUser::organizations"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SystemUser.organizations#exists
             * @methodOf lbServices.SystemUser.organizations
             *
             * @description
             *
             * Check the existence of organizations relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for organizations
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.organizations.exists = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::exists::SystemUser::organizations"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.SystemUser.projects
     * @header lbServices.SystemUser.projects
     * @object
     * @description
     *
     * The object `SystemUser.projects` groups methods
     * manipulating `Project` instances related to `SystemUser`.
     *
     * Call {@link lbServices.SystemUser#projects SystemUser.projects()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.SystemUser#projects
             * @methodOf lbServices.SystemUser
             *
             * @description
             *
             * Queries projects of SystemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::SystemUser::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SystemUser.projects#exists
             * @methodOf lbServices.SystemUser.projects
             *
             * @description
             *
             * Check the existence of projects relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - User id
             *
             *  - `fk` – `{*}` - Foreign key for projects
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects.exists = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::exists::SystemUser::projects"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SystemAccess
 * @header lbServices.SystemAccess
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SystemAccess` model.
 *
 * **Details**
 *
 * Map principals to roles
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SystemAccess",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/SystemAccesses/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#prototype$__get__role
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Fetches belongsTo relation role.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "prototype$__get__role": {
              url: urlBase + "/SystemAccesses/:id/role",
              method: "GET",
            },

            // INTERNAL. Use SystemAccess.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/SystemAccesses/:id/systemUser",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#create
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/SystemAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#createMany
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/SystemAccesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#upsert
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/SystemAccesses",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#replaceOrCreate
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/SystemAccesses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#upsertWithWhere
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/SystemAccesses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#exists
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/SystemAccesses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#findById
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/SystemAccesses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#replaceById
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/SystemAccesses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#find
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/SystemAccesses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#findOne
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/SystemAccesses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#updateAll
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/SystemAccesses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#deleteById
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/SystemAccesses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#count
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/SystemAccesses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#prototype$updateAttributes
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/SystemAccesses/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#createChangeStream
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/SystemAccesses/change-stream",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#patchOrCreate
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#updateOrCreate
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#patchOrCreateWithWhere
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#update
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#destroyById
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#removeById
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#patchAttributes
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemAccess` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SystemAccess#modelName
        * @propertyOf lbServices.SystemAccess
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SystemAccess`.
        */
        R.modelName = "SystemAccess";


            /**
             * @ngdoc method
             * @name lbServices.SystemAccess#systemUser
             * @methodOf lbServices.SystemAccess
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RoleMapping id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::SystemAccess::systemUser"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Group
 * @header lbServices.Group
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Group` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Group",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Groups/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Group.owner() instead.
            "prototype$__get__owner": {
              url: urlBase + "/Groups/:id/owner",
              method: "GET",
            },

            // INTERNAL. Use Group.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/Groups/:id/organization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#create
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Groups",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#createMany
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Groups",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#upsert
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Groups",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#replaceOrCreate
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Groups/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#upsertWithWhere
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Groups/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#exists
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Groups/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#findById
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Groups/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#replaceById
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Groups/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#find
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Groups",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#findOne
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Groups/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#updateAll
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Groups/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#deleteById
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Groups/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#count
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Groups/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#prototype$updateAttributes
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Groups/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Group#createChangeStream
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Groups/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Organization.groups.findById() instead.
            "::findById::Organization::groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.groups.destroyById() instead.
            "::destroyById::Organization::groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.groups.updateById() instead.
            "::updateById::Organization::groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.groups() instead.
            "::get::Organization::groups": {
              isArray: true,
              url: urlBase + "/Organizations/:id/groups",
              method: "GET",
            },

            // INTERNAL. Use Organization.groups.create() instead.
            "::create::Organization::groups": {
              url: urlBase + "/Organizations/:id/groups",
              method: "POST",
            },

            // INTERNAL. Use Organization.groups.createMany() instead.
            "::createMany::Organization::groups": {
              isArray: true,
              url: urlBase + "/Organizations/:id/groups",
              method: "POST",
            },

            // INTERNAL. Use Organization.groups.destroyAll() instead.
            "::delete::Organization::groups": {
              url: urlBase + "/Organizations/:id/groups",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.groups.count() instead.
            "::count::Organization::groups": {
              url: urlBase + "/Organizations/:id/groups/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Group#patchOrCreate
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Group#updateOrCreate
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Group#patchOrCreateWithWhere
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Group#update
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Group#destroyById
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Group#removeById
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Group#patchAttributes
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Group#modelName
        * @propertyOf lbServices.Group
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Group`.
        */
        R.modelName = "Group";


            /**
             * @ngdoc method
             * @name lbServices.Group#owner
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Fetches belongsTo relation owner.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.owner = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Group::owner"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Group#organization
             * @methodOf lbServices.Group
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Group::organization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Organization
 * @header lbServices.Organization
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Organization` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Organization",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Organizations/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Organization.groups.findById() instead.
            "prototype$__findById__groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.groups.destroyById() instead.
            "prototype$__destroyById__groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.groups.updateById() instead.
            "prototype$__updateById__groups": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/groups/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.systemUsers.findById() instead.
            "prototype$__findById__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers.destroyById() instead.
            "prototype$__destroyById__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.updateById() instead.
            "prototype$__updateById__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.systemUsers.link() instead.
            "prototype$__link__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.systemUsers.unlink() instead.
            "prototype$__unlink__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.exists() instead.
            "prototype$__exists__systemUsers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/systemUsers/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Organization.projects.findById() instead.
            "prototype$__findById__projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects.destroyById() instead.
            "prototype$__destroyById__projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.projects.updateById() instead.
            "prototype$__updateById__projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.files.findById() instead.
            "prototype$__findById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.files.destroyById() instead.
            "prototype$__destroyById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.files.updateById() instead.
            "prototype$__updateById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.groups() instead.
            "prototype$__get__groups": {
              isArray: true,
              url: urlBase + "/Organizations/:id/groups",
              method: "GET",
            },

            // INTERNAL. Use Organization.groups.create() instead.
            "prototype$__create__groups": {
              url: urlBase + "/Organizations/:id/groups",
              method: "POST",
            },

            // INTERNAL. Use Organization.groups.destroyAll() instead.
            "prototype$__delete__groups": {
              url: urlBase + "/Organizations/:id/groups",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.groups.count() instead.
            "prototype$__count__groups": {
              url: urlBase + "/Organizations/:id/groups/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers() instead.
            "prototype$__get__systemUsers": {
              isArray: true,
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "GET",
            },

            // INTERNAL. Use Organization.systemUsers.create() instead.
            "prototype$__create__systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "POST",
            },

            // INTERNAL. Use Organization.systemUsers.destroyAll() instead.
            "prototype$__delete__systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.systemUsers.count() instead.
            "prototype$__count__systemUsers": {
              url: urlBase + "/Organizations/:id/systemUsers/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects() instead.
            "prototype$__get__projects": {
              isArray: true,
              url: urlBase + "/Organizations/:id/projects",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects.create() instead.
            "prototype$__create__projects": {
              url: urlBase + "/Organizations/:id/projects",
              method: "POST",
            },

            // INTERNAL. Use Organization.projects.destroyAll() instead.
            "prototype$__delete__projects": {
              url: urlBase + "/Organizations/:id/projects",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.projects.count() instead.
            "prototype$__count__projects": {
              url: urlBase + "/Organizations/:id/projects/count",
              method: "GET",
            },

            // INTERNAL. Use Organization.files() instead.
            "prototype$__get__files": {
              isArray: true,
              url: urlBase + "/Organizations/:id/files",
              method: "GET",
            },

            // INTERNAL. Use Organization.files.create() instead.
            "prototype$__create__files": {
              url: urlBase + "/Organizations/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Organization.files.destroyAll() instead.
            "prototype$__delete__files": {
              url: urlBase + "/Organizations/:id/files",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.files.count() instead.
            "prototype$__count__files": {
              url: urlBase + "/Organizations/:id/files/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#create
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Organizations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#createMany
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Organizations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#upsert
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Organizations",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#replaceOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Organizations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#upsertWithWhere
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Organizations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#exists
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Organizations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#findById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Organizations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#replaceById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Organizations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#find
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Organizations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#findOne
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Organizations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#updateAll
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Organizations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#deleteById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Organizations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#count
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Organizations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#prototype$updateAttributes
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Organizations/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#createChangeStream
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Organizations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#getFiles
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Get files of a specific type : e.g Organizations/A/creo-lectures/files
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/Organizations/:id/:componentModel/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#relatedUsers
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Get all the related users of an organization
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Array of SystemUser instances
             */
            "relatedUsers": {
              isArray: true,
              url: urlBase + "/Organizations/:id/relatedUsers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#uploadFile
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Uploads a file for this organization : e.g organizationAId/assessment/uploadFile
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/Organizations/:id/:componentModel/uploadFile",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organization#updateFile
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Updates a file for this organization : e.g OrganizationsorganizationAId/assessment/updateFile/:FileId1
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `fileId` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/Organizations/:id/:componentModel/updateFile/:fileId",
              method: "POST",
            },

            // INTERNAL. Use Group.organization() instead.
            "::get::Group::organization": {
              url: urlBase + "/Groups/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Project.organization() instead.
            "::get::Project::organization": {
              url: urlBase + "/Projects/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use File.organization() instead.
            "::get::File::organization": {
              url: urlBase + "/Files/:id/organization",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Organization#patchOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#updateOrCreate
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#patchOrCreateWithWhere
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#update
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#destroyById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#removeById
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organization#patchAttributes
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Organization#modelName
        * @propertyOf lbServices.Organization
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Organization`.
        */
        R.modelName = "Organization";

    /**
     * @ngdoc object
     * @name lbServices.Organization.groups
     * @header lbServices.Organization.groups
     * @object
     * @description
     *
     * The object `Organization.groups` groups methods
     * manipulating `Group` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#groups Organization.groups()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#groups
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries groups of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R.groups = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::get::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#count
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Counts groups of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.groups.count = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::count::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#create
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Creates a new instance in groups of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R.groups.create = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::create::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#createMany
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Creates a new instance in groups of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R.groups.createMany = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::createMany::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#destroyAll
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Deletes all groups of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.groups.destroyAll = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::delete::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#destroyById
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Delete a related item by id for groups.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for groups
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.groups.destroyById = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::destroyById::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#findById
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Find a related item by id for groups.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for groups
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R.groups.findById = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::findById::Organization::groups"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.groups#updateById
             * @methodOf lbServices.Organization.groups
             *
             * @description
             *
             * Update a related item by id for groups.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for groups
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Group` object.)
             * </em>
             */
        R.groups.updateById = function() {
          var TargetResource = $injector.get("Group");
          var action = TargetResource["::updateById::Organization::groups"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.systemUsers
     * @header lbServices.Organization.systemUsers
     * @object
     * @description
     *
     * The object `Organization.systemUsers` groups methods
     * manipulating `SystemUser` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#systemUsers Organization.systemUsers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#systemUsers
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries systemUsers of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#count
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Counts systemUsers of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.systemUsers.count = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::count::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#create
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Creates a new instance in systemUsers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.create = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::create::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#createMany
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Creates a new instance in systemUsers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.createMany = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::createMany::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#destroyAll
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Deletes all systemUsers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.systemUsers.destroyAll = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::delete::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#destroyById
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Delete a related item by id for systemUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.systemUsers.destroyById = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::destroyById::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#exists
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Check the existence of systemUsers relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.exists = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::exists::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#findById
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Find a related item by id for systemUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.findById = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::findById::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#link
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Add a related item by id for systemUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.link = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::link::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#unlink
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Remove the systemUsers relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.systemUsers.unlink = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::unlink::Organization::systemUsers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.systemUsers#updateById
             * @methodOf lbServices.Organization.systemUsers
             *
             * @description
             *
             * Update a related item by id for systemUsers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for systemUsers
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUsers.updateById = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::updateById::Organization::systemUsers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.projects
     * @header lbServices.Organization.projects
     * @object
     * @description
     *
     * The object `Organization.projects` groups methods
     * manipulating `Project` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#projects Organization.projects()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#projects
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries projects of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#count
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Counts projects of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.projects.count = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::count::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#create
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Creates a new instance in projects of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects.create = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::create::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#createMany
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Creates a new instance in projects of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects.createMany = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::createMany::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#destroyAll
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Deletes all projects of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.projects.destroyAll = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::delete::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#destroyById
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Delete a related item by id for projects.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for projects
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.projects.destroyById = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::destroyById::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#findById
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Find a related item by id for projects.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for projects
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects.findById = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::findById::Organization::projects"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.projects#updateById
             * @methodOf lbServices.Organization.projects
             *
             * @description
             *
             * Update a related item by id for projects.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for projects
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.projects.updateById = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::updateById::Organization::projects"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Organization.files
     * @header lbServices.Organization.files
     * @object
     * @description
     *
     * The object `Organization.files` groups methods
     * manipulating `File` instances related to `Organization`.
     *
     * Call {@link lbServices.Organization#files Organization.files()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Organization#files
             * @methodOf lbServices.Organization
             *
             * @description
             *
             * Queries files of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#count
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Counts files of Organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.files.count = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::count::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#create
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Creates a new instance in files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#createMany
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Creates a new instance in files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#destroyAll
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Deletes all files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.files.destroyAll = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::delete::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#destroyById
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Delete a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.files.destroyById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroyById::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#findById
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Find a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.findById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::findById::Organization::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Organization.files#updateById
             * @methodOf lbServices.Organization.files
             *
             * @description
             *
             * Update a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.updateById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::updateById::Organization::files"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Exam
 * @header lbServices.Exam
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Exam` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Exam",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Exams/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Exam.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/Exams/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Exam.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Exams/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Exam.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/Exams/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Exam.file.create() instead.
            "prototype$__create__file": {
              url: urlBase + "/Exams/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Exam.file.update() instead.
            "prototype$__update__file": {
              url: urlBase + "/Exams/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Exam.file.destroy() instead.
            "prototype$__destroy__file": {
              url: urlBase + "/Exams/:id/file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#create
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Exams",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#createMany
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Exams",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#upsert
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Exams",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#replaceOrCreate
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Exams/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#upsertWithWhere
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Exams/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#exists
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Exams/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#findById
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Exams/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#replaceById
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Exams/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#find
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Exams",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#findOne
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Exams/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#updateAll
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Exams/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#deleteById
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Exams/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#count
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Exams/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#prototype$updateAttributes
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Exams/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Exam#createChangeStream
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Exams/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Project.exams.findById() instead.
            "::findById::Project::exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.exams.destroyById() instead.
            "::destroyById::Project::exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.exams.updateById() instead.
            "::updateById::Project::exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.exams() instead.
            "::get::Project::exams": {
              isArray: true,
              url: urlBase + "/Projects/:id/exams",
              method: "GET",
            },

            // INTERNAL. Use Project.exams.create() instead.
            "::create::Project::exams": {
              url: urlBase + "/Projects/:id/exams",
              method: "POST",
            },

            // INTERNAL. Use Project.exams.createMany() instead.
            "::createMany::Project::exams": {
              isArray: true,
              url: urlBase + "/Projects/:id/exams",
              method: "POST",
            },

            // INTERNAL. Use Project.exams.destroyAll() instead.
            "::delete::Project::exams": {
              url: urlBase + "/Projects/:id/exams",
              method: "DELETE",
            },

            // INTERNAL. Use Project.exams.count() instead.
            "::count::Project::exams": {
              url: urlBase + "/Projects/:id/exams/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Exam#patchOrCreate
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#updateOrCreate
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#patchOrCreateWithWhere
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#update
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#destroyById
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#removeById
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Exam#patchAttributes
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Exam#modelName
        * @propertyOf lbServices.Exam
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Exam`.
        */
        R.modelName = "Exam";


            /**
             * @ngdoc method
             * @name lbServices.Exam#systemUser
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Exam::systemUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Exam#project
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Exam::project"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Exam.file
     * @header lbServices.Exam.file
     * @object
     * @description
     *
     * The object `Exam.file` groups methods
     * manipulating `File` instances related to `Exam`.
     *
     * Call {@link lbServices.Exam#file Exam.file()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Exam#file
             * @methodOf lbServices.Exam
             *
             * @description
             *
             * Fetches hasOne relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Exam::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Exam.file#create
             * @methodOf lbServices.Exam.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Exam::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Exam.file#createMany
             * @methodOf lbServices.Exam.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Exam::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Exam.file#destroy
             * @methodOf lbServices.Exam.file
             *
             * @description
             *
             * Deletes file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.file.destroy = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroy::Exam::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Exam.file#update
             * @methodOf lbServices.Exam.file
             *
             * @description
             *
             * Update file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.update = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::update::Exam::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Lecture
 * @header lbServices.Lecture
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Lecture` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Lecture",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Lectures/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Lecture.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/Lectures/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.findById() instead.
            "prototype$__findById__proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.destroyById() instead.
            "prototype$__destroyById__proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.proposals.updateById() instead.
            "prototype$__updateById__proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Lecture.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Lectures/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Lecture.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/Lectures/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Lecture.file.create() instead.
            "prototype$__create__file": {
              url: urlBase + "/Lectures/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Lecture.file.update() instead.
            "prototype$__update__file": {
              url: urlBase + "/Lectures/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Lecture.file.destroy() instead.
            "prototype$__destroy__file": {
              url: urlBase + "/Lectures/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.proposals() instead.
            "prototype$__get__proposals": {
              isArray: true,
              url: urlBase + "/Lectures/:id/proposals",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.create() instead.
            "prototype$__create__proposals": {
              url: urlBase + "/Lectures/:id/proposals",
              method: "POST",
            },

            // INTERNAL. Use Lecture.proposals.destroyAll() instead.
            "prototype$__delete__proposals": {
              url: urlBase + "/Lectures/:id/proposals",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.proposals.count() instead.
            "prototype$__count__proposals": {
              url: urlBase + "/Lectures/:id/proposals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#create
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Lectures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#createMany
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Lectures",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#upsert
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Lectures",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#replaceOrCreate
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Lectures/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#upsertWithWhere
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Lectures/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#exists
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Lectures/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#findById
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Lectures/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#replaceById
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Lectures/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#find
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Lectures",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#findOne
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Lectures/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#updateAll
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Lectures/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#deleteById
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Lectures/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#count
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Lectures/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#prototype$updateAttributes
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Lectures/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#createChangeStream
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Lectures/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Lecture#uploadProposal
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Uploads a proposal for a lecture
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
            "uploadProposal": {
              url: urlBase + "/Lectures/:id/uploadProposal",
              method: "POST",
            },

            // INTERNAL. Use LectureProposal.lecture() instead.
            "::get::LectureProposal::lecture": {
              url: urlBase + "/LectureProposals/:id/lecture",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures.findById() instead.
            "::findById::Project::lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures.destroyById() instead.
            "::destroyById::Project::lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectures.updateById() instead.
            "::updateById::Project::lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.lectures() instead.
            "::get::Project::lectures": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectures",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures.create() instead.
            "::create::Project::lectures": {
              url: urlBase + "/Projects/:id/lectures",
              method: "POST",
            },

            // INTERNAL. Use Project.lectures.createMany() instead.
            "::createMany::Project::lectures": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectures",
              method: "POST",
            },

            // INTERNAL. Use Project.lectures.destroyAll() instead.
            "::delete::Project::lectures": {
              url: urlBase + "/Projects/:id/lectures",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectures.count() instead.
            "::count::Project::lectures": {
              url: urlBase + "/Projects/:id/lectures/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Lecture#patchOrCreate
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#updateOrCreate
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#patchOrCreateWithWhere
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#update
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#destroyById
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#removeById
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Lecture#patchAttributes
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Lecture#modelName
        * @propertyOf lbServices.Lecture
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Lecture`.
        */
        R.modelName = "Lecture";


            /**
             * @ngdoc method
             * @name lbServices.Lecture#systemUser
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Lecture::systemUser"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Lecture.proposals
     * @header lbServices.Lecture.proposals
     * @object
     * @description
     *
     * The object `Lecture.proposals` groups methods
     * manipulating `LectureProposal` instances related to `Lecture`.
     *
     * Call {@link lbServices.Lecture#proposals Lecture.proposals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Lecture#proposals
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Queries proposals of Lecture.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.proposals = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::get::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#count
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Counts proposals of Lecture.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.proposals.count = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::count::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#create
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Creates a new instance in proposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.proposals.create = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::create::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#createMany
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Creates a new instance in proposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.proposals.createMany = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::createMany::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#destroyAll
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Deletes all proposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.proposals.destroyAll = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::delete::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#destroyById
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Delete a related item by id for proposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `fk` – `{*}` - Foreign key for proposals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.proposals.destroyById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::destroyById::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#findById
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Find a related item by id for proposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `fk` – `{*}` - Foreign key for proposals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.proposals.findById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::findById::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.proposals#updateById
             * @methodOf lbServices.Lecture.proposals
             *
             * @description
             *
             * Update a related item by id for proposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `fk` – `{*}` - Foreign key for proposals
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.proposals.updateById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::updateById::Lecture::proposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture#project
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Lecture::project"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Lecture.file
     * @header lbServices.Lecture.file
     * @object
     * @description
     *
     * The object `Lecture.file` groups methods
     * manipulating `File` instances related to `Lecture`.
     *
     * Call {@link lbServices.Lecture#file Lecture.file()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Lecture#file
             * @methodOf lbServices.Lecture
             *
             * @description
             *
             * Fetches hasOne relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Lecture::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.file#create
             * @methodOf lbServices.Lecture.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Lecture::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.file#createMany
             * @methodOf lbServices.Lecture.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Lecture::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.file#destroy
             * @methodOf lbServices.Lecture.file
             *
             * @description
             *
             * Deletes file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.file.destroy = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroy::Lecture::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Lecture.file#update
             * @methodOf lbServices.Lecture.file
             *
             * @description
             *
             * Update file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.update = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::update::Lecture::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.LectureProposal
 * @header lbServices.LectureProposal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `LectureProposal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "LectureProposal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/LectureProposals/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use LectureProposal.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/LectureProposals/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.lecture() instead.
            "prototype$__get__lecture": {
              url: urlBase + "/LectureProposals/:id/lecture",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/LectureProposals/:id/project",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.file.create() instead.
            "prototype$__create__file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "POST",
            },

            // INTERNAL. Use LectureProposal.file.update() instead.
            "prototype$__update__file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use LectureProposal.file.destroy() instead.
            "prototype$__destroy__file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#create
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/LectureProposals",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#createMany
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/LectureProposals",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#upsert
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/LectureProposals",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#replaceOrCreate
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/LectureProposals/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#upsertWithWhere
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/LectureProposals/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#exists
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/LectureProposals/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#findById
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/LectureProposals/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#replaceById
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/LectureProposals/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#find
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/LectureProposals",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#findOne
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/LectureProposals/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#updateAll
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/LectureProposals/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#deleteById
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/LectureProposals/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#count
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/LectureProposals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#prototype$updateAttributes
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/LectureProposals/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#createChangeStream
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/LectureProposals/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#download
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Download proposal
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `type` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
            "download": {
              url: urlBase + "/LectureProposals/:id/download",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.findById() instead.
            "::findById::Lecture::proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.destroyById() instead.
            "::destroyById::Lecture::proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.proposals.updateById() instead.
            "::updateById::Lecture::proposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Lectures/:id/proposals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Lecture.proposals() instead.
            "::get::Lecture::proposals": {
              isArray: true,
              url: urlBase + "/Lectures/:id/proposals",
              method: "GET",
            },

            // INTERNAL. Use Lecture.proposals.create() instead.
            "::create::Lecture::proposals": {
              url: urlBase + "/Lectures/:id/proposals",
              method: "POST",
            },

            // INTERNAL. Use Lecture.proposals.createMany() instead.
            "::createMany::Lecture::proposals": {
              isArray: true,
              url: urlBase + "/Lectures/:id/proposals",
              method: "POST",
            },

            // INTERNAL. Use Lecture.proposals.destroyAll() instead.
            "::delete::Lecture::proposals": {
              url: urlBase + "/Lectures/:id/proposals",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.proposals.count() instead.
            "::count::Lecture::proposals": {
              url: urlBase + "/Lectures/:id/proposals/count",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals.findById() instead.
            "::findById::Project::lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals.destroyById() instead.
            "::destroyById::Project::lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectureProposals.updateById() instead.
            "::updateById::Project::lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.lectureProposals() instead.
            "::get::Project::lectureProposals": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals.create() instead.
            "::create::Project::lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "POST",
            },

            // INTERNAL. Use Project.lectureProposals.createMany() instead.
            "::createMany::Project::lectureProposals": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "POST",
            },

            // INTERNAL. Use Project.lectureProposals.destroyAll() instead.
            "::delete::Project::lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectureProposals.count() instead.
            "::count::Project::lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#patchOrCreate
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#updateOrCreate
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#patchOrCreateWithWhere
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#update
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#destroyById
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#removeById
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#patchAttributes
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.LectureProposal#modelName
        * @propertyOf lbServices.LectureProposal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `LectureProposal`.
        */
        R.modelName = "LectureProposal";


            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#systemUser
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::LectureProposal::systemUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#lecture
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Fetches belongsTo relation lecture.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lecture = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::get::LectureProposal::lecture"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#project
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::LectureProposal::project"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.LectureProposal.file
     * @header lbServices.LectureProposal.file
     * @object
     * @description
     *
     * The object `LectureProposal.file` groups methods
     * manipulating `File` instances related to `LectureProposal`.
     *
     * Call {@link lbServices.LectureProposal#file LectureProposal.file()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.LectureProposal#file
             * @methodOf lbServices.LectureProposal
             *
             * @description
             *
             * Fetches hasOne relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::LectureProposal::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal.file#create
             * @methodOf lbServices.LectureProposal.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::LectureProposal::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal.file#createMany
             * @methodOf lbServices.LectureProposal.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::LectureProposal::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal.file#destroy
             * @methodOf lbServices.LectureProposal.file
             *
             * @description
             *
             * Deletes file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.file.destroy = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroy::LectureProposal::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LectureProposal.file#update
             * @methodOf lbServices.LectureProposal.file
             *
             * @description
             *
             * Update file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.update = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::update::LectureProposal::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Syllabus
 * @header lbServices.Syllabus
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Syllabus` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Syllabus",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/syllabuses/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Syllabus.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/syllabuses/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/syllabuses/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.file.create() instead.
            "prototype$__create__file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Syllabus.file.update() instead.
            "prototype$__update__file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Syllabus.file.destroy() instead.
            "prototype$__destroy__file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#create
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/syllabuses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#createMany
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/syllabuses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#upsert
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/syllabuses",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#replaceOrCreate
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/syllabuses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#upsertWithWhere
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/syllabuses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#exists
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/syllabuses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#findById
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/syllabuses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#replaceById
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/syllabuses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#find
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/syllabuses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#findOne
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/syllabuses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#updateAll
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/syllabuses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#deleteById
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/syllabuses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#count
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/syllabuses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#prototype$updateAttributes
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/syllabuses/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#createChangeStream
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/syllabuses/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Project.syllabuses.findById() instead.
            "::findById::Project::syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.syllabuses.destroyById() instead.
            "::destroyById::Project::syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.syllabuses.updateById() instead.
            "::updateById::Project::syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.syllabuses() instead.
            "::get::Project::syllabuses": {
              isArray: true,
              url: urlBase + "/Projects/:id/syllabuses",
              method: "GET",
            },

            // INTERNAL. Use Project.syllabuses.create() instead.
            "::create::Project::syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses",
              method: "POST",
            },

            // INTERNAL. Use Project.syllabuses.createMany() instead.
            "::createMany::Project::syllabuses": {
              isArray: true,
              url: urlBase + "/Projects/:id/syllabuses",
              method: "POST",
            },

            // INTERNAL. Use Project.syllabuses.destroyAll() instead.
            "::delete::Project::syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses",
              method: "DELETE",
            },

            // INTERNAL. Use Project.syllabuses.count() instead.
            "::count::Project::syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Syllabus#patchOrCreate
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#updateOrCreate
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#patchOrCreateWithWhere
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#update
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#destroyById
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#removeById
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#patchAttributes
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Syllabus#modelName
        * @propertyOf lbServices.Syllabus
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Syllabus`.
        */
        R.modelName = "Syllabus";


            /**
             * @ngdoc method
             * @name lbServices.Syllabus#systemUser
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Syllabus::systemUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Syllabus#project
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Syllabus::project"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Syllabus.file
     * @header lbServices.Syllabus.file
     * @object
     * @description
     *
     * The object `Syllabus.file` groups methods
     * manipulating `File` instances related to `Syllabus`.
     *
     * Call {@link lbServices.Syllabus#file Syllabus.file()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Syllabus#file
             * @methodOf lbServices.Syllabus
             *
             * @description
             *
             * Fetches hasOne relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Syllabus::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Syllabus.file#create
             * @methodOf lbServices.Syllabus.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Syllabus::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Syllabus.file#createMany
             * @methodOf lbServices.Syllabus.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Syllabus::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Syllabus.file#destroy
             * @methodOf lbServices.Syllabus.file
             *
             * @description
             *
             * Deletes file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.file.destroy = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroy::Syllabus::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Syllabus.file#update
             * @methodOf lbServices.Syllabus.file
             *
             * @description
             *
             * Update file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.update = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::update::Syllabus::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Assessment
 * @header lbServices.Assessment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Assessment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Assessment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Assessments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Assessment.systemUser() instead.
            "prototype$__get__systemUser": {
              url: urlBase + "/Assessments/:id/systemUser",
              method: "GET",
            },

            // INTERNAL. Use Assessment.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Assessments/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Assessment.file() instead.
            "prototype$__get__file": {
              url: urlBase + "/Assessments/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Assessment.file.create() instead.
            "prototype$__create__file": {
              url: urlBase + "/Assessments/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Assessment.file.update() instead.
            "prototype$__update__file": {
              url: urlBase + "/Assessments/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Assessment.file.destroy() instead.
            "prototype$__destroy__file": {
              url: urlBase + "/Assessments/:id/file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#create
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Assessments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#createMany
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Assessments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#upsert
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Assessments",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#replaceOrCreate
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Assessments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#upsertWithWhere
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Assessments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#exists
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Assessments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#findById
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Assessments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#replaceById
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Assessments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#find
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Assessments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#findOne
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Assessments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#updateAll
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Assessments/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#deleteById
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Assessments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#count
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Assessments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#prototype$updateAttributes
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Assessments/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Assessment#createChangeStream
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Assessments/change-stream",
              method: "POST",
            },

            // INTERNAL. Use Project.assessments.findById() instead.
            "::findById::Project::assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.assessments.destroyById() instead.
            "::destroyById::Project::assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.assessments.updateById() instead.
            "::updateById::Project::assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.assessments() instead.
            "::get::Project::assessments": {
              isArray: true,
              url: urlBase + "/Projects/:id/assessments",
              method: "GET",
            },

            // INTERNAL. Use Project.assessments.create() instead.
            "::create::Project::assessments": {
              url: urlBase + "/Projects/:id/assessments",
              method: "POST",
            },

            // INTERNAL. Use Project.assessments.createMany() instead.
            "::createMany::Project::assessments": {
              isArray: true,
              url: urlBase + "/Projects/:id/assessments",
              method: "POST",
            },

            // INTERNAL. Use Project.assessments.destroyAll() instead.
            "::delete::Project::assessments": {
              url: urlBase + "/Projects/:id/assessments",
              method: "DELETE",
            },

            // INTERNAL. Use Project.assessments.count() instead.
            "::count::Project::assessments": {
              url: urlBase + "/Projects/:id/assessments/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Assessment#patchOrCreate
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#updateOrCreate
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#patchOrCreateWithWhere
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#update
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#destroyById
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#removeById
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Assessment#patchAttributes
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Assessment#modelName
        * @propertyOf lbServices.Assessment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Assessment`.
        */
        R.modelName = "Assessment";


            /**
             * @ngdoc method
             * @name lbServices.Assessment#systemUser
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Fetches belongsTo relation systemUser.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.systemUser = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Assessment::systemUser"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assessment#project
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::Assessment::project"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Assessment.file
     * @header lbServices.Assessment.file
     * @object
     * @description
     *
     * The object `Assessment.file` groups methods
     * manipulating `File` instances related to `Assessment`.
     *
     * Call {@link lbServices.Assessment#file Assessment.file()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Assessment#file
             * @methodOf lbServices.Assessment
             *
             * @description
             *
             * Fetches hasOne relation file.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Assessment::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assessment.file#create
             * @methodOf lbServices.Assessment.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Assessment::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assessment.file#createMany
             * @methodOf lbServices.Assessment.file
             *
             * @description
             *
             * Creates a new instance in file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Assessment::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assessment.file#destroy
             * @methodOf lbServices.Assessment.file
             *
             * @description
             *
             * Deletes file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.file.destroy = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroy::Assessment::file"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Assessment.file#update
             * @methodOf lbServices.Assessment.file
             *
             * @description
             *
             * Update file of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProjectComponent id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.file.update = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::update::Assessment::file"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Project
 * @header lbServices.Project
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Project` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Project",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Projects/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__findById__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find a related item by id for access.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for access
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__findById__access": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/access/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__destroyById__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a related item by id for access.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for access
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__access": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/access/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__updateById__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update a related item by id for access.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for access
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__updateById__access": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/access/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.users.link() instead.
            "prototype$__link__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.users.unlink() instead.
            "prototype$__unlink__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.users.exists() instead.
            "prototype$__exists__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/users/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Project.assessments.findById() instead.
            "prototype$__findById__assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.assessments.destroyById() instead.
            "prototype$__destroyById__assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.assessments.updateById() instead.
            "prototype$__updateById__assessments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/assessments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.exams.findById() instead.
            "prototype$__findById__exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.exams.destroyById() instead.
            "prototype$__destroyById__exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.exams.updateById() instead.
            "prototype$__updateById__exams": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/exams/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.lectures.findById() instead.
            "prototype$__findById__lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures.destroyById() instead.
            "prototype$__destroyById__lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectures.updateById() instead.
            "prototype$__updateById__lectures": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectures/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.lectureProposals.findById() instead.
            "prototype$__findById__lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals.destroyById() instead.
            "prototype$__destroyById__lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectureProposals.updateById() instead.
            "prototype$__updateById__lectureProposals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/lectureProposals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.syllabuses.findById() instead.
            "prototype$__findById__syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.syllabuses.destroyById() instead.
            "prototype$__destroyById__syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.syllabuses.updateById() instead.
            "prototype$__updateById__syllabuses": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/syllabuses/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/Projects/:id/organization",
              method: "GET",
            },

            // INTERNAL. Use Project.files.findById() instead.
            "prototype$__findById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.files.destroyById() instead.
            "prototype$__destroyById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.files.updateById() instead.
            "prototype$__updateById__files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__get__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries access of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__get__access": {
              isArray: true,
              url: urlBase + "/Projects/:id/access",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__create__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Creates a new instance in access of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$__create__access": {
              url: urlBase + "/Projects/:id/access",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__delete__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Deletes all access of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__access": {
              url: urlBase + "/Projects/:id/access",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$__count__access
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Counts access of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__access": {
              url: urlBase + "/Projects/:id/access/count",
              method: "GET",
            },

            // INTERNAL. Use Project.users() instead.
            "prototype$__get__users": {
              isArray: true,
              url: urlBase + "/Projects/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Project.assessments() instead.
            "prototype$__get__assessments": {
              isArray: true,
              url: urlBase + "/Projects/:id/assessments",
              method: "GET",
            },

            // INTERNAL. Use Project.assessments.create() instead.
            "prototype$__create__assessments": {
              url: urlBase + "/Projects/:id/assessments",
              method: "POST",
            },

            // INTERNAL. Use Project.assessments.destroyAll() instead.
            "prototype$__delete__assessments": {
              url: urlBase + "/Projects/:id/assessments",
              method: "DELETE",
            },

            // INTERNAL. Use Project.assessments.count() instead.
            "prototype$__count__assessments": {
              url: urlBase + "/Projects/:id/assessments/count",
              method: "GET",
            },

            // INTERNAL. Use Project.exams() instead.
            "prototype$__get__exams": {
              isArray: true,
              url: urlBase + "/Projects/:id/exams",
              method: "GET",
            },

            // INTERNAL. Use Project.exams.create() instead.
            "prototype$__create__exams": {
              url: urlBase + "/Projects/:id/exams",
              method: "POST",
            },

            // INTERNAL. Use Project.exams.destroyAll() instead.
            "prototype$__delete__exams": {
              url: urlBase + "/Projects/:id/exams",
              method: "DELETE",
            },

            // INTERNAL. Use Project.exams.count() instead.
            "prototype$__count__exams": {
              url: urlBase + "/Projects/:id/exams/count",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures() instead.
            "prototype$__get__lectures": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectures",
              method: "GET",
            },

            // INTERNAL. Use Project.lectures.create() instead.
            "prototype$__create__lectures": {
              url: urlBase + "/Projects/:id/lectures",
              method: "POST",
            },

            // INTERNAL. Use Project.lectures.destroyAll() instead.
            "prototype$__delete__lectures": {
              url: urlBase + "/Projects/:id/lectures",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectures.count() instead.
            "prototype$__count__lectures": {
              url: urlBase + "/Projects/:id/lectures/count",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals() instead.
            "prototype$__get__lectureProposals": {
              isArray: true,
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "GET",
            },

            // INTERNAL. Use Project.lectureProposals.create() instead.
            "prototype$__create__lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "POST",
            },

            // INTERNAL. Use Project.lectureProposals.destroyAll() instead.
            "prototype$__delete__lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals",
              method: "DELETE",
            },

            // INTERNAL. Use Project.lectureProposals.count() instead.
            "prototype$__count__lectureProposals": {
              url: urlBase + "/Projects/:id/lectureProposals/count",
              method: "GET",
            },

            // INTERNAL. Use Project.syllabuses() instead.
            "prototype$__get__syllabuses": {
              isArray: true,
              url: urlBase + "/Projects/:id/syllabuses",
              method: "GET",
            },

            // INTERNAL. Use Project.syllabuses.create() instead.
            "prototype$__create__syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses",
              method: "POST",
            },

            // INTERNAL. Use Project.syllabuses.destroyAll() instead.
            "prototype$__delete__syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses",
              method: "DELETE",
            },

            // INTERNAL. Use Project.syllabuses.count() instead.
            "prototype$__count__syllabuses": {
              url: urlBase + "/Projects/:id/syllabuses/count",
              method: "GET",
            },

            // INTERNAL. Use Project.files() instead.
            "prototype$__get__files": {
              isArray: true,
              url: urlBase + "/Projects/:id/files",
              method: "GET",
            },

            // INTERNAL. Use Project.files.create() instead.
            "prototype$__create__files": {
              url: urlBase + "/Projects/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Project.files.destroyAll() instead.
            "prototype$__delete__files": {
              url: urlBase + "/Projects/:id/files",
              method: "DELETE",
            },

            // INTERNAL. Use Project.files.count() instead.
            "prototype$__count__files": {
              url: urlBase + "/Projects/:id/files/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#create
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Projects",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createMany
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#upsert
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Projects",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Projects/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#upsertWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Projects/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#exists
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Projects/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Projects/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#replaceById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Projects/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#find
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Projects",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#findOne
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Projects/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#updateAll
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Projects/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#deleteById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Projects/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#count
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Projects/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#prototype$updateAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Projects/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#createChangeStream
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Projects/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#getFiles
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get files of a specific type : e.g Projects/A/creo-lectures/files
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/Projects/:id/:componentModel/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#inviteUsers
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Invite users with roles to a project
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `users` – `{*}` - JSON Array of users
             *
             *  - `id` – `{string}` - Valid Project ID
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `usersInvited` – `{number=}` -
             */
            "inviteUsers": {
              url: urlBase + "/Projects/:id/inviteUsers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#lectureOrder
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update the order of a Project's order
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `lectureIdsInOrder` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "lectureOrder": {
              url: urlBase + "/Projects/:id/lectureOrder/:lectureIdsInOrder",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#updateProposal
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Accept or Reject a Lecture's Proposal
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `proposalId` – `{string}` -
             *
             *  - `action` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "updateProposal": {
              url: urlBase + "/Projects/:id/lectureProposal/:proposalId/:action",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#uploadFile
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Uploads a file for this project : e.g projectAId/assessment/uploadFile
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/Projects/:id/:componentModel/uploadFile",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#updateFile
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Updates a file for this project : e.g ProjectsprojectAId/assessment/updateFile/:FileId1
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `fileId` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/Projects/:id/:componentModel/updateFile/:fileId",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Project#userRoles
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Get the current user roles in this project
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `user` – `{object=}` -
             */
            "userRoles": {
              url: urlBase + "/Projects/:id/userRoles",
              method: "GET",
            },

            // INTERNAL. Use SystemUser.organizations.exists() instead.
            "::exists::SystemUser::organizations": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SystemUsers/:id/organizations/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use SystemUser.projects.exists() instead.
            "::exists::SystemUser::projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SystemUsers/:id/projects/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use SystemUser.organizations() instead.
            "::get::SystemUser::organizations": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/organizations",
              method: "GET",
            },

            // INTERNAL. Use SystemUser.projects() instead.
            "::get::SystemUser::projects": {
              isArray: true,
              url: urlBase + "/SystemUsers/:id/projects",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects.findById() instead.
            "::findById::Organization::projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects.destroyById() instead.
            "::destroyById::Organization::projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.projects.updateById() instead.
            "::updateById::Organization::projects": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/projects/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.projects() instead.
            "::get::Organization::projects": {
              isArray: true,
              url: urlBase + "/Organizations/:id/projects",
              method: "GET",
            },

            // INTERNAL. Use Organization.projects.create() instead.
            "::create::Organization::projects": {
              url: urlBase + "/Organizations/:id/projects",
              method: "POST",
            },

            // INTERNAL. Use Organization.projects.createMany() instead.
            "::createMany::Organization::projects": {
              isArray: true,
              url: urlBase + "/Organizations/:id/projects",
              method: "POST",
            },

            // INTERNAL. Use Organization.projects.destroyAll() instead.
            "::delete::Organization::projects": {
              url: urlBase + "/Organizations/:id/projects",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.projects.count() instead.
            "::count::Organization::projects": {
              url: urlBase + "/Organizations/:id/projects/count",
              method: "GET",
            },

            // INTERNAL. Use Exam.project() instead.
            "::get::Exam::project": {
              url: urlBase + "/Exams/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Lecture.project() instead.
            "::get::Lecture::project": {
              url: urlBase + "/Lectures/:id/project",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.project() instead.
            "::get::LectureProposal::project": {
              url: urlBase + "/LectureProposals/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.project() instead.
            "::get::Syllabus::project": {
              url: urlBase + "/syllabuses/:id/project",
              method: "GET",
            },

            // INTERNAL. Use Assessment.project() instead.
            "::get::Assessment::project": {
              url: urlBase + "/Assessments/:id/project",
              method: "GET",
            },

            // INTERNAL. Use File.project() instead.
            "::get::File::project": {
              url: urlBase + "/Files/:id/project",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Project#updateOrCreate
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Project#patchOrCreateWithWhere
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Project#update
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Project#destroyById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#removeById
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Project#patchAttributes
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Project#modelName
        * @propertyOf lbServices.Project
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Project`.
        */
        R.modelName = "Project";

    /**
     * @ngdoc object
     * @name lbServices.Project.users
     * @header lbServices.Project.users
     * @object
     * @description
     *
     * The object `Project.users` groups methods
     * manipulating `SystemUser` instances related to `Project`.
     *
     * Call {@link lbServices.Project#users Project.users()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#users
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries users of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.users = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::get::Project::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.users#exists
             * @methodOf lbServices.Project.users
             *
             * @description
             *
             * Check the existence of users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.users.exists = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::exists::Project::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.users#link
             * @methodOf lbServices.Project.users
             *
             * @description
             *
             * Add a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SystemUser` object.)
             * </em>
             */
        R.users.link = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::link::Project::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.users#unlink
             * @methodOf lbServices.Project.users
             *
             * @description
             *
             * Remove the users relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.unlink = function() {
          var TargetResource = $injector.get("SystemUser");
          var action = TargetResource["::unlink::Project::users"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.assessments
     * @header lbServices.Project.assessments
     * @object
     * @description
     *
     * The object `Project.assessments` groups methods
     * manipulating `Assessment` instances related to `Project`.
     *
     * Call {@link lbServices.Project#assessments Project.assessments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#assessments
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries assessments of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R.assessments = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::get::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#count
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Counts assessments of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.assessments.count = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::count::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#create
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Creates a new instance in assessments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R.assessments.create = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::create::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#createMany
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Creates a new instance in assessments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R.assessments.createMany = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::createMany::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#destroyAll
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Deletes all assessments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assessments.destroyAll = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::delete::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#destroyById
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Delete a related item by id for assessments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for assessments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assessments.destroyById = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::destroyById::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#findById
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Find a related item by id for assessments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for assessments
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R.assessments.findById = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::findById::Project::assessments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.assessments#updateById
             * @methodOf lbServices.Project.assessments
             *
             * @description
             *
             * Update a related item by id for assessments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for assessments
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Assessment` object.)
             * </em>
             */
        R.assessments.updateById = function() {
          var TargetResource = $injector.get("Assessment");
          var action = TargetResource["::updateById::Project::assessments"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.exams
     * @header lbServices.Project.exams
     * @object
     * @description
     *
     * The object `Project.exams` groups methods
     * manipulating `Exam` instances related to `Project`.
     *
     * Call {@link lbServices.Project#exams Project.exams()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#exams
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries exams of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R.exams = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::get::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#count
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Counts exams of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.exams.count = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::count::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#create
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Creates a new instance in exams of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R.exams.create = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::create::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#createMany
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Creates a new instance in exams of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R.exams.createMany = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::createMany::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#destroyAll
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Deletes all exams of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.exams.destroyAll = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::delete::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#destroyById
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Delete a related item by id for exams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for exams
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.exams.destroyById = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::destroyById::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#findById
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Find a related item by id for exams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for exams
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R.exams.findById = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::findById::Project::exams"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.exams#updateById
             * @methodOf lbServices.Project.exams
             *
             * @description
             *
             * Update a related item by id for exams.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for exams
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Exam` object.)
             * </em>
             */
        R.exams.updateById = function() {
          var TargetResource = $injector.get("Exam");
          var action = TargetResource["::updateById::Project::exams"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.lectures
     * @header lbServices.Project.lectures
     * @object
     * @description
     *
     * The object `Project.lectures` groups methods
     * manipulating `Lecture` instances related to `Project`.
     *
     * Call {@link lbServices.Project#lectures Project.lectures()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#lectures
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries lectures of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lectures = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::get::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#count
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Counts lectures of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.lectures.count = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::count::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#create
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Creates a new instance in lectures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lectures.create = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::create::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#createMany
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Creates a new instance in lectures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lectures.createMany = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::createMany::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#destroyAll
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Deletes all lectures of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.lectures.destroyAll = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::delete::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#destroyById
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Delete a related item by id for lectures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectures
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.lectures.destroyById = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::destroyById::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#findById
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Find a related item by id for lectures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectures
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lectures.findById = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::findById::Project::lectures"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectures#updateById
             * @methodOf lbServices.Project.lectures
             *
             * @description
             *
             * Update a related item by id for lectures.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectures
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Lecture` object.)
             * </em>
             */
        R.lectures.updateById = function() {
          var TargetResource = $injector.get("Lecture");
          var action = TargetResource["::updateById::Project::lectures"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.lectureProposals
     * @header lbServices.Project.lectureProposals
     * @object
     * @description
     *
     * The object `Project.lectureProposals` groups methods
     * manipulating `LectureProposal` instances related to `Project`.
     *
     * Call {@link lbServices.Project#lectureProposals Project.lectureProposals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#lectureProposals
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries lectureProposals of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.lectureProposals = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::get::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#count
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Counts lectureProposals of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.lectureProposals.count = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::count::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#create
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Creates a new instance in lectureProposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.lectureProposals.create = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::create::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#createMany
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Creates a new instance in lectureProposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.lectureProposals.createMany = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::createMany::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#destroyAll
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Deletes all lectureProposals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.lectureProposals.destroyAll = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::delete::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#destroyById
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Delete a related item by id for lectureProposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectureProposals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.lectureProposals.destroyById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::destroyById::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#findById
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Find a related item by id for lectureProposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectureProposals
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.lectureProposals.findById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::findById::Project::lectureProposals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.lectureProposals#updateById
             * @methodOf lbServices.Project.lectureProposals
             *
             * @description
             *
             * Update a related item by id for lectureProposals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for lectureProposals
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LectureProposal` object.)
             * </em>
             */
        R.lectureProposals.updateById = function() {
          var TargetResource = $injector.get("LectureProposal");
          var action = TargetResource["::updateById::Project::lectureProposals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.syllabuses
     * @header lbServices.Project.syllabuses
     * @object
     * @description
     *
     * The object `Project.syllabuses` groups methods
     * manipulating `Syllabus` instances related to `Project`.
     *
     * Call {@link lbServices.Project#syllabuses Project.syllabuses()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#syllabuses
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries syllabuses of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R.syllabuses = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::get::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#count
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Counts syllabuses of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.syllabuses.count = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::count::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#create
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Creates a new instance in syllabuses of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R.syllabuses.create = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::create::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#createMany
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Creates a new instance in syllabuses of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R.syllabuses.createMany = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::createMany::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#destroyAll
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Deletes all syllabuses of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.syllabuses.destroyAll = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::delete::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#destroyById
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Delete a related item by id for syllabuses.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for syllabuses
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.syllabuses.destroyById = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::destroyById::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#findById
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Find a related item by id for syllabuses.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for syllabuses
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R.syllabuses.findById = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::findById::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.syllabuses#updateById
             * @methodOf lbServices.Project.syllabuses
             *
             * @description
             *
             * Update a related item by id for syllabuses.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for syllabuses
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Syllabus` object.)
             * </em>
             */
        R.syllabuses.updateById = function() {
          var TargetResource = $injector.get("Syllabus");
          var action = TargetResource["::updateById::Project::syllabuses"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project#organization
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::Project::organization"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Project.files
     * @header lbServices.Project.files
     * @object
     * @description
     *
     * The object `Project.files` groups methods
     * manipulating `File` instances related to `Project`.
     *
     * Call {@link lbServices.Project#files Project.files()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Project#files
             * @methodOf lbServices.Project
             *
             * @description
             *
             * Queries files of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::get::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#count
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Counts files of Project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.files.count = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::count::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#create
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Creates a new instance in files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.create = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::create::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#createMany
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Creates a new instance in files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.createMany = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::createMany::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#destroyAll
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Deletes all files of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.files.destroyAll = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::delete::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#destroyById
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Delete a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.files.destroyById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::destroyById::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#findById
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Find a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.findById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::findById::Project::files"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Project.files#updateById
             * @methodOf lbServices.Project.files
             *
             * @description
             *
             * Update a related item by id for files.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `fk` – `{*}` - Foreign key for files
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R.files.updateById = function() {
          var TargetResource = $injector.get("File");
          var action = TargetResource["::updateById::Project::files"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.File
 * @header lbServices.File
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `File` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "File",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Files/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use File.project() instead.
            "prototype$__get__project": {
              url: urlBase + "/Files/:id/project",
              method: "GET",
            },

            // INTERNAL. Use File.organization() instead.
            "prototype$__get__organization": {
              url: urlBase + "/Files/:id/organization",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#create
             * @methodOf lbServices.File
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Files",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#createMany
             * @methodOf lbServices.File
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Files",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#upsert
             * @methodOf lbServices.File
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/Files",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#replaceOrCreate
             * @methodOf lbServices.File
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Files/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#upsertWithWhere
             * @methodOf lbServices.File
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Files/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#exists
             * @methodOf lbServices.File
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Files/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#findById
             * @methodOf lbServices.File
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Files/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#replaceById
             * @methodOf lbServices.File
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Files/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#find
             * @methodOf lbServices.File
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#findOne
             * @methodOf lbServices.File
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Files/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#updateAll
             * @methodOf lbServices.File
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Files/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#deleteById
             * @methodOf lbServices.File
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Files/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#count
             * @methodOf lbServices.File
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Files/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#prototype$updateAttributes
             * @methodOf lbServices.File
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/Files/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#createChangeStream
             * @methodOf lbServices.File
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Files/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#download
             * @methodOf lbServices.File
             *
             * @description
             *
             * Download file
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `type` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "download": {
              url: urlBase + "/Files/:id/download",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#getFiles
             * @methodOf lbServices.File
             *
             * @description
             *
             * Get files of a specific type : e.g subfolder/files
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string=}` -
             *
             *  - `componentModel` – `{string}` - Search files by type with regular expressions , e.g. ^creo- 
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/Files/:componentModel/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#uploadFile
             * @methodOf lbServices.File
             *
             * @description
             *
             * Uploads a file : e.g subfolder/uploadFile
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "uploadFile": {
              url: urlBase + "/Files/:componentModel/uploadFile",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.File#updateFile
             * @methodOf lbServices.File
             *
             * @description
             *
             * Updates a file : e.g subfolder/updateFile/:FileId1
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ctx` – `{object=}` -
             *
             *  - `componentModel` – `{string}` -
             *
             *  - `fileId` – `{string}` -
             *
             *  - `meta` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
            "updateFile": {
              url: urlBase + "/Files/:componentModel/updateFile/:fileId",
              method: "POST",
            },

            // INTERNAL. Use Organization.files.findById() instead.
            "::findById::Organization::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "GET",
            },

            // INTERNAL. Use Organization.files.destroyById() instead.
            "::destroyById::Organization::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.files.updateById() instead.
            "::updateById::Organization::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Organizations/:id/files/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Organization.files() instead.
            "::get::Organization::files": {
              isArray: true,
              url: urlBase + "/Organizations/:id/files",
              method: "GET",
            },

            // INTERNAL. Use Organization.files.create() instead.
            "::create::Organization::files": {
              url: urlBase + "/Organizations/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Organization.files.createMany() instead.
            "::createMany::Organization::files": {
              isArray: true,
              url: urlBase + "/Organizations/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Organization.files.destroyAll() instead.
            "::delete::Organization::files": {
              url: urlBase + "/Organizations/:id/files",
              method: "DELETE",
            },

            // INTERNAL. Use Organization.files.count() instead.
            "::count::Organization::files": {
              url: urlBase + "/Organizations/:id/files/count",
              method: "GET",
            },

            // INTERNAL. Use Exam.file() instead.
            "::get::Exam::file": {
              url: urlBase + "/Exams/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Exam.file.create() instead.
            "::create::Exam::file": {
              url: urlBase + "/Exams/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Exam.file.createMany() instead.
            "::createMany::Exam::file": {
              isArray: true,
              url: urlBase + "/Exams/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Exam.file.update() instead.
            "::update::Exam::file": {
              url: urlBase + "/Exams/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Exam.file.destroy() instead.
            "::destroy::Exam::file": {
              url: urlBase + "/Exams/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use Lecture.file() instead.
            "::get::Lecture::file": {
              url: urlBase + "/Lectures/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Lecture.file.create() instead.
            "::create::Lecture::file": {
              url: urlBase + "/Lectures/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Lecture.file.createMany() instead.
            "::createMany::Lecture::file": {
              isArray: true,
              url: urlBase + "/Lectures/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Lecture.file.update() instead.
            "::update::Lecture::file": {
              url: urlBase + "/Lectures/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Lecture.file.destroy() instead.
            "::destroy::Lecture::file": {
              url: urlBase + "/Lectures/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use LectureProposal.file() instead.
            "::get::LectureProposal::file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "GET",
            },

            // INTERNAL. Use LectureProposal.file.create() instead.
            "::create::LectureProposal::file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "POST",
            },

            // INTERNAL. Use LectureProposal.file.createMany() instead.
            "::createMany::LectureProposal::file": {
              isArray: true,
              url: urlBase + "/LectureProposals/:id/file",
              method: "POST",
            },

            // INTERNAL. Use LectureProposal.file.update() instead.
            "::update::LectureProposal::file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use LectureProposal.file.destroy() instead.
            "::destroy::LectureProposal::file": {
              url: urlBase + "/LectureProposals/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use Syllabus.file() instead.
            "::get::Syllabus::file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Syllabus.file.create() instead.
            "::create::Syllabus::file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Syllabus.file.createMany() instead.
            "::createMany::Syllabus::file": {
              isArray: true,
              url: urlBase + "/syllabuses/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Syllabus.file.update() instead.
            "::update::Syllabus::file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Syllabus.file.destroy() instead.
            "::destroy::Syllabus::file": {
              url: urlBase + "/syllabuses/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use Assessment.file() instead.
            "::get::Assessment::file": {
              url: urlBase + "/Assessments/:id/file",
              method: "GET",
            },

            // INTERNAL. Use Assessment.file.create() instead.
            "::create::Assessment::file": {
              url: urlBase + "/Assessments/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Assessment.file.createMany() instead.
            "::createMany::Assessment::file": {
              isArray: true,
              url: urlBase + "/Assessments/:id/file",
              method: "POST",
            },

            // INTERNAL. Use Assessment.file.update() instead.
            "::update::Assessment::file": {
              url: urlBase + "/Assessments/:id/file",
              method: "PUT",
            },

            // INTERNAL. Use Assessment.file.destroy() instead.
            "::destroy::Assessment::file": {
              url: urlBase + "/Assessments/:id/file",
              method: "DELETE",
            },

            // INTERNAL. Use Project.files.findById() instead.
            "::findById::Project::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "GET",
            },

            // INTERNAL. Use Project.files.destroyById() instead.
            "::destroyById::Project::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Project.files.updateById() instead.
            "::updateById::Project::files": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Projects/:id/files/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Project.files() instead.
            "::get::Project::files": {
              isArray: true,
              url: urlBase + "/Projects/:id/files",
              method: "GET",
            },

            // INTERNAL. Use Project.files.create() instead.
            "::create::Project::files": {
              url: urlBase + "/Projects/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Project.files.createMany() instead.
            "::createMany::Project::files": {
              isArray: true,
              url: urlBase + "/Projects/:id/files",
              method: "POST",
            },

            // INTERNAL. Use Project.files.destroyAll() instead.
            "::delete::Project::files": {
              url: urlBase + "/Projects/:id/files",
              method: "DELETE",
            },

            // INTERNAL. Use Project.files.count() instead.
            "::count::Project::files": {
              url: urlBase + "/Projects/:id/files/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.File#patchOrCreate
             * @methodOf lbServices.File
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.File#updateOrCreate
             * @methodOf lbServices.File
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.File#patchOrCreateWithWhere
             * @methodOf lbServices.File
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.File#update
             * @methodOf lbServices.File
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.File#destroyById
             * @methodOf lbServices.File
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.File#removeById
             * @methodOf lbServices.File
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.File#patchAttributes
             * @methodOf lbServices.File
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `File` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.File#modelName
        * @propertyOf lbServices.File
        * @description
        * The name of the model represented by this $resource,
        * i.e. `File`.
        */
        R.modelName = "File";


            /**
             * @ngdoc method
             * @name lbServices.File#project
             * @methodOf lbServices.File
             *
             * @description
             *
             * Fetches belongsTo relation project.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Project` object.)
             * </em>
             */
        R.project = function() {
          var TargetResource = $injector.get("Project");
          var action = TargetResource["::get::File::project"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.File#organization
             * @methodOf lbServices.File
             *
             * @description
             *
             * Fetches belongsTo relation organization.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PersistedModel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organization` object.)
             * </em>
             */
        R.organization = function() {
          var TargetResource = $injector.get("Organization");
          var action = TargetResource["::get::File::organization"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Queue
 * @header lbServices.Queue
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Queue` model.
 *
 * **Details**
 *
 * Provide access to data about the queues and the rabbitmq server
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Queue",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Queue/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Queue#status
             * @methodOf lbServices.Queue
             *
             * @description
             *
             * Get an status overview of the connected rabbitmq server
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Queue` object.)
             * </em>
             */
            "status": {
              url: urlBase + "/Queue/status",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Queue#queues
             * @methodOf lbServices.Queue
             *
             * @description
             *
             * Get queues of connected rabbitmq server
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Queue` object.)
             * </em>
             */
            "queues": {
              url: urlBase + "/Queue/queues",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Queue#modelName
        * @propertyOf lbServices.Queue
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Queue`.
        */
        R.modelName = "Queue";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

"use strict";

if (window.ENV !== 'test' && window.ENV !== 'production' && window.ENV !== 'beta') window.ENV = 'development';
window.AESG = {
    allowedLoginRoles: ["superadmin"],
    canLogin: function(response) {
        console.log(response)
        var res = response.data;
        res.roles = res.roles || [];
        var userAllowedToLogin = false;
        for (var i = 0; i < res.roles.length; i++) {
            if (window.AESG.allowedLoginRoles.indexOf(res.roles[i]) >= 0) { userAllowedToLogin = true; }
        }
        return userAllowedToLogin;
    }

};
var host = window.location.origin;
var path = window.location.pathname;
var cdnUrl = 'https://storage.googleapis.com/';
angular.module('config', [])
    .constant('SERVER', {
        host: host,
        path: path
    })
    .constant('ENV', {
        development: {
            sylvaHost: "https://a.dev.sylva.ac",
            host: host,
            path: path,
            apiUrl: 'https://api.' + host.split('.')[1] + '.sylva.ac/api',
            cdnUrl: cdnUrl,
            siteUrl: '/',
            'StorageContainers': [
                { label: 'Application', value: 'application', id: "sylva-app-test" },
                { label: 'Projects', value: 'projects', id: "sylva-projects-test" },
                { label: 'Organizations', value: 'organizations', id: "sylva-organizations-test" },
                { label: 'Public', value: 'public', id: "sylva-files-test" }
            ]
        },
        beta: {
            sylvaHost: "https://beta.sylva.ac",
            host: host,
            path: path,
            apiUrl: host + '/api',
            cdnUrl: cdnUrl,
            siteUrl: host + '/admin',
            'StorageContainers': [
                { label: 'Application', value: 'application', id: "sylva-app-beta" },
                { label: 'Projects', value: 'projects', id: "sylva-projects-beta" },
                { label: 'Organizations', value: 'organizations', id: "sylva-organizations-beta" }
            ]
        },
        test: {
            sylvaHost: "https://test.sylva.ac",
            host: host,
            path: path,
            apiUrl: host + '/api',
            cdnUrl: cdnUrl,
            siteUrl: host + '/admin',
            'StorageContainers': [
                { label: 'Application', value: 'application', id: "sylva-app-test" },
                { label: 'Projects', value: 'projects', id: "sylva-projects-test" },
                { label: 'Organizations', value: 'organizations', id: "sylva-organizations-test" },
                { label: 'Public', value: 'public', id: "sylva-files-test" }
            ]
        },
        production: {
            sylvaHost: "https://app.sylva.ac",
            host: 'https://identity.sylva.ac',
            path: path,
            apiUrl: host + '/api',
            cdnUrl: cdnUrl,
            siteUrl: host + '/admin',
            'StorageContainers': [
                { label: 'Application', value: 'application', id: "sylva-app-prod" },
                { label: 'Projects', value: 'projects', id: "sylva-projects-prod" },
                { label: 'Organizations', value: 'organizations', id: "sylva-organizations-prod" },
                { label: 'Public', value: 'public', id: "sylva-files" }
            ]
        }
    })
    .constant('CONFIG', {
        'ProjectRoles': [
            { map: 'admin', label: 'Project Admin', value: 'Project Admin' },
            { map: 'contentmanager', label: 'Content Manager', value: 'Content Manager' },
            { map: 'lecturer', label: 'Lecturer', value: 'Lecturer' },
            { map: 'teachingassistant', label: 'Teaching Assistant', value: 'Teaching Assistant' },
            { map: 'student', label: 'Student', value: 'Student' },
            { map: 'owner', label: 'Owner', value: 'Owner' }
        ],
        'SystemRoles': [
            { label: 'Super Admin', id: 'adminRoleID', value: "superadmin" },
            { label: 'Creo User', id: 'creouserRoleID', value: "creouser" },
            { label: 'Sylva User', id: 'sylvaRoleID', value: "sylvauser" },
            { label: 'Developer User', id: 'developerRoleID', value: "developer" }
        ],
        'OrganizationTypes': [
            { label: 'University', id: 'university', value: "university" },
            { label: 'Company', id: 'company', value: "company" }
        ],
        'ProjectBackgroundSizes': {
            "1024x768": "", //1M resolution
            "1366x768": "", //hd ready
            "1600x1024": "", //wide
            "1920x1280": "" //full hd
        }

    })
